var uScope =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp_name_"];
/******/ 	window["webpackJsonp_name_"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length)
/******/ 			resolves.shift()();
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};

/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		23: 0
/******/ 	};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}

/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return Promise.resolve();

/******/ 		// an Promise means "currently loading".
/******/ 		if(installedChunks[chunkId]) {
/******/ 			return installedChunks[chunkId][2];
/******/ 		}
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;

/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};

/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunks[chunkId][2] = promise;

/******/ 		head.appendChild(script);
/******/ 		return promise;
/******/ 	};

/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 608);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 This file contains constants, enumerated types and ...
 Some of these reflect AIL and therefore ImageServer specific coding.

 Notes:
 element class names: although the css explictly uses the values, use these constants in the code;
 remember if you change the css value that you need to change these, and visa-versa
 */

var us = {};

us.idROOT = 'uscope'; // the default viewer root node - note that this may be replaced by VIL settings
us.idHashROOT = '#uscope'; // the default viewer root node with # prepended
us.clsROOTSTYLE = 'us_rootstyle'; // additional class on the root div to bring in uScope styling

// FB 23050: Some images, in some browsers (IE, FF occasionally) exhibit a "tearing" effect when rotation is applied.
// Setting this flag will cause the renderer in viewportAP to offset the tiles 1px closer to their counterpart, closing
// the gap. NOTE that this makes the images overlap by 1px. This could cause distortion, but we haven't been able to
// discern it.
// FB 23074: We found out how to discern the offset! Setting the below to true causes all tiles to be shifted, causing
// annotations to be shifted up and to the left!
us.EXPAND_TILE_SIZE = true;
us.REQUEST_LARGER_TILES = false;

us.clsPANEL = 'us_panel'; // class for all uscope panels
us.clsPANELCLICKCLOSE = 'us_panelclickclose'; // class for all uscope panels that should be closed when the user clicks on the view
us.clsTRANSPARENT = 'us_transparent'; // class for transparency

us.idTOPTOOLBARV = 'us_toptoolbar_v'; // toolbar verical
us.idIATOOLBAR = 'us_iatoolbar'; // toolbar for image analysis panels

us.idMSGPANEL = 'us_msgPanel';

us.clsIMAGETOOLBAR = 'us_clsimagetoolbar'; // image toolbar
us.clsIMAGETOOLBARSTATE = 'us_clsimagetoolbarstate'; // image toolbar state indicator div
us.clsIMAGETOOLBARBTN = 'us_clsimagetoolbarbtn'; // image toolbar button class
us.clsIMAGETOOLBARSPC = 'us_clsimagetoolbarspc'; // image toolbar spacer vertical bar
us.clsTBCLOSEIMAGE = 'us_tbcloseimage'; // image toolbar: close image button
us.clsTBPINNED = 'us_tbpinned'; // image toolbar: pinned

us.clsTBCONTROL = 'us_tbcontrol'; // image toolbar: control slide indicator
us.clsTBPREVSLIDE = 'us_tbprevslide'; // image toolbar: previous slide
us.clsTBNEXTSLIDE = 'us_tbnextslide'; // image toolbar: next slide

us.clsTBBUTTON = 'us_tbbutton'; // toolbar button class
us.idTBRESIZE = 'us_tbresize'; // toolbar resize button
us.TBSETTINGS = 'us_tbsettings'; // toolbar settings/options button

us.TBANNOTPANEL = 'us_tbannotpanel'; // toolbar annotation panel open icon

us.TBRASTEROPEN = 'us_tbrasteropen'; // toolbar raster panel open icon

us.idTBMULTIVIEW = 'us_tbmultiview'; // toolbar tiling options button
us.TBISCOPE = 'us_tbimagescope'; // toolbar open-in-imagescope button
us.TBSNAPSHOT = 'us_tbsnapshot'; // toolbar snapshot button

us.clsRBBUTTON = 'us_rbbutton'; // region toolbar button class
us.REGTBREDRAW = 'us_regtbredraw'; // context menu redraw
us.REGTBCOPY = 'us_regtbcopy'; // context menu region copy
us.REGTBMOVE = 'us_regtbmove'; // context menu regioncopy


/* raster panels */
us.idRASTERPANEL = 'us_idRASTERPANEL'; // raster panel container div
us.idRPTEXT = 'us_idrptext'; //              text info
us.idRPINSTR = 'us_idrpinstr';

us.clsRPBUTTON = 'us_rpbutton'; // raster panel button class
us.RPSETTINGS = 'us_rpsettings';
us.RPSTART = 'us_rpstart';
us.RPPAUSE = 'us_rppause';
us.RPSLOW = 'us_rpslow';
us.RPFAST = 'us_rpfast';
us.RPBACKUP = 'us_rpbackup';
us.RPRASTERBAR = 'us_rprasterbar';

us.eSEQUENCESTYLES = { BYTISSUEPIECES: 0, ALLTISSUE: 1, WHOLESLIDE: 2 };
us.strSEQUENCESTYLES = ['By Tissue Pieces', 'All Tissue', 'Whole Slide'];

us.clsSEQUENCESTYLE = 'us_clsSEQUENCESTYLE'; // raster panel radio btns for seg style
us.idRSSTYLEDIV = 'us_idRSSTYLEDIV';
us.clsRSSTYLESEL = 'us_clsRSSTYLESEL';

us.clsSELECTBOX = 'us_clsselectbox';
us.idRASTERSETTINGS = 'us_idrastersettings'; // raster settings panel
us.idRASTERMODE = 'us_idrastermode';
us.idRASTERMAG = 'us_idrastermag';
us.RPSETTINGSADV = 'us_rpsettingsadv';
us.idRPSETTINGSDEF = 'us_idrpsettingsdef';

us.idRASTERSETADV = 'us_idrastersetadv'; // raster advanced settings panel

us.idRPPATTERN = 'us_idrppattern';
us.idRPOVERLAP = 'us_idrpoverlap';
us.idRPSENSITIVITY = 'us_idrpsensitivity'; //remove me?
us.idRPTHRESHOLD = 'us_idrpthreshold';

/* raster thumbnail */
us.CVSRASTERIMAGE = 'cvsrasterimage';
us.IMGRASTER = 'imgraster';

/* image adjustment panel */
us.idIMGADJPANEL = 'us_imgadjpanel';
us.idBRIGHTSETTING = 'us_idbrightsetting';
us.idCONTRASTSETTING = 'us_idcontrastsetting';
us.BRIGHTICON = 'us_brighticon';
us.CONTRASTICON = 'us_contrasticon';
us.TBIMGADJOPEN = 'us_tbimgadjopen'; // toolbar annotation panel open icon

/* annotation panel */
us.clsAPBUTTON = 'us_apbutton'; // annot panel button class
us.idANNOTPANEL = 'us_annotpanel'; // ann panel container div
us.APANNOTARROW = 'us_apannotarrow'; // ann panel draw arrow
us.APANNOTRECT = 'us_apannotrect'; // ann panel draw rectangle
us.APANNOTPEN = 'us_apannotpen'; // ann panel draw pen
us.APANNOTNEGPEN = 'us_apannotnegpen'; // ann panel draw negative pen
us.APANNOTPIN = 'us_apannotpin'; // ann panel draw pin
us.APANNOTPOLY = 'us_apannotpoly'; // ann panel draw ploygon

us.APANNOTCALIPER = 'us_apannotcaliper'; // ann panel draw caliper
us.APANNOTREPORT = 'us_apannotreport'; // ann panel report region button
us.APANNOTELLIPSE = 'us_apannotellipse'; // ann panel draw ellipse
us.APANNOTTEXT = 'us_apannottext'; // ann panel freetext tool
us.APTRASH = 'us_apannottrash'; // ann panel trash can for annot delete
us.APANNOTCOLOR = 'us_apannotcolor'; // ann panel color picker
us.APNOTE = 'us_apnote'; // ann panel note


us.idCLRPICKPANEL = 'us_clrpickpanel'; // color picker panel
us.idCLRPICKDIV = 'us_clrpickdiv'; // container for color squares
us.clsCLRPICKGRID = 'us_clrpickgrid'; // color picker panel
us.idCLRPCKBAR = 'us_clrpickbar'; // color bar of selected color

us.idANNAVDIV = 'us_anavdiv'; // container for annot nav elements
us.clsANAVBUTTON = 'us_anavbutton'; // annotation nav button class
us.ANAVPREV = 'us_anavprev'; // annav panel icon for aprevious region
us.idANAVCURRENT = 'us_anavcurrent'; // annav panel icon for current selection icon
us.ANAVNEXT = 'us_anavnext'; // annav panel icon for next region
us.clsBLANKBTN = 'us_blankbtn';

us.clsANAVCURRENT = 'us_clsANAVCURRENT'; // annav panel icon for current selection icon


us.idSOUNDDING = 'us_idsoundding'; // debug sound

// context menu
us.clsREGIONRAR = 'us_clsREGIONRAR';

//-------------------------------------------------------------------------------------------------
us.idSETTINGSTABS = 'us_settingstabs'; // settings/options tab
us.idTABPREFERENCES = 'us_preferences'; // tab preferences

us.idTABACTIONS = 'us_actions'; // tab for use actions
us.idLINKTEXTBOX = 'us_linktextbox';

us.idTABREPORT = 'us_report'; // tab for report options
us.idREPORTFIXEDDIV = 'us_idfixedreportdiv';
us.idREPORTFIXEDWIDTH = 'us_idreportwidth';
us.idREPORTFIXEDHEIGHT = 'us_idreportheight';
us.clsREPORTTYPE = 'us_reporttype'; //

us.idTABIMAGEINFO = 'us_imageinfo'; // tab image info
us.idTABPERFORMANCE = 'us_performance'; // tab performance
us.idTABABOUT = 'us_about'; // tab about
us.idTABHOTKEYS = 'us_hotkeys'; // tab hotkeys
us.idTABPERFTEST = 'us_perftest'; // tab performance test
us.clsSETCHOICE = 'us_setchoice'; //
us.clsSETBUTTON = 'us_setbutton'; // style of visibility buttons

us.idHMCLEARBTN = 'us_idhmclearbtn'; // heat map clear btn
us.clsVIZCHECKBOX = 'us_vizcheckbox'; // visibility checkboxes
us.idVIZALLCHECKBOX = 'us_vizallcheckbox'; // visibility all checkbox
us.idOPTIONSBTN = 'us_idoptionsbtn'; // options btn


us.clsPREFBUTTON = 'us_prefbutton'; // style of preference buttons
us.idPREFLABELROTBTN = 'us_prefsavelabelbtn'; //
us.idPREFQUALITYSLIDER = 'us_qualitySlider'; //
us.idCONSOLEBUTTON = 'us_consolebutton'; //
us.idPREFDEFAULTBTN = 'us_prefdefaultbtn'; //
us.idVISDEFAULTBTN = 'us_visdefaultbtn'; //
us.idRPTDEFAULTBTN = 'us_rptdefaultbtn'; //

us.idIMAGEINFODIV = 'us_imageinfodiv';
us.idCOPYLINKBTN = 'us_copylinkbtn'; // button to copy image link
us.idLINKIMAGE = 'us_imglink'; // link icon used on button

us.idPTESTREPORTBTN = 'us_ptestreportbtn'; // performance testing
us.idPTESTRUNBTN = 'us_ptestrunbtn'; // run
us.clsPERFTESTOPTION = 'us_ptestoption'; // radio buttons
us.clsPERFTESTINTERVAL = 'us_ptestinterval'; // radio buttons
us.idPERFTESTINTERVAL = 'us_idptestinterval';
us.idPTESTSHOWBTN = 'us_ptestshowbtn'; //

us.idADVANCEDPANEL = 'us_advancedpanel'; // advanced options panel
us.idADVCONSOLE = 'us_advconsole'; //

us.clsADVBUTTON1 = 'us_advbutton1';
us.clsADVBUTTON2 = 'us_advbutton2';

us.idTEXTEDITPANEL = 'us_texteditpanel'; // text edit panel

us.idDBGCONSOLE = 'us_debugconsole'; // debug console panel
us.idDBGCONSOLELOG = 'us_debugconsolelog';
us.idDBGSWITCHPANEL = 'us_dbgswitchpanel'; // debug switches panel

//-------------------------------------------------------------------------------------------------

us.clsOVERLAY = 'us_overlay'; // for elements place on top of viewport tiles and above graphics
us.clsSUPEROVERLAY = 'us_superoverlay'; // for elements placed on top of overlay class elements

us.clsPREPEND_ID = 'us_img_'; // prepended to image ID to use as a css class in viewport


us.clsOUTERVIEWPORT = 'us_outerviewport'; // container div for the image viewport that holds overlays
us.clsDotOUTERVIEWPORT = '.' + us.clsOUTERVIEWPORT;
us.clsVIEWPORT = 'us_viewport'; // the image viewport class
us.clsDotVIEWPORT = '.' + us.clsVIEWPORT;

us.clsEDGEDIV = 'us_edgediv'; // edge divs

us.clsANNOTDIV = 'us_paper'; // container for Raphael graphics
us.clsDotANNOTDIV = '.' + us.clsANNOTDIV;
us.clsGRAPHICS = 'us_graphics';

//-------------------------------------------------------------------------------------------------

us.clsDIVTHUMBNAIL = 'us_thumbnail';
us.clsIMGTHUMBNAIL = 'us_imgThumbnail';
us.clsDIVVIEWFINDER = 'us_thumbviewfinder';
us.clsDIVTHUMBHOVER = 'us_clsDIVTHUMBHOVER';
us.idTHHOVERCHECKBOX = 'us_idTHHOVERCHECKBOX';

us.CVSHEATMAP = 'us_cvsheatmap';

us.clsDIVLABEL = 'us_label';
us.clsIMGLABEL = 'us_imgLabel';

us.ROTATE = 'us_rotate'; // prefix to rotation style

us.clsDIVMARKER = 'us_marker';
us.clsIMGMARKER = 'us_imgMarker';

us.clsDIVZOOMSLIDER = 'us_zoomSlider';
us.clsDIVZOOMCTL = 'us_zoomControl';
us.clsDIVZOOMBTNS = 'us_zoomButtons';
us.clsDIVZOOMBTN = 'us_zoomButton';

us.clsDIVMAG = 'us_magnifier';
us.clsDIVIMGWRAP = 'us_imgMagWrapper';
us.clsIMGMAG = 'us_imgMag';
us.clsIMGREGION = 'us_imgRegion'; // generic image region
us.clsDIVMAGTAB = 'us_magTab';
us.clsMAGXHAIR = 'us_clsMagXHair';

us.clsDIVOUTERSCALEBAR = 'us_scalebarouter';
us.clsDIVSCALEBAR = 'us_scaleBar';
us.clsDIVSCALETEXT = 'us_scaleText';
us.clsDIVSCALEMAG = 'us_scaleMag';
us.clsSBROTKNOB = 'us_sbrotknob';
us.clsSBROTKNOBANGLE = 'us_sbrotknobangle';

us.clsROTATIONDIV = 'us_rotationDiv';
us.clsROTATIONDIAL = 'us_rotationDial';
us.clsROTATEPRESET = 'us_rotatePreset';

us.clsDIVGUAGES = 'us_guagesdiv'; // tile meter
us.clsDIVGUAGE = 'us_guagediv';
us.clsGUAGETEXT = 'us_guagetext';
us.clsGUAGETILES = 'us_guagetiles';
us.clsGUAGECELL = 'us_guagecell';
us.clsGUAGETILETEXT = 'us_guagetiletext';
us.clsGUAGEVIEWTEXT = 'us_guageviewtext';

us.clsGUAGEREF = 'us_guageref'; // view refresh meter

us.clsAPANDIV = 'us_autoPanDiv'; // the auto pan indicator at the view center
us.clsAPANCUR = 'us_autoPanCursor'; // the auto pan cursor
//-------------------------------------------------------------------------------------------------
us.clsTUNINGWINDOW = 'us_clstuningwindow';

//-------------------------------------------------------------------------------------------------

// constants
us.Rad2Deg = 180. / Math.PI;
us.Deg2Rad = Math.PI / 180.;
us.PI = 3.14159265359;
us.PI_2 = us.PI / 2.;

//-------------------------------------------------------------------------------------------------
// use of these adds clarity to the code
us.WITHFORCE = true;
us.WITHOUTFORCE = false;

us.FORCE_VIEWREFRESH = true;
us.DONT_FORCE_VIEWREFRESH = true;

us.DO_HIGHLIGHT = true;
us.DONT_HIGHLIGHT = true;

//-------------------------------------------------------------------------------------------------
//    event definitions
us.eEVENTWHICHBTN = { left: 1, middle: 2, right: 3 };

//-------------------------------------------------------------------------------------------------
// uScope custom events, triggers
//--------------------------------------------------
//    TO VIL        note: VIL watches for these events so take care if renaming
//--------------------------------------------------
us.evAJAXERROR = 'us_evAJAXERROR'; // parms: {imageId: @NUM, request: ImageServerRequest, jqXHR: jqXHR}
us.evIMAGEREADY = 'us_evIMAGEREADY'; // parms: {imageId: @NUM, uScopeIdx: NUM, status: true/false}
us.evIMAGECLOSE = 'us_evIMAGECLOSE'; // parms: {imageId: @NUM} toolbar button close event

us.evRESIZECLICK = 'us_evRESIZECLICK'; // parms: {NONE}

// note: VIL watches for these events so take care if renaming
us.evOPENNEXTSLIDE = 'us_evOPENNEXTSLIDE'; // parms: {NONE}
us.evOPENPREVSLIDE = 'us_evOPENPREVSLIDE'; // parms: {NONE}

//--------------------------------------------------
//    INTERNAL
//--------------------------------------------------
// user preference actions
us.evUSERPREFSREADY = 'us_evUSERPREFSREADY';
us.evUSERPREFSET = 'us_evUSERPREFSET'; // {className: STR, value: bool}
us.evUSERPREFDEFAULTVISIBLE = 'us_evUSERPREFDEFAULTVISIBLE';
us.evUSERPREFDEFAULTREPORT = 'us_evUSERPREFDEFAULTREPORT';
us.evUSERPREFDEFAULTLABELROT = 'us_evUSERPREFDEFAULTLABELROT';
us.evUSERPREFDEFAULTTHUMBHOVER = 'us_evUSERPREFDEFAULTTHUMBHOVER';

// general purpose
us.evIMAGEUPDATE = 'us_evIMAGEUPDATE'; // parms: { } // image added, removed, replaced
us.evVIEWCHANGE = 'us_evVIEWCHANGE'; // parms: {imageId: @NUM, uScopeIdx: NUM, desc: STR, x: NUM, y: NUM, zoom: NUM, angleDeg: NUM }
us.evMOUSECHANGE = 'us_evMOUSECHANGE'; // parms: {imageId: @NUM, uScopeIdx: NUM, x: NUM, y: NUM }
us.evIMAGESELECTED = 'us_evIMAGESELECTED'; // parms: {imageId: @NUM, uScopeIdx: NUM}
us.evMODECHANGE = 'us_evMODECHANGE'; // parms: {navMode: NUM }

us.evIMAGEROTATE = 'us_evIMAGEROTATE'; // parms: {imageId: @NUM, uScopeIdx: NUM, angleDeg: NUM },  imageId = "@0" or uScopeIdx = -1, all images rotated
us.evNAVMODEHALT = 'us_evNAVMODEHALT'; // parms: {imageId: @NUM, uScopeIdx: NUM },  imageId = "@0" or uScopeIdx = -1, halt navigation of all images

// events fired to request something to happen
us.evREGIONSELECT = 'us_evREGIONSELECT'; // select a region by rfId, parms { imageId: @NUM, rfId: NUM, bReposition: true|false, bSaveSel: true|false }
// when a region is selected, deleted, or added the event us.evANNOTCHANGE is fired - which could be in response to this event or a user action
us.evLAYERSELECT = 'us_evLAYERSELECT'; // select a layer by layerId, parms {imageId: @NUM, LayerId: NUM}

us.evVIEWRESIZE = 'us_evVIEWRESIZE'; // parms: {}
us.evRENDERCOMPLETE = 'us_evRENDERCOMPLETE'; // parms: {imageId: @NUM}

///////////////////////////////////////////////////////
us.evGETMARKUPSTATE = 'us_evGETMARKUPSTATE'; // parms { imageId: @NUM }
us.evGETMARKUPSTATE_RESP = 'us_evGETMARKUPSTATE_RESP'; // parms { imageId: @NUM, show: true|false, globalShow: true|false, imageHasMarkups: true|false }
us.evMARKUPCHANGE = 'us_evMARKUPCHANGE'; // markup state change;  parms { imageId: @NUM, show: true|false }

us.evREGIONDELETE = 'us_evREGIONDELETE'; // delete a region; parms { imageId: @NUM, regionId: NUM }
///////////////////////////////////////////////////////

// rasterscan events
us.evSPACEBAR = 'us_evSPACEBAR';
us.evRASTERPROGRESS = 'us_evRASTERPROGRESS';
us.evHEATMAPCLEAR = 'us_evHEATMAPCLEAR';

// uScope constants
us.TOUCHEVENT = true; // flags for mouse/touch handlers
us.NOTTOUCHEVENT = false;

us.kDEF_TILE_POS = -4000; // constant default left,top tile position
us.kDEF_TILE_POS_PX = us.kDEF_TILE_POS + 'px';

us.kREFRESH_RATE = 50; // Used to rate limit rendering

//-------------------------------------------------------------------------------------------------
// enums kept in sync with AIL, cViewport,  DataServer
us.eAICCaptureType = { // image capture type
    aic_i_BF: 0, // Bright Field
    aic_i_FL: 1, // FLuorescence
    aic_i_MIX: 2 // BF and FL (fusion)
};
us.captureNames = ['BrightField', 'Fluorescence', 'Fused'];

//-------------------------------------------------------------------------------------------------
// ANNOTATIONS
//-------------------------------------------------------------------------------------------------
// note: do not change the type order as ImageScope/Viewport depend upon it
//        and do not change these strings as pin drop navigation depend upon them (at least 'pin')
// note that the ruler creation is replaced by the caliper in this viewer
//        but is drawn if present in annotations from an older view

us.eAnTypes = { // these annotation types are used as indexes into us.anShapes
    pen: 0,
    rect: 1,
    ellipse: 2,
    arrow: 3,
    ruler: 4,
    pin: 5,
    caliper: 6,
    text: 7,
    report: 8,
    polygon: 9,
    negpen: 10
};

us.anShapes = Object.keys(us.eAnTypes);
us.eAnAnalysis = [1, 1, 0, 0, 0, // index to anTypes that can be analyzed - IMPORTANT TO KEEP IN ORDER WITH eAnTypes!
0, 0, 0, 0, 1, 0, 0];
us.kREGIONTYPES = us.anShapes.length; // number of region types

us.anLayerTypesSupported = {}; // annotation layer types supported
us.anLayerTypes = {
    aafinput: 1,
    aafinal: 2,
    aafresult: 3,
    manual: 4, // user drawn
    zstack: 5,
    cwsregion: 6,
    track: 7,
    report: 8 // report layer for report region
};

// interpretation of status returned from ALGORITHMRUN   //todo: move to appropriate local
us.algoRunStatus = { 'error': -1, 'queued': 0, 'active': 1, 'completed': 2, 'canceled': 3 };
us.algoRunStatusStr = ['queued', 'active', 'completed', 'canceled'];
us.algoRunStatusStr[-1] = 'error';

us.AnnotLayerName = 'Annotation'; // the A-layer, the name of the layer to hold regions with colors other than that of the layer
us.AnnotLayerRGB = '#0000FF'; // default RGB ordered color for A-layer (layer named "Annotation")
us.ReportLayerName = 'Report Image'; // the R-layer, the name of the layer to hold the one and only report region
us.ReportLayerRGB = '#FF0000'; // default RGB ordered color for R-layer (layer named "Report Image")


us.colorPalette = [// hex RGB ordered formatted and configured for colorPicker
'#ffaaaa', '#ffd4aa', '#ffffaa', '#d4ffaa', '#aaffaa', '#aaffd4', '#aaffff', '#aad4ff', '#aaaaff', '#d4aaff', '#ffaaff', '#ffaad4', '#ffffff', '#ff5656', '#ffaa56', '#ffff56', '#aaff56', '#56ff56', '#56ffaa', '#56ffff', '#56aaff', '#5656ff', '#aa56ff', '#ff56ff', '#ff007f', '#cfcfcf', '#ff0000', '#ff7f00', '#ffff00', '#7fff00', '#00ff00', '#00ff7f', '#00ffff', '#007fff', '#0000ff', '#7f00ff', '#ff00ff', '#ff007f', '#8f8f8f', '#bf0000', '#bf5f00', '#bfbf00', '#5fbf00', '#00bf00', '#00bf5f', '#00bfbf', '#005fbf', '#0000bf', '#5f00bf', '#bf00bf', '#bf005f', '#4f4f4f', '#7f0000', '#7f3f00', '#7f7f00', '#3f7f00', '#007f00', '#007f3f', '#007f7f', '#003f7f', '#00007f', '#3f007f', '#7f007f', '#7f003f', '#000000'];

// report region settings
us.eReportTypes = {
    FullRes_FixedDim: 0, // Full Resolution Image, Fixed Sized Report Region
    FullRes_UserDrawn: 1, // Full Resolution Image, User Drawn Report Region
    CurRes_FixedDim: 2, // Current Image Resolution, Fixed Sized Report Region
    CurRes_UserDrawn: 3 // Current Image Resolution,User Drawn Report Region
};

us.eReportSpec = {
    defReportType: 0, // default report types {eReportTypes}
    defWidthPx: 160, // default report width
    defHeightPx: 120, // default report height

    minDimPx: 50, // min and max width,height dims
    maxDimPx: 1600
};

//-------------------------------------------------------------------------------------------------
// COORDINATE SYSTEM DEFINITION
//-------------------------------------------------------------------------------------------------
// Note that this is a cheap means to differentiate
//        "normal" graphics coordinate system
//            ( with the origin at the top left, x-positive right, y-positive down)
//        from the open layers 3 coordinate system
//            ( with the origin at the top left, x-positive right, y-negative down)

us.coordSystemNORM = { x: 1, y: 1 };
us.coordSystemOL = { x: 1, y: -1 }; // xform to/from OL to Norm

//-------------------------------------------------------------------------------------------------
// NAVIGATION - for viewport and thumbnail event handlers
//-------------------------------------------------------------------------------------------------

us.eNavModes = { // navigation modes -really related to interpretation of the mouse actions
    nmNone: 0, // default
    // image nav modes
    nmDragImage: 1, // todo - useless mode
    nmThumbDragImage: 2,
    nmZoom: 3,
    nmDClickZoom: 4, // todo - useless mode; never set.
    nmPinchZoom: 5,
    nmSmoothZoom: 6,
    // annotation "nav" modes
    nmAnnotPin: 7,
    nmAnnotArrow: 8,
    nmAnnotRect: 9,
    nmAnnotEllipse: 10,
    nmAnnotPen: 11,
    nmAnnotCaliper: 12,
    nmAnnotText: 13,
    nmAnnotReport: 14,
    nmAnnotPolygon: 15,
    nmAnnotNegPen: 16,

    nmRedrawStarting: 17, // region redraw
    nmRedraw: 18,

    nmAutoPan: 19,
    nmRasterScan: 20,

    nmRotatingOverlay: 21, // only scalebar rotation so far

    nmNOMORE: 22
};

//-------------------------------------------------------------------------------------------------
// multiple image settings
us.multiSpecs = {
    maxImages: 4 // maximum number of images (views)
};
//-------------------------------------------------------------------------------------------------
//    layout settings for overlay visuals (elements that are above the viewport)
// These settings apply for all open images.

us.kOVERLAY_ELEMENT_SPACE = 2; // space in pixels from the viewport boundary and between adjacent elements

//-------------------------------------------------------------------------------------------------
// annotation elements
us.pinSpecs = {
    'coords': [14.676, -30.3985, 14.642, -31.3935, 14.542, -32.3875, 14.373, -33.3725, 14.138, -34.3445, 13.839, -35.2905, 13.47, -36.2275, 13.04, -37.1325, 12.551, -38.0025, 12.007, -38.8335, 11.395, -39.6425, 10.744, -40.3895, 10.038, -41.0985, 9.285, -41.7585, 8.496, -42.3605, 7.658, -42.9145, 6.78, -43.4115, 5.877, -43.8435, 4.962, -44.2075, 3.996, -44.5165, 3.025, -44.7555, 2.053, -44.9255, 1.059, -45.0295, 0.047, -45.0675, -0.943, -45.0375, -1.938, -44.9405, -2.924, -44.7765, -3.898, -44.5445, -4.856, -44.2455, -5.785, -43.8835, -6.682, -43.4625, -7.554, -42.9775, -8.406, -42.4235, -9.199, -41.8275, -9.957, -41.1735, -10.669, -40.4695, -11.325, -39.7275, -11.943, -38.9235, -12.494, -38.0965, -12.989, -37.2315, -13.425, -36.3305, -13.801, -35.3965, -14.107, -34.4535, -14.35, -33.4845, -14.527, -32.4905, -14.635, -31.4985, -14.676, -30.5115, -14.649, -29.5025, -14.556, -28.5035, -14.396, -27.5255, -14.168, -26.5525, -13.871, -25.5895, -13.512, -24.6565, -13.091, -23.7545, -12.604, -22.8735, -12.069, -22.0435, -11.47, -21.2405, -10.819, -20.4815, -10.119, -19.7675, -9.372, -19.1035, -8.58, -18.4895, -7.746, -17.9305, -6.874, -17.4285, -5.981, -16.9915, -5.208, -16.4705, -4.909, -15.5245, -4.609, -14.5735, -4.307, -13.6175, -4.006, -12.6635, -3.704, -11.7085, -3.399, -10.7445, -3.101, -9.8005, -2.798, -8.8425, -2.496, -7.8865, -2.195, -6.9325, -1.893, -5.9745, -1.597, -5.0385, -1.292, -4.0735, -0.994, -3.1295, -0.688, -2.1615, -0.39, -1.2165, -0.091, -0.2705, 0.211, -0.6505, 0.512, -1.6015, 0.818, -2.5715, 1.119, -3.5235, 1.417, -4.4665, 1.718, -5.4165, 2.02, -6.3745, 2.322, -7.3285, 2.624, -8.2825, 2.925, -9.2365, 3.226, -10.1875, 3.53, -11.1505, 3.832, -12.1045, 4.132, -13.0535, 4.43, -13.9985, 4.734, -14.9595, 5.033, -15.9055, 5.444, -16.7625, 6.356, -17.1645, 7.249, -17.6325, 8.105, -18.1595, 8.907, -18.7315, 9.681, -19.3665, 10.409, -20.0515, 11.09, -20.7835, 11.72, -21.5615, 12.296, -22.3815, 12.817, -23.2415, 13.272, -24.1225, 13.668, -25.0375, 14.002, -25.9835, 14.272, -26.9585, 14.469, -27.9235, 14.602, -28.9115],
    'width': 29.352, 'height': 44.797
};

//-------------------------------------------------------------------------------------------------
//
//    image view settings
us.kOVERTILES = 0; // number of tiles to overflow viewport boundaries //todo: probably should remove now
us.kFRAMETILES = 1; // width in tiles of frame about the viewport boundaries
us.kTILEMULTIPLIER = 2; // multiplier on image tile dims

us.labelSpecs = { // label settings
    'width': 100
};
us.zoomSpecs = { // zoom control settings
    'sliderMin': 0, // zoom slider min/max values
    'sliderMax': 200,
    'stepFactor': 0.2,

    'fitZoomMax': 200 // the maximum zoom that "Fit" is permitted
};

// debug console specs
us.consoleSpecs = {
    'msg': [],
    'msgCnt': 0,
    'msgMax': 500
};
//-------------------------------------------------------------------------------------------------
//    annotation settings
us.annotSpecs = {
    minAnnotDim: 20, // minimum dimension of an annotation in pixels
    minPenPointDist: 3, // minimum distance between saved pen points

    fontSize: 14,
    strokeWidthTextBorder: 2,
    strokeWidthPin: 2,
    strokeWidth: 3,
    strokeWidthSel: 5,
    strokeWidthHiLight: 2,
    strokeWidthCopyMove: 4,

    fillOpacity: '0.2',

    textBBoxPad: 4,
    textBBoxRadius: 8
};

//    text edit settings
us.textEditSpecs = {
    'width': 300, // width, height in pixels of text entry panel
    'height': 200,
    'maxChars': 275, // limit imposed by dataserver is 1023; DS fails if send it more!
    'noteWidth': 44 // width in pixels of hover note
};

us.reDrawSpecs = { // region redraw tolerances
    'thinTolerance': 10,
    'startTolerance': 100,
    'skipTolerance': 10,
    'removeTolerance': 50
};

//-------------------------------------------------------------------------------------------------
//    analysis related

// Note that ImageServer has a limitation on the dimensions of its returned JPEG compressed image
// (currently clipping each dimension to 2000 pixels).
us.IMAGESERVER_MAXJDIM = 2000; // hardcoded ImageServer limitation on dims of JPEG

// types defined by cAAFParameterTypes in  AAFTypes.h
us.AAFParameterType = ['eInteger', 'eDouble', 'eString', 'eBool', 'eList', 'eMultiSelList', 'eDynamicList'];
us.AAFParameterTypeNames = { eInteger: 0, eDouble: 1, eString: 2, eBool: 3, eList: 4, eMultiSelList: 5, eDynamicList: 6 };

//-------------------------------------------------------------------------------------------------
// objectiveColor - This function returns the industry standard color associated with a given magnification.
//    References:
//         color codes for objective lens:
//        http://zeiss-campus.magnet.fsu.edu/tutorials/objectivecolorcoding/
us.objectiveColors = [];
us.objectiveColor = function (mag) {
    var white = '#808080'; // because of BF and FL white and black backgrounds, change white color code to gray

    if (us.objectiveColors.length == 0) {
        // fill in the objective color array
        us.objectiveColors.push({ 'mag': 100, color: white }); // White
        us.objectiveColors.push({ 'mag': 83, color: white }); // White
        us.objectiveColors.push({ 'mag': 80, color: white }); // White

        us.objectiveColors.push({ 'mag': 63, color: '#0B4EA2' }); // Cobalt Blue
        us.objectiveColors.push({ 'mag': 60, color: '#0B4EA2' }); // Cobalt Blue

        us.objectiveColors.push({ 'mag': 50, color: '#007DC5' }); // Light Blue
        us.objectiveColors.push({ 'mag': 40, color: '#007DC5' }); // Light Blue

        us.objectiveColors.push({ 'mag': 32, color: '#10B050' }); // Green
        us.objectiveColors.push({ 'mag': 25, color: '#10B050' }); // Green

        us.objectiveColors.push({ 'mag': 20, color: '#00aa00' }); // Green
        us.objectiveColors.push({ 'mag': 16, color: '#10B050' }); // Green

        us.objectiveColors.push({ 'mag': 10, color: '#FFFF00' }); // Yellow

        us.objectiveColors.push({ 'mag': 6, color: '#FEB811' }); // Orange
        us.objectiveColors.push({ 'mag': 5, color: '#990033' }); // changed from original value of "#EF3449" to distinguish mag 4 and pyramid level mag 5 // Red
        us.objectiveColors.push({ 'mag': 4, color: '#EF3449' }); // Red

        us.objectiveColors.push({ 'mag': 2.5, color: '#A78D2C' }); // Brown
        us.objectiveColors.push({ 'mag': 2, color: '#A78D2C' }); // Brown

        us.objectiveColors.push({ 'mag': 1.25, color: '#231F20' }); // Black
        us.objectiveColors.push({ 'mag': 1.5, color: '#231F20' }); // Black
        us.objectiveColors.push({ 'mag': 1, color: '#231F20' }); // Black
    }

    for (var i = 0, clen = us.objectiveColors.length; i < clen; i++) {
        if (us.objectiveColors[i].mag == mag) return us.objectiveColors[i].color;
    }
    return white;
};

exports.default = us;
module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(315);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(166)('wks')
  , uid        = __webpack_require__(143)
  , Symbol     = __webpack_require__(7).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isUnDefined = exports.memset = exports.removeChunk = exports.insertAt = exports.roundToDecimals = undefined;
exports.circBuffer = circBuffer;
exports.getIndexWith = getIndexWith;
exports.toStringAssoc = toStringAssoc;
exports.assocArrayLength = assocArrayLength;
exports.cloneObject = cloneObject;
exports.isNumber = isNumber;
exports.isDefined = isDefined;
exports.stripLeadingAtSign = stripLeadingAtSign;
exports.hexColortoRGB = hexColortoRGB;
exports.toHexColor = toHexColor;
exports.reverseCLR = reverseCLR;
exports.isLightColor = isLightColor;
exports.roundToNearset = roundToNearset;
exports.limitValue = limitValue;
exports.getClassList = getClassList;
exports.array2DCreate = array2DCreate;
exports.divRotate = divRotate;
exports.computeRotationOffset = computeRotationOffset;
exports.getImageIdFromSrcAttr = getImageIdFromSrcAttr;
exports.download = download;

var _objects = __webpack_require__(16);

var _lbsPiDash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lbsPiDash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// TODO: Group functions by capability (colors, math, etc)

/**
 * Rounds `value` to the nearest decimal. Borrowed from MDN (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round).
 * Returns NaN if the input is not a number.
 * @param {Number} value - the value to round
 * @param {Number} exp - the number of decimals to round to
 * @returns {Number}
 */
var roundToDecimals = exports.roundToDecimals = function roundToDecimals(value) {
    var exp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

    value = Number(value);
    exp = Number(exp);

    if (isNaN(value) || isNaN(exp)) {
        return NaN;
    }

    value = value.toString().split('e');
    value = Math.round(Number(value[0] + 'e' + (value[1] ? +value[1] + exp : exp)));

    value = value.toString().split('e');
    return Number(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp));
};

/**
 * Inserts a value at the specified index
 * @param array
 * @param index
 * @param value
 * @returns {*|Array.<T>}
 */
var insertAt = exports.insertAt = function insertAt(array, index, value) {
    return array.splice(index, 0, value);
};

/**
 * Removes a chunk of elements from an array
 * @param array
 * @param start (integer) Start index
 * @param end (integer) End index. If not supplied only the single element will be removed
 * @returns {*}
 */
var removeChunk = exports.removeChunk = function removeChunk(array, start, end) {
    var rest = array.slice((end || start) + 1 || array.length);
    array.length = start < 0 ? array.length + start : start;
    return array.push.apply(array, rest);
};

/**
 * Sets the first num elements of the array starting from offset and ending the specified num elements later to the
 * specified value
 * @param array (Array) The array to fill
 * @param offset (Number) The starting index
 * @param length (Number) The number of elements to fill
 * @param value (*) Value to be set
 */
var memset = exports.memset = function memset(array, offset, length, value) {
    for (var i = 0; i < length; i++) {
        array[offset++] = value;
    }
};

/**
 * creates and updates a circular buffer of the specified length for numeric values and maintains the sum and average
 * value of the buffer.
 *   Note that the average value will be skewed low until the buffer has been filled.
 *   Note that numerical values are assumed to be in the buffer.
 * @param length
 * @returns {{get: get, push: push, getSum: getSum, getLength: getLength, getAvg: getAvg, getAvgInt: getAvgInt, toString: toString, reset: reset}}
 */
function circBuffer(length) {

    var pointer = 0,
        buffer = new Array(length);
    var sum = 0;
    for (var i = 0; i < length; i++) {
        buffer[i] = 0;
    }
    return {
        get: function get(key) {
            return buffer[key];
        },
        push: function push(item) {
            var nextPtr = (length + pointer + 1) % length;
            sum -= buffer[nextPtr];
            sum += item;
            buffer[pointer] = item;
            pointer = nextPtr;
        },
        getSum: function getSum() {
            return sum;
        },
        getLength: function getLength() {
            return length;
        },
        getAvg: function getAvg() {
            return sum / length;
        },
        getAvgInt: function getAvgInt() {
            return parseInt(sum / length);
        },
        toString: function toString() {
            for (var rtnStr = buffer[0], i = 1; i < length; i++) {
                rtnStr += ', ' + buffer[i];
            }return rtnStr;
        },
        reset: function reset() {
            pointer = 0;
            sum = 0;
            for (var i = 0; i < length; i++) {
                buffer[i] = 0;
            }
        }
    };
}

/**
 * in an array of json objects, find index where array[idx][key] == value
 * @param array
 * @param key
 * @param value
 * @returns {number}
 */
function getIndexWith(array, key, value) {
    if (!array) {
        return -1;
    }

    for (var i = 0, len = array.length; i < len; i++) {
        if (array[i] && array[i][key] == value) {
            return i;
        }
    }

    return -1;
}

// This function is predominantly used for debugging purposes. TODO: Exterminate!
function toStringAssoc(assocArray, opt_delimiter, opt_dontReport) {
    var str = '';
    var delimiter = opt_delimiter == undefined ? ', ' : opt_delimiter + ' ';

    for (var key in assocArray) {
        if (assocArray.hasOwnProperty(key)) {
            if (opt_dontReport && opt_dontReport[key] != undefined) continue;
            if (str.length != 0) str += delimiter;
            str += key + ': ' + assocArray[key];
        }
    }
    return str;
}

/**
 * Returns the "length" of a JavaScript object, where the length is interpreted of the number of keys in the object.
 * @param assocArray
 * @returns {Number}
 */
function assocArrayLength(assocArray) {
    return Object.keys(assocArray).length;
}

// This has been updated to pass through to lodash lite. Original implementation was radically flawed (checked if typeof object was "source"???)
// TODO: Replace with _.clone.
function cloneObject(object) {
    return _.clone(object);
}

/**
 *
 * @param object
 * @returns {*}
 */
// TODO: Review this logic. It appears to check if object is "number-like", not actually if it's a number.
function isNumber(object) {
    return !isNaN(parseFloat(object)) && isFinite(object);
}

// left in for compatibility with legacy. TODO: Replace with lodash.
var isUnDefined = exports.isUnDefined = _.isUndefined;

// Wow, really? TODO: Remove.
function isDefined(variable) {
    return variable !== undefined;
}

/**
 * This function returns the passed imageId without a leading '@' sign
 * @param imageId
 * @returns {string|*}
 */
// TODO: This is used enough that it seems like it should be done once and cached, rather than recalculated as convenient.
function stripLeadingAtSign(imageId) {
    return imageId.indexOf('@') == 0 ? imageId.substr(1) : imageId;
}

/**
 * This function converts a hex color value (e.g. "#FFFFFF") to decimal RGB
 * @param hexColor
 * @returns {*}
 */
function hexColortoRGB(hexColor) {
    var rtnColor = hexColor;
    if (typeof hexColor == 'string' && hexColor.indexOf('#') === 0) rtnColor = parseInt(hexColor.substr(1), 16);
    return rtnColor;
}

/**
 * This function converts a decimal RGB value to hex
 * @param decRGB
 * @returns {number}
 */
function toHexColor(decRGB) {
    var red = decRGB >> 16 & 0xFF;
    var green = decRGB >> 8 & 0xFF;
    var blue = decRGB & 0xFF;

    red = red.toString(16);
    green = green.toString(16);
    blue = blue.toString(16);

    if (red.length < 2) red = '0' + red;
    if (green.length < 2) green = '0' + green;
    if (blue.length < 2) blue = '0' + blue;

    return red + green + blue;
}

/**
 * This function returns a decimal BGR ordered color from a decimal RGB ordered color or visa versa!
 * @param decRGB
 * @returns {number}
 */
function reverseCLR(decRGB) {
    var blue = decRGB & 0xFF;
    var green = decRGB >> 8 & 0xFF;
    var red = decRGB >> 16 & 0xFF;

    return (blue << 16) + (green << 8) + red;
}

/**
 * This function returns true if the input color is light, otherwise it returns false. Determines brightness of color by
 * converting to the Y component of YUV, which is brightness.
 * @param color
 * @returns {boolean}
 */
function isLightColor(color) {
    color = hexColortoRGB(color); // if input is hex format, convert it
    var blue = color & 0xFF;
    var green = color >> 8 & 0xFF;
    var red = color >> 16 & 0xFF;
    //    don't need U and V, but fyi, they are:      U = 0.436 * (blue - Y) / (1 / 0.114);  V = 0.615 * (red - Y) / (1 / 0.299);
    var Y = parseInt(red * 0.299 + green * 0.587 + blue * 0.114);
    return Y > 139;
}

/**
 * This function rounds a float value to the nearest decimal as determined by the number of decimals
 * @param value
 * @param decplace
 * @returns {Number}
 */
function roundToNearset(value, decplace) {
    return Math.round(value * decplace) / decplace;
}

/**
 * This function returns the value if it is inclusively within the min/max Value boundaries;
 * @param value
 * @param minValue
 * @param maxValue
 * @returns {number} returns the minValue if it is less than the minValue; returns the maxValue if it is greater than
 * the maxValue
 */
function limitValue(value, minValue, maxValue) {
    return Math.min(Math.max(minValue, value), maxValue);
}

/**
 * This function returns an array of the classes associated with the passed element or undefined if the element had no class.
 * @param element
 * @returns {*}
 */
function getClassList(element) {
    var classes = element.getAttribute('class');

    if (classes) return classes.split(' ');

    return undefined;
}

/**
 * This function creates an n dimensional array.
 * @param length
 * @returns {Array}
 */
function arrayNDCreate(length) {
    var a = new Array(length || 0);
    if (a.dims == undefined) {
        a.dims = new Array(arguments.length);
        for (var i = 0; i < arguments.length; i++) {
            a.dims[i] = arguments[i];
        }
    }

    if (arguments.length > 1) {
        var args = Array.prototype.slice.call(arguments, 1);
        for (var i = 0; i < length; i++) {
            a[i] = arrayNDCreate.apply(this, args);
        }
    }
    return a;
}

//-------------------------------------------------------------------------------------------------
// array2DCreate - This function wraps arrayNDCreate and adds the width and height properties to the array.
function array2DCreate(width, height) {
    var a = arrayNDCreate(width, height);

    a.width = a.dims[0];
    a.height = a.dims[1];
    return a;
}

//-------------------------------------------------------------------------------------------------
//    divRotate -
//
//    Depends upon:
//        Rectangle object
//
//    Note that the DIV position must be absolute or relative
//    Reference: http://stackoverflow.com/questions/2449668/how-to-rotate-a-div-html-layer
//

/**
 * This function rotates a div about its center and returns a rect of its position offset.
 * @param divObj
 * @param divLeft
 * @param divTop
 * @param divWidth
 * @param divHeight
 * @param angleRad
 * @returns {Rectangle}
 */
function divRotate(divObj, divLeft, divTop, divWidth, divHeight, angleRad) {
    var isNotIE = window.navigator.userAgent.indexOf('MSIE ') <= 0 || typeof document.documentElement.style.opacity != 'undefined';
    var radAngle = angleRad;
    var spinAngle = radAngle;

    if (window.navigator.userAgent.indexOf('MSIE ') <= 0 || typeof document.documentElement.style.opacity != 'undefined') radAngle = -radAngle;

    var sinAngle = parseFloat(parseFloat(Math.sin(radAngle)).toFixed(8));
    var cosAngle = parseFloat(parseFloat(Math.cos(radAngle)).toFixed(8));

    var m11 = cosAngle;
    var m12 = -sinAngle;
    var m21 = sinAngle;
    var m22 = cosAngle;

    if (isNotIE == true) {
        divObj.style.WebkitTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';
        divObj.style.MozTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + 'px,' + 0 + 'px)';
        divObj.style.msTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';
        divObj.style.OTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';
        divObj.style.transform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';

        divObj.style.top = divTop + 'px';
        divObj.style.left = divLeft + 'px';
    }
    var sinSpinAngle = -parseFloat(parseFloat(Math.sin(-spinAngle)).toFixed(8));
    var cosSpinAngle = parseFloat(parseFloat(Math.cos(-spinAngle)).toFixed(8));
    var sinAnglePerp = parseFloat(parseFloat(Math.sin(radAngle - Math.PI)).toFixed(8));
    var cosAnglePerp = parseFloat(parseFloat(Math.cos(radAngle - Math.PI)).toFixed(8));
    var halfHeight = divHeight / 2;
    var halfWidth = divWidth / 2;
    var radius = Math.sqrt(halfHeight * halfHeight + halfWidth * halfWidth);

    var ulx = divLeft + halfWidth - radius * cosSpinAngle + sinAnglePerp * halfHeight;
    var uly = divTop + halfHeight - radius * sinSpinAngle + cosAnglePerp * halfHeight;

    var urx = radius * cosSpinAngle + divLeft + halfWidth + sinAnglePerp * halfHeight;
    var ury = radius * sinSpinAngle + divTop + halfHeight + cosAnglePerp * halfHeight;

    var lrx = radius * cosSpinAngle + divLeft + halfWidth - sinAnglePerp * halfHeight;
    var lry = radius * sinSpinAngle + divTop + halfHeight - cosAnglePerp * halfHeight;

    var llx = divLeft + halfWidth - radius * cosSpinAngle - sinAnglePerp * halfHeight;
    var lly = divTop + halfHeight - radius * sinSpinAngle - cosAnglePerp * halfHeight;

    if (isNotIE == false) divObj.style.filter = 'filter: progid:DXImageTransform.Microsoft.Matrix( M11=' + m11 + ', M12=' + m12 + ', M21=' + m21 + ', M22=' + m22 + ', sizingMethod=\'auto expand\' );';

    var spinTop = Math.min(uly, ury, lry, lly);
    var spinRight = Math.max(ulx, urx, lrx, llx);
    var spinBottom = Math.max(uly, ury, lry, lly);
    var spinLeft = Math.min(ulx, urx, lrx, llx);

    if (isNotIE == false) {
        divObj.style.top = spinTop + 'px';
        divObj.style.right = spinRight + 'px';
        divObj.style.bottom = spinBottom + 'px';
        divObj.style.left = spinLeft + 'px';
    }
    return new _objects.Rectangle(spinLeft.toFixed(2), spinTop.toFixed(2), (spinRight - spinLeft).toFixed(2), (spinBottom - spinTop).toFixed(2));
}

function computeRotationOffset(divW, divH, angleRad) {
    var cpRtn = new _objects.Point(0, 0); // return point object
    if (angleRad != 0) {
        if (angleRad > Math.PI) angleRad = angleRad - Math.PI;

        var xc = divW / 2,
            yc = divH / 2;

        // compute y offset.....................................
        var x = 0,
            y = 0; // use top left corner
        var dx = angleRad <= Math.PI / 2 ? x - xc : xc - x;
        var dy = yc - y;
        var hypot = Math.sqrt(dx * dx + dy * dy);

        var thetaRad = Math.atan2(dy, dx);
        var phiRad = thetaRad - angleRad;
        cpRtn.y = hypot * Math.sin(phiRad);

        var yi = yc - cpRtn.y;
        cpRtn.y = Math.round(yi);
        if (cpRtn.y >= divH) cpRtn.y = divH - cpRtn.y;

        // compute x offset.....................................
        x = 0, y = divH; // use bottom left corner
        var dx = angleRad <= Math.PI / 2 ? x - xc : xc - x;
        dy = yc - y;
        hypot = Math.sqrt(dx * dx + dy * dy);

        var thetaRad = Math.atan2(dy, dx);
        var phiRad = thetaRad - angleRad;
        cpRtn.x = hypot * Math.cos(phiRad);

        var xi = cpRtn.x + xc;
        cpRtn.x = Math.round(xi);
        if (cpRtn.x >= divW) cpRtn.x = divW - cpRtn.x;
    }
    return cpRtn;
}

//-------------------------------------------------------------------------------------------------
// MISCELLANEOUS FUNCTIONS
//-------------------------------------------------------------------------------------------------
// getImageIdFromSrcAttr - This function returns the image id encoded into the passed event's src attribute
//            or undefined if it is not found. The returned image id has the @ sign prepended to it.
function getImageIdFromSrcAttr(event) {
    var id;
    var srcAttr = $(event).attr('src'); // source attribute e.g. "/@2?0+0+122+122+-2"
    var at = srcAttr.lastIndexOf('@');
    var q = srcAttr.indexOf('?');
    if (at !== -1 && q !== -1) id = srcAttr.slice(at, q);
    return id;
}

/**
 * Downloads a file from the specified uri or blob.
 * @param uri
 * @param blob
 * @param filename
 */
function download(_ref) {
    var _ref$uri = _ref.uri,
        uri = _ref$uri === undefined ? null : _ref$uri,
        _ref$blob = _ref.blob,
        blob = _ref$blob === undefined ? null : _ref$blob,
        _ref$filename = _ref.filename,
        filename = _ref$filename === undefined ? null : _ref$filename;

    var link = document.createElement('a');

    // Chrome, FF, Edge support adding a 'download' attribute which makes a hyperlink downloadable.
    if (uri && typeof link.download === 'string') {
        link.href = uri;

        if (filename) {
            link.download = filename;
        }

        // This is stupid but Firefox requires the link to be in the body for the click() call to work.
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // Microsoft pushed a download API in IE before the download attribute was standardized, so fallback to that if we can.
    } else if (blob && window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filename);
        // If all else fails just open a new window.
    } else {
        window.open(uri);
    }
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compact", function() { return compact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return forEach; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forOwn", function() { return forOwn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "once", function() { return once; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return defaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return clone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return invert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return escape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return unescape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trim", function() { return trim; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return isUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return isFunction; });
/*
 * Collection helpers. These helpers act on either objects or arrays.
 * */

/**
 * like [].forEach but works on objects as well. On objects will loop through all inherited members as well
 * @param object - source object or array
 * @param iteratee - function to be called on each iteration
 */
var forEach = function forEach(object, iteratee) {
    for (var item in object) {
        iteratee(object[item], item);
    }
};

/**
 * Iterates over own enumerable properties of an object invoking iteratee for each property. The iteratee is invoked with three arguments: (value, key, object). Iteratee functions may exit iteration early by explicitly returning false.
 * @param {Object} object - The object to iterate over
 * @param {Function} iteratee - The function invoked per iteration
 */
var forOwn = function forOwn(object, iteratee) {
    for (var item in object) {
        if (object.hasOwnProperty(item)) {
            iteratee(object[item], item);
        }
    }
};

/**
 * Iterates over elements of collection, returning an array of all elements predicate returns truthy for. The predicate is invoked with three arguments: (value, index|key, collection).
 * @param collection {Array|Object}: The collection to iterate over.
 * @param predicate {Function}: The function invoked per iteration.
 * @returns {Array}
 */
function filter(collection, predicate) {
    var results = [];
    forEach(collection, function (value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

/*
* Array helpers.
* */

/**
 * Creates an array with all falsey values removed. The values false, null, 0, "", undefined, and NaN are falsey.
 * @param array
 */
function compact(array) {
  return filter(array, Boolean);
}

/*
 * Helpers that modify how and when functions execute.
 * */

/**
 * Creates a function that is restricted to invoking func once. Repeat calls to the function return the value of the
 * first invocation. The func is invoked with the this binding and arguments of the created function.
 * @param fn (function) - the function to restrict
 * @returns {function(...[*]=)}
 */
var once = function once(fn) {
    var _this = this;

    var called = false;
    var rv = void 0;
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var context = _this;
        if (!called) {
            rv = fn.apply(context, args);
            called = true;
        }
        return rv;
    };
};

/**
 * Creates a throttled function that only invokes func at most once per every wait milliseconds. The func is invoked
 * with the arguments provided to the throttled function in the context from which it was invoked. func will only be
 * invoked on the leading edge of each wait timeout.
 * @param func {Function} - The function to throttle.
 * @param delay {Number} - The number of milliseconds to throttle invocations to. Defaults to 100 if unspecified.
 * @returns {Function} Returns the new throttled function.
 */
var throttle = function throttle(func) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var wait = false;

    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var self = this;
        if (!wait) {
            wait = true;
            setTimeout(function () {
                wait = false;
                func.apply(self, args);
            }, delay);
        }
    };
};

/*
 * Object helpers.
 * */

/**
 * Assigns own and inherited enumerable string keyed properties of source objects to the destination object for all
 * destination properties that resolve to undefined. Source objects are applied from left to right. Once a property is
 * set, additional values of the same property are ignored.
 * NOTE: This will mutate the original object
 * @param object
 * @param [sources]
 */
function defaults(object) {
    for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
    }

    forEach(sources, function (source) {
        forEach(source, function (value, key) {
            if (!object.hasOwnProperty(key)) {
                object[key] = value;
            }
        });
    });
    return object;
}

/**
 * Gets the value at path of object. If the resolved value is undefined, the defaultValue is returned in its place.
 * @param object (Object): The object to query.
 * @param path (Array|string): The path of the property to get.
 * @param [defaultValue] (*): The value returned for undefined resolved values.
 */
function get(object, path) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    var props = path.split('.');
    var out = object;
    while (out && props.length) {
        var next = props.shift();
        if (out[next]) {
            out = out[next];
        } else {
            var arrayMatches = next.match(/\[(\d)\]/);
            if (arrayMatches) {
                next = next.replace(arrayMatches[0], '');
                out = out[next] ? out[next][arrayMatches[1]] : defaultValue;
            } else {
                out = defaultValue;
                break;
            }
        }
    }
    return out;
}

/**
 * Assigns own enumerable properties of source objects to the destination object. Source objects are applied from left to right. Subsequent sources overwrite property assignments of previous sources.
 * @param {Object} object - The destination object
 * @param {Object} [sources] The source objects
 * @returns {Object} returns object
 */
var assign = function assign(object) {
    for (var _len2 = arguments.length, sources = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        sources[_key2 - 1] = arguments[_key2];
    }

    forEach(sources, function (arg) {
        forOwn(arg, function (prop, name) {
            object[name] = prop;
        });
    });
    return object;
};

/**
 * Creates a shallow clone of value.
 * @param value - the value to clone
 */
var clone = function clone(value) {
    return assign({}, value);
};

/**
 * Creates an object composed of the inverted keys and values of object. If object contains duplicate values, subsequent values overwrite property assignments of previous values.
 * @param object (Object): The object to invert.
 * @returns (Object): Returns the new inverted object.
 */
function invert(object) {
    var result = {};
    var keys = Object.keys(object);
    for (var i = 0, length = keys.length; i < length; i++) {
        result[object[keys[i]]] = keys[i];
    }
    return result;
}

/*
 * Helpers that make common string functions simpler.
 * */

var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#x27;',
    '`': '&#x60;'
};
var unescapeMap = invert(escapeMap);

// Helper to create escape maps
var createEscaper = function createEscaper(map) {
    var escaper = function escaper(match) {
        return map[match];
    };

    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + Object.keys(map).join('|') + ')';
    var testRegexp = new RegExp(source);
    var replaceRegexp = new RegExp(source, 'g');
    return function (string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
};

/**
 * Converts the characters "&", "<", ">", '"', "'", and "`" in string to their corresponding HTML entities.
 * @param [string=''] (string): The string to escape.
 */
var escape = createEscaper(escapeMap);

/**
 * The inverse of _.escape; this method converts the HTML entities &amp;, &lt;, &gt;, &quot;, &#39;, and &#96; in string
 * to their corresponding characters.
 * @param [string=''] (string): The string to unescape.
 */
var unescape = createEscaper(unescapeMap);

/**
 * Removes leading and trailing whitespace or specified characters from string.
 * @param (string): The string to trim.
 * @returns {XML|*|void|string}
 */
function trim() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return string.replace(/^\s+|\s+$/g, '');
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

/*
 * Helpers that help to determine type information.
 * */

var genTag = '[object GeneratorFunction]';
var funcTag = '[object Function]';
var objectToString = Object.prototype.toString;

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 */
function isUndefined(value) {
  return value === undefined;
}

/**
 * Checks if value is the language type of Object. (e.g. arrays, functions, objects, regexes, new Number(0), and new String(''))
 * @param value - object to test
 * @returns {boolean}
 */
var isObject = function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return !!value && (type == 'object' || type == 'function');
};

/**
 * Checks if value is a function
 * @param value - object to test
 * @returns {boolean}
 */
var isFunction = function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array constructors, and
  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
};


//# sourceMappingURL=pi-dash.mjs.map


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _uScope = __webpack_require__(78);

var _uScope2 = _interopRequireDefault(_uScope);

var _lbsPiDash = __webpack_require__(5);

var _pluginService = __webpack_require__(477);

var _eventChannel = __webpack_require__(311);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publicApi = {};

function tryRun(command) {
    var args = [].splice.call(arguments, 1);
    if (uScope && uScope[command]) {
        return uScope[command].apply(uScope, args);
    }
    return false;
}

// TODO: Not sure what to do with this singleton...
var uScope = void 0;

//............................................ navigateTo() public
//    navigateTo - This function positions the image(s) at the specified x,y,z and magnification.
//                        Note that magnification must be valid.
publicApi.navigateTo = function (imgSettings) {
    return tryRun('navigateTo', imgSettings);
};

//............................................ goToRegion() public
//    goToRegion - This function positions the image at a region and selects it.
//        The passed imageId must already be open.
// TODO: VIL should do this itself
publicApi.goToRegion = function (imageId, regionId) {
    uScope.events.trigger(_defines2.default.evREGIONSELECT, {
        imageId: imageId,
        regionId: regionId,
        bReposition: true,
        bSaveSel: false
    });
    return true;
};

//............................................ getImageState() public
//    getImageState - This function returns the state of uScope's images.
publicApi.getImageState = function () {
    return tryRun('getStateArray');
};

//............................................ resize() public
// resize - This function reconfigures the viewer to fit within its root div.
//    parameters:
//        e : optional, event data. When called by the container, no event is passed.
publicApi.resize = function (e) {
    if (e) {
        var sTargetClass = $(e.target).first().attr('class');
        if (sTargetClass) // because in FF, resize bubbles here first and then to resizables like the scaleBar
            return; // and that means that layout.refresh is called unnecessarily
    }

    return tryRun('resize'); // update root div position and dims
};

//............................................ imageUpdate() public
// imageUpdate - This function adds, removes, and replaces images in uScope.
//
//    usage:
//        imageUpdate("add", jsonSettings);                        adds a new view of the image specified in jsonSettings
//        imageUpdate("remove", jsonSettings);                    removes the view of the image specified in jsonSettings
//        imageUpdate("replace", jsonOrig, jsonSettingsNew);    replaces jsonOrig image with jsonSettingsNew image
//        imageUpdate("replace", jsonSettings);                    replaces the single unpinned image with the image specified in jsonSettings
//        imageUpdate("state", jsonStateChange);                changes the state (pinned, sampleType) of the image in jsonSettings
//
//    where:
//        jsonSettings and opt_jsonSettings are in image setting format
//            (image or images subset of settings into uScopeStart())
//
//        jsonStateChange image setting format for sampleTyle change
//            this will do:  { "imagePath": "@2", "sampleType": "positive", "isPinned": true}
//                where only those states that changed need be indicated
//
publicApi.imageUpdate = function (action, jsonSettings, opt_jsonSettings) {
    return tryRun('imageUpdate', action, jsonSettings, opt_jsonSettings);
};

//............................................ closeDialogs() public
// closeDialogs - This function closes all of uScope's dialogs.
publicApi.closeDialogs = function () {
    // always verify this works with Use Case: HC change from one case to another and back again
    var jPanels = $(document.body).find('.' + _defines2.default.clsPANEL); // all uscope panels have this class
    jPanels.each(function (index) {
        // Note: MUST use === true below: if you call dialog("isOpen") on an element that is not yet a dialog,
        //    it returns an object. In IE8, this is interpreted as true
        if ($(this).dialog('isOpen') === true) {
            $(this).dialog('close');
        }
    });
    jPanels.remove(); //remove all panels from the DOM
};

//............................................ lockDown() public
// lockDown - This function sets the viewer's state into /out-of  lock down mode.
publicApi.lockDown = function (on) {
    if (!uScope) {
        return;
    }
    uScope.setInLockDownMode(on);
};

//............................................ stop() public
//    stop - This function stops uScope by closing all images and all open dialogs.
//todo: should probably remove the toolbar
publicApi.stop = function () {
    if (!uScope) {
        return;
    }
    // ('uScopeStop called'); // eslint-disable-line no-undef
    uScope.destroy();
    publicApi.closeDialogs();
    uScope = undefined;
};

//............................................ start() public
//    start - This function starts up uScope.
//
publicApi.start = function (settings) {
    var images = (0, _lbsPiDash.get)(settings, 'images', []);
    var startupStatus = true;

    // Ensure uScope is a singleton, for now...
    if (uScope instanceof _uScope2.default) {
        return false;
    }

    uScope = new _uScope2.default(publicApi.events);

    startupStatus = startupStatus && uScope.init(settings);

    publicApi.events.trigger('lbs.uscope:start', uScope);

    if (startupStatus && images.length > 0) {
        startupStatus = uScope.imageUpdate('add', settings.images);
    }

    return startupStatus;
};

publicApi.getLegacyUScope = function () {
    return uScope;
};

// Add a global event channel (but don't let it bleed into the global space)
publicApi.events = new _eventChannel.EventChannel();

// Create and expose the plugin service
var plugins = new _pluginService.PluginService(publicApi.events);
/**
 * Expose the plugin system
 * @param plugin
 * @param options
 */
publicApi.use = function (plugin) {
    if (plugin.installed) {
        return;
    }

    for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
    }

    if (typeof plugin.install === 'function') {
        plugin.install.apply(plugin, options);
    } else if (typeof plugin === 'function') {
        plugin.apply(null, options);
    }

    plugins.register(plugin);

    plugin.installed = true;
};
publicApi.plugins = plugins;

exports.default = publicApi;
module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(46);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Point = __webpack_require__(107);

Object.defineProperty(exports, 'Point', {
  enumerable: true,
  get: function get() {
    return _Point.Point;
  }
});

var _Size = __webpack_require__(310);

Object.defineProperty(exports, 'Size', {
  enumerable: true,
  get: function get() {
    return _Size.Size;
  }
});

var _Rectangle = __webpack_require__(309);

Object.defineProperty(exports, 'Rectangle', {
  enumerable: true,
  get: function get() {
    return _Rectangle.Rectangle;
  }
});

var _BoundingBox = __webpack_require__(308);

Object.defineProperty(exports, 'BoundingBox', {
  enumerable: true,
  get: function get() {
    return _BoundingBox.BoundingBox;
  }
});

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(34);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(496);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(495);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(108);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(108);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.env = exports.resolveEnvironment = undefined;

var _slicedToArray2 = __webpack_require__(102);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _lbsPiDash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Polyfill for domnode.remove() (https://www.w3.org/TR/dom/#dom-childnode-remove)
 */
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

var resolveEnvironment = exports.resolveEnvironment = function resolveEnvironment(window) {
    var navigator = window.navigator;
    var document = window.document;

    var BROWSER_TEST_CASES = {
        Explorer: [/MSIE (\d+\.?\d+)/, /Trident.+rv:(\d+\.?\d+)/],
        Firefox: [/Firefox\/(\d+)/]
    };

    function getBrowserInfo() {
        var browser = '';
        var version = NaN;

        (0, _lbsPiDash.forEach)(BROWSER_TEST_CASES, function (tests, name) {
            tests.some(function (test) {
                var _ref = navigator.userAgent.match(test) || [],
                    _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                    v = _ref2[1];

                if (v) {
                    browser = name;
                    version = v;
                    return true;
                }
            });
        });

        return { browser: browser, version: version };
    }

    var OS_TEST_CASES = {
        iOS: [/iPad|iPhone|iPod/i]
    };

    function getOsInfo() {
        var os = '';
        (0, _lbsPiDash.forEach)(OS_TEST_CASES, function (tests, name) {
            tests.some(function (test) {
                if (test.test(navigator.userAgent)) {
                    os = name;
                    return true;
                }
            });
        });
        return os;
    }

    // Features
    var supportsCanvas = !!document.createElement('canvas').getContext;
    // Browser Info

    var _getBrowserInfo = getBrowserInfo(),
        browser = _getBrowserInfo.browser,
        version = _getBrowserInfo.version;

    var OS = getOsInfo();

    var isIE = browser.indexOf('Explorer') > -1;
    var isFirefox = browser.indexOf('Firefox') > -1;
    var isIEBelow9 = isIE && (isNaN(version) || version < 9);
    var isIOS = OS === 'iOS';

    return {
        supportsCanvas: supportsCanvas,
        isIE: isIE,
        isFirefox: isFirefox,
        isIEBelow9: isIEBelow9,
        isIOS: isIOS
    };
};

var env = exports.env = resolveEnvironment(window);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Toolbar = Toolbar;
exports.openTextEditPanel = openTextEditPanel;
exports.setIconState = setIconState;
exports.genericMessage = genericMessage;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _browserCompatibility = __webpack_require__(26);

var _events = __webpack_require__(31);

var _uScope = __webpack_require__(78);

var _uScope2 = _interopRequireDefault(_uScope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 This file creates the toolbar for uscope, creates the settings panel, and other panels and handles their events.

 The "main" toolbar contains the feature access buttons and settings.  It is positioned below
 the selected image's toolbar.
 */

function Toolbar(uScope) {
    var self = this;
    var jtoolbar;

    //............................................ position() public
    //    position - This function positions the main toolbar on the selected image.
    this.position = function (crOffset) {
        if (crOffset == undefined) jtoolbar.css({ 'left': '2px', 'top': '2px' });else jtoolbar.css({ 'left': crOffset.x + 'px', 'top': crOffset.y + crOffset.h + 'px' });
    };
    //............................................ bindEvents_() local
    // bindEvents_ - This function adds the autopan event handlers.
    //
    //    Note that an exception is made here and the namespace is not an image's namespace.

    var bindEvents_ = function bindEvents_() {
        var namespace = '.autopan';
        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.idTBRESIZE + '-e', function (e) {
            (0, _events.triggerUScopeEvent)(_defines2.default.evRESIZECLICK, {});
            return false;
        });

        if (_browserCompatibility.env.isIOS) {
            $(_defines2.default.idHashROOT).on('touchstart' + namespace, '.' + _defines2.default.idTBRESIZE + '-e', function (e) {
                (0, _events.triggerUScopeEvent)(_defines2.default.evRESIZECLICK, {});
                return false;
            });
        }

        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.idTBMULTIVIEW + '-4' // multi image arrangement button
        + ',.' + _defines2.default.idTBMULTIVIEW + '-v' + ',.' + _defines2.default.idTBMULTIVIEW + '-h', function (e) {
            if (uScope.getImageCount() > 1) uScope.imageArrange(true);
            return false;
        });
    };
    //............................................ init_() local
    //    init_ = This function creates the toolbar, sizes it and adds its event handlers.
    var init_ = function init_() {
        var settingsButton;

        jtoolbar = $(_defines2.default.idHashROOT).find('#' + _defines2.default.idTOPTOOLBARV); // if the toolbar already exists, remove it
        if (jtoolbar.length) jtoolbar.remove();
        jtoolbar = $('<div/>', { // build the toolbar div tag
            'id': _defines2.default.idTOPTOOLBARV,
            'class': _defines2.default.clsSUPEROVERLAY + ' ' + _defines2.default.clsTRANSPARENT,
            'title': 'Click to AutoPan Up, Click Again to Stop AutoPan'
        });

        if (_defines2.default.SHOWALLTOOLBARICONS || uScope.toolbarCanAddButton('resizeBtn')) // if there's intent to show the button
            jtoolbar.append($('<a/>', {
                'id': _defines2.default.idTBRESIZE,
                'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.idTBRESIZE + '-e',
                'title': 'Resize the image viewer'
            }));

        // multi-image arangement
        jtoolbar.append($('<a/>', {
            'id': _defines2.default.idTBMULTIVIEW,
            'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.idTBMULTIVIEW + '-4',
            'title': 'Change image tiling pattern'
        }));

        settingsButton = $('<a/>', {
            'id': _defines2.default.TBSETTINGS,
            'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.TBSETTINGS + '-e',
            'title': 'Open the settings panel'
        });
        jtoolbar.append(settingsButton);

        $(_defines2.default.idHashROOT).append(jtoolbar); // append the toolbar to the root node
        self.position();

        // Expose the ability to add a button externally
        self.addButton = function (button) {
            return $(button).insertBefore(settingsButton);
        };

        bindEvents_();
    };

    init_();
}

// Text Editor dialog, randomly placed inside the toolbar file...
var $textEditPanel = void 0,
    $textEditForm = void 0,
    lastCursorPosition = void 0,
    lastCallback = void 0;
var createTextEditPanel = function createTextEditPanel(initialText) {
    $textEditPanel = $('<div/>', { 'id': _defines2.default.idTEXTEDITPANEL, 'class': _defines2.default.clsPANEL });

    $textEditForm = $('<textarea />').val(initialText).css('resize', 'none').width(_defines2.default.textEditSpecs.width - 30).height(_defines2.default.textEditSpecs.height - 120);

    $textEditPanel.append($textEditForm);

    $textEditPanel.dialog({
        autoOpen: false,
        draggable: true,
        resizable: false,
        stack: true,
        modal: true,
        width: _defines2.default.textEditSpecs.width,
        minWidth: _defines2.default.textEditSpecs.width,
        height: _defines2.default.textEditSpecs.height,
        minHeight: _defines2.default.textEditSpecs.height,
        dialogClass: 'uscope-dialog dialogMover',
        buttons: [{
            text: 'Cancel',
            click: function click() {
                $textEditPanel.find('textarea').val(''); // clear text and close
                $textEditPanel.dialog('close');
                lastCallback(lastCursorPosition);
            }
        }, {
            text: 'Ok',
            click: function click() {
                var jtext = $textEditPanel.find('textarea');
                var outText = $(jtext).val();
                jtext.val(''); // clear text and close
                $textEditPanel.dialog('close');
                lastCallback(lastCursorPosition, outText);
            }
        }],
        resize: function resize(event, ui) {
            // TODO: Is this function used?
            var w = $textEditPanel.width() - 10;
            var h = $textEditPanel.height() - 10;
            $textEditForm.width(w);
            $textEditForm.height(h);
        },

        // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
        // (would normally want it appended to the uscope div)
        appendTo: 'body'
    });
};
function openTextEditPanel(title) {
    var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var callback = arguments[2];
    var cursorPosition = arguments[3];

    if (!_uScope2.default.instance.isThisImageValid()) {
        return;
    }
    var hotKeyState = _defines2.default.ENABLEDEVHOTKEYS;
    if (hotKeyState) {
        _defines2.default.ENABLEDEVHOTKEYS = false;
    }

    if (!$textEditPanel) {
        createTextEditPanel(text);
    } else {
        $textEditForm.val(text);
    }

    lastCallback = function lastCallback() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        _defines2.default.ENABLEDEVHOTKEYS = hotKeyState;
        callback && callback.apply(null, args);
    };
    lastCursorPosition = cursorPosition;
    $textEditPanel.dialog('option', 'title', title);

    $textEditPanel.dialog('open');
}

//-------------------------------------------------------------------------------------------------
//    ICON MANAGEMENT
//-------------------------------------------------------------------------------------------------
//............................................ setIconState
//    setIconState - This function sets an icon to its active, enabled or disabled state
//            OR sets the muti-image icon to one of its 3 possible states.
//
//        Note that it depends upon the css class naming convention:
//            classRoot-e - defines icon for enabled state
//            classRoot-d - defines icon for disabled state
//            classRoot-a - defines icon for active state
//
function setIconState(jContainer, classRoot, state) {
    if (state == 'active') // most toolbar icon states
        jContainer.addClass(classRoot + '-a').removeClass(classRoot + '-e').removeClass(classRoot + '-d');else if (state == 'enabled') jContainer.addClass(classRoot + '-e').removeClass(classRoot + '-a').removeClass(classRoot + '-d');else if (state == 'disabled') jContainer.addClass(classRoot + '-d').removeClass(classRoot + '-e').removeClass(classRoot + '-a');else if (state == 't') //multi image icon states
        jContainer.addClass(classRoot + '-4').removeClass(classRoot + '-v').removeClass(classRoot + '-h').removeClass(classRoot + '-d');else if (state == 'v') jContainer.addClass(classRoot + '-v').removeClass(classRoot + '-4').removeClass(classRoot + '-h').removeClass(classRoot + '-d');else if (state == 'h') jContainer.addClass(classRoot + '-h').removeClass(classRoot + '-4').removeClass(classRoot + '-v').removeClass(classRoot + '-d');else if (state == 'd' || state == '1' || state == '4') jContainer.addClass(classRoot + '-d').removeClass(classRoot + '-h').removeClass(classRoot + '-v').removeClass(classRoot + '-4');else return;
}

//-------------------------------------------------------------------------------------------------
//    DIALOG HELPER METHODS
//-------------------------------------------------------------------------------------------------

//............................................ genericMessage
//    genericMessage - A general purpose message panel that removes itself from the DOM when closed.
//
//    parameters:
//        message:        required, string, your message to the user
//        title:            optional, string, default "Notice"
//
function genericMessage(message, title) {
    if (message == undefined) message = '';
    title = title != undefined ? title : 'Notice';

    var jPanel = $('<div id=' + _defines2.default.idMSGPANEL + ' title="' + title + '">' + message + '</div>');
    $(_defines2.default.idHashROOT).append(jPanel); // add the panel to the root

    $(jPanel).dialog({
        autoOpen: true,
        modal: true,
        closeOnEscape: false,
        resizable: false,
        dialogClass: 'uscope-dialog dialogMover',
        close: function close(event, ui) {
            $(this).remove();
        },
        buttons: [{
            text: 'OK', click: function click() {
                $(this).remove();
            }
        }]
    });

    // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
    //    (would normally want it appended to the uscope div)
    // note that the dialog is the parent to the panel created
    $('#' + _defines2.default.idMSGPANEL).parent().appendTo('body');
}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.triggerUScopeEvent = triggerUScopeEvent;

var _lbsPiDash = __webpack_require__(5);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _uScope = __webpack_require__(78);

var _uScope2 = _interopRequireDefault(_uScope);

var _navigation = __webpack_require__(314);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// events.js
// This file contains event handlers for uScope including user events, developement events, and keystroke events.
//
//
//    history
//    1106    cperz        created
//
//    _______________________________________end_AIHv1/PR __________________________________________
//    141118    cperz        added annotation hot keys control v, control c and control m
//    150728  cboarman    added Gecko (FF) keycodes for plus/minus keys
//________________________________________________________________________________________________
$(document).ready(function () {
    //............................................ iOS touch events
    // mouse down, click work in iOS on overlay elements
    document.ontouchstart = function (e) {
        if (!_uScope2.default.instance.isThisImageValid()) return; // if opened with no image, do not respond
        var thisImg = _uScope2.default.instance.getThisImage();
        //dbg-only document.title = "ontouchstart: navMode: " + thisImg.navModeGet();
        if (thisImg.navModeGet() != _defines2.default.eNavModes.nmNone) return;

        var overObj = String(document.elementFromPoint(e.pageX, e.pageY).className);

        // instead of viewport the raphael paper object is the target
        // but sometimes the annot div is hidden the tile itself is touched
        if (overObj.indexOf('SVGAnimatedString') != -1 || overObj.indexOf('us-tile-container') != -1) {
            e.preventDefault();
            (0, _navigation.vp_mousedown)(thisImg, e, _defines2.default.TOUCHEVENT);
            return false;
        }
        // for reasons unknown, the edgediv overlay and the top toolbar overlay do not get bubbled click or mousedown events
        // so capture the event here and start autopan
        else if (overObj.indexOf(_defines2.default.clsEDGEDIV) != -1 || String(document.elementFromPoint(e.pageX, e.pageY).id) == _defines2.default.idTOPTOOLBARV) {
                thisImg.autoPan.onOffToggle();
                //    vpAutoPan(thisImg);
                return false;
            }
        return true; // permit bubbling of event to thumbnail, dialogs, etc.
    };
    document.ontouchmove = (0, _lbsPiDash.throttle)(function (e) {
        var elem = document.elementFromPoint(e.pageX, e.pageY);
        if ($(elem).closest(_defines2.default.idHashROOT).length == 0) {
            // touch is not in uScope, ignore it
            return true;
        }
        if (!_uScope2.default.instance.isThisImageValid()) return;
        var thisImg = _uScope2.default.instance.getThisImage();

        e.preventDefault();
        (0, _navigation.vp_mousemove)(thisImg, e, _defines2.default.TOUCHEVENT);
        return false;
    }, _defines2.default.kREFRESH_RATE);
    document.ontouchend = function (e) {
        // iOS equivalent to mouse up
        if (!_uScope2.default.instance.isThisImageValid()) return;
        var viewport = _uScope2.default.instance.getThisImage();

        if (viewport.navModeGet() == _defines2.default.eNavModes.nmDragImage) {
            // if dragging the image which starts with one touch, check if a double click occurred
            e.preventDefault();
            var now = new Date().getTime(); // double click event check
            var lastTouch = $(this).attr('lastTouch') || now + 1;
            //amnvar lastTouch = $(this).data('lastTouch') || now + 1;
            var delta = now - lastTouch;
            if (delta < 300 && delta > 0) {
                // if the second touchend event happened within a certain dtime, it's a double click
                viewport.navModeSwitch(_defines2.default.eNavModes.nmNone); // set nav mode back to none TODO Not navModeHalt()?
                (0, _navigation.vp_mousedclick)(viewport, e, _defines2.default.TOUCHEVENT);
                return false;
            }
            //amn$(this).data('lastTouch', now);             // save the time of the last touch
            $(this).attr('lastTouch', now); // save the time of the last touch
        }

        // for reasons unknown, the edgediv overlay and the top toolbar overlay do not get bubbled click or mousedown events
        // so capture the event here and stop autopan
        else if (viewport.navModeGet() == _defines2.default.eNavModes.nmAutoPan) {
                viewport.autoPan.onOffToggle();
                return false;
            }
        //
        if (viewport.navModeGet() == _defines2.default.eNavModes.nmDragImage || viewport.navModeGet() == _defines2.default.eNavModes.nmPinchZoom) {
            (0, _navigation.vp_mouseup)(viewport, e, _defines2.default.TOUCHEVENT); //
            e.preventDefault();
            return false;
        }

        return true; // permit bubbling of event to thumbnail, dialogs, etc.
    };
});

//-------------------------------------------------------------------------------------------------
//    TRIGGERS
//-------------------------------------------------------------------------------------------------
//............................................ triggerUScopeEvent
// triggerUScopeEvent - This function fires the passed event with the passed parameters.
function triggerUScopeEvent(evName, parms) {
    $(_defines2.default.idHashROOT).trigger(evName, parms);
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(140)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(13)
  , IE8_DOM_DEFINE = __webpack_require__(316)
  , toPrimitive    = __webpack_require__(168)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(32) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(33)
  , createDesc = __webpack_require__(142);
module.exports = __webpack_require__(32) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(7)
  , core      = __webpack_require__(12)
  , ctx       = __webpack_require__(19)
  , hide      = __webpack_require__(35)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(33).f
  , has = __webpack_require__(84)
  , TAG = __webpack_require__(3)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(519)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(317)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(524);
var global        = __webpack_require__(7)
  , hide          = __webpack_require__(35)
  , Iterators     = __webpack_require__(47)
  , TO_STRING_TAG = __webpack_require__(3)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = UScopeViewer;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _toolbar = __webpack_require__(27);

var _browserCompatibility = __webpack_require__(26);

var _objects = __webpack_require__(16);

var _viewportAP = __webpack_require__(491);

var _viewportAP2 = _interopRequireDefault(_viewportAP);

var _viewLayout = __webpack_require__(490);

var _viewLayout2 = _interopRequireDefault(_viewLayout);

var _Size = __webpack_require__(310);

var _events = __webpack_require__(31);

var _userPreferences = __webpack_require__(486);

var _userPreferences2 = _interopRequireDefault(_userPreferences);

var _helpers = __webpack_require__(4);

var _lbsPiDash = __webpack_require__(5);

var _notificationService = __webpack_require__(476);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 ________________________________________________________________________________________________
 This file contains the application uScope's primary object, also called self.
 Public functions in the uScope object are called by components within the uScope application
 and by those functions isolated in the file public-api.js which is the exposed interface to
 the application's parent.

 Coding conventions: see Google JavaScript Style Guide
 declare primary objects as cXxxxxxxx (lowercase c, Uppercase first letter of object name)
 use var xx = [] instead of var xx = []
 add var to loop vars: for (var i=0; i<10; i++)
 place open bracket on the same line as the statement, e.g. if (x) {
 place open bracket on the same line as the function declaration, e.g. function xx () {
 use if (xxx == false) instead of if(!xxx) for clarity; same for true
 declare closure functions this way, function f() { ... }, so they can be defined at the bottom of the parent fn
 literally '//............................................ functionName' precedes fn declarations - this makes searched for fn easy to find

 Legacy Naming conventions (to be phased out in favor of modern best-practices):
 instead of this.fnname use the group name as specified at the beginning of the cUScope object (below)
 use var xxx_ for local vars and local functions (trailing underscore)
 jxxx is a jquery object
 naming convention for constants: kDESC, start with a k for "konstant", use capitals for description

 consistent var names: PLEASE ALWAYS USE THEM so search returns useful results
 thisImg is used as a reference to a cViewport object.
 - get it this way: var thisImg = self.getThisImage();
 jVpDiv is used as the jquery object of the selected viewport div.
 - get it this way: var jVpDiv = this.vpDivGet(); or var jVpDiv = thisImg.vpDivGet();
 - get it this way: var anObj = thisImg.getAnnotObj();
 */

/*
 Object Name: uScope
 Overview: The uScope object creates and manages the layout of viewport divs and their
 associated viewport objects which manage the displayed images.

 Associated Panel: none

 Dependencies and Supporting objects:
 o cViewLayout
 o cViewport
 o UserPreferences
 o todo: list panels and toolbars
 o Point, Size, Rectangle

 Assumptions: o todo

 Limitations:
 o Duplicate Image:
 The current design does NOT support the same image open more than once.
 If that is to change the following must be done.  (Many of these items are in-work or complete.)
 - the viewport div ids must include a unique id beyond the imageId, like the image index
 - the namespace of event handlers must also include something unique
 - find by id, and other such searches, need to be reviewed
 - compare index not id

 Terms Used: o todo

 Functionality: o todo

 Data Structures:
 o images_ is an array containing references to valid, opened image viewports
 o rootRect_ is the uScope div position and dimensions in a Rectangle object

 HTML:
 The uScope parent div is created outside of uScope and its ID is passed into uScope in uScopeStart().
 uScope creates a viewLayout div and populates it with the viewport divs in buildVPDiv_().

 References: o none

 UScopeViewer - This object contains and maintains the state variables for the uScope viewer configuration.
 */
function UScopeViewer(eventChannel) {
    // Expose the global uScope instance. TODO - There's no business requirement for a single uscope instance. Refactor.
    if (UScopeViewer.instance) {
        throw new Error('uScope Error: There can be only one.');
    }
    UScopeViewer.instance = this;

    var initStatus = true;
    var self = this;

    // ..... to group fns in js parser, for ease of search (e.g. search for all 'USCOPE_INQUIRY')
    var USCOPE_EXTERNAL_INTERFACE = this; // public group of fns allowed to be called external to uScope (from file public-api.js)
    var USCOPE_IMAGE = this; // public group of fns related to open images
    var USCOPE_INQUIRY = this; // public group of inquiry fns
    var USCOPE_GET = this; // public group of get fns
    var USCOPE_SET = this; // public group of set fns
    var USCOPE_PREFS = this; // public group of fns related to user preferences
    var USCOPE_OVERLAY = this; // public group of fns related to overlays

    var progName = 'uScope';

    // The following constants are injected by WebPack during the build process.
    var progDate = "Fri Jan 19 2018"; // eslint-disable-line no-undef
    var progVersion = "1.5.6"; // eslint-disable-line no-undef

    USCOPE_GET.getProgName = function () {
        return progName;
    };
    USCOPE_GET.getProgVersion = function () {
        return progVersion;
    };
    USCOPE_GET.getProgDate = function () {
        return progDate;
    };
    USCOPE_GET.about = function () {
        return self.getProgName() + ' ' + self.getProgVersion() + ' ' + self.getProgDate();
    };

    //............................................ construct_() local
    var construct_ = function construct_() {
        // HACK ALERT - extend uScope with conferencing methods. Don't want to break existing implementations.
        // These methods are provided in case the conferencing module is not included in the WV build or if
        // the user simply doesn't have rights to start a conference.
        // TODO: Refactor this out of uScope.
        self.isConfLeader = self.isModeConference = self.isConfMember = function () {
            return false;
        };

        // (self.about()); // eslint-disable-line no-undef
    };

    // initialization vars .................................
    var createdBy = void 0; // parent/creator application name
    var userName = void 0; // user's login or full name (!not loginName used in dev mode!)
    var userId = void 0; // user's id (database table 'users')
    var title = void 0; // start up title // not implemented
    USCOPE_GET.getUserName = function () {
        return userName;
    };
    USCOPE_SET.setUserName = function (newName) {
        userName = newName;
    };
    USCOPE_GET.getUserId = function () {
        return userId;
    };
    USCOPE_GET.getCreatedBy = function () {
        return createdBy;
    };

    //............................................................................................
    // image/viewport container
    //............................................................................................
    var viewLayout_; // object to implement jquery layout plugin

    var images_ = []; // array of image/cViewport objects in view
    var imageSelIdx_ = 0; // index of image with focus
    var imageCountFromStart_ = 0; // count of number of images ever opened since uscopestart

    //toconsider: I'd like to remove this array - need to replace dependency on getfullurl and the like
    var imageInitState_ = []; // array of image initial state

    //............................................ imageListReport() public
    // imageListReport - This function logs information about the open images.
    USCOPE_IMAGE.imageListReport = function () {
        // debug use
        // ('uScope Image List: count: ' + self.getImageCount() + '  imageSelIdx_: ' + imageSelIdx_); // eslint-disable-line no-undef
        for (var i = 0, len = images_.length; i < len; i++) {
            var thisImg = images_[i];
            if (thisImg == undefined) {
                // ('image idx: ' + i + ' is empty'); // eslint-disable-line no-undef
            } else {
                // ('image idx: ' + i + ' contains imageId: ' + thisImg.getImageId()); // eslint-disable-line no-undef
            }
        }
    };
    //............................................ getImageCount() public
    // getImageCount - This function returns the open image count.
    USCOPE_IMAGE.getImageCount = function () {
        for (var i = 0, count = 0, len = images_.length; i < len; i++) {
            if (images_[i] != undefined) count++;
        }return count;
    };

    USCOPE_IMAGE.getImageCountFromStart = function () {
        return imageCountFromStart_;
    };

    //............................................................................................
    // image selection functions
    //............................................................................................

    //............................................ getThisImage() public
    //    getThisImage - This function returns a reference to the currently selected image or undefined.
    USCOPE_IMAGE.getThisImage = function (idx) {
        return idx == undefined ? images_[imageSelIdx_] : images_[idx];
    };

    //............................................ getThisImageById() public
    //    getThisImageById - This function searches the images_ array for the passed imageId.
    //                It returns the image object or return -1 if the imageId is not in images_[].
    USCOPE_IMAGE.getThisImageById = function (imageId) {
        // imageId includes @ sign, e.g.'@2'
        var idx = findImageIdx_(imageId);
        return idx < 0 ? undefined : images_[idx];
    };

    //............................................ getSelImageIdx() public
    //    getSelImageIdx -  This function returns the currently selected image index.
    USCOPE_IMAGE.getSelImageIdx = function () {
        return imageSelIdx_;
    };

    //............................................ getSelImageId() public
    //    getSelImageId -  This function returns the currently selected imageId or -1
    USCOPE_IMAGE.getSelImageId = function () {
        return images_[imageSelIdx_] ? images_[imageSelIdx_].getImageId() : -1;
    };

    USCOPE_IMAGE.getAllImages = function () {
        return images_;
    };

    //............................................ setImageSelected() public
    //    setImageSelected -  This function selects the image related to the passed index.
    //    If that image is already selected, the selection is not made unless the optional force
    //    parameter is true.
    USCOPE_IMAGE.setImageSelected = function (idx, opt_bForce) {
        // note index is used b/c could have same image id open multiple places
        if (idx !== imageSelIdx_ || opt_bForce == true) {
            var state = imageInitState_[idx];
            if (!state) {
                // ('Attempted to select out of bounds viewport!'); // eslint-disable-line no-undef
                return;
            }
            imageSelIdx_ = idx;
            (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGESELECTED, {
                imageId: state.imageId,
                uScopeIdx: imageSelIdx_
            });
            images_[idx].setImageSelected();
            self.events.trigger('uscope:viewport:selected', self);
        }
    };
    //............................................ setImageNextSelected() public
    //    setImageNextSelected -  This function selects the next image in image list.
    // todo: it doesn't really do what it says it does... check out what is desired
    USCOPE_IMAGE.setImageNextSelected = function (idx) {
        if (imageSelIdx_ == idx) {
            imageSelIdx_ = -1;
            for (var i = 0; i < images_.length; i++) {
                if (images_[i] != undefined) {
                    self.setImageSelected(i);
                    return;
                }
            }
        }
    };
    //............................................ isThisImageValid() public
    //    isThisImageValid - This function returns true if the currently selected image is valid and false otherwise.
    USCOPE_IMAGE.isThisImageValid = function () {
        //todo: rename to isSelectedImageValid
        return !!images_[imageSelIdx_];
    };

    // This appears to be used by IA simple and IA Macro. Removing for now.
    /*
     USCOPE_IMAGE.isThisImageAnnotReady = function () {
     if (isDefined(images_[imageSelIdx_])) {
     var anObj = images_[imageSelIdx_].getAnnotObj();
     return (anObj && anObj.isInitialized) ? true : false;
     }
     return false;
     };
     */

    //    isThisImageValid - This function returns true if the passed image ID is open and false otherwise.
    USCOPE_IMAGE.isThisImageIdValid = function (imageId) {
        for (var i = 0, len = images_.length; i < len; i++) {
            if (images_[i] != undefined) {
                var thisId = images_[i].getImageId();
                if (imageId == thisId) return true;
            }
        }
        return false;
    };

    //............................................ findImageIdx_() local
    // findImageIdx_ - This function searches the images_ array for the passed imageId.
    //                It returns the index to the image with this imageId or return -1 if the imageId is not in images_[].
    var findImageIdx_ = function findImageIdx_(imageId) {
        for (var i = 0; i < images_.length; i++) {
            if (images_[i] != undefined) {
                var aImageId = images_[i].getImageId();
                if (aImageId == imageId) return i;
            }
        }
        return -1;
    };
    //............................................................................................
    // toolbar options from VIL
    //............................................................................................
    //............................................ toolbarCanAddButton() public
    USCOPE_INQUIRY.toolbarCanAddButton = function (tbOptionName) {
        if (self.vilSettings && self.vilSettings.toolbarOptions && self.vilSettings.toolbarOptions[tbOptionName]) return self.vilSettings.toolbarOptions[tbOptionName];else return false;
    };
    USCOPE_INQUIRY.getSetting = function (path) {
        return (0, _lbsPiDash.get)(self.vilSettings, path);
    };

    //............................................................................................
    // mode related vars & functions
    //............................................................................................
    var inDevMode = false; // flag indicating developement mode
    USCOPE_INQUIRY.isModeDev = function () {
        return inDevMode;
    }; // development mode indication - necessary for unit tests
    USCOPE_SET.setInDevMode = function (dev) {
        inDevMode = dev;
    };

    var inLockDownMode = false; // flag indicating lock down mode
    var annotDrawB4LD = true; // the state of annotation draw before lockdown is on
    //............................................ isModeLockDown() public
    //    isModeLockDown - This function returns true if uScope is in lock down mode and false otherwise.
    USCOPE_INQUIRY.isModeLockDown = function () {
        return inLockDownMode;
    }; // is in Lock Down mode?

    //............................................ setInLockDownMode() public
    //    setInLockDownMode - This function sets uScope into or out of lock down mode.
    //    In lock down mode drawing of annotations is disabled.
    USCOPE_EXTERNAL_INTERFACE.setInLockDownMode = function (enable) {
        // switch into/out-of lock down mode
        if (enable && !inLockDownMode) {
            inLockDownMode = true;
            if (self.annotPanel) self.annotPanel.enableDrawingIcons(self.canAnnotate());
        } else if (!enable && inLockDownMode) {
            inLockDownMode = false;
            if (self.annotPanel) self.annotPanel.enableDrawingIcons(self.canAnnotate());
        }
    };

    //............................................ canSaveAnnotations() public
    //    canSaveAnnotations - This function returns true if uScope can save annotations and false otherwise.
    USCOPE_INQUIRY.canSaveAnnotations = function () {
        // can save annotations?
        return _defines2.default.ENABLEAUTOANNOTSAVE ? true : false;
    };
    //............................................................................................
    // user rights related
    //............................................................................................

    //............................................ canAnnotate() public
    // canAnnotate - This function report if an annotation can be created.
    // Note that the 'saveAnnotations' option is a user right and means the user can view but not create annotations
    USCOPE_INQUIRY.canAnnotate = function () {
        // can create annotations?
        // TODO: refactor to allow uScope to be put into some kind of "read only" mode, decoupling the need for
        // TODO: annotations to know anything about conferencing, or vice-versa
        var thisImgCan = imageSelIdx_ >= 0 && imageInitState_[imageSelIdx_] ? // can the selected image create annots? (user rights)
        imageInitState_[imageSelIdx_].saveAnnotations : false;

        return !!(self.isModeLockDown() == false && // lockdown or conferencing mode disables annot creation
        self.isModeConference() == false && thisImgCan == true && _defines2.default.ENABLEANNOTCREATE == true);
    };
    //............................................ canViewLabel() public
    USCOPE_INQUIRY.canViewLabel = function () {
        return _defines2.default.ENABLELABEL ? true : false;
    }; // can view label? note this is a user right
    //............................................ canSaveMacro() public
    USCOPE_INQUIRY.canSaveMacro = function () {
        return true;
    }; // can saveMacro? note this is a user right
    //............................................ canRunAnalysis() public
    USCOPE_INQUIRY.canRunAnalysis = function () {
        return true;
    }; // can run analysis? note this is a user right

    //............................................................................................
    // miscellaneous functions
    //............................................................................................

    //............................................ overlayRefresh public
    //    overlayRefresh - This function refreshes the overlays on all images.
    USCOPE_OVERLAY.overlayRefresh = function () {
        for (var i = 0; i < images_.length; i++) {
            var thisImg = images_[i];
            if (thisImg && thisImg.overLayout) thisImg.overLayout.refresh();
        }
    };
    //............................................ memoryUsage public
    // memoryUsage - This function returns the memory usage of uScope in MBytes.
    //                Note- I don't think it is accurate!
    USCOPE_INQUIRY.memoryUsage = function () {
        return ($(_defines2.default.idHashROOT).html().length / 1024 / 1024).toFixed(3);
    };

    //............................................................................................
    // credentials functions
    //............................................................................................
    // access to credentials ...............................
    // - this is necessary to initialize an image/cViewport so even though each image stores its own credentials
    // the uScope object maintains its own quick reference, unfortunately

    //toconsider: query the images themselves so imageInitState_ can be eliminated whe conferencing moves to VIL
    USCOPE_GET.getFullURL = function () {
        return imageInitState_[imageSelIdx_] ? imageInitState_[imageSelIdx_].fullURL : undefined;
    };
    USCOPE_GET.getServer = function () {
        return imageInitState_[imageSelIdx_] ? imageInitState_[imageSelIdx_].server : undefined;
    };
    USCOPE_GET.getToken = function () {
        if (self.isModeDev() == true) return imageInitState_[imageSelIdx_] ? imageInitState_[imageSelIdx_].token : undefined;
        return undefined;
    };
    USCOPE_GET.getImageId = function () {
        return imageInitState_[imageSelIdx_] ? imageInitState_[imageSelIdx_].imageId : undefined;
    };
    USCOPE_GET.isConnectedViaApache = function () {
        if (imageInitState_[imageSelIdx_] != undefined) return imageInitState_[imageSelIdx_].server.indexOf('imageserver') != -1;else return undefined;
    };

    // stand alone development credentials .................
    // - use setLoginName() and setPassword() prior to uScopeStart() in test harnesses
    var loginName;
    var password;
    USCOPE_GET.getLoginName = function () {
        return loginName;
    };
    USCOPE_SET.setLoginName = function (lNname) {
        loginName = lNname;
    };
    USCOPE_GET.getPassword = function () {
        return password;
    };
    USCOPE_SET.setPassword = function (pWord) {
        password = pWord;
    };

    //............................................................................................
    // input settings management
    //............................................................................................

    //............................................ parseVILSettings() public
    // parseVILSettings() - This fuction parses the passed JSON formatted parameters...
    var parseVILSettings = function parseVILSettings(settings) {
        self.vilSettings = (0, _lbsPiDash.clone)(settings);
        var vilSettings = self.vilSettings;
        var status = true;

        if (vilSettings.setup && vilSettings.setup.inDevMode) {
            inDevMode = true;
        }

        enforceBrowserDependentSettings();

        if (inDevMode == false) {
            // insure that these dev mode options are not active if not in dev mode
            _defines2.default.ENABLEDEVHOTKEYS = false;
            _defines2.default.DISABLEOVERLAYITEMS = false;
            _defines2.default.DISABLEEXTERNALCALLBACKS = false;
            _defines2.default.SHOWALLTOOLBARICONS = false;
            _defines2.default.DISABLEUSERPREFS2DB = false;
            _defines2.default.DBGZMBTNPYRAMID = false;
        } else {
            if (_defines2.default.DISABLEOVERLAYITEMS == true) _defines2.default.ENABLELABEL = _defines2.default.ENABLEMAG = _defines2.default.ENABLETHUMB = _defines2.default.ENABLESCALEBAR = _defines2.default.ENABLEZOOMCTL = _defines2.default.ENABLEROTATION = false;
        }

        // settings.setup ................................
        if (vilSettings.setup) {
            _defines2.default.idROOT = vilSettings.setup.divId || _defines2.default.idROOT;
            _defines2.default.idHashROOT = '#' + _defines2.default.idROOT;
            $(_defines2.default.idHashROOT).addClass(_defines2.default.clsROOTSTYLE);

            userName = userName || vilSettings.setup.userName;
            userId = Number(userId || vilSettings.setup.userid);
            createdBy = createdBy || vilSettings.setup.createdBy;
            title = title || vilSettings.setup.title;
        }
        if ((0, _helpers.isUnDefined)(userName) || userName.length == 0) // default user name
            userName = 'DefaultUser';
        if (userId === 0 || isNaN(userId)) userId = -1; // invalidate user id - prevents calls depending upon it from executing
        if ((0, _helpers.isUnDefined)(createdBy) || createdBy.length == 0) createdBy = 'unspecified creator';

        // settings.overlays .............................
        if (vilSettings.overlays.none) {
            // if disable all overlays
            _defines2.default.ENABLELABEL = _defines2.default.ENABLEMAG = _defines2.default.ENABLETHUMB = _defines2.default.ENABLESCALEBAR = _defines2.default.ENABLEZOOMCTL = _defines2.default.ENABLEHEATMAP = _defines2.default.ENABLEROTATION = false;
            //note-I don't think this should disable the toolbar us.ENABLETOOLBAR =
        } else {
            // else enable/disable specific overlays
            _defines2.default.ENABLELABEL = _defines2.default.ENABLELABEL || vilSettings.overlays.label;
            _defines2.default.ENABLEMAG = _defines2.default.ENABLEMAG || vilSettings.overlays.magnifier;
            _defines2.default.ENABLETHUMB = _defines2.default.ENABLETHUMB || vilSettings.overlays.thumbnail;
            _defines2.default.ENABLESCALEBAR = _defines2.default.ENABLESCALEBAR || vilSettings.overlays.scalebar;
            _defines2.default.ENABLEZOOMCTL = _defines2.default.ENABLEZOOMCTL || vilSettings.overlays.zoombar;
            _defines2.default.ENABLEROTATION = _defines2.default.ENABLEROTATION || vilSettings.overlays.rotation;
            _defines2.default.ENABLEHEATMAP = _defines2.default.ENABLEHEATMAP || vilSettings.overlays.heatMap;
        }

        // settings.features .............................
        if (settings.features) {
            _defines2.default.ENABLEAUTOANNOTSAVE = _defines2.default.ENABLEAUTOANNOTSAVE || vilSettings.features.annotAutoSaveEnabled;
            _defines2.default.ENABLELINKTOIMAGE = _defines2.default.ENABLELINKTOIMAGE || vilSettings.features.linkToImage;
            _defines2.default.ENABLERUNANALYSIS = _defines2.default.ENABLERUNANALYSIS || vilSettings.features.runAnalysis;
        }
        // settings.iapanels .............................
        if (settings.iapanels == undefined || settings.iapanels.panels == undefined || settings.iapanels.panels.length == 0) {
            // if no iapanels are specified, disable the imageAnalysis button
            self.vilSettings.toolbarOptions['imageAnalysis'] = false;
        }

        return status;
    };
    //............................................................................................
    // plugin and VIL interface helper functions
    //............................................................................................

    //............................................ getImageInfo() public
    // getImageInfo() - This function returns json of static information about the open image(s).
    //todo: add sample type, pinned, ....
    USCOPE_IMAGE.getImageInfo = function () {
        var imageJson;
        var imgSettings = []; // array of imageJson
        for (var i = 0; i < images_.length; i++) {
            var thisImg = images_[i];
            if (thisImg != undefined) {
                imageJson = {
                    'imagePath': thisImg.getImageId(), 'fullURL': thisImg.getFullURL(),
                    'baseMag': thisImg.getBaseMag(), 'baseMPP': thisImg.getBaseMPP(),
                    'captureType': thisImg.getCaptureType(), 'hasALabel': thisImg.hasALabel(),
                    'hasAThumbnail': thisImg.hasAThumbnail(), 'thumbZoom': thisImg.getThumbZoom(),
                    'thumbWidth': thisImg.getThumbFileDims().w, 'thumbHeight': thisImg.getThumbFileDims().h,
                    'imageWidth': thisImg.getImageWidth(), 'imageHeight': thisImg.getImageHeight(),
                    'tileWidth': thisImg.getTileWidth(), 'tileHeight': thisImg.getTileHeight()
                };
                imgSettings.push(imageJson);
            }
        }
        return imgSettings;
    };
    //............................................ getStateArray() public
    // getStateArray - This function returns json of the view state of the open image(s).
    USCOPE_EXTERNAL_INTERFACE.getStateArray = function (index) {
        var imgSettings = []; // array of imageJson
        var imageJson;

        //..................................................
        if (index != undefined) {
            imageJson = imageStateGet(index);
            if (imageJson != undefined) imgSettings.push(imageJson);
        } else {
            for (var i = 0; i < images_.length; i++) {
                imageJson = imageStateGet(i);
                if (imageJson != undefined) imgSettings.push(imageJson);
            }
        }
        return imgSettings;

        //..................................................
        // closure functions
        function imageStateGet(idx) {
            var thisImg = images_[idx];
            imageJson = undefined;
            if (thisImg != undefined) {
                // return send "normal" graphics coords
                imageJson = {
                    'imagePath': thisImg.getImageId(), 'fullURL': thisImg.getFullURL(),
                    'x': thisImg.getViewCenterX(true), 'y': thisImg.getViewCenterY(true), 'z': thisImg.getViewFocus(),
                    'mag': thisImg.getViewMag(),
                    'angle': thisImg.getViewAngle(true),
                    'sampleType': thisImg.sampleTypeGet(),
                    'isPinned': thisImg.isPinned(),
                    'saveAnnotations': imageInitState_[idx].saveAnnotations
                };
            }
            return imageJson;
        }

        //..................................................
    };
    //............................................ navigateTo() public
    // navigateTo() - This function translates and zooms the current images according to passed settings.
    USCOPE_EXTERNAL_INTERFACE.navigateTo = function (imgSettings) {
        var saveImgIdx = imageSelIdx_;
        var slen = imgSettings.length;

        for (var i = 0; i < images_.length; i++) {
            imageSelIdx_ = i;
            var thisImg = images_[i];
            if (thisImg != undefined) {
                var imageId = thisImg.getImageId();

                for (var s = 0; s < slen; s++) {
                    // find this image in the imgSettings array
                    if (imgSettings[s].imagePath == imageId) {
                        var settings = imgSettings[s];
                        if ((0, _helpers.isDefined)(settings.mag)) {
                            var zoom = thisImg.convertToZoom(settings.mag); // because imgSettings sends magnification, get what zoom that is
                            thisImg.zoomAbsolute(zoom); // zoom as specified
                        }
                        //                        else if (isDefined(settings.zoom)) {
                        //                            thisImg.zoomAbsolute(zoom);         // else zoom as specified
                        //                        }

                        if ((0, _helpers.isDefined)(settings.x) && (0, _helpers.isDefined)(settings.y)) // translate as specified
                            thisImg.moveAbsoluteCenter(settings.x, settings.y, _defines2.default.coordSystemNORM);
                        if ((0, _helpers.isDefined)(settings.angle)) // rotate as specfied
                            thisImg.viewRotate(settings.angle);
                    }
                }
            }
        }
        imageSelIdx_ = saveImgIdx; // restore selected image index
    };

    //............................................................................................
    // image management
    //............................................................................................

    //............................................ imageUpdate() public
    //    imageUpdate - This function adds, replaces, removes or changes the state (properties) of one or more images.
    USCOPE_EXTERNAL_INTERFACE.imageUpdate = function (action, jsonImageSet1, jsonImageSet2) {
        var status = false;

        var aImageState = parseImageSet_(jsonImageSet1); // parse the input settings into local arraysthe formated exactly liek the by imageInitState_ array
        var bImageState = parseImageSet_(jsonImageSet2);

        // in PR DST replace action, sends imagePath of just '@' in a and valid in b //todo: remove this when DST is fixed
        if (aImageState.length == 0 && bImageState.length == 1) {
            aImageState = bImageState;
            action = 'add';
        }

        if (aImageState.length == 0) // not a failure to have no images, just return
            return true;

        if (action == 'add') {
            // dispatch by action
            if (hasDuplicates_(aImageState) == true) return false;
            // ('imageUpdate: add: ' + aImageState[0].imageId); // eslint-disable-line no-undef
            // TODO: iterate for the N images
            var layoutInfo = buildLayoutJSON_(aImageState);
            status = imageAdd(aImageState, layoutInfo);
        } else if (action == 'remove') {
            // ('imageUpdate: remove: ' + aImageState[0].imageId); // eslint-disable-line no-undef
            //todo: iterate for the N images
            status = imageRemove(aImageState);
        } else if (action == 'replace') {
            // when there is NO DST and perhaps when there is no one tracking the currently open file
            // you can ask to replace the unpinned image without specifying it
            // Note: this is NOT normal operation with the DST - the DST must indicate which image is to be replaced to keep uScope's views in sync with the DST display
            if (bImageState.length == 0) {
                // if b is not passed in then replace the single unpinned image
                bImageState = aImageState; // b is (now, as usual) the image to be opened
                var idx = findUnPinnedImageIdx_(); // a is the image to be closed/replaced, an empty image array will cause an image add
                aImageState = idx != -1 ? [{ 'imageId': images_[idx].getImageId() }] : [];
            }

            if (bImageState && aImageState[0].imageId == bImageState[0].imageId) {
                // don't replace an image with itself
                // ('imageUpdate: replace: ' + aImageState[0].imageId + ' already open'); // eslint-disable-line no-undef
                // TODO: iterate for the N images
                return true;
            }
            if (hasDuplicates_(bImageState) == true) return false;
            var layoutInfo = buildLayoutJSON_(bImageState);
            // ('imageUpdate: replace: ' + aImageState[0].imageId + ' with ' + bImageState[0].imageId); // eslint-disable-line no-undef
            status = imageReplace(aImageState, bImageState, layoutInfo); //todo: iterate for the N images
        } else if (action == 'state') {
            for (var a = 0; a < aImageState.length; a++) {
                // ('imageUpdate: ' + aImageState[a].imageId + ' to state: ' + aImageState[a].sampleType);
            } // eslint-disable-line no-undef
            status = imageStateChange(aImageState);
        } else {
            // ('imageUpdate: unrecognized action: ' + action); // eslint-disable-line no-undef
            return false;
        }
        (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGEUPDATE, {}); // fire event: imageupdate completed
        return status;

        //..................................................
        // closure functions

        //..................................................  findUnPinnedImage_
        function findUnPinnedImageIdx_() {
            for (var i = 0; i < images_.length; i++) {
                if (images_[i] != undefined && images_[i].isPinned() == false) return i;
            }
            return -1;
        }

        //..................................................  parseVILImage_
        // parseVILImage_ - This function returns a json object of validated image initial settings, return false if not parsable
        function parseVILImage_(aImage) {
            // initialize the return json object .............
            var bImage = {
                // begin official interface vars.........................................
                fullURL: aImage.fullURL, //e.g. /imageserver/@@token/@imageid2 or //host:82/@@token/@imageid

                // initial view settings: priority of view state:
                //        1st: regionId  2nd: xyz&mag 3rd: last selected region from annotations xml
                regionId: undefined,
                centerX: undefined, centerY: undefined, // center of view X,Y position in base image coords
                focus: undefined, // focus depth (z)
                mag: 'Fit', // magnfication value or "Fit", "Scan", "2", "4", ...
                zoom: undefined, // specified only when conferencing
                angle: 0,

                saveAnnotations: true, // default saveAnnotations to true (user rights - really means create annotations)
                title: undefined,
                sampleType: 'patient', // default sample type
                isPinned: false, // default pinned status
                // end official interface vars...........................................

                // derived vars .........................................................
                server: undefined, //e.g. /imageserver/  -  always via apache (not imageserver direct)
                token: undefined, //e.g. @@f5gHzmgSn6URMsJeIVbg==
                imageId: undefined // image identifier; e.g. @2 or imageserver/filename.ext
            };
            // parse image url ...............................
            if ((0, _helpers.isDefined)(bImage.fullURL) && bImage.fullURL.length) {
                // case 1: If you put a * in servers_list.php's External Host Names field, it will use the proxy rule, e.g./imageserver/@@token/@imageid
                // case 2: If you make the External Host Names field empty, it will talk to ImageServer directly, e.g. //host:82/@@token/@imageid
                // case 3: //host/redirect/@@token==/@id

                var thisURL = bImage.fullURL;
                bImage.server = thisURL.slice(0, thisURL.indexOf('@@')); // = /imageserver/
                bImage.server.toLowerCase(); // url is always lowercase but just be sure

                var tokenPlus = thisURL.slice(-(thisURL.length - thisURL.indexOf('@@'))); //  = @@f5gHzmgSn6URMsJeIVbg==/@2
                bImage.imageId = tokenPlus.slice(-(tokenPlus.length - tokenPlus.indexOf('/@') - 1)); // = @2
                bImage.token = tokenPlus.slice(0, tokenPlus.indexOf('/@')); // = @@f5gHzmgSn6URMsJeIVbg==

                var partialToken = bImage.token.slice(0, 8) + bImage.token.slice(-4); // don't report the full token
            } else if (aImage.imagePath && aImage.imagePath.indexOf('@') === 0) {
                // if fullURL is not given, this is usually uScope stand alone test harness driven (uname, pword given)
                var rawId = (0, _helpers.stripLeadingAtSign)(aImage.imagePath);
                if ((0, _helpers.isNumber)(rawId) == false) {
                    // ('parseVILImage_: invalid imagePath: ' + aImage.imagePath); // eslint-disable-line no-undef
                    return;
                }

                bImage.imageId = aImage.imagePath;
                bImage.server = '/imageserver/';
                // ('parseVILImage_: fullURL missing, imagePath alone will be used.'); // eslint-disable-line no-undef
            } else {
                // here's where you'd look for a filepath but since that isn't handled yet
                return false;
            }

            // parse image initial state ...............................
            if ((0, _helpers.isDefined)(aImage.x) && (0, _helpers.isNumber)(aImage.x)) bImage.centerX = Math.round(aImage.x);
            if ((0, _helpers.isDefined)(aImage.y) && (0, _helpers.isNumber)(aImage.y)) bImage.centerY = Math.round(aImage.y);
            if ((0, _helpers.isDefined)(aImage.z) && (0, _helpers.isNumber)(aImage.z)) bImage.focus = Math.round(aImage.z);
            if ((0, _helpers.isDefined)(aImage.mag) && ((0, _helpers.isNumber)(aImage.mag) || aImage.mag === 'Fit' || aImage.mag === 'Scan')) // mag can be "Fit", "Scan"
                bImage.mag = aImage.mag;
            if ((0, _helpers.isDefined)(aImage.zoom)) // conferencing initial state specifies a zoom not a mag - conf is only time zoom is specified
                bImage.zoom = aImage.zoom;
            if ((0, _helpers.isDefined)(aImage.angle)) bImage.angle = aImage.angle;

            if ((0, _helpers.isDefined)(aImage.SaveAnnotations)) // input capital S from user rights
                bImage.saveAnnotations = aImage.SaveAnnotations;else if ((0, _helpers.isDefined)(aImage.saveAnnotations)) // input small s from user rights
                bImage.saveAnnotations = aImage.saveAnnotations;

            if ((0, _helpers.isDefined)(aImage.title)) bImage.title = aImage.title;
            if ((0, _helpers.isDefined)(aImage.sampleType)) bImage.sampleType = aImage.sampleType;
            if ((0, _helpers.isDefined)(aImage.isPinned)) bImage.isPinned = aImage.isPinned;
            if ((0, _helpers.isDefined)(aImage.regionId) && (0, _helpers.isNumber)(aImage.regionId)) bImage.regionId = aImage.regionId;
            return bImage;
        }

        //..................................................  parseImageSet_
        //    parseImageSet_ - This function parses the input json image data into the format used by imageInitState_ array.
        function parseImageSet_(jsonImageSet) {
            var rtnArray = [];
            if (jsonImageSet != undefined) {

                if (jsonImageSet.image) {
                    // original single image format
                    var imgState = parseVILImage_(jsonImageSet.image);
                    if (imgState != false) rtnArray.push(imgState);
                } else {
                    // multi-image format
                    for (var i = 0, len = jsonImageSet.length; i < len; i++) {
                        var imgState = parseVILImage_(jsonImageSet[i]); // separates server,token,imageid; sets undefined parms to defaults
                        if (imgState != false) rtnArray.push(imgState);else {
                            // ('imageUpdate: parseImageSet_: input image object could not be parsed'); // eslint-disable-line no-undef
                        }
                    }
                }
            }
            return rtnArray;
        }

        //..................................................  buildLayoutJSON_
        //    buildLayoutJSON_ - This function builds a list of information needed for cViewLayout to append an image.
        //        The information includes imageId, sampleType, vpclassid, and the outer viewport div, "jImgDiv"
        //        The outer viewport div is built here by calling buildVPDiv_() but is not sized.

        function buildLayoutJSON_(aImageState) {
            var appendList = [];
            for (var i = 0; i < aImageState.length; i++) {
                // build the appendList that contains each image's key info nec. for viewLayout_ to manage it
                var vpclassid = _defines2.default.classFromImageId(aImageState[i].imageId); // convert the imageId into a class name
                if (vpclassid != undefined) {
                    // create the outer viewport div with the imageId as a class
                    var jVpDivOuter = buildVPDiv_(vpclassid, false); //
                    appendList.push({
                        imageId: aImageState[i].imageId,
                        sampleType: aImageState[i].sampleType,
                        vpclassid: vpclassid,
                        jImgDiv: jVpDivOuter
                    });
                }
            }
            return appendList;
        }

        //..................................................  hasDuplicates_
        //    hasDuplicates_ - This function returns true if any image is duplicated in the input image list
        //                    or if any of those images are currently opened. otherwise it returns false;
        function hasDuplicates_(aImageState) {
            var alen = aImageState.length;
            for (var i = 0; i < alen; i++) {
                // check if any image in aImageState is already open
                var imageIdx = findImageIdx_(aImageState[i].imageId);
                if (imageIdx != -1) {
                    // if the imageId IS in the currently opened image list
                    if (aImageState[i].server == images_[imageIdx].getServer()) {
                        // if both the server name and the imageId match
                        // ('imageUpdate: input image is already opened.'); // eslint-disable-line no-undef
                        return true;
                    }
                }
            }

            for (var i = 0; i < alen; i++) {
                // check if any image in aImageState is duplicated in aImageState
                for (var j = i + 1; j < alen; j++) {
                    if (aImageState[i].imageId == aImageState[j].imageId && aImageState[i].server == aImageState[j].server) {
                        // ('imageUpdate: input image is duplicated.'); // eslint-disable-line no-undef
                        return true;
                    }
                }
            }
            return false;
        }

        //..................................................
    };

    //............................................ buildVPDiv_() local
    // buildVPDiv_ - This function creates the outer or inner viewport div and always returns the outer div.
    //                It does not size the div(s).
    // Notes:
    //        o create the VIEWPORT divs with the imageId as a class to uniquely identify them
    //        o vpclassid is an additional call on the viewport divs to differentiate each image's viewports
    //        o the outer vp div  is defined with the tabindex attribute so it can recieve key strokes
    // TODO: The viewport should build it's own DOM
    var buildVPDiv_ = function buildVPDiv_(vpclassid, bBuildInner) {
        var jVpDivOuter;
        if (!bBuildInner) {
            jVpDivOuter = $('<div/>', { 'class': _defines2.default.clsOUTERVIEWPORT + ' ' + vpclassid });
            jVpDivOuter.attr({ 'tabindex': 0 }); // for keystroke focus
        } else {
            // create the inner VP div
            jVpDivOuter = $('.' + _defines2.default.clsOUTERVIEWPORT + '.' + vpclassid); // find the outer
            jVpDivOuter.append($('<div/>', { 'class': _defines2.default.clsVIEWPORT + ' ' + vpclassid, 'id': vpclassid })); //ol3
        }

        return jVpDivOuter;
    };
    //............................................ imageAdd() public
    // This function adds images to the existing layout
    //        or if no images exist yet (and therefore no layout) it creates a layout and adds the images.
    //
    //    aImageState:    an array of initial states for the images....
    //    layoutInfo:        an array of specific information for the cViewLayout object
    //
    //    Note that this fn uses layout's append() to add images when none are displayed
    //        and expand() to add images when some are already present

    var imageAdd = function imageAdd(aImageState, layoutInfo) {
        var curImageCount = self.getImageCount();
        if (curImageCount == _defines2.default.multiSpecs.maxImages) {
            // ('Maximum number of images reached, will not add new image(s)'); // eslint-disable-line no-undef
            return;
        }

        var status = true;
        var openIdx = 0; // first image in imageInitState_ that needs to be opened

        if (viewLayout_ == undefined) {
            // ...................... create a new layout
            layoutInfo.length = Math.min(layoutInfo.length, _defines2.default.multiSpecs.maxImages); // reduce num new images if necessary to enforce max image limit
            if (layoutInfo.length == 0) return false; // nothing to do

            rootRectCompute_(); // insure rootRect_ is up to date
            // construct the layout into the uScope div, size it
            viewLayout_ = new _viewLayout2.default($(_defines2.default.idHashROOT), self.rootRect_, layoutInfo.length, onResizePane_);
            status = viewLayout_.status; // check construction status
            if (status == true) status = viewLayout_.append(layoutInfo); // arrange the images in panes and append their outer viewports to their panes
            if (status == true) {
                imageInitState_ = aImageState; // initialize the image state array with this/these image[s]
                (0, _toolbar.setIconState)($('#' + _defines2.default.idTBMULTIVIEW), _defines2.default.idTBMULTIVIEW, viewLayout_.getPaneDesc());
            }
        } else {
            // ...................... change an existing layout
            layoutInfo.length = Math.min(layoutInfo.length, _defines2.default.multiSpecs.maxImages - curImageCount); // reduce num new images if necessary to enforce max image limit
            if (layoutInfo.length == 0) return false; // nothing to do

            var newImageCount = curImageCount + layoutInfo.length;
            // construct the layout into the uScope div, size it
            var newviewLayout_ = new _viewLayout2.default($(_defines2.default.idHashROOT), self.rootRect_, newImageCount, onResizePane_);
            status = newviewLayout_.status; // check construction status
            if (status == true) status = newviewLayout_.expand(viewLayout_, layoutInfo);
            if (status == true) {
                viewLayout_ = newviewLayout_; // replace ref to viewLayout_ with new layout
                onResizePane_();

                openIdx = imageInitState_.length; // first image in the list that needs to be opened
                imageInitState_ = imageInitState_.concat(aImageState);

                (0, _toolbar.setIconState)($('#' + _defines2.default.idTBMULTIVIEW), _defines2.default.idTBMULTIVIEW, viewLayout_.getPaneDesc());
            }
        }

        if (status == true) {
            // for each new image: append the innner viewport and open the image into it

            for (var i = openIdx, len = imageInitState_.length; i < len; i++) {
                var vpclassid = layoutInfo[i - openIdx].vpclassid;
                buildVPDiv_(vpclassid, true);
                var imgStatus = createViewport(i); // open this image
                status = status && imgStatus;
            }
        }
        return status;
    };

    //............................................ imageRemove()
    //    imageReplace - This function closes one or more open images.
    var imageRemove = function imageRemove(aImageState) {
        if (viewLayout_ == undefined) {
            // ('imageRemove: no layout defined'); // eslint-disable-line no-undef
            return false;
        }

        var status = true;
        for (var a = 0, len = aImageState.length; a < len; a++) {
            var imageId = aImageState[a].imageId;
            imageClose1ById(imageId);
            // modify this viewLayout_ (change will not take immediate effect)
            viewLayout_.remove(imageId);
        }

        // now create a new layout of just the current images
        var newImageCount = self.getImageCount();
        if (newImageCount == 0) {
            viewLayout_ = undefined;
            // ('imageRemove: no images open.'); // eslint-disable-line no-undef
            return true;
        }

        // construct the layout into the uScope div, size it
        var newviewLayout_ = new _viewLayout2.default($(_defines2.default.idHashROOT), self.rootRect_, newImageCount, onResizePane_);
        status = newviewLayout_.status; // check construction status
        if (status == true) status = newviewLayout_.compress(viewLayout_); // move the viewport Divs from viewLayout_ into newviewLayout_
        if (status == true) {
            viewLayout_ = newviewLayout_; // replace ref to viewLayout_ with new layout
            onResizePane_();
            (0, _toolbar.setIconState)($('#' + _defines2.default.idTBMULTIVIEW), _defines2.default.idTBMULTIVIEW, viewLayout_.getPaneDesc());
        }
        return status;
    };

    //............................................ imageReplace()
    //    imageReplace - This function closes one image and opens another in its place.
    //    aImageState - image to be replaced
    //    bImageState - new image
    //    layoutInfo - of new image
    var imageReplace = function imageReplace(aImageState, bImageState, layoutInfo) {
        if (!viewLayout_) {
            // ('uScope: imageReplace: no layout defined, calling imageAdd'); // eslint-disable-line no-undef
            return imageAdd(bImageState, layoutInfo);
        }
        if (aImageState.length !== bImageState.length) {
            // ('imageReplace: lopsided image arrays'); // eslint-disable-line no-undef
            return false;
        }

        self.events.trigger('uscope:image:replace');

        var status = true;
        for (var a = 0, len = aImageState.length; a < len; a++) {

            var imageId = aImageState[a].imageId;
            var imageIdx = imageClose1ById(imageId); // close image first
            if (imageIdx != -1) imageInitState_[imageIdx] = bImageState[a]; // update the init state array with the replacement image

            status = viewLayout_.replace(imageId, layoutInfo[a]); // update the layout with the replacement image
            if (status == true) {
                var vpclassid = layoutInfo[a].vpclassid;
                // NOTE (cc): Originally  buildVPDiv_ was assigned to an implicit global called jVpDivOuter. buildVpDiv()
                // does real work (it creates the required DOM structure for the next image's viewport), but jVpDivOuter
                // recalculated and used elsewhere.
                buildVPDiv_(vpclassid, true);
                createViewport(imageIdx); // open the replacement image
            }
        }
        return status;
    };
    //............................................ imageArrange()
    // This function changes the arrangement of panes (aka layout) to the next in the sequence.
    USCOPE_IMAGE.imageArrange = function (reArrange) {

        var newPaneDesc = viewLayout_.getNextPaneDesc();
        if (newPaneDesc.length) {
            var curImageCount = self.getImageCount();
            // construct the layout into the uScope div, size it
            var newviewLayout_ = new _viewLayout2.default($(_defines2.default.idHashROOT), self.rootRect_, curImageCount, onResizePane_, newPaneDesc);
            var status = newviewLayout_.status; // check construction status
            if (status == true) status = newviewLayout_.compress(viewLayout_); // arrange the images in panes and append their outer viewports to their panes
            if (status == true) {
                viewLayout_ = newviewLayout_; // replace ref to viewLayout_ with new layout
                onResizePane_();

                (0, _toolbar.setIconState)($('#' + _defines2.default.idTBMULTIVIEW), _defines2.default.idTBMULTIVIEW, viewLayout_.getPaneDesc());
            } else {//todo: and for all other layout fns
            }
        }
    };
    //............................................ imageStateChange()
    //    This function executes external image state changes.
    //    Image state changes handled are:
    //        sampleType:    when an opened image's sampleType is changed
    //
    var imageStateChange = function imageStateChange(aImageState) {

        if (viewLayout_ == undefined) {
            // ('imageStateChange: no layout defined'); // eslint-disable-line no-undef
            return false;
        }

        var status = true;
        var bDoNewLayout = false;
        for (var a = 0, len = aImageState.length; a < len; a++) {
            var imageId = aImageState[a].imageId;
            var imageIdx = findImageIdx_(imageId); // find the image in images_
            if (imageIdx >= 0) {
                if (aImageState[a].sampleType != undefined // sampleType change
                && aImageState[a].sampleType != imageInitState_[imageIdx].sampleType) {
                    var sampleType = aImageState[a].sampleType;

                    //todo: should I insure there are no other sample types of this kind?
                    imageInitState_[imageIdx].sampleType = sampleType; // change the image sample type//cp-not sure this is nec, vp holds it
                    images_[imageIdx].sampleTypeSet(sampleType); // tell the viewport of the sample type change

                    // modify this viewLayout_ (change will not take immediate effect)
                    viewLayout_.stateChange(aImageState[a].imageId, 'sampleType', sampleType);

                    bDoNewLayout = true;
                }
                if (aImageState[a].isPinned != undefined // isPinned change
                && aImageState[a].isPinned != imageInitState_[imageIdx].isPinned) {
                    var isPinned = aImageState[a].isPinned;
                    imageInitState_[imageIdx].isPinned = isPinned; // change the image pinned state//cp-not sure this is nec, vp holds it
                    images_[imageIdx].isPinnedSet(isPinned); // tell the viewport of the pinned state change
                }
            }
        }

        if (bDoNewLayout == true) {
            // if a state change really was specified,

            // note that imageInitState_.length !=  self.getImageCount() b/c holes can be created in the array
            // construct the layout into the uScope div, size it
            var newviewLayout_ = new _viewLayout2.default($(_defines2.default.idHashROOT), self.rootRect_, self.getImageCount(), onResizePane_);
            status = newviewLayout_.status; // check construction status
            if (status == true) status = newviewLayout_.compress(viewLayout_); // move the viewport Divs from viewLayout_ into newviewLayout_

            if (status == true) {
                viewLayout_ = newviewLayout_; // replace ref to viewLayout_ with new layout
                onResizePane_();
                (0, _toolbar.setIconState)($('#' + _defines2.default.idTBMULTIVIEW), _defines2.default.idTBMULTIVIEW, viewLayout_.getPaneDesc());
            }
        }
        return status;
    };
    //............................................ imageOpen() public
    //    imageOpen - This function opens the images parsed into the imageInitState_ array.
    //todo: remove me soon - replaced by imageUpdate("add", ...)
    USCOPE_IMAGE.imageOpen = function (imgSettings) {
        if (initStatus == false) {
            // do not open images if initialization failed
            // ('imageOpen: Cannot open image(s) because start up initialization failed'); // eslint-disable-line no-undef
            return initStatus;
        }
        self.imageClose(); // close ALL open images
        viewLayout_ = undefined; // destroy the current view layout
        return self.imageUpdate('add', imgSettings); // and rebuild it with the new imageset
    };
    //............................................ createViewport() local
    //    createViewport - This function opens the passed imageId by creating a viewport div,
    //                attaching them to the root node, creating a viewport object related to that div,
    //                and adding the new image to the image array.
    //
    //    Input parameters: imageInitState_[idx] contains the following - where idx is the image index -
    //        imageID:    required, image id number starting with the @ sign or filename starting with imageserver/
    //        rectDiv:    required, the position in the root div of this viewport
    //
    //        centerX:    optional, initial center of view X position
    //        centerY:    optional, initial center of view X position
    //        focus:        optional, initial focus (z position)
    //        mag:         optional, initial magnfiction
    //        regionId:    optional, initial region to center view on
    //        zoom:        optional, initial zoom
    //        angle:        optional, initial rotation angle in degrees
    //    added to the json:
    //        uScopeIdx:    required, the index into uScope's images_ array of this image
    //
    var createViewport = function createViewport(idx) {
        imageInitState_[idx].uScopeIdx = idx; // add the index into uScope's images_ array  of this image
        var initState = imageInitState_[idx]; // don't open if imageId isn't valid

        if (!initState.imageId || initState.imageId.length === 0 || !_defines2.default.classFromImageId(initState.imageId)) {
            return false;
        }

        var imageId = initState.imageId;
        var vpclassid = _defines2.default.classFromImageId(imageId); // convert the imageId into a class name
        if (!vpclassid) {
            // return error of the class name isn't valid
            return false;
        }

        var viewport = new _viewportAP2.default(initState, self); // open the image into this viewport

        self.events.trigger('uscope:image:init', viewport);

        // user pref's currently requires an image ID to work since it's passed through the image server...
        viewport.events.once('viewport:before-image-open', USCOPE_PREFS.userPrefs.fetch);
        viewport.events.on('viewport:selected', USCOPE_IMAGE.setImageSelected, self);

        viewport.open();

        var openStatus = viewport.getStatus();
        if (openStatus == true) {
            images_[idx] = viewport; // add this image to image container
            imageCountFromStart_++; // update image open count since uscopestart
        }

        return openStatus;
    };
    //............................................ closeAllButSelectedImage() public
    //    closeAllButSelectedImage - This function closes all open images except the selected image.
    USCOPE_IMAGE.closeAllButSelectedImage = function () {
        if (self.getImageCount > 1) {
            for (var i = 0; i < images_.length; i++) {
                if (i != imageSelIdx_ && images_[i] != undefined) {
                    (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGECLOSE, { imageId: images_[i].getImageId() });
                }
            }
        }
    };
    //............................................ imageClose() public
    //    imageClose - This function closes all open images.
    //todo: really this is a close all function and really it could be incorportated into imageupdate and really it should use us.evIMAGECLOSE
    USCOPE_EXTERNAL_INTERFACE.imageClose = function () {
        for (var i = 0; i < images_.length; i++) {
            imageClose1(i);
        }
        imageSelIdx_ = 0; // reset the current image ptr
        images_.length = 0; // clear the array - maybe not necessary?

        //toconsider: should the settings panel be deleted and protected from opening?
    };

    //............................................ imageClose1ById() local
    //    imageClose1ById - This function closes the image with the passed imageId
    var imageClose1ById = function imageClose1ById(imageId) {
        var imageIdx = findImageIdx_(imageId); // find the image in images_
        if (imageIdx >= 0) {
            imageClose1(imageIdx); // close this image
        } else {
            // ('imageClose1ById: image is not open: ' + imageId); // eslint-disable-line no-undef
        }
        return imageIdx;
    };
    //............................................ imageClose1() local
    //    imageClose1 - This function closes the image at images_[imageIdx].

    var imageClose1 = function imageClose1(imageIdx) {
        var thisImg = images_[imageIdx];

        if (thisImg != undefined) {
            var imageId = thisImg.getImageId();
            var vpclassid = _defines2.default.classFromImageId(imageId); // convert the imageId into a class name

            thisImg.imageClose(); // close the image

            // faster to prevent memory leak and speed up DST switching images
            $('.' + _defines2.default.clsVIEWPORT + '.' + vpclassid).remove();
            $('.' + _defines2.default.clsOUTERVIEWPORT + '.' + vpclassid).detach().removeData();

            images_[imageIdx] = undefined;
            imageInitState_[imageIdx] = undefined;

            self.events.trigger('uscope:image:close', thisImg);
        }
    };
    //............................................................................................
    // uscope root div managment
    //............................................................................................

    var rootRect_; // uScope div position and dimensions; updated upon resize event

    //............................................ rootRectCompute_() local
    //    rootRectCompute_ - This function returns the current root div dimension and the root div desired
    //        position.  When not-in-development-mode the root div position must be 0,0 - relative to
    //        its normal position.
    var rootRectCompute_ = function rootRectCompute_() {
        var rootPos = $(_defines2.default.idHashROOT).offset(); // position relative to the document
        self.rootRect_ = new _objects.Rectangle(rootPos.left, rootPos.top, $(_defines2.default.idHashROOT).width(), $(_defines2.default.idHashROOT).height());
        return self.rootRect_;
    };
    //............................................ rootRectGet() public
    USCOPE_GET.rootRectGet = function () {
        return self.rootRect_ == undefined ? rootRectCompute_() : self.rootRect_;
    };
    //............................................ resize() public
    //    resize - This function sets the width and height of the root div.
    //        If not in-development-mode (e.g. not on its own page but given a div next to the DST)
    //            then there is a pr-esized 'idRoot' div for this function to return.
    //        If in-development-mode this function determines the maximum size possible to fill the
    //            window and sizes the 'idRoot' div accordingly.
    USCOPE_EXTERNAL_INTERFACE.resize = function () {
        var jRoot = $('#' + _defines2.default.idROOT);
        if (self.isModeDev() == false) {
            // when NOT in dev mode
            if (jRoot.length === 0) {
                // make sure that the uscope div is defined
                // ('self.resize: uscope div is not defined.'); // eslint-disable-line no-undef
                return;
            } else if (jRoot.width() < 10) {
                // make sure that the uscope div is sized.
                // ('self.resize: uscope div is not sized.'); // eslint-disable-line no-undef
                return;
            }
        }

        // in dev mode I size the uscope div myself if it is not already sized
        if (self.isModeDev() == true && $(_defines2.default.idHashROOT).width() < 20 && $(_defines2.default.idHashROOT).height() < 20) {
            var windowSize = getWindowSize();
            var width = Math.floor(windowSize.w - 1);
            var height = Math.floor(windowSize.h - 1); // w/o -1 had seen scroll bars when resized
            $(_defines2.default.idHashROOT).width(width).height(height);
        }

        rootRectCompute_(); // insure rootRect_ is up to date
        if (viewLayout_) {
            // check b/c when opened w/o an image, no layout is defined
            viewLayout_.onResize(self.rootRect_); // update the layout panes
            onResizePane_(); // now the viewports inside the panes can be resized

            self.events.trigger('uscope:resize');
        }
        return true;
    };
    //............................................ onResizePane_() local
    // onResizePane_ - This function is a callback when a pane is resized and called directly when the browser or DST resizes
    var onResizePane_ = function onResizePane_(paneName, paneElement, paneState, paneOptions, layoutName) {
        if (images_.length == 0) return;

        rootRectCompute_(); // insure rootRect_ is up to date
        for (var i = 0; i < images_.length; i++) {
            // resize each viewport
            var thisImg = images_[i];
            if (thisImg) thisImg.viewResize(false); // false means do not resize thumbnail
        }
    };
    //............................................................................................
    // user preference management.
    // TODO: The user pref's service, being bound to a single user, can truly be a singleton, while uScope shouldn't be.
    // TODO: Externalize this elsewhere, maybe the "public api"?
    //............................................................................................

    //............................................ prefGet public
    //    prefGet - This function returns a specific, cached, user preference.
    USCOPE_PREFS.prefGet = function (name, defaultVal) {
        return self.userPrefs.get(name, defaultVal);
    };
    //............................................ prefSet public
    //    prefSet - This function sets a specific user preference.
    USCOPE_PREFS.prefSet = function (name, value) {
        self.userPrefs.set(name, value);
    };

    //............................................................................................
    // initialization
    //............................................................................................

    //............................................ reset() public
    // reset - This function resets to default values uScope vars that are initialized at uScopeStart.
    USCOPE_EXTERNAL_INTERFACE.reset = function () {
        USCOPE_PREFS.userPrefs.reset();
        createdBy = undefined;
        userName = undefined;
        userId = undefined;
        title = undefined;

        imageInitState_.length = 0; // clear the array
        images_.length = 0; // clear the array
        imageSelIdx_ = 0; //

        viewLayout_ = undefined;
    };

    /**
     * Enforces browser dependent settings. It overwrites the input settings and sets the appropriate feature switches.
     */
    var enforceBrowserDependentSettings = function enforceBrowserDependentSettings() {
        if (_browserCompatibility.env.isIEBelow9) {
            // TODO: IE8 and below are no longer supported.
            self.vilSettings.overlays.rotation = false;
            self.vilSettings.overlays.heatMap = false;
            _defines2.default.ENABLEDRAGMOMENTUM = false;
            _defines2.default.USEMULTIPYRAMIDLEVELS = false;
        } else if (_browserCompatibility.env.isIOS) {
            _defines2.default.ENABLEZOOMSLIDER = false; // no need for the slider in ios
            _defines2.default.kTILEMULTIPLIER = 1; // small view in iOS uses single tile dims
        }
    };

    //............................................ init - This function initializes self.
    // Note: because this fn sizes the uscope div, it is called by uScopeStart
    USCOPE_EXTERNAL_INTERFACE.init = function (settings) {
        // parse any passed settings including image ids and states
        if (settings) {
            initStatus = parseVILSettings(settings);
        }

        self.events = eventChannel.$new();
        self.notifications = new _notificationService.NotificationService($(_defines2.default.idHashROOT)[0]);
        self.topToolbar = new _toolbar.Toolbar(self);
        self.userPrefs = new _userPreferences2.default(self);

        // get uScope div size; sanity check it
        initStatus = initStatus && self.resize();

        // set a flag indicating if function getPropertyValue is/isn't available - perf improvement
        if (!self.bHasPropertyValue) {
            var jVar = $(document).find(_defines2.default.idHashROOT);
            self.bHasPropertyValue = !!jVar[0].style.getPropertyValue;
        }

        bindEvents_();

        if (!initStatus) {
            // ('init: Start up initialization failed'); // eslint-disable-line no-undef
        }

        return initStatus;
    };

    function bindEvents_() {
        var namespace = '.uscope';
        // TODO: Publish context menu event from viewport only
        if (!_defines2.default.ENABLECONTEXTMENU) {
            // disable context menu on all of uscope if context menu is disabled.
            $(_defines2.default.idHashROOT).on('contextmenu' + namespace, function () {
                return false;
            });
        } else {
            // disable context menu on panels to prevent region toolbar from activating over the panels
            $('.' + _defines2.default.clsPANEL).on('contextmenu' + namespace, function () {
                return false;
            });
        }

        self.events.trigger('uscope:bind-events');
    }

    function unbindEvents() {
        var namespace = '.uscope';
        var $rootNode = $(_defines2.default.idHashROOT);

        $rootNode.off('contextmenu' + namespace);
        $('.' + _defines2.default.clsPANEL).off('contextmenu' + namespace);

        $rootNode.off(_defines2.default.evREGIONSELECT + namespace);
        $rootNode.off(_defines2.default.evLAYERSELECT + namespace);
        $rootNode.off(_defines2.default.evMARKUPCHANGE + namespace);
        $rootNode.off(_defines2.default.evREGIONDELETE + namespace);
    }

    USCOPE_EXTERNAL_INTERFACE.destroy = function () {
        self.imageClose();
        self.reset();
        self.events.$destroy();
        unbindEvents();
        UScopeViewer.instance = undefined;
    };

    //............................................ construction
    construct_();
}

// ---------------------------------  helper functions  --------------------------------------------

/**
 * This method computes the inner dimensions of the window accounting for browser variations.
 * @returns {Size}
 */
var getWindowSize = function getWindowSize() {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    return new _Size.Size(width, height);
};
module.exports = exports['default'];

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(28)
  , TAG = __webpack_require__(3)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(46)
  , document = __webpack_require__(7).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(509)
  , defined = __webpack_require__(161);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(494);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(493);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).document && document.documentElement;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(167)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(82)
  , ITERATOR  = __webpack_require__(3)('iterator')
  , Iterators = __webpack_require__(47);
module.exports = __webpack_require__(12).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 106 */
/***/ (function(module, exports) {



/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Point = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _lbsPiDash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This is a generic x,y point object intended to expand to include common operations performed on x,y points.
 */
var Point = exports.Point = function () {
    function Point(x, y) {
        (0, _classCallCheck3.default)(this, Point);

        if ((0, _lbsPiDash.isObject)(x)) {
            this.setPoint(x);
        } else {
            this.set(x, y);
        }
    }

    (0, _createClass3.default)(Point, [{
        key: 'set',
        value: function set() {
            var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            this.x = Number(x);
            this.y = Number(y);
        }
    }, {
        key: 'setPoint',
        value: function setPoint(cp) {
            this.set(cp.x, cp.y);
            return this;
        }
    }, {
        key: 'add',
        value: function add(dx, dy) {
            this.x = this.x + Number(dx);
            this.y = this.y + Number(dy);
            return this;
        }
    }, {
        key: 'addPoint',
        value: function addPoint(cp) {
            return this.add(cp.x, cp.y);
        }
    }, {
        key: 'subtract',
        value: function subtract(dx, dy) {
            this.x = this.x - Number(dx);
            this.y = this.y - Number(dy);
            return this;
        }
    }, {
        key: 'subractPoint',
        value: function subractPoint(cp) {
            return this.subtract(cp.x, cp.y);
        }
    }, {
        key: 'multiply',
        value: function multiply(dx, dy) {
            this.x = this.x * dx;
            this.y = this.y * dy;
            return this;
        }

        // this method appears to be unused

    }, {
        key: 'divide',
        value: function divide(dx, dy) {
            this.x = this.x / dx;
            this.y = this.y / dy;
            return this;
        }
    }, {
        key: 'cityBlockDistance',
        value: function cityBlockDistance(cpIn) {
            return Math.abs(cpIn.x - this.x) + Math.abs(cpIn.y - this.y);
        }
    }, {
        key: 'distance',
        value: function distance(cpIn) {
            return Math.sqrt((cpIn.x - this.x) * (cpIn.x - this.x) + (cpIn.y - this.y) * (cpIn.y - this.y));
        }
    }, {
        key: 'isEqual',
        value: function isEqual(cpIn) {
            return cpIn.x === this.x && cpIn.y === this.y;
        }
    }, {
        key: 'toInt',
        value: function toInt() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        }
    }, {
        key: 'toFixed',
        value: function toFixed(dec) {
            if (dec <= 0) {
                return this.toInt();
            }
            this.x = this.x.toFixed(dec);
            this.y = this.y.toFixed(dec);
            return this;
        }

        // This method appears unused. Looks like it checks if a point is within a rectangle, which TBH should live in the rect class anyway
        /*
         isWithin(csValue, bInclusive = true) {
             if (this.x < 0 || this.y < 0) {
                 return false;
             }
               if (bInclusive) {
                 return this.x >= csValue.w || this.y >= csValue.h;
             }
               return this.x > csValue.w || this.y > csValue.h;
         }
         */

    }, {
        key: 'rotate',
        value: function rotate(angleDeg) {
            var angleRad = angleDeg * _defines2.default.Deg2Rad;
            var cosAngle = Math.cos(angleRad);
            var sinAngle = Math.sin(angleRad);

            var rotX = this.x * cosAngle - this.y * sinAngle;
            var rotY = this.x * sinAngle + this.y * cosAngle;
            this.x = rotX;
            this.y = rotY;
            return this;
        }
    }, {
        key: 'rotateAbout',
        value: function rotateAbout(angleDeg, cpOrigin, opt_precision) {
            this.subractPoint(cpOrigin); // remove origin
            this.rotate(angleDeg);
            this.addPoint(cpOrigin); // remove origin (cc - you mean restore?)

            if (opt_precision) {
                this.toFixed(opt_precision);
            }
            return this;
        }
    }]);
    return Point;
}();

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(498);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(497);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//-------------------------------------------------------------------------------------------------
//    Hot Keys
//-------------------------------------------------------------------------------------------------
//Note that keydown and keyup provide a code indicating which key is pressed,
//while keypress indicates which character was entered. For example, a lowercase "a"
//will be reported as 65 by keydown and keyup, but as 97 by keypress. An uppercase "A"
//is reported as 65 by all events. Because of this distinction, when catching special
//keystrokes such as arrow keys, .keydown() or .keyup() is a better choice.
//keycodes can be found at: http://www.webonweboff.com/tips/js/event_key_codes.aspx
//    or http://unixpapa.com/js/key.html
// Note: FF has different keycodes for plus/minus keys [ref: http://unixpapa.com/js/key.html]

var keyCodes = exports.keyCodes = {
    enter: 13,
    shift: 16,
    control: 17,
    alt: 18,
    escape: 27,
    spacebar: 32,
    arrowLeft: 37,
    arrowUp: 38,
    arrowRight: 39,
    arrowDown: 40,
    zero: 48,
    one: 49,
    two: 50,
    three: 51,
    four: 52,
    five: 53,
    six: 54,
    seven: 55,
    eight: 56,
    nine: 57,
    num0: 96,
    num1: 97,
    num2: 98,
    num3: 99,
    num4: 100,
    num5: 101,
    num6: 102,
    num7: 103,
    num8: 105,
    num9: 107,

    numLock4: 100,
    numLock5: 105,
    numPlus: 107,
    numMinus: 109,
    CapsLock: 20,
    deleteKey: 46,

    a: 65,
    b: 66,
    c: 67,
    d: 68,
    e: 69,
    f: 70,
    g: 71,
    h: 72,
    i: 73,
    j: 74,
    k: 75,
    l: 76,
    m: 77,
    n: 78,
    o: 79,
    p: 80,
    q: 81,
    r: 82,
    s: 83,
    t: 84,
    u: 85,
    v: 86,
    w: 87,
    x: 88,
    y: 89,
    z: 90,

    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,

    minus: 189,
    plus: 187,
    FF_minus: 173,
    FF_plus: 61
};

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(321)
  , enumBugKeys = __webpack_require__(162);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(546);

__webpack_require__(380);

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(551);

__webpack_require__(416);

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CREATE_BUTTON_ID = exports.CREATE_BUTTON_ID = 'us_tbconfcreate';
var CONFERENCE_MARKER_EVENT = exports.CONFERENCE_MARKER_EVENT = 'us_evCONFMARKER';

/**
 * Dev Mode has two side effects:
 *   1. Turns on additional event logging in the Conferencing service
 *   2. If the test-panel is enabled (by including it in the build), adds a bunch of buttons triggering various conf events
 */
var ENABLE_DEV_MODE = exports.ENABLE_DEV_MODE = true;

/**
 * If the test-panel is enabled, adds a button that does a bunch of stuff. It doesn't actually look conferencing related
 * but the button's title says "Exit Conferencing", so what the heck do I know?
 */
var ENABLE_TEST_ICON = exports.ENABLE_TEST_ICON = true;

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(315);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(13)
  , dPs         = __webpack_require__(515)
  , enumBugKeys = __webpack_require__(162)
  , IE_PROTO    = __webpack_require__(165)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(83)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(103).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(166)('keys')
  , uid    = __webpack_require__(143);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(46);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(7)
  , core           = __webpack_require__(12)
  , LIBRARY        = __webpack_require__(74)
  , wksExt         = __webpack_require__(170)
  , defineProperty = __webpack_require__(33).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(3);

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cXINFO;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _lbsPiDash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//-------------------------------------------------------------------------------------------------
// xinfo.js
//    This file contains the request for xinfo data and the class, functions to access that data.
//    - http://localhost:82/@1?XINFO
//
//    history
//    1105    cperz        created
//    _______________________________________end_AIHv1/PR __________________________________________
//    141118    cperz
//    141222    cperz        change construction signature; use passed in log function; add support for analysis;
//    150318    cperz        decoded Algorithm for markups
//
//________________________________________________________________________________________________
//

function cXINFO(imageId) {
    // object for XINFO
    var status = false; // initialized ok
    var inImageId_ = imageId; //save the imageId this object is related to

    this.scanner = 'not defined';
    this.version = 'not defined';
    this.bitsPerSampl = 8;
    this.acqBitsPerSampl = 8; //todo: not parsed yet
    this.samplPerPix = 3;
    this.capturetype = _defines2.default.eAICCaptureType.aic_i_BF;
    this.left = 0; //cp-i don't see it in xinfo but a tma core (sub image) should have a non-zero left,top coord - or should it when connect to imageserver?
    this.top = 0;
    this.width = 0;
    this.height = 0;
    this.depth = 0; //
    this.tileWidth = 0;
    this.tileHeight = 0;
    this.title = '';
    this.description = '';
    this.filesize = 0;
    this.imagesize = 0;
    this.comptype = 0;
    this.comptypedesc = '';
    this.compquality = 0;
    this.compcodec = 0;
    this.apparentMag = 20;
    this.MPP = 0.5;

    this.isFused = false;
    this.fusedFiles = []; // fused member image file names

    this.layers = 0; // layer object array that contains level object arrays
    this.layerTbl = [];

    this.thumb = new thumb();
    this.macro = new macro();
    this.label = new label();

    // public methods
    //............................................ status related
    this.getStatus = function () {
        return status;
    };
    this.setStatus = function (bstate) {
        status = bstate === true ? true : false;
    };

    //............................................ search description field related
    this.getDescValue = function (tag, defaultValue) {
        if (this.descArray != undefined) {
            for (var i = 0, len = this.descArray.length; i < len; i++) {
                if (this.descArray[i].indexOf(tag) != -1) {
                    // if the tag is found
                    var valIdx = this.descArray[i].indexOf('=') + 1;
                    var value = this.descArray[i].slice(valIdx);
                    value = (0, _lbsPiDash.trim)(value);
                    return value;
                }
            }
        }
        return defaultValue;
    };
    //............................................ image pyramid access
    // defaults lev=0,lay=0
    this.GetLevelObj = function (lev, lay) {
        // get level object for pyramid(layer, level
        var lev = lev === undefined ? 0 : lev;
        var lay = lay === undefined ? 0 : lay;
        if (lay > this.layers || lev > this.layerTbl[lay].levels) return null;
        return this.layerTbl[lay].levelTbl[lev];
    };
    this.get_imageLevels = function (lay) {
        // get number of image pyramid levels
        var lay = lay === undefined ? 0 : lay;
        return +this.layerTbl[lay].levels;
    };
    this.get_imageZoom = function (lev, lay) {
        // get image pyramid level zoom  (e.g. 1, 4, 16)
        var oLevel = this.GetLevelObj(lev, lay);
        return oLevel != null ? +oLevel.zoom : 0;
    };
    this.get_imageWidth = function (lev, lay) {
        // get image width for a given layer,level
        var oLevel = this.GetLevelObj(lev, lay);
        return oLevel != null ? +oLevel.width : 0;
    };
    this.get_imageHeight = function (lev, lay) {
        // get image height for a given layer,level
        var oLevel = this.GetLevelObj(lev, lay);
        return oLevel != null ? +oLevel.height : 0;
    };
    this.get_tilesX = function (lev, lay) {
        // get number of tiles in X for a given layer,level
        var oLevel = this.GetLevelObj(lev, lay);
        return oLevel != null ? +oLevel.tilesX : 0;
    };
    this.get_tilesY = function (lev, lay) {
        // get number of tiles in Y for a given layer,level
        var oLevel = this.GetLevelObj(lev, lay);
        return oLevel != null ? +oLevel.tilesY : 0;
    };
    this.get_baseMag = function () {
        return this.apparentMag;
    };
    this.get_MPP = function (lev, lay) {
        var zoom = this.get_imageZoom(lev, lay);
        var MPP = this.MPP * zoom;
        return MPP;
    };
    this.getAlgorithmName = function () {
        return this.AlgorithmName;
    };

    //............................................ parse xinfo response, populate XINFO object - call back from ajaxXINFO
    //improvement: convert to use of x2js
    this.init = function (xinfoDoc, inImageId) {
        // verify xinfo is the response
        if (!jQuery.isXMLDoc(xinfoDoc) || xinfoDoc.getElementsByTagName('xinfo')[0].nodeName !== 'xinfo') {
            // ('Error:  uScope: xinfo: init: input xinfoDoc is not xinfo content'); // eslint-disable-line no-undef
            return status;
        }
        // verify this response is for the imageId associated with this viewport
        if (inImageId !== inImageId_) {
            // ('Error:  uScope: xinfo: init: passed imageId ' + inImageId + ' is not associated with this viewport'); // eslint-disable-line no-undef
            return status;
        }

        this.version = xinfoDoc.getElementsByTagName('version')[0].childNodes[0].nodeValue;
        this.bitsPerSampl = +xinfoDoc.getElementsByTagName('bitsPerSampl')[0].childNodes[0].nodeValue;

        this.samplPerPix = +xinfoDoc.getElementsByTagName('samplPerPix')[0].childNodes[0].nodeValue;
        this.capturetype = xinfoDoc.getElementsByTagName('capturetype')[0].childNodes[0].nodeValue;
        this.width = +xinfoDoc.getElementsByTagName('width')[0].childNodes[0].nodeValue;
        this.height = +xinfoDoc.getElementsByTagName('height')[0].childNodes[0].nodeValue;
        this.depth = +xinfoDoc.getElementsByTagName('depth')[0].childNodes[0].nodeValue;
        this.tileWidth = +xinfoDoc.getElementsByTagName('tilewidth')[0].childNodes[0].nodeValue;
        this.tileHeight = +xinfoDoc.getElementsByTagName('tileheight')[0].childNodes[0].nodeValue;

        if (xinfoDoc.getElementsByTagName('title').firstChild != null) // title not always present
            this.title = xinfoDoc.getElementsByTagName('title')[0].childNodes[0].nodeValue;

        // get the image description and parse it. Here's a typical description string:
        //        "Aperio Image Library v10.0.51 42320x31454 [0,100 41392x31354] (256x256) JPEG/RGB Q=70|
        //        AppMag = 20|StripeWidth = 1840|ScanScope ID = SS5340|Filename = 347031|Date = 11/10/09|
        //        Time = 12:09:18|User = d74add0a-174c-468a-bf95-d7b4d274a196|MPP = 0.5015|Left = 35.625134|
        //        Top = 21.241474|LineCameraSkew = -0.000185|LineAreaXOffset = 0.032367|LineAreaYOffset = -0.065287|
        //        Focus Offset = -0.001000|DSR ID = dsr-mfg|ImageID = 347031|OriginalWidth = 42320|Originalheight = 31454|
        //        ICC Profile = ScanScope v1"

        if (xinfoDoc.getElementsByTagName('description')[0].childNodes[0]) {
            // description not always present
            this.description = xinfoDoc.getElementsByTagName('description')[0].childNodes[0].nodeValue;
            this.scanner = this.description.split(' ')[0].split(';')[0]; // Ariol;ASE requires the split(';')

            this.descArray = this.description.split('|'); // | delimits the aperio description string

            for (var i = 1, len = this.descArray.length; i < len; i++) {
                // starting after the "Aperio Image Library" item

                if (this.descArray[i].indexOf('=') != -1) {
                    // if there is a name = value item
                    var newObj = this.descArray[i].split('='); // then add it to this xinfo object
                    this[jQuery.trim(newObj[0])] = jQuery.trim(newObj[1]);
                }
            }

            this.apparentMag = parseFloat(this.getDescValue('AppMag', 20));
            this.MPP = parseFloat(this.getDescValue('MPP', 0.5));
            this.filename = this.getDescValue('Filename', undefined);
            this.date = this.getDescValue('Date', undefined);
            this.scanScopeId = this.getDescValue('ScanScope ID', undefined);
            this.iccProfile = this.getDescValue('ICC Profile', undefined);
            this.acqBitsPerSampl = parseFloat(this.getDescValue('Acquisition Bit Depth', undefined));
            this.AlgorithmName = this.getDescValue('Algorithm', undefined);
            var memberFile;
            for (var i = 0; i < 12; i++) {
                memberFile = this.getDescValue('Fused Image ' + i, undefined);
                if (memberFile) {
                    this.fusedFiles[i] = memberFile;
                } else {
                    break;
                }
            }
        }
        this.isFused = this.fusedFiles.length > 0 ? true : false;

        this.filesize = +xinfoDoc.getElementsByTagName('filesize')[0].childNodes[0].nodeValue;
        this.imagesize = +xinfoDoc.getElementsByTagName('imagesize')[0].childNodes[0].nodeValue;
        this.comptype = +xinfoDoc.getElementsByTagName('comptype')[0].childNodes[0].nodeValue;
        this.comptypedesc = xinfoDoc.getElementsByTagName('comptypedesc')[0].childNodes[0].nodeValue;
        this.compquality = +xinfoDoc.getElementsByTagName('compquality')[0].childNodes[0].nodeValue;
        this.compcodec = xinfoDoc.getElementsByTagName('compcodec')[0].childNodes[0].nodeValue;

        // get the thumbnail before the levels (seen old imageservers report AFI image levels with widths of the thumbnail and of 0)
        var subImage = xinfoDoc.getElementsByTagName('thumb'); //thumb not always present
        if (subImage.length) this.thumb.init(subImage[0].getElementsByTagName('width')[0].childNodes[0].nodeValue, subImage[0].getElementsByTagName('height')[0].childNodes[0].nodeValue, subImage[0].getElementsByTagName('zoom')[0].childNodes[0].nodeValue);

        var subImage = xinfoDoc.getElementsByTagName('macro'); //macro not always present
        if (subImage.length) this.macro.init(subImage[0].getElementsByTagName('width')[0].childNodes[0].nodeValue, subImage[0].getElementsByTagName('height')[0].childNodes[0].nodeValue);

        var subImage = xinfoDoc.getElementsByTagName('label'); //label not always present
        if (subImage.length) this.label.init(subImage[0].getElementsByTagName('width')[0].childNodes[0].nodeValue, subImage[0].getElementsByTagName('height')[0].childNodes[0].nodeValue);

        this.layers = xinfoDoc.getElementsByTagName('layers')[0].childNodes[0].nodeValue;
        var xLayers = xinfoDoc.getElementsByTagName('layer');
        for (var lay = 0, maxLay = this.layers; lay < maxLay; lay++) {
            // for each layer
            this.layerTbl[lay] = new layer(lay, xLayers[lay].getElementsByTagName('zoff')[0].childNodes[0].nodeValue, xLayers[lay].getElementsByTagName('depth')[0].childNodes[0].nodeValue, xLayers[lay].getElementsByTagName('focus')[0].childNodes[0].nodeValue, xLayers[lay].getElementsByTagName('levels')[0].childNodes[0].nodeValue);
            var nlevels = 0;
            var xLevels = xLayers[lay].getElementsByTagName('level');

            for (var lev = 0, maxLev = this.layerTbl[lay].levels; lev < maxLev; lev++) {
                // for each level
                // don't add a level that is smaller than the thumbnail unless it is the base level
                // note - sometimes XINFO of fused imagery reports this.  It may be fixed.
                var levWidth = +xLevels[lev].getElementsByTagName('width')[0].childNodes[0].nodeValue;
                if (lev != 0 && levWidth < this.thumb.width) {
                    // ('.... xinfo:init: ignoring level ' + lev + 'width=' + levWidth); // eslint-disable-line no-undef
                    continue;
                }
                this.layerTbl[lay].levelTbl[lev] = new level(lev, xLevels[lev].getElementsByTagName('width')[0].childNodes[0].nodeValue, xLevels[lev].getElementsByTagName('height')[0].childNodes[0].nodeValue, xLevels[lev].getElementsByTagName('zoom')[0].childNodes[0].nodeValue, this.tileWidth, this.tileHeight);
                nlevels++;
            }
            this.layerTbl[lay].levels = nlevels;
        }
        status = true;
        return status;
    };

    //............................................ xinfo subImage object
    function subImage() {
        // prototype for thumb, macro, label //cp-not used!!!
        this.isValid = false;
        this.width = 0;
        this.height = 0;
        this.zoom = 1.0; // n/a for macro and label

        this.init = function (w, h, zm) {
            this.width = +w;
            this.height = +h;
            this.zoom = +zm;
            this.isValid = true; //cp-more stringent test here
        };
    }

    //............................................ xinfo thumb object
    function thumb() {
        // object for thumbnail
        this.isValid = false;
        this.width = 0;
        this.height = 0;
        this.zoom = 1.0;

        this.init = function (w, h, zm) {
            this.width = +w;
            this.height = +h;
            this.zoom = +zm;
            this.isValid = true; //cp-more stringent test here
        };
    }

    //............................................ xinfo macro image object
    function macro(w, h) {
        this.isValid = false;
        this.width = 0;
        this.height = 0;
        //this.zoom = 0;

        this.init = function (w, h, zm) {
            this.width = +w;
            this.height = +h;
            //this.zoom = +zm;
            this.isValid = true; //cp-more stringent test here
        };
    }

    //............................................ xinfo label object
    function label(w, h) {
        this.isValid = false;
        this.width = 0;
        this.height = 0;
        //this.zoom = 0;

        this.init = function (w, h, zm) {
            this.width = +w;
            this.height = +h;
            //this.zoom = +zm;
            this.isValid = true; //cp-more stringent test here
        };
    }

    //............................................ xinfo level object - levels of the image pyramid
    function level(id, w, h, zm, tileW, tileH) {
        this.id = id;
        this.width = w;
        this.height = h;
        this.zoom = zm * 1; // *1 assures numeric interpretation

        this.tilesX = Math.round(this.width / tileW); // (this.width + tileW - 1) / tileW;
        this.tilesY = Math.round(this.height / tileH);
    }

    //............................................ xinfo layer object - (z position of the microscope objective)
    function layer(id, zoff, depth, focus, levels) {
        this.id = id;
        this.zoff = zoff;
        this.depth = depth;
        this.focus = focus;
        this.levels = levels;
        this.levelTbl = [];
    }
}
module.exports = exports['default'];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BoundingBox = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _Point = __webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A bounding box defines the boundaries of a rectangle. Semantically it directly exposes the left, top, right, and bottom
 * boundaries, and calculates the width and height, so it's slightly more performant for use cases where the borders
 * are more interesting than the properties of the rectangle.
 */
var BoundingBox = exports.BoundingBox = function () {
    function BoundingBox(l, t, r, b) {
        (0, _classCallCheck3.default)(this, BoundingBox);

        this.set(l, t, r, b);
    }

    (0, _createClass3.default)(BoundingBox, [{
        key: 'set',
        value: function set() {
            var l = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var b = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

            this.left = Number(l);
            this.right = Number(r);
            this.top = Number(t);
            this.bottom = Number(b);
        }
    }, {
        key: 'zero',
        value: function zero() {
            this.set(0, 0, 0, 0);
        }
    }, {
        key: 'isZero',
        value: function isZero() {
            return this.w <= 0 || this.h <= 0;
        }
    }, {
        key: 'getCenter',
        value: function getCenter() {
            return new _Point.Point(this.cx, this.cy);
        }
    }, {
        key: 'getArea',
        value: function getArea() {
            return this.area;
        }
    }, {
        key: 'hasOverlap',
        value: function hasOverlap(rect2) {
            return !(this.left > rect2.right || rect2.left > this.right || this.top > rect2.bottom || rect2.top > this.bottom);
        }
    }, {
        key: 'intersect',
        value: function intersect(rect2) {
            // modifies the rect to be that of the intersection with the passed rect
            if (rect2.left > this.left) this.left = rect2.left;
            if (rect2.top > this.top) this.top = rect2.top;
            if (rect2.right < this.right) this.right = rect2.right;
            if (rect2.bottom < this.bottom) this.bottom = rect2.bottom;
            if (this.left >= this.right || this.top >= this.bottom) this.zero();
        }
    }, {
        key: 'getIntersectRect',
        value: function getIntersectRect(crect2) {
            // preserves this rect, returns the intersection between this and the passed rect
            var rtnRect2 = new BoundingBox(this.left, this.top, this.right, this.bottom);
            rtnRect2.intersect(crect2);
            return rtnRect2;
        }
    }, {
        key: 'w',
        get: function get() {
            return this.right - this.left;
        }
    }, {
        key: 'h',
        get: function get() {
            return this.bottom - this.top;
        }
    }, {
        key: 'cx',
        get: function get() {
            return this.left + this.w / 2.;
        }
    }, {
        key: 'cy',
        get: function get() {
            return this.top + this.h / 2.;
        }
    }, {
        key: 'area',
        get: function get() {
            return this.w * this.h;
        }
    }]);
    return BoundingBox;
}();

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Rectangle = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This is a generic rectangle object.
 */
var Rectangle = function () {
    function Rectangle(left, top, width, height) {
        (0, _classCallCheck3.default)(this, Rectangle);

        this.setxywh(left, top, width, height);
    }

    (0, _createClass3.default)(Rectangle, [{
        key: "setxy",
        value: function setxy() {
            var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            this.x = Number(x);
            this.y = Number(y);

            return this;
        }
    }, {
        key: "setxywh",
        value: function setxywh(x, y) {
            var w = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

            this.setxy(x, y);
            this.w = Number(w);
            this.h = Number(h);

            return this;
        }
    }, {
        key: "set",
        value: function set(cp, cs) {
            return this.setxywh(cp.x, cp.y, cs.w, cs.h);
        }
    }, {
        key: "setRect",
        value: function setRect(rect) {
            return this.setxywh(rect.x, rect.y, rect.w, rect.h);
        }
    }, {
        key: "offset",
        value: function offset(offsetX, offsetY) {
            this.x += Number(offsetX);
            this.y += Number(offsetY);
            return this;
        }
    }, {
        key: "scale",
        value: function scale(_scale) {
            this.x *= Number(_scale);
            this.y *= Number(_scale);
            this.w *= Number(_scale);
            this.h *= Number(_scale);
            return this;
        }
    }, {
        key: "clone",
        value: function clone() {
            return new Rectangle().setRect(this);
        }

        /**
         * Converts coordinates to a rectangle drawn from top-left to bottom-right
         */

    }, {
        key: "normalize",
        value: function normalize() {
            if (this.h < 0) {
                this.h = -this.h;
                this.y -= this.h;
            }
            if (this.w < 0) {
                this.w = -this.w;
                this.x -= this.w;
            }
            return this;
        }
    }, {
        key: "cx",
        get: function get() {
            return this.x + this.w / 2;
        }
    }, {
        key: "cy",
        get: function get() {
            return this.y + this.h / 2;
        }
    }, {
        key: "area",
        get: function get() {
            return this.w * this.h;
        }
    }]);
    return Rectangle;
}();

exports.Rectangle = Rectangle;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Size = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This is a generic w,h size object.
 */
var Size = exports.Size = function () {
    function Size(w, h) {
        (0, _classCallCheck3.default)(this, Size);

        return this.set(w, h);
    }

    (0, _createClass3.default)(Size, [{
        key: "set",
        value: function set() {
            var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            this.w = Number(w);
            this.h = Number(h);
            return this;
        }
    }, {
        key: "setSize",
        value: function setSize(cs) {
            this.set(cs.w, cs.h);
            return this;
        }
    }, {
        key: "getArea",
        value: function getArea() {
            return this.w * this.h;
        }
    }, {
        key: "add",
        value: function add(dw, dh) {
            this.w += Number(dw);
            this.h += Number(dh);
            return this;
        }
    }, {
        key: "addSize",
        value: function addSize(cs) {
            return this.add(cs.w, cs.h);
        }

        // TODO rename to Subtract

    }, {
        key: "subt",
        value: function subt(dw, dh) {
            this.w -= Number(dw);
            this.h -= Number(dh);
            return this;
        }
    }, {
        key: "mult",
        value: function mult(dx, dy) {
            this.w = this.w * dx;
            this.h = this.h * dy;
            return this;
        }
    }, {
        key: "div",
        value: function div(dx, dy) {
            this.w = this.w / dx;
            this.h = this.h / dy;
            return this;
        }

        // TODO: This looks out of place... A generic "shape" probably shouldn't know what an Image Server tile is...

    }, {
        key: "toTileNums",
        value: function toTileNums(tileW, tileH, zoom) {
            this.w = Math.ceil(this.w / tileW / zoom);
            this.h = Math.ceil(this.h / tileH / zoom);
            return this;
        }
    }, {
        key: "maxDim",
        value: function maxDim() {
            return Math.max(this.w, this.h);
        }
    }, {
        key: "toInt",
        value: function toInt() {
            this.w = Math.round(this.w);
            this.h = Math.round(this.h);
            return this;
        }
    }, {
        key: "getCenterW",
        value: function getCenterW(roundToInt) {
            // note that 0-based counting is assumed by the -1
            return roundToInt ? Math.round(this.w / 2 - 1) : this.w / 2 - 1;
        }
    }, {
        key: "getCenterH",
        value: function getCenterH(roundToInt) {
            // note that 0-based counting is assumed by the -1
            return roundToInt ? Math.round(this.h / 2 - 1) : this.h / 2 - 1;
        }
    }]);
    return Size;
}();

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// An event channel, based loosely on Backbone's implementation with some memory management ideas borrowed
// from Angular. One problem uScope has is that events can happen in several contexts. The global space can
// (theoretically) create multiple uScope instances. Events in each uScope instance's scope don't, for the most
// part, care about events in another context's scope. Similarly, each uScope instance can have multiple images
// open, and the child controls of each image don't really care about events in the other images' scope. This
// event channel borrows from Angular's $rootscope service the ability to chain event channels.
var EventChannel = exports.EventChannel = function EventChannel(source) {
    var publicEvents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var self = this;
    var allListeners = {};
    var children = [];
    var rootChannel = void 0;

    if (!Array.isArray(publicEvents)) {
        publicEvents = [publicEvents];
    }

    /* *****************************************************************************************************
     * Public Methods
     ***************************************************************************************************** */

    /**
     * Bind an event to a `callback` function
     * @param {String} name - the name of the event. Since this impl is a singleton make sure it's unique!
     * @param {Function} callback - what to do when the event is triggered
     * @param {*} context - `this` argument for @callback
     * @returns {Function} - handy detacher function; the equivalent of `eventChannel.off(name, callback, context)`
     */
    self.on = function (name, callback, context) {
        if (!allListeners[name]) {
            allListeners[name] = [];
        }

        allListeners[name].push({
            callback: callback,
            context: context,
            ctx: context || this
        });

        return self.off.bind(null, name, callback, context);
    };

    /**
     * Bind an event to a `callback` function and immediately detach
     * @param {String} name - the name of the event. Since this impl is a singleton make sure it's unique!
     * @param {Function} callback - what to do when the event is triggered
     * @param {*} context - `this` argument for @callback
     * @returns {Function} - handy detacher function; the equivalent of `eventChannel.off(name, callback, context)`
     */
    self.once = function (name, callback, context) {
        var done = self.on(name, function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            callback.apply(context, args);
            done();
        }, context);
    };

    /**
     * Remove one or many callbacks
     * @param {String} name - the name of the event
     * @param {Function} callback - the specific handler to remove. If null removes all callbacks for the named event
     * @param {*} context - the specific context-bound handler to remove. If null removes all callbacks for the function
     */
    self.off = function (name, callback, context) {
        var retain = void 0,
            event = void 0,
            listeners = void 0,
            i = void 0,
            len = void 0;
        if (!name && !callback && !context || !allListeners[name]) {
            return;
        }

        listeners = allListeners[name];

        allListeners[name] = retain = [];
        if (callback || context) {
            for (i = 0, len = listeners.length; i < len; i++) {
                event = listeners[i];
                if (callback && callback !== event.callback && callback !== event.callback._callback || context && context !== event.context) {
                    retain.push(event);
                }
            }
        }

        if (retain.length === 0) {
            delete allListeners[name];
        }
    };

    /**
     * Trigger one or many events, firing all bound callbacks. Callbacks are
     * passed the same arguments as `trigger` is, apart from the event name.
     * "Public Events" will be triggered on the root scope
     * @param {String} name - the name of the event to trigger
     * @param {*} [args] - optional arguments to pass to listeners
     */
    self.trigger = function (name) {
        var listeners = allListeners[name];

        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
        }

        if (!listeners) {
            triggerRootScopeEvent.apply(undefined, [name].concat(args));
            return;
        }

        // A difficult-to-believe, but optimized internal dispatch function for
        // triggering events. Tries to keep the usual cases speedy (most internal
        // events have < 3 arguments).
        var ev = void 0,
            i = -1;
        var l = listeners.length,
            a1 = args[0],
            a2 = args[1],
            a3 = args[2];
        switch (args.length) {
            case 0:
                while (++i < l) {
                    (ev = listeners[i]).callback.call(ev.ctx);
                }break;
            case 1:
                while (++i < l) {
                    (ev = listeners[i]).callback.call(ev.ctx, a1);
                }break;
            case 2:
                while (++i < l) {
                    (ev = listeners[i]).callback.call(ev.ctx, a1, a2);
                }break;
            case 3:
                while (++i < l) {
                    (ev = listeners[i]).callback.call(ev.ctx, a1, a2, a3);
                }break;
            default:
                while (++i < l) {
                    (ev = listeners[i]).callback.apply(ev.ctx, args);
                }}

        triggerRootScopeEvent.apply(undefined, [name].concat(args));
    };

    /**
     * Trigger one or many events, firing all bound callbacks and collecting their return values.
     * "Public Events" are not triggered on the root scope.
     * @param name
     * @param args
     * @returns {Array} An array of return values for each listener
     */
    // TODO: This feels like a code smell. The implementation for this trigger is different than the default trigger, and collecting return values kind of defeats the point of the decoupling that this class offers.
    self.triggerWithReturn = function (name) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
        }

        var listeners = allListeners[name];
        if (!listeners) {
            return [];
        }

        return listeners.map(function (listener) {
            return listener.callback.apply(listener.ctx, args);
        });
    };

    /**
     * Removes all callbacks bound to a given context
     * @param context
     */
    self.disconnect = function (context) {
        if (!context) {
            return;
        }
        Object.keys(allListeners).forEach(function (key) {
            var listeners = allListeners[key];
            listeners.forEach(function (event) {
                if (event.context === context) {
                    self.off(key, event.callback, event.context);
                }
            });
        });
    };

    /**
     * Create a child event channel.
     * @param {object} source Provides a means of tracking the source of the events
     * @param publicEvents
     * @returns {EventChannel}
     */
    self.$new = function (source, publicEvents) {
        var child = new EventChannel(source, publicEvents);
        child.parent = self;
        children.push(child);
        return child;
    };

    /**
     * Destroys all event listeners on this event channel and all its children. Use when tearing down
     * an element. Use this to assist in the prevention of memory leaks!
     * Note that this method doesn't actually `delete` references to its children; that's left up to
     * the browser's garbage collector.
     */
    self.$destroy = function () {
        self.trigger('$destroy');
        Object.keys(allListeners).forEach(function (key) {
            self.off(key);
        });
        children.forEach(function (child) {
            child.$destroy();
        });
    };

    /* *****************************************************************************************************
     * Private / Helper Methods
     ***************************************************************************************************** */

    var getRootChannel = function getRootChannel() {
        if (!rootChannel) {
            var parent = self.parent || self;
            while (parent.parent) {
                parent = parent.parent;
            }
            rootChannel = parent;
        }
        return rootChannel;
    };

    var triggerRootScopeEvent = function triggerRootScopeEvent(name) {
        for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            args[_key4 - 1] = arguments[_key4];
        }

        if (publicEvents.indexOf(name) >= 0 && getRootChannel() && rootChannel !== self) {
            var _rootChannel;

            (_rootChannel = rootChannel).trigger.apply(_rootChannel, [name, source].concat(args));
        }
    };
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UrlBuilder = UrlBuilder;
function UrlBuilder(inUrlRoot, inImageId) {
    var opt_quality = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 80;

    var self = this;
    var urlRoot = inUrlRoot;
    var imageId = inImageId;
    var imageQuality = '+' + opt_quality;

    self.setImageId = function (id) {
        imageId = id;
        var idx = urlRoot.lastIndexOf('@');
        urlRoot = urlRoot.substr(0, idx) + imageId; //imageId has leading @ sign
    };

    self.getImageId = function () {
        return imageId;
    };

    self.setQuality = function (quality) {
        if (quality > 50) {
            imageQuality = '+' + quality;
        }
    };

    self.thumb = function (width, height) {
        // example aperio imageserver format (when connected thru apache) : /imageserver/@2?0+0+435+0+-1
        // - note that id is not used as it is appended already to the 'urlRoot'
        return urlRoot + '?' + '0+0+' + width + '+' + height + '+-1';
    };

    self.label = function (width, height) {
        // example aperio imageserver format (when connected thru apache) : /imageserver/@2?0+0+122+122+-2
        // - note that id is not used as it is appended already to the 'urlRoot'
        return urlRoot + '?' + '0+0+' + width + '+' + height + '+-2';
    };

    self.region = function (x, y, width, height, zoom, opt_progressive) {
        // I would like to round each of these values as they come in, but the ImageServer has some odd rules about how
        // it interprets these values. For instance, prefixing X and Y coordinates tells it that the coordinate is
        // actually relative to the image's base coordinates. I'm not sure what other odd rules are embedded in that
        // server but given how often this method is called I feel its too risky to attempt to round coming requests.

        // example aperio imageserver format (when connected thru apache) : /imageserver/@2?0+0+1956+1628+27
        // - note that id is not used as it is appended already to the 'urlRoot'
        var url = urlRoot + '?' + x + '+' + y + '+' + width + '+' + height + '+' + zoom + imageQuality;
        if (opt_progressive) url += '+P';
        return url;
    };
}

/***/ }),
/* 313 */,
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.vp_mousemove = undefined;
exports.VP_MOUSEWHEEL = VP_MOUSEWHEEL;
exports.VP_MOUSEHANDLER = VP_MOUSEHANDLER;
exports.vp_mousedown = vp_mousedown;
exports.vp_mouseup = vp_mouseup;
exports.vp_mousedclick = vp_mousedclick;

var _lbsPiDash = __webpack_require__(5);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _helpers = __webpack_require__(4);

var _uScope = __webpack_require__(78);

var _uScope2 = _interopRequireDefault(_uScope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// navigation.js
//    This file contains the viewportAP object event handlers.
//
//    history
//    1105     cperz        created
//    _______________________________________end_AIHv1/PR __________________________________________
//    141118    cperz        move RasterScanService to its own file;  move other fns to us namespace;
//    141120    cperz        add support for negative pen
//    150318    cperz        minor cleaning
//________________________________________________________________________________________________

//............................................ VP_MOUSEWHEEL
// VP_MOUSEWHEEL - This function dispatches the viewport mouse wheel events.
// TODO: Only used by Viewport AP
function VP_MOUSEWHEEL(viewport, e, delta, deltaX, deltaY) {
    if (_defines2.default.DISABLEWHEELZOOM) {
        return;
    }

    viewport.setImageSelected();

    if (deltaY) {
        // deltaY -> zoom
        viewport.zoomStep(-deltaY * _defines2.default.zoomSpecs.stepFactor);
    }

    if (deltaX != 0) {
        // deltaX -> pan
        var dx = deltaX * 20;
        viewport.moveRelative(dx, 0);
    }
    return true;
}

//............................................ VP_MOUSEHANDLER
//    VP_MOUSEHANDLER - This function dispatches viewport mouse click and move events.
function VP_MOUSEHANDLER(viewport, e) {
    e.preventDefault(); // necessary for IE panning to halt properly when pan cursor moves off viewport

    // TODO: How often does this fire when simply moving the mouse?
    // The mousemove event is constantly captured yet it is only relevant when in conferencing or in a navmode. So get out as soon as possible
    if (e.type == 'mousemove' && viewport.navModeGet() == _defines2.default.eNavModes.nmNone && _uScope2.default.instance.isRegionCopyActive() == false && _uScope2.default.instance.isModeConference() == false) {
        return;
    }

    var sClassList = (0, _helpers.getClassList)(e.currentTarget); // provides sTargetClass === us.clsVIEWPORT
    if ((0, _helpers.isUnDefined)(sClassList)) return;
    var sTargetClass = sClassList[0];

    switch (e.type) {
        case 'mousedown':
            if (sTargetClass == _defines2.default.clsVIEWPORT || sTargetClass == _defines2.default.clsAPANIMG) vp_mousedown(viewport, e);
            break;
        case 'mousemove':
            if (sTargetClass == _defines2.default.clsVIEWPORT || sTargetClass == _defines2.default.clsAPANIMG) {
                // ok if mouse cursor touches autopan image
                vp_mousemove(viewport, e);
            } else {
                vp_mouseup(viewport, e, _defines2.default.NOTTOUCHEVENT); // if targetClass is something unknown, just stop nav mode via mouseup
            }
            break;
        case 'focus':
        case 'blur':
        case 'mouseup':
        case 'mouseleave':
            if (sTargetClass == _defines2.default.clsVIEWPORT) {
                vp_mouseup(viewport, e, _defines2.default.NOTTOUCHEVENT);
            }
            break;
        case 'dblclick':
            if (sTargetClass == _defines2.default.clsVIEWPORT) vp_mousedclick(viewport, e);
            break;
        default:
            // ('unimplemented VP_MOUSEHANDLER event: ' + e.type); // eslint-disable-line no-undef
    }
}

//............................................ vp_mousedown
// vp_mousedown - This function handles mousedown and touchstart events for the viewport.
// TODO: Used by Events JS (touchscreen support only)
function vp_mousedown(viewport, e, isTouchEvent) {
    viewport.focus(); // force focus on this vp for hot keys
    var anObj = viewport.getAnnotObj();
    if (anObj) anObj.regHoverShow(false); // hide any hovering note

    $(_defines2.default.idHashROOT).find('.' + _defines2.default.clsPANELCLICKCLOSE).dialog('close'); // close click-closable panels

    if (e.which == _defines2.default.eEVENTWHICHBTN.right) {
        // on right click (context menu)
        _uScope2.default.instance.setImageSelected(viewport.getImageIdx()); // insure this is the selected image
        return; // and return, nothing else to do here
    }

    var cpVpRelPos = _defines2.default.coordPageToView(e, viewport); // the unrotated viewport relative cursor position
    viewport.setMouseDown(cpVpRelPos.x, cpVpRelPos.y); // save last mouse down position

    var navMode = viewport.navModeGet(); // cache nav mode since it can be set inside the switch statement
    if (navMode != _defines2.default.eNavModes.nmNone) // don't compute basePos unless needed
        var basePos = _defines2.default.coordBaseImage2(cpVpRelPos, viewport); // the cursor in base image coords

    switch (navMode) {
        case _defines2.default.eNavModes.nmNone:
            // mouse down when no nav mode happening means start of drag image navigation or pinch zoom
            if (isTouchEvent && e.touches.length > 1) {
                // start pinch zoom
                viewport.navModeSwitch(_defines2.default.eNavModes.nmPinchZoom);
            } else {
                // start drag mode
                viewport.setCursor('move'); // change to move cursor
                viewport.navModeSwitch(_defines2.default.eNavModes.nmDragImage);
                viewport.setMouseCur(cpVpRelPos.x, cpVpRelPos.y, 'initPrev'); // initialize previous mouse cursor position to this too
            }
            break;
        case _defines2.default.eNavModes.nmAnnotPin:
            // start (and finish) drawing the pin, text
            // mouse down when annotate pin, text and report region means set element here
            if (anObj) {
                var anType = _defines2.default.eAnTypes.pin;
                anObj.startNew(anType, basePos, viewport.getViewZoom(), viewport.getViewAngle(true));
            }
            break;
        case _defines2.default.eNavModes.nmAnnotText:
            anObj.createTextAt(anObj, basePos);
            break;
        case _defines2.default.eNavModes.nmAnnotReport:
            if (anObj) anObj.startNew(_defines2.default.eAnTypes.report, basePos, viewport.getViewZoom(), viewport.getViewAngle(true));
            break;
        case _defines2.default.eNavModes.nmAnnotRect: // mousedown for these region types starts drawing
        case _defines2.default.eNavModes.nmAnnotEllipse:
        case _defines2.default.eNavModes.nmAnnotPen:
        case _defines2.default.eNavModes.nmAnnotArrow:
        case _defines2.default.eNavModes.nmAnnotNegPen:
            if (anObj) {
                var anType = _defines2.default.eAnTypes.rect; //cp-could cure this mess with a data structure
                if (navMode === _defines2.default.eNavModes.nmAnnotEllipse) anType = _defines2.default.eAnTypes.ellipse;else if (navMode === _defines2.default.eNavModes.nmAnnotArrow) anType = _defines2.default.eAnTypes.arrow;else if (navMode === _defines2.default.eNavModes.nmAnnotPen) anType = _defines2.default.eAnTypes.pen;else if (navMode === _defines2.default.eNavModes.nmAnnotNegPen) anType = _defines2.default.eAnTypes.negpen;
                anObj.startNew(anType, basePos, viewport.getViewZoom(), viewport.getViewAngle(true));
            }
            break;
        case _defines2.default.eNavModes.nmAnnotCaliper: // caliper sets new position down on each mousedown
        case _defines2.default.eNavModes.nmAnnotPolygon:
            // caliper sets new position down on each mousedown
            if (anObj) {
                if (anObj.drawingIsStarted()) // if already drawing, update caliper tool
                    anObj.updateNew(basePos, 'mousedown');else {
                    // otherwise, start drawing the caliper or polygon
                    var type = navMode == _defines2.default.eNavModes.nmAnnotCaliper ? _defines2.default.eAnTypes.caliper : _defines2.default.eAnTypes.polygon;
                    anObj.startNew(type, basePos, viewport.getViewZoom(), viewport.getViewAngle(true));
                }
            }
            break;
        case _defines2.default.eNavModes.nmRedrawStarting:
            // start pen redraw mode
            if (anObj) {
                if (anObj.regReDraw('start', basePos, viewport.getViewZoom())) {
                    viewport.navModeSwitch(_defines2.default.eNavModes.nmRedraw);
                }
            }
            break;
        case _defines2.default.eNavModes.nmAutoPan:
            // mouse down when autopanning means stop
            viewport.navModeHalt();
            break;
        case _defines2.default.eNavModes.nmRasterScan:
            // mouse down when rastering means stop
            _uScope2.default.instance.rasterPanel.pause(); // pause raster scan
            viewport.navModeHalt();
            break;
        case _defines2.default.eNavModes.nmZoom:
        case _defines2.default.eNavModes.nmDClickZoom:
            // can this happen?
            break;
        default:
    }
}

//............................................ vp_mousemove
// vp_mousemove - This function dispatches the mousemove and touchmove events.
// TODO: Used by Events JS (apparently for touchscreen support) and Markup Service (because...?)
var vp_mousemove = exports.vp_mousemove = function vp_mousemove(viewport, e, isTouchEvent) {
    var navMode = viewport.navModeGet();
    var cpVpRelPos = _defines2.default.coordPageToView(e, viewport); // the unrotated viewport relative cursor position

    if (_uScope2.default.instance.isConfLeader()) {
        // only in conferencing are mouse states recorded
        var basePos = _defines2.default.coordBaseImage2(cpVpRelPos, viewport); // the cursor in base image coords
        viewport.stateVector.mouseUpdate(basePos, 'mousemove', true); // force a save of this mouse move event
    }
    if (_uScope2.default.instance.isRegionCopyActive() == true) {
        //todo: call into a uScope region toolbar fn instead of doing this here...
        var crsrPosBase = _defines2.default.coordBaseImage(e, viewport); // compute the position of the cursor in base image coords
        var anObj = viewport.getAnnotObj();
        anObj.regMoveCenter(crsrPosBase);
    }
    switch (navMode) {
        case _defines2.default.eNavModes.nmDragImage:
            // mouse move in drag image navigation
            if (isTouchEvent && e.touches.length > 1) {
                // swiping but two fingers show up, switch out of drag and start pinch zoom
                viewport.navModeSwitch(_defines2.default.eNavModes.nmPinchZoom); // note - this is very unusual but make pinch initiation more reliable
                return;
            }
            var ptDelta = viewport.setMouseCurRtnDiff(cpVpRelPos.x, cpVpRelPos.y);
            if (ptDelta.x != 0 || ptDelta.y != 0) // note that this occurs more than you'd imagine
                viewport.moveRelative(ptDelta.x, ptDelta.y); // move the image dx, dy
            break;
        case _defines2.default.eNavModes.nmPinchZoom:
            if (viewport.initDist == 0 && e.changedTouches.length > 1) {
                var dx = e.changedTouches[0].clientX - e.changedTouches[1].clientX;
                var dy = e.changedTouches[0].clientY - e.changedTouches[1].clientY;
                viewport.initDist = parseInt(Math.sqrt(dx * dx + dy * dy));
                viewport.initMag = viewport.getViewMag();
            } else if (e.changedTouches.length > 1) {
                // insure two touches, sometimes there is only one!
                var dx = e.changedTouches[0].clientX - e.changedTouches[1].clientX;
                var dy = e.changedTouches[0].clientY - e.changedTouches[1].clientY;
                var curDist = parseInt(Math.sqrt(dx * dx + dy * dy));

                var scale = (1.0 - (viewport.initDist - curDist) / viewport.initDist).toFixed(3);
                var mag = viewport.initMag * scale;
                var zoom = viewport.convertToZoom(mag);
                zoom = (0, _helpers.roundToDecimals)(zoom);
                if (zoom !== viewport.getViewZoom()) {
                    viewport.zoomAbsolute(zoom);
                }
            }
            break;

        case _defines2.default.eNavModes.nmAnnotRect:
        case _defines2.default.eNavModes.nmAnnotEllipse:
        case _defines2.default.eNavModes.nmAnnotPen:
        case _defines2.default.eNavModes.nmAnnotNegPen:
        case _defines2.default.eNavModes.nmAnnotReport:
        case _defines2.default.eNavModes.nmAnnotArrow:
            var basePos = _defines2.default.coordBaseImage2(cpVpRelPos, viewport); // the cursor in base image coords
            if (viewport.getAnnotObj()) viewport.getAnnotObj().updateNew(basePos, 'mousemove');
            break;
        case _defines2.default.eNavModes.nmAnnotPin: // nothing to do on mouse move for pin, text
        case _defines2.default.eNavModes.nmAnnotText:
            break;
        case _defines2.default.eNavModes.nmAnnotCaliper:
        case _defines2.default.eNavModes.nmAnnotPolygon:
            // caliper sets new position down on each mousedown
            var basePos = _defines2.default.coordBaseImage2(cpVpRelPos, viewport); // the cursor in base image coords
            if (viewport.getAnnotObj()) viewport.getAnnotObj().updateNew(basePos, 'mousemove');
            break;
        case _defines2.default.eNavModes.nmRedraw:
            // continue pen redraw
            var basePos = _defines2.default.coordBaseImage2(cpVpRelPos, viewport); // the cursor in base image coords
            var anObj = viewport.getAnnotObj(); // the annot object
            if (anObj) {
                if (anObj.regReDraw('update', basePos, viewport.getViewZoom()) == false) anObj.regReDraw('finish');
            }
            break;
        case _defines2.default.eNavModes.nmAutoPan:
            //  autopan motion is controlled on a timer but it needs the current mouse position
            viewport.setMouseCur(cpVpRelPos.x, cpVpRelPos.y); // update current mouse position in vp
            break;
        case _defines2.default.eNavModes.nmRasterScan:
            break;
        case _defines2.default.eNavModes.nmRotatingOverlay:
            viewport.scaleBar.rotateToCursor(e); // scale bar rotation .. same code in scalebar mousemove
            break;
        default:
    }
};

//............................................ vp_mouseup
// vp_mouseup - This function dispatches mouse up events that usually indicate either an end to drawing
//                or and end to a nvaigation mode, with a few exceptions.
function vp_mouseup(viewport, e) {
    switch (viewport.navModeGet()) {
        case _defines2.default.eNavModes.nmDragImage:
            if (_defines2.default.ENABLEDRAGMOMENTUM && viewport.isFitZoom() == false) {
                // if enabled and not fit zoom, finish drag with momentum
                viewport.navModeHalt(); // must halt before drag momentum
                viewport.viewDragMomemtumGo();
            } else {
                viewport.navModeHalt();
            }
            break;
        case _defines2.default.eNavModes.nmThumbDragImage:
            // thumb mouse up passes thru here
            viewport.navModeHalt();
            break;
        case _defines2.default.eNavModes.nmDClickZoom:
        case _defines2.default.eNavModes.nmZoom:
            break;
        case _defines2.default.eNavModes.nmPinchZoom:
            viewport.initDist = 0; // reset distance measurement
            viewport.navModeHalt(); // must halt first so that final zoom can use all pyr levels
            viewport.zoomAbsolute((0, _helpers.roundToDecimals)(viewport.picZoom)); // execute the zoom
            break;
        case _defines2.default.eNavModes.nmAnnotArrow:
        case _defines2.default.eNavModes.nmAnnotRect:
        case _defines2.default.eNavModes.nmAnnotEllipse:
        case _defines2.default.eNavModes.nmAnnotPen:
        case _defines2.default.eNavModes.nmAnnotNegPen:
        case _defines2.default.eNavModes.nmAnnotReport:
            // halt nav mode these drawing tools
            if (viewport.getAnnotObj()) {
                viewport.getAnnotObj().finishNew();
            }
            viewport.navModeHalt();
            break;
        case _defines2.default.eNavModes.nmAnnotCaliper: // halt nav mode on mouse leave for caliper but not mouse up
        case _defines2.default.eNavModes.nmAnnotPolygon:
            // caliper sets new position down on each mousedown
            if (e.type == 'mouseleave' && viewport.getAnnotObj()) {
                viewport.getAnnotObj().finishNew();
                viewport.navModeHalt();
            }
            break;
        case _defines2.default.eNavModes.nmRedraw:
        case _defines2.default.eNavModes.nmRedrawStarting:
            if (viewport.getAnnotObj()) {
                viewport.getAnnotObj().regReDraw('finish');
            }
            viewport.navModeHalt();
            break;
        case _defines2.default.eNavModes.nmAutoPan:
            // if the mouse just rolled over the autopan center target, don't halt nav
            // note: since there can be multiple classNames (space delimited) so string-in-string is performed
            if (e.relatedTarget.className.indexOf(_defines2.default.clsAPANIMG) === -1) {
                viewport.navModeHalt();
            }
            break;
        case _defines2.default.eNavModes.nmRasterScan:
            break;
        default:
            viewport.navModeHalt();
    }
}

//............................................ vp_mousedclick
// vp_mousedclick - This function dispatches mouse double click events.
// TODO: Used by Events JS (touchscreen support only)
function vp_mousedclick(viewport, e, isTouchEvent) {

    // for iOS: the manner in which the double click is detected does not provide the
    //            touch event in e and the page coords are 0,0
    if (isTouchEvent) {
        var mdPos = viewport.getMouseDown();
        var e = jQuery.Event('', { pageX: mdPos.x, pageY: mdPos.y }); // create event
    }

    switch (viewport.navModeGet()) {
        case _defines2.default.eNavModes.nmNone:
            viewport.zoomDblClick(e, isTouchEvent);
            break;
        case _defines2.default.eNavModes.nmAnnotCaliper:
        case _defines2.default.eNavModes.nmAnnotPolygon:
            var anObj = viewport.getAnnotObj();
            if (anObj && anObj.drawingIsStarted()) {
                var crsrPosBase = _defines2.default.coordBaseImage(e, viewport); // compute the position of the cursor in base image coords
                anObj.updateNew(crsrPosBase, 'mousedown');
                anObj.finishNew();
                viewport.navModeHalt();
            }
            break;
    }
}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(502), __esModule: true };

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(32) && !__webpack_require__(140)(function(){
  return Object.defineProperty(__webpack_require__(83)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(74)
  , $export        = __webpack_require__(45)
  , redefine       = __webpack_require__(322)
  , hide           = __webpack_require__(35)
  , has            = __webpack_require__(84)
  , Iterators      = __webpack_require__(47)
  , $iterCreate    = __webpack_require__(511)
  , setToStringTag = __webpack_require__(75)
  , getPrototypeOf = __webpack_require__(517)
  , ITERATOR       = __webpack_require__(3)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(164)
  , createDesc     = __webpack_require__(142)
  , toIObject      = __webpack_require__(85)
  , toPrimitive    = __webpack_require__(168)
  , has            = __webpack_require__(84)
  , IE8_DOM_DEFINE = __webpack_require__(316)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(32) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(321)
  , hiddenKeys = __webpack_require__(162).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 320 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(84)
  , toIObject    = __webpack_require__(85)
  , arrayIndexOf = __webpack_require__(507)(false)
  , IE_PROTO     = __webpack_require__(165)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(35);

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 This file contains debug switches for console reporting and disabling of features.

 The following switches can be overridden by uScopeStart's settings ...................
 */

_defines2.default.DISABLEOVERLAYITEMS = false; // default false, enable load label, mag, thumb, scalebar, zoom, toolbar
_defines2.default.ENABLELABEL = true; // default true, enable load/create of the label
_defines2.default.ENABLEMAG = true; // default true, enable load/create of the magnifier
_defines2.default.ENABLETHUMB = true; // default true, enable load/create of the thumbnail
_defines2.default.ENABLESCALEBAR = true; // default true, enable load/create of the scale bar
_defines2.default.ENABLEZOOMCTL = true; // default true, enable load/create of the zoom control
_defines2.default.ENABLEZOOMSLIDER = true; // default true, enable load/create of the zoom slider control
_defines2.default.ENABLEROTATION = true; // default true, enable image rotation
_defines2.default.ENABLEHEATMAP = true; // default true, visibility and draw switch
_defines2.default.ENABLEAUTOANNOTSAVE = true; // default true, enable automatic (as drawn) save annotations
_defines2.default.ENABLEANNOTCREATE = true; // default true, [dis|en]able annotation creation
_defines2.default.ENABLEANNOTSELSAVE = false; // default false, enable save each region select action - NOT overridden (yet) by start settings
_defines2.default.ENABLELINKTOIMAGE = false; // default false, provide link to image

////////////////////////////////////in work
////us.ENABLEANALYSIS = true;	// default true overridden by VIL's settings/toolbarOptions/imageAnalysis //todo: ??? move me???
_defines2.default.ENABLERUNANALYSIS = false; //in-work
////////////////////////////////////

//........................... the following switches are used for development purposes  ...................

_defines2.default.ENABLEDEVHOTKEYS = false; // default false, permit development hotkey action
_defines2.default.SHOWALLTOOLBARICONS = false; // default false, display all top toolbar icons
_defines2.default.ENABLEPERFTEST = false; // disabled on purpose until fixed in multi-image        // default true, permit performance testing (expose on settings panel)

_defines2.default.ENABLEVIEWPREVNEXT = false; // default false, previous/next VIEW .... until this is exposed to the user

_defines2.default.ENABLEADDTOANYLAYER = false; // default false, add all new regions to A-layer

_defines2.default.DISABLEEXTERNALCALLBACKS = false; // default false, do not issue any callbacks; useful when callbacks crash

_defines2.default.DISABLEUSERPREFS2DB = false; // default false, inhibit read/write to database

_defines2.default.DISABLEWHEELZOOM = false; // default false, inhibit zoom with mouse wheel
_defines2.default.ENABLEDRAGMOMENTUM = true; // default true, perform drag momentum

_defines2.default.ENABLEPROGRESSIVE = true; // default true, perform fake progressive rendering

_defines2.default.ENABLETILEMETER = false; // default false, don't perform tile timing
_defines2.default.ENABLEREFRESHMETER = false; // default false, display refresh meter with tilemeter

_defines2.default.ENABLECONTEXTMENU = true; // default true, right click context toolbar


// the following are performance and visual options .....................
_defines2.default.DOVERTICALZOOMCTL = true; // default true, zoom controls can be horizontal
_defines2.default.DOZOOMCOLOR = true; // default true, add objective color codes to zoom buttons
_defines2.default.ENABLETHUMBHOVER = true; // default true, allows hover over thumbnail to enlarge thumbnail
_defines2.default.ENABLEIMAGEQUALITYSETTING = false; // This does nothing but display an image qualify slider, which isn't actually hooked up.
_defines2.default.ENABLEAUTOPAN = true; // default true,

// the following are view refresh and tile construction option .........
_defines2.default.ENABLEPYRAMIDREFRESH = true; // default true, tile requests at pyramid levels (as opposed to server side scaling)
_defines2.default.USEMULTIPYRAMIDLEVELS = true; // default true, refresh at multiple pyrmaid levels
_defines2.default.ADDINTERMEDIATELEVEL = true; // default true, add intermediate pyramid level half way between gaps > 3x (e.g 10x between 20 and 5)
_defines2.default.USEBASECOORDS = false; // default false, tile url to use base level coords or directly address the zoom level

_defines2.default.ONLYLOWPYRAMIDLEVEL = false; // default false, override multiple level to only display refresh of low pyr level zoom.... for testing

//________________________________________________________________________________________________
// the following switches are used for debug  purposes  ...................

_defines2.default.DBGTILEBOUNDARIES = false; // outline tile boundaries

_defines2.default.DBGSTART = false; // console startup and image open reports
_defines2.default.DBGLOAD = false; // console load script reports
_defines2.default.DBGXINFO = false; // console xinfo reports
_defines2.default.DBGPYRAMID = false; // console xinfo pyramid reports

_defines2.default.DBGANNOT = false; // console annotation reports
_defines2.default.DBGREDRAW = false; // console freeform/pen redraw reports
_defines2.default.DBGANNOTEX = false; // console annotation reports - extreme
_defines2.default.DBGPDNAV = false; // console pin drop navigation reports

_defines2.default.DBGTILEMETER = false; // console tile meter reports
_defines2.default.DBGVIEWMETER = false; // console view meter reports

_defines2.default.DBGMULTIVIEW = false; // console multi-image reports

_defines2.default.DBGANALYSIS = false; // console analysis reports
_defines2.default.DBGMARKUP = false; // console markup reports
_defines2.default.DBGMARKUPEX = false; // console markup reports extended
_defines2.default.DBGMACROS = false; // console macro reports
_defines2.default.DBGALGOS = false; // console algorithm reports
_defines2.default.DBGTUNING = true; /////

_defines2.default.DBGTHREAD = false; // console thread reports
_defines2.default.DBGEVENTS = false; // console event reports - all but mouse
_defines2.default.DBGMOUSEEVENTS = false; // console mouse event reports - all but mouse move
_defines2.default.DBGMOUSEMOVE = false; // console mouse move reports
_defines2.default.DBGDCLICK = false; // console mouse double click reports

_defines2.default.DBGNAV = false; // console navigation reports
_defines2.default.DBGMOMENTUM = false; // console drag momentum reports
_defines2.default.DBGRESIZE = false; // console resize reports

_defines2.default.DBGIOS = false; // console ios reports
_defines2.default.DBGSWIPE = false; // console ios swipe reports
_defines2.default.DBGPINCH = false; // console ios pinch zoom reports

_defines2.default.DBGRASTERSCAN = false; // console rasterScan reports
_defines2.default.DBGAUTOPAN = false; // console autopan reports
_defines2.default.DBGEDGENAV = false; // console edge nav reports

_defines2.default.DBGMSGING = false; // console messaging reports
_defines2.default.DBGIMAGEPAINT = false; // console refresh reports and tile coords printed on each tile
_defines2.default.DBGIMAGEPAINTEX = false; // console refresh reports - extreme
_defines2.default.DBGTILEBUILD = false; // console build tile reports

_defines2.default.DBGPROGRESSIVE = false; // console progressive image reports

_defines2.default.DBGIMGLOAD = false; // console tile load reports
_defines2.default.DBGTIME = false; // console time reports for: tile, row of tiles,

_defines2.default.DBGMOVETIME = false; // console time reports for view move
_defines2.default.DBGREFRESHTIME = false; // console time reports for view refresh
_defines2.default.DBGPERFTEST = false && _defines2.default.ENABLEPERFTEST; // console reports on performance testing

_defines2.default.DBGSTATEVECTOR = false; // console state vector reports
_defines2.default.DBGSTATEVECTOREX = false; // console state vector reports - extreme

_defines2.default.DBGLAYOUT = false; // console overlay layout reports
_defines2.default.DBGVIEWLAYOUT = false; // console view layout reports
_defines2.default.DBGTHUMBCTL = false; // console thumbnail reports
_defines2.default.DBGTHUMBVFCTL = false; // console thumbnail viewfinderreports
_defines2.default.DBGLABELCTL = false; // console label reports
_defines2.default.DBGMARKERCTL = false; // console marker reports
_defines2.default.DBGMAGCTL = false; // console magnifier reports

_defines2.default.DBGZOOMCTL = false; // console zoom control and zoom execution reports
_defines2.default.DBGZMBTNPYRAMID = false; // construct a zoom button control with LOTS of zoom choices

_defines2.default.DBGTOOLBAR = false; // toolbar reports
_defines2.default.DBGOPTIONS = false; // options (settings) panel reports

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var template = '<div class="lbs-notification-bar lbs-dismissable">\n    <div class="lbs-status-icon lbs-status-icon-medium lbs-status-icon-$TYPE"></div>\n    <h4>$MESSAGE</h4>\n    <button class="lbs-notification-dismiss-button"></button>\n</div>';

var createNotificationBar = exports.createNotificationBar = function createNotificationBar(type, message) {
    var container = document.createElement('div');
    container.innerHTML = template.replace('$TYPE', type).replace('$MESSAGE', message);

    // Center this on the bottom of the uScope div.
    Object.assign(container.style, {
        zIndex: 9999,
        position: 'absolute',
        minWidth: '560px',
        left: '25%',
        right: '25%',
        bottom: 0,
        height: '60px'
    });

    // Wire up the close button.
    var closeButton = container.querySelectorAll('.lbs-notification-dismiss-button')[0];
    closeButton.addEventListener('click', function () {
        ui.hide();
    });

    // Animate this thing.
    var notification = container.querySelectorAll('div')[0];

    var ui = {
        show: function show() {
            notification.classList.add('lbs-animate-enter');
            setTimeout(function () {
                notification.classList.remove('lbs-animate-enter');
            }, 5);
        },
        hide: function hide() {
            notification.classList.add('lbs-animate-leaving');
            notification.addEventListener('transitionend', container.remove);
        },

        container: container
    };

    return ui;
};

/***/ }),
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _conferencingService = __webpack_require__(381);

var _conferencingService2 = _interopRequireDefault(_conferencingService);

var _conferencingMarker = __webpack_require__(379);

var _conferencingMarker2 = _interopRequireDefault(_conferencingMarker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The conferencing service operates in global scope and can destroy or spin up uScope instances. In order to do this it
// needs to be able to exist in global scope. Note that it shouldn't need to destroy uScope, but since that's a
// singleton, we're doing this for now...
var conferencingSingleton = void 0;

exports.default = {
    createService: function createService(uScope) {
        if (!conferencingSingleton) {
            conferencingSingleton = new _conferencingService2.default(uScope);
        } else {
            conferencingSingleton.setUScope(uScope);
        }

        // HACK ALERT - extend uScope with conferencing methods. Don't want to break existing implementations
        uScope.confCreate = conferencingSingleton.confCreate;
        uScope.isConfLeader = conferencingSingleton.isConfLeader;
        uScope.isModeConference = conferencingSingleton.isInConference;
        uScope.isConfMember = conferencingSingleton.isConfMember;

        // Note that this can be refactored to "extend" the viewport and simplify this nest a little
        uScope.events.on('uscope:image:init', function (viewport) {
            viewport.events.on('viewport:initialize-layout', function () {
                new _conferencingMarker2.default(viewport);
            });
        });

        return conferencingSingleton;
    }
};
module.exports = exports['default'];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ConferenceMarker;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _objects = __webpack_require__(16);

var _constants = __webpack_require__(155);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ConferenceMarker(viewport) {
    var jVpDiv = viewport.vpDivGet();
    var jConfMarker;

    var cpOffset = new _objects.Point(0, 0);

    //............................................ move_local
    //    This function positions the conference marker offset from the current cursor
    //    or can hide the marker.  CoordSystem of marker is us.coordSystemNORM
    var move_ = function move_(xBase, yBase) {
        if (!jConfMarker) {
            return;
        }
        var cpLT = viewport.getViewLeftTop(_defines2.default.coordSystemNORM);
        var zoom = viewport.getViewZoom();
        var x = Math.floor((xBase - cpLT.x) / zoom - cpOffset.x);
        var y = Math.floor((yBase - cpLT.y) / zoom - cpOffset.y);
        jConfMarker.css({
            display: 'block',
            left: x + 'px',
            top: y + 'px'
        });
    };
    //............................................ load_() local
    //    This function loads the conference marker
    var load_ = function load_() {
        if (jConfMarker) return; // if this viewport already has a marker, return

        // first create an offscreen div that will contain the marker img and add it to the vp
        jConfMarker = $('<div/>', { // build the div tag that contains the img tag
            class: _defines2.default.clsDIVMARKER, // dsc marker class sets its own z-index
            css: {
                display: 'none'
            }
        });
        jVpDiv.append(jConfMarker); // place the marker div in the vp

        cpOffset.x = Math.floor(jConfMarker.width() / 2); // define marker's offset from cursor
        cpOffset.y = Math.floor(jConfMarker.height() / 2);

        bindEvents_(); // add event handlers

        //..................................................
        // closure functions
        //............................................ bindEvents_()
        function bindEvents_() {
            var namespace = viewport.eventNameSpaceGet();

            // show/hide conference marker of conference leader/follower
            $(_defines2.default.idHashROOT).on(CONSTANTS.CONFERENCE_MARKER_EVENT + namespace, function (e, parms) {
                if (viewport.getImageId() == parms.imageId) // move marker on the matching image
                    move_(parms.MarkerX, parms.MarkerY);else // hide the marker on non-matching images
                    jConfMarker.css({
                        display: 'none'
                    });
            });
        }
    };

    load_();
}
module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

var _browserCompatibility = __webpack_require__(26);

var _constants = __webpack_require__(155);

var CONSTANTS = _interopRequireWildcard(_constants);

var _conferencingFactory = __webpack_require__(378);

var _conferencingFactory2 = _interopRequireDefault(_conferencingFactory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_publicApi2.default.plugins.register({
    name: 'us:conferencing',

    extends: 'uScope',

    canStart: function canStart(uScope) {
        return !_browserCompatibility.env.isIOS && uScope.toolbarCanAddButton('dscSetupBtn');
    },


    constructor: function constructor(uScope) {
        var conferencingService = _conferencingFactory2.default.createService(uScope);

        addToolbarButton(conferencingService, uScope);
    }
});

var addToolbarButton = function addToolbarButton(conferencingService, uScope) {
    var button = $('<a/>', {
        'id': CONSTANTS.CREATE_BUTTON_ID,
        'class': _defines2.default.clsTBBUTTON + ' ' + CONSTANTS.CREATE_BUTTON_ID + '-e',
        'title': 'Create a conference'
    });

    var handleMainButtonClick = function handleMainButtonClick(event) {
        if (!conferencingService.isInConference()) {
            conferencingService.confCreate();
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
    };

    button.on('click', handleMainButtonClick);

    uScope.topToolbar.addButton(button);
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ConferencingService;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _toolbar = __webpack_require__(27);

var _objects = __webpack_require__(16);

var _events = __webpack_require__(31);

var _helpers = __webpack_require__(4);

var _constants = __webpack_require__(155);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//    This file contains the uScope portion of the Conferencing Service, for both leader and joiner
//    of a conference in conjunction with DSCClient.  It also contains cConfTestPanel which
//    provides unit testing of uScope's conferencing features.
//
//    Design notes:
//        Conference Leader Role:
//            - recvs VIL-issued join conference event specifies role of leader or becomes leader
//                on VIL-issued leaderChange event
//            - recvs view and cursor events issued by cStateVector, sends view and marker updates to VIL
//                who transmits them to the followers via the DSC server
//            - recvs VIL-issued exit event and no longer performs conferencing actions
//            - note that the leader's tray can open, close, and change attributes such as positive/negative control
//                 of an image and that VIL recvs tray actions to be transmitted to the followers  via the DSC server
//
//        Conference Follower Role:
//            - recvs VIL-issued join conference event specifies role of follower or becomes follower
//                on VIL-issued leaderChange event
//            - recvs VIL-issued view and marker events, updates the view and marker states
//            - recvs VIL-issued exit event and no longer performs conferencing actions
//            - note that the follower's tray can open, close, and change attributes such as positive/negative
//                control of an image in response to VIL-issued events originating from the leader's tray
//
//    Handy conferencing URLs
//            http://localhost/dscserver/RESET        to clear all current conferences
//            http://localhost/dscserver/STATS        to see if a conference is running
//

// Compatibility only. confEvents is defined in AIH to conference folder
var confEvent = window.confEvent || {};

// Main class
function ConferencingService(uScopeInstance) {
    var uScope = uScopeInstance;
    var self = this;
    var bAmInConf_;
    var ptName_;
    var bAmLeader_;

    var thisImg;
    var namespace_ = '.usconference';
    var confMarkerLT_ = new _objects.Point(0, 0);

    var minViewMovePx_ = 6; // the minimum distance in pixels of view change to respond to

    //............................................ queries public
    this.isInConference = function () {
        return bAmInConf_;
    };
    this.isConfLeader = function () {
        return bAmInConf_ && bAmLeader_;
    };
    this.isConfMember = function () {
        return bAmInConf_ && (bAmLeader_ ? false : true);
    };

    //____________________________________________________________________________________________
    //     CONFERENCE EVENTS TO VIL FROM CONFERENCE INITIATOR
    //____________________________________________________________________________________________

    //............................................ confCreate public
    //    This function fires an event indicating the user wants to create a conference.
    this.confCreate = function () {
        if (confEvent.createBtn) {
            triggerConfEvent(confEvent.createBtn, { src: 'uScope' });
        }
    };

    this.setUScope = function (uScopeInstance) {
        return uScope = uScopeInstance;
    };

    //____________________________________________________________________________________________
    //     LOCAL FUNCTIONS
    //____________________________________________________________________________________________
    var eventLog = function eventLog(str, eventName, parms) {
        if (CONSTANTS.ENABLE_DEV_MODE) {
            // ('conf: user: ' + ptName_ + ' ' + str + ' ' + eventName + ': {' + (0, _helpers.toStringAssoc)(parms) + '}'); // eslint-disable-line no-undef
        }
    };
    //............................................ triggerConfEvent
    // triggerConfEvent - This function fires the passed event with the passed parameters.
    var triggerConfEvent = function triggerConfEvent(evName, parms) {
        $(document).trigger(evName, parms);
    };
    //............................................ bindEvents_() local
    //    This function is called when joining a conference.
    var bindEvents_ = function bindEvents_() {
        //............................................ confEvent.openimage
        // Listen for a conference open image event.
        //{src: 'uScope', imageId: @NUM, uScopeIdx: NUM, 'imagePath': STR }
        $(document).on(confEvent.openimage + namespace_, function (e, json) {
            if (self.isInConference() == true && self.isConfLeader() == false) {

                if (json == undefined) {
                    // ('Error: confEvent.openimage: json input undefined'); // eslint-disable-line no-undef
                    return;
                }
                eventLog('recieved', confEvent.openimage, json);
                thisImg = uScope.getThisImage();
                if (thisImg == undefined) {
                    // no image in view, so open the passed image
                    var imageSet1 = {
                        'images': [{
                            'imagePath': json.imageId, 'fullURL': json.imagePath //the image that is opening
                            , x: json.x, y: json.y, zoom: json.zoom, angle: json.angleDeg
                        }]
                    };
                    uScope.imageUpdate('add', imageSet1.images);

                    thisImg = uScope.getThisImage(); // now reference to the newly opened image
                } else {
                    // uScope already has an image, so replace it with this one
                    var _imageSet = { 'images': [{ 'imagePath': thisImg.getImageId() }] }; // the image that is closing
                    // NOTE: the mess here is that 'imagePath' means the fullURL to the conference and it means the imageId to uScope.
                    var imageSet2 = {
                        'images': [{
                            'imagePath': json.imageId, 'fullURL': json.imagePath,
                            x: json.x, y: json.y, zoom: json.zoom, angle: json.angleDeg
                        }]
                    }; // the image that is opening
                    uScope.imageUpdate('replace', _imageSet.images, imageSet2.images);

                    thisImg = uScope.getThisImage(); // now reference to the newly opened image
                }

                if (thisImg) {
                    // angle is not handled in the general, non-conference, image opening yet - if ever
                    if (json.angleDeg) {
                        if (json.angleDeg !== thisImg.getViewAngle(true)) {// update the view rotation if it has changed
                            // todo: rotation angle here
                        }
                    }

                    if (json.MarkerX && json.MarkerY) {
                        // if a marker position is present
                        confMarkerLT_.set(json.MarkerX, json.MarkerY); // update the marker position
                        (0, _events.triggerUScopeEvent)(CONSTANTS.CONFERENCE_MARKER_EVENT, json); // and fire event of conferencing follower's marker position update
                    }
                    triggerConfEvent(confEvent.imageChange, { src: 'uScope', imageId: thisImg.getImageId() }); // tell listeners (like slide tray) that image has changed (from no image to first image of conference)
                }
            }
        });
        //............................................ confEvent.closeimage
        // Listen for a conference close image event.
        //{src: 'uScope', imageId: @NUM }
        $(document).on(confEvent.closeimage + namespace_, function (e, json) {
            if (self.isInConference() == true && self.isConfLeader() == false) {
                eventLog('recieved', confEvent.closeimage, json);

                var imageSet = { 'images': [{ 'imagePath': json.imageId }] };
                uScope.imageUpdate('remove', imageSet.images);
            }
        });

        //............................................ confEvent.leadChange
        // Listen for a conference leadership change event.
        $(document).on(confEvent.leadChange + namespace_, function (e, json) {
            if (self.isInConference() == true) {
                if (json == undefined) {
                    // ('Error: confEvent.leadChange: json input undefined'); // eslint-disable-line no-undef
                    return;
                }
                eventLog('recieved', confEvent.leadChange, json);
                var newLeaderState = json.lead == true ? true : false;
                if (bAmLeader_ != newLeaderState) {
                    bAmLeader_ = newLeaderState;
                    roleInit_(); // bind/unbind events depending upon leader/follower role
                }
            }
        });

        //............................................ confEvent.update
        // Listen for a conference view change event and
        //    If this is the conference leader, do nothing
        //    If this is a conference follower, update the image views accordingly
        //
        // where json = {imageId: @NUM, x: baseCoordX, y: baseCoordY, zoom: viewZoom, angle: viewAngleDeg };
        $(document).on(confEvent.update + namespace_, function (e, json) {
            if (self.isConfLeader() == true) {
                // nothing to do, actually won't even see this event
            } else {
                //todo: consider issuing an internal event (that checks if it is already at this pos,zoom,angle and if so does nothing)
                if (json == undefined) {
                    // ('Error: confEvent.update: json input undefined'); // eslint-disable-line no-undef
                    return;
                }
                eventLog('recieved', confEvent.update, json);
                var thisImg = uScope.getThisImageById(json.imageId); // thisImg is vp of the passed imageId to update

                if (thisImg == undefined) {
                    // open thisImg if it is not the currently opened image
                    triggerConfEvent(confEvent.imageChange, { src: 'uScope', imageId: json.imageId });

                    thisImg = uScope.getThisImage();
                    if (thisImg == undefined) {
                        // no image in view,
                        var imageSet1 = { 'images': [{ 'imagePath': json.imageId, 'fullURL': json.imagePath }] }; //the image that is opening
                        uScope.imageUpdate('add', imageSet1.images);

                        thisImg = uScope.getThisImage(); // now reference to the newly opened image
                    } else {
                        // uScope has an image, replace it with this one
                        var imageId0 = thisImg.getImageId();
                        var imageSet1 = { 'images': [{ 'imagePath': thisImg.getImageId() }] }; // the image that is closing
                        // NOTE: the mess here is that 'imagePath' means the fullURL to the conference and it means the imageId to uScope.
                        /////remove me //////    var imageSet2 = { 'images': [{ 'imagePath': json.imageId, 'fullURL': buildFULLURL_(json.imageId)}] }; //the image that is opening
                        var imageSet2 = { 'images': [{ 'imagePath': json.imageId, 'fullURL': json.imagePath }] }; //the image that is opening

                        uScope.imageUpdate('replace', imageSet1.images, imageSet2.images);

                        thisImg = uScope.getThisImage(); // now reference to the newly opened image
                    }

                    return; // note!  to prevent a race condition that the vp is not fully initialized and so cannot zoom or pan, get out now
                }

                if (thisImg) {
                    // prevent race conditions (image switched and view or marker change followed fast before vp was initialized
                    if (thisImg.isInitialized() == false) return;

                    if (json.zoom && json.zoom !== thisImg.getViewZoom()) // update the view zoom if it has changed
                        thisImg.zoomAbsolute(json.zoom);

                    if (json.x && json.y) {
                        var cpCenter = thisImg.getViewCenter(true); //xform coords?        // update the view center if it has changed
                        var ptNewCenter = new _objects.Point(json.x, json.y);
                        if (ptNewCenter.cityBlockDistance(cpCenter) > minViewMovePx_) thisImg.moveAbsolute(ptNewCenter.x - thisImg.getViewWidth() / 2, ptNewCenter.y - thisImg.getViewHeight() / 2, _defines2.default.coordSystemNORM);
                    }
                    if (json.z) {
                        // todo: zstack position here
                    }
                    if (typeof json.angleDeg != 'undefined') {
                        if (json.angleDeg !== thisImg.getViewAngle(true)) {
                            // update the view rotation if it has changed
                            thisImg.viewRotate(json.angleDeg);
                        }
                    }
                    if (json.MarkerX && json.MarkerY) {
                        // if a marker position is present
                        if (json.MarkerX != confMarkerLT_.x || json.MarkerY != confMarkerLT_.y) {
                            // and if it has changed
                            confMarkerLT_.set(json.MarkerX, json.MarkerY); // then update the marker position
                            (0, _events.triggerUScopeEvent)(CONSTANTS.CONFERENCE_MARKER_EVENT, json); // and fire event of conferencing follower's marker position update
                        }
                    }
                } else {
                    // ('... Error: conf: view change requested of image that is not opened: ' + json.imageId); // eslint-disable-line no-undef
                }
            }
        });

        // Hide conferencing icon for pinned images, because only unpinned image is opened in a conference (and pinned are closed at start)
        // This function was pulled from Annotations because yea it makes total sense for conferencing to be part of annotations. There's
        // some kind of bleed over that we will need to decouple thought. TODO - reverse engineer what the hell is going on here and fix it.
        var namespace = '.annotpanel';
        var jRoot = $(_defines2.default.idHashROOT);
        jRoot.on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
            var thisImg = uScope.getThisImage();
            (0, _toolbar.setIconState)($('#' + CONSTANTS.CREATE_BUTTON_ID), CONSTANTS.CREATE_BUTTON_ID, thisImg.isPinned() ? 'disabled' : 'enabled');
        });
    };
    //............................................ buildFULLURL_() local //todo: may not be used in the future.. remove me?
    var buildFULLURL_ = function buildFULLURL_(imageId) {
        //imageId has leading @ sign
        var rtnURL;
        var fullURL = uScope.getFullURL(); //assumes a selected image
        if (fullURL != undefined) {
            var idx = fullURL.lastIndexOf('@');
            if (idx > 0) rtnURL = fullURL.substr(0, idx) + imageId; // imageId has leading @ sign
        }
        return rtnURL;
    };
    //............................................ bindEventsOff_ local
    //    This function is called when exiting a conference.
    var bindEventsOff_ = function bindEventsOff_() {
        $(_defines2.default.idHashROOT).off(namespace_);
    };
    //............................................ roleInit_ local
    //    roleInit_ -  This function binds/unbinds events according to the conference participant's role.
    //    Specifically the conference leader monitors uScope-internal events evVIEWCHANGE and evMOUSECHANGE
    var roleInit_ = function roleInit_() {
        eventLog('conf: roleInit_: as ' + (self.isConfLeader() == true ? 'Leader' : 'Follower'));
        if (self.isConfLeader() == true) {

            // enable the next/prev slide toolbar buttons
            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBNEXTSLIDE), _defines2.default.clsTBNEXTSLIDE, 'enabled');
            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBPREVSLIDE), _defines2.default.clsTBPREVSLIDE, 'enabled');

            // as conference leader, listen for internal view change event and fire conference view event
            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGEREADY, function (e, parms) {
                if (sendOpenImage_(parms.imageId) == false) {
                    // ('conf: evIMAGEREADY event received but I cannot get thisImage: ' + parms.imageId); // eslint-disable-line no-undef
                }
            });
            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGECLOSE, function (e, parms) {
                var json = { 'src': 'uScope', 'imageId': parms.imageId };
                eventLog('sending', confEvent.imageclose, json);
                triggerConfEvent(confEvent.imageclose, json); // fire event to close image
            });

            (0, _events.triggerUScopeEvent)(CONSTANTS.CONFERENCE_MARKER_EVENT, { imageId: undefined }); // hide the conference marker, imageId == undefined hides the marker

            // as conference leader, listen for internal view change event and fire conference view event
            // us.evVIEWCHANGE
            //            parms = {
            //                imageId:    required, imageId of selected image
            //                x:            required, view center X base coord in 'normal' graphics coord space
            //                y:            required, view center Y base coord in 'normal' graphics coord space
            //                zoom:        required, view zoom
            //                angleDeg:    optional, rotation angle in degrees
            //            };                $(us.idHashROOT).on(us.evVIEWCHANGE + namespace_, function (e, parms) {
            $(_defines2.default.idHashROOT).on(_defines2.default.evVIEWCHANGE + namespace_, function (e, parms) {
                // internal view change event
                if (parms.desc == 'move' || parms.desc == 'zoom' || parms.desc == 'rotate') {
                    parms.src = 'uScope';
                    var thisImg = uScope.getThisImageById(parms.imageId);
                    if (thisImg) {
                        var json = {
                            'src': 'uScope',
                            'imageId': parms.imageId,
                            'uScopeIdx': parms.uScopeIdx,
                            'x': parms.x,
                            'y': parms.y,
                            'z': '',
                            'zoom': parms.zoom,
                            'angleDeg': parms.angleDeg,
                            'imagePath': thisImg.getFullURL()
                        };
                        eventLog('sending', confEvent.view, json);
                        triggerConfEvent(confEvent.view, json); // fire event that conferencing leader's view has changed
                    } else {
                        // ('conf: evVIEWCHANGE event received but I cannot get thisImage'); // eslint-disable-line no-undef
                    }
                }
            });

            // as conference leader, listen for internal mouse change event and fire conference marker event
            // us.evMOUSECHANGE
            //            parms = {
            //                imageId:    required, imageId of selected image
            //                x:            required, X base coord of marker
            //                y:            required, Y base coord of marker
            //            };
            $(_defines2.default.idHashROOT).on(_defines2.default.evMOUSECHANGE + namespace_, function (e, parms) {
                if (uScope.isThisImageValid()) {
                    var thisImg = uScope.getThisImage();
                    var json = {
                        'src': 'uScope',
                        'imageId': parms.imageId,
                        'uScopeIdx': thisImg.getImageIdx(),
                        'MarkerX': parms.x,
                        'MarkerY': parms.y,
                        'imagePath': thisImg.getFullURL()
                    };
                    eventLog('sending', confEvent.marker, json);
                    triggerConfEvent(confEvent.marker, json); // fire event for VIL that conferencing leader's view has changed
                }
            });

            //            ////////////////// temporary events for development prior to DST integration - single image operation ///////////////////
            //            // temporarily force a view change event to be sent on by VIL to conf server and on to conf participants
            //            if (uScope.isThisImageValid()) {
            //                var thisImg = uScope.getThisImage();
            //                eKey = jQuery.Event('', { type: 'keydown', which: us.keyCodes.arrowLeft }); // create keydown event
            //                vpKeyEvent(eKey, thisImg);
            //            }
            //            ////////////////// temporary events for development prior to DST integration - single image operation ///////////////////
        } else {
            // is conference follower
            // disable the next/prev slide toolbar buttons
            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBNEXTSLIDE), _defines2.default.clsTBNEXTSLIDE, 'disabled');
            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBPREVSLIDE), _defines2.default.clsTBPREVSLIDE, 'disabled');

            // a conference follower does not listen to internal view change events
            $(_defines2.default.idHashROOT).off(_defines2.default.evVIEWCHANGE + namespace_);

            // a conference follower does not listen to internal mouse change events
            $(_defines2.default.idHashROOT).off(_defines2.default.evMOUSECHANGE + namespace_);
        }
    };
    //............................................ configure_ local
    //    configure_ -  This function informs viewport that a conference is starting or stopping
    //                    so that it can configure itself as necessary.
    //    parameters:
    //        inConference - required, boolen, true indicates joining conference;
    //                                        false indicates exiting conference;

    var configure_ = function configure_(inConference) {
        var iScopeBtnExists = _defines2.default.SHOWALLTOOLBARICONS || uScope.toolbarCanAddButton('openImageScopeBtn');
        if (inConference == true) {

            triggerConfEvent(_defines2.default.evNAVMODEHALT, { uScopeIdx: -1 }); // fire event to halt navigation for all images

            if (uScope.annotPanel) {
                // Until annotations are supported during a conference,
                uScope.annotPanel.enableDrawingIcons(false); // disable the annotation drawing tools
                uScope.annotPanel.show(false); // close the annotation panel
            }
            if (uScope.toolbarCanAddButton('dscSetupBtn')) // give user feedback that conf is active by toolbar icon
                (0, _toolbar.setIconState)($('#' + CONSTANTS.CREATE_BUTTON_ID), CONSTANTS.CREATE_BUTTON_ID, 'active');
            if (iScopeBtnExists) // disable open-in-imagescope
                (0, _toolbar.setIconState)($('#' + _defines2.default.TBISCOPE), _defines2.default.TBISCOPE, 'disabled');
            // The following code to rotate to zero and uncheck the rotation check box is no longer needed now that rotation is supported during a conference -cb
            //            if (us.ENABLEROTATION == true && uScope.visibilityPanel) {
            //              triggerUScopeEvent(us.evIMAGEROTATE, { imageId: '@0', uScopeIdx: -1, angleDeg: 0 }); // fire event to rotate all images to 0
            //                uScope.visibilityPanel.check(us.clsROTATIONDIV, false);
            //            }
            bindEvents_();
        } else {
            // not in conference
            bindEventsOff_();
            (0, _events.triggerUScopeEvent)(CONSTANTS.CONFERENCE_MARKER_EVENT, { imageId: undefined }); // hide the conference marker, imageId == undefined hides the marker

            if (uScope.annotPanel) uScope.annotPanel.enableDrawingIcons(uScope.canAnnotate()); // set state of annotation drawing tools

            if (uScope.toolbarCanAddButton('dscSetupBtn')) // change the toolbar icon to enabled if it is active
                (0, _toolbar.setIconState)($('#' + CONSTANTS.CREATE_BUTTON_ID), CONSTANTS.CREATE_BUTTON_ID, 'enabled');
            if (iScopeBtnExists) (0, _toolbar.setIconState)($('#' + _defines2.default.TBISCOPE), _defines2.default.TBISCOPE, 'enabled');

            // enable the next/prev slide toolbar buttons
            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBNEXTSLIDE), _defines2.default.clsTBNEXTSLIDE, 'enabled');
            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBPREVSLIDE), _defines2.default.clsTBNEXTSLIDE, 'enabled');
        }
    };

    //............................................ reportState public
    this.reportState = function () {
        var str = 'Not in conference';
        if (this.isConfLeader()) str = 'Is conference leader';else if (this.isConfMember()) str = 'Is conference member';
        return str;
    };

    //............................................ reset_ local
    var reset_ = function reset_() {
        bAmInConf_ = false;
        ptName_ = 'ptName';
        bAmLeader_ = false;
        confMarkerLT_.set(0, 0);
    };
    //............................................ sendOpenImage_() local
    var sendOpenImage_ = function sendOpenImage_(opt_imageId) {
        var thisImg = opt_imageId == undefined ? uScope.getThisImage() : uScope.getThisImageById(opt_imageId);
        if (thisImg) {
            var imageId = thisImg.getImageId();
            // send 'normal' graphics coords
            var json = {
                src: 'uScope',
                imageId: thisImg.getImageId(),
                uScopeIdx: thisImg.getImageIdx(),
                'imagePath': thisImg.getFullURL(),

                x: thisImg.getViewCenterX(true),
                y: thisImg.getViewCenterY(true),
                zoom: thisImg.getViewZoom(),
                angleDeg: thisImg.getViewAngle(true),

                MarkerX: thisImg.getViewCenterX(true),
                MarkerY: thisImg.getViewCenterY(true) // initially place the marker at the image center
            };
            eventLog('sending', confEvent.openimage, json);
            triggerConfEvent(confEvent.openimage, json); // fire event that the leader has opened an image
            return true;
        }
        return false;
    };
    //............................................ construct_() local
    var construct_ = function construct_() {
        reset_();

        //............................................ confEvent.join
        var nspace = '.confStatic'; // these two events do not bind/unbind .....
        // Listen for a conference join event.
        $(document).on(confEvent.join + nspace, function (e, json) {

            if (self.isInConference() == false) {
                eventLog('recieved', confEvent.join, json);
                configure_(true); // enable/disable for conferencing - must be done prior to setting state to 'in-conference'

                ptName_ = json.userName;
                bAmLeader_ = json.lead == true ? true : false;
                bAmInConf_ = true;

                if (bAmLeader_ == true) {
                    uScope.closeAllButSelectedImage(); // close all but the currently selected image
                    if (sendOpenImage_() == false) {
                        // if leader has an image open, send the openimage event
                        // ('conf: leader: no image open yet'); // eslint-disable-line no-undef
                    }
                }
                roleInit_(); // bind/unbind events depending upon leader/follower role
            }
        });
        //............................................ confEvent.exit
        // Listen for a conference exit event.
        $(document).on(confEvent.exit + nspace, function (e, json) {
            if (self.isInConference() == true) {
                eventLog('received', confEvent.exit, json);
                reset_(); //
                configure_(false); //
            }
        });
    };

    //............................................ construction
    construct_();
}
module.exports = exports['default'];

/***/ }),
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _imageToolbar = __webpack_require__(417);

var _imageToolbar2 = _interopRequireDefault(_imageToolbar);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loader = {
    name: 'us:image-adjust-ui',

    extends: 'viewport',

    constructor: function (_ImageToolbar) {
        (0, _inherits3.default)(ImageToolbarHack, _ImageToolbar);

        function ImageToolbarHack(uScope, viewport) {
            (0, _classCallCheck3.default)(this, ImageToolbarHack);

            // HACK ALERT - mutating the viewport
            var _this = (0, _possibleConstructorReturn3.default)(this, (ImageToolbarHack.__proto__ || Object.getPrototypeOf(ImageToolbarHack)).call(this, uScope, viewport));

            viewport.toolbar = _this;
            return _this;
        }

        return ImageToolbarHack;
    }(_imageToolbar2.default)
};

_publicApi2.default.plugins.register(loader);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ImageToolbar;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _objects = __webpack_require__(16);

var _toolbar = __webpack_require__(27);

var _events = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//-------------------------------------------------------------------------------------------------
//    IMAGE TITLE TOOLBAR OBJECT
//
//    Each image has an associated toolbar in its top left corner containing:
//        Active Buttons
//            - a close button
//            - possibly the previous and next slide buttons
//        Indicators
//            - an icon indicating the sample is a positive or negative control, if applicable
//            - an icon indicating the image is pinned, if applicable
//

function ImageToolbar(uScope, viewport) {
    var self = this;
    var isLoaded = false; // image tooblar has been loaded

    var jVpDiv = viewport.vpDivGet('outer');
    var jToolbar;
    var jToolbarStateDiv;
    var spacerWidth_;
    var jCloseIcon;
    var jPinnedIcon;
    var jControlIcon;
    var jPrevSlideIcon;
    var jNextSlideIcon;

    //............................................ pinnedSet() public
    this.isPinnedSet = function () {
        if (viewport.sampleTypeIsControl() == false) {
            // no need to show pinned when is a control sample
            if (viewport.isPinned()) jPinnedIcon.show();else jPinnedIcon.hide();
            showStateDiv_(); // show/hide the state indicator div
        } else {
            jPinnedIcon.hide();
        }
    };
    //............................................ sampleTypeSet() public
    // This function hides or (shows and sets) the sample type icon
    this.sampleTypeSet = function () {
        if (viewport.sampleTypeIsControl() == false) {
            jControlIcon.hide();
        } else {
            jControlIcon.removeClass(_defines2.default.clsTBCONTROL + '-p').removeClass(_defines2.default.clsTBCONTROL + '-n');
            jControlIcon.addClass(getControlClass_());
            jControlIcon.attr('title', getControlTip_());
            jControlIcon.show();
        }

        nextPrevSlideSet_(); // show/hide the next slide, previous slide buttons
        showStateDiv_(); // show/hide the state indicator div
    };

    //............................................ nextPrevSlideSet() public
    // This function shows/disables/hides the next slide and previous slide buttons
    var nextPrevSlideSet_ = function nextPrevSlideSet_() {
        if (viewport.sampleTypeIsControl() == true // control slides don't show prev/next slide on the image's toolbar
        || viewport.isPinned() == true // pinned slides don't either
        || uScope.toolbarCanAddButton('nextPrevSlide') == false) {
            jPrevSlideIcon.hide();
            jNextSlideIcon.hide();
        } else {

            if (uScope.isConfMember() == true) {
                // disable the buttons if in conference as follower
                // TODO: Create some kind of "read-only" mode in uScope and use it to eliminate coupling between
                // TODO: ITB and Conferencing and vice-versa
                (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBPREVSLIDE), _defines2.default.clsTBPREVSLIDE, 'disabled');
                (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBNEXTSLIDE), _defines2.default.clsTBNEXTSLIDE, 'disabled');
            } else {
                // enable and show the buttons
                (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBPREVSLIDE), _defines2.default.clsTBPREVSLIDE, 'enabled');
                (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBNEXTSLIDE), _defines2.default.clsTBNEXTSLIDE, 'enabled');
                jPrevSlideIcon.show();
                jNextSlideIcon.show();
            }
        }
    };
    //............................................ getOffsetRect() public
    this.getOffsetRect = function () {
        var pos = jToolbar.offset();
        var rect = uScope.rootRectGet();
        var rtnOffset = new _objects.Rectangle(pos.left - rect.x, pos.top - rect.y, jToolbar.width(), jToolbar.height());

        return rtnOffset;
    };
    //............................................ showStateDiv_() local
    //    If only the spacer bar is displayed on the state indicator div, hide the div
    var showStateDiv_ = function showStateDiv_() {
        if (jToolbarStateDiv.width() > spacerWidth_) jToolbarStateDiv.show();else jToolbarStateDiv.hide();
    };
    //............................................ getControlClass_() local
    var getControlClass_ = function getControlClass_() {
        var ext = '-o';
        var type = viewport.sampleTypeGet();
        if (type == 'positive') ext = '-p';else if (type == 'negative') ext = '-n';

        return _defines2.default.clsTBCONTROL + ext;
    };
    //............................................ getControlTip_() local
    var getControlTip_ = function getControlTip_() {
        var type = viewport.sampleTypeGet();
        if (type == 'positive') return 'Image is a Positive Control';else if (type == 'negative') return 'Image is a Negative Control';

        return '';
    };
    //............................................ bindEvents_() local
    // bindEvents_ - This function adds the image toolbar event handlers.
    //
    //    Note that by using the same namespace as the viewport when the
    //    viewport removes its events by namespace, these are also removed.

    var bindEvents_ = function bindEvents_() {
        var namespace = viewport.eventNameSpaceGet();

        jCloseIcon.on('click' + namespace, function (e) {
            if (uScope.getImageCount() > 1) {
                // Initially provided for manual sync to be able to handle the special case when the unpinned viewport
                // is closed.
                uScope.events.trigger('uscope:viewport:toolbar:close-click', viewport);

                (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGECLOSE, { imageId: viewport.getImageId() });
            }
            return false;
        });
        jVpDiv.on('click' + namespace, '.' + _defines2.default.clsTBNEXTSLIDE + '-e', function (e) {
            (0, _events.triggerUScopeEvent)(_defines2.default.evOPENNEXTSLIDE, {});
            return false;
        });
        jVpDiv.on('click' + namespace, '.' + _defines2.default.clsTBPREVSLIDE + '-e', function (e) {
            (0, _events.triggerUScopeEvent)(_defines2.default.evOPENPREVSLIDE, {});
            return false;
        });

        $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGEUPDATE, function (e, parms) {
            // set close button icon to enabled if > 1 image open
            (0, _toolbar.setIconState)(jCloseIcon, _defines2.default.clsTBCLOSEIMAGE, uScope.getImageCount() == 1 ? 'disabled' : 'enabled');
            nextPrevSlideSet_(); // disable the next/prev slide buttons if in conference as a member
        });
    };

    //............................................ init_() local
    //    init_ = This function creates the toolbar, sizes it and adds its event handlers.
    var init_ = function init_() {
        jToolbar = $('<div/>', { 'class': _defines2.default.clsIMAGETOOLBAR + ' ' + _defines2.default.clsTRANSPARENT });

        //toconsider: an image title
        //        var title = viewport.getTitle();
        //        if (title && title.length > 0) jToolbar.text(title);

        // action buttons .....................................
        jToolbar.append($('<a/>', {
            'class': _defines2.default.clsTBCLOSEIMAGE + (uScope.getImageCount() == 1 ? '-d' : '-e') // set close button icon to enabled if > 1 image open
            + ' ' + _defines2.default.clsTBCLOSEIMAGE + ' ' + _defines2.default.clsIMAGETOOLBARBTN, 'title': 'Close this image'
        }));

        // because slide state can change from patient to a control in which case the next/prev slide button is hidden,
        // always load the buttons and hide them if the slide is a control via nextPrevSlideSet_()
        jToolbar.append($('<a/>', {
            'class': _defines2.default.clsTBPREVSLIDE + ' ' + _defines2.default.clsTBPREVSLIDE + '-e' + ' ' + _defines2.default.clsIMAGETOOLBARBTN,
            'title': 'Open the previous slide in the tray (keyboard: q, Q)'
        }));
        jToolbar.append($('<a/>', {
            'class': _defines2.default.clsTBNEXTSLIDE + ' ' + _defines2.default.clsTBNEXTSLIDE + '-e' + ' ' + _defines2.default.clsIMAGETOOLBARBTN,
            'title': 'Open the next slide in the tray (keyboard: e, E)'
        }));

        //status indicators .....................................
        jVpDiv.append(jToolbar); // place the toolbar div in the vp
        jToolbar.append($('<div/>', { 'class': _defines2.default.clsIMAGETOOLBARSTATE }));
        jToolbarStateDiv = jToolbar.find('.' + _defines2.default.clsIMAGETOOLBARSTATE);

        jToolbarStateDiv.append($('<div/>', { 'class': _defines2.default.clsIMAGETOOLBARSPC + ' ' + _defines2.default.clsIMAGETOOLBARBTN }));
        spacerWidth_ = jToolbarStateDiv.width(); //save

        jToolbarStateDiv.append($('<a/>', {
            'class': _defines2.default.clsTBPINNED + ' ' + _defines2.default.clsIMAGETOOLBARBTN,
            'title': 'Status: Image is Pinned Open'
        }));
        jToolbarStateDiv.append($('<a/>', {
            'class': _defines2.default.clsTBCONTROL + ' ' + getControlClass_() + ' ' + _defines2.default.clsIMAGETOOLBARBTN,
            'title': 'Status: Image is a Positive Control'
        }));

        jCloseIcon = jToolbar.find('.' + _defines2.default.clsTBCLOSEIMAGE);
        jPrevSlideIcon = jToolbar.find('.' + _defines2.default.clsTBPREVSLIDE + '-e');
        jNextSlideIcon = jToolbar.find('.' + _defines2.default.clsTBNEXTSLIDE + '-e');

        jPinnedIcon = jToolbarStateDiv.find('.' + _defines2.default.clsTBPINNED);
        jControlIcon = jToolbarStateDiv.find('.' + _defines2.default.clsTBCONTROL);

        self.sampleTypeSet(); // update the status of sampleType
        self.isPinnedSet(); // update the status of pinned
        bindEvents_(); // add event handlers
        isLoaded = true;
    };

    //............................................ construction
    init_();
}
module.exports = exports['default'];

/***/ }),
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LegacyAjaxWrapper;
//________________________________________________________________________________________________
// ajaxCalls.js
//    This file contains cAJAX, the ajax request object.
//
//    history
//    1108    cperz        created
//    _______________________________________end_AIHv1/PR __________________________________________
//    141222    cperz        refactor functions into cAJAX object; combine them into imageserver and dataserver calls
//    1412XX    cperz        add ajax calls for IA; add callback parms to doIMGSRVREQ;
//
//________________________________________________________________________________________________
//
function LegacyAjaxWrapper(uScope, viewport, imageId) {
    var self = this;

    //................................................................. doIMGSRVREQ
    //    doIMGSRVREQ: This function sends a request to image server
    //    parameters:
    //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
    //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
    //        requestName            required, dataserver request name
    //        opt_cbParms            optional, parms to send to call back function
    //        opt_datatype:        optional, defulat is 'xml',  {'xml, 'html}
    //                            IE issue:  it seems that the return xml from getannotatons of "<Annotations/>"
    //                            cannot interpreted properly so just get the text w/o interpretation.
    //                            DataServer calls always provide the results wrapped in XML and can be interpreted properly.
    //                            Note that when dataType is 'html' then HTML is returned as plain text
    //
    //        opt_reqImageId:        optional, imageId to request xinfo of; default is viewport; markup images provide this;

    self.queryImageServer = function (query) {
        return $.post(self.buildFullUrl(), query).then(function () {
            var _$$Deferred;

            if (!isImageStillValid()) {
                return $.Deferred().reject('image is no longer valid');
            }
            return (_$$Deferred = $.Deferred()).resolve.apply(_$$Deferred, arguments);
        });
    };

    this.doIMGSRVREQ = function (cbSuccessFn, cbFailureFn, requestName, opt_cbParms) {
        var opt_datatype = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'xml';
        var opt_reqImageId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : imageId;


        var parms = {
            type: 'POST',
            timeout: 6000,
            cache: false,
            async: true,
            dataType: opt_datatype,
            data: requestName,
            success: function success(data, textStatus, jqXHR) {
                if (isImageStillValid() == false) return;

                if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
                else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName);
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                if (isImageStillValid() == false) return;

                if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
                else defaultFailureFn(' Error: doIMGSRVREQ ' + requestName + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
            }
        };
        // add authentication to the request parameters and issue the ajax request
        if (ajaxAddAuth('doIMGSRVREQ', parms, opt_reqImageId)) $.ajax(parms);
    };

    //................................................................. doDATASVRREQ
    // doDATASVRREQ - This function sends a DoDBCall to ImageServer.
    //                    e.g. ImageServer request: GET <path>?DODBCALL+<method>+<input xml to method>
    // passed parameters:
    //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
    //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
    //        requestName            required, dataserver request name
    //        strXML                required, xml string specifying specifics of the request
    //        opt_cbParms            optional, parms to send to call back function

    this.doDATASVRREQ = function (cbSuccessFn, cbFailureFn, requestName, strXML, opt_cbParms) {
        var parms = {
            type: 'POST', timeout: 6000, cache: false, async: true, dataType: 'html', // 'html' datatype prevents IE complaints about XML
            data: 'DODBCALL' + '+' + requestName + '+' + strXML,

            success: function success(data, textStatus, jqXHR) {
                if (isImageStillValid() == false) return;

                if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
                else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName);
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                if (isImageStillValid() == false) return;

                //        if (textStatus == "parsererror") {                // IE is touchy about the garbage at the end of the xml returned from imageserver
                //            cbSuccessFn(undefined, textStatus, jqXHR, cbParms);

                if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
                else defaultFailureFn(' Error: DODBCALL ' + requestName + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
            }
        };
        // add authentication to the request parameters and issue the ajax request
        if (ajaxAddAuth('doDATASVRREQ: ' + requestName, parms, imageId)) $.ajax(parms);
    };

    //................................................................. doANALSVRREQ
    // doANALSVRREQ - This function sends a DoIACall to ImageServer.
    //                    e.g. ImageServer request: GET <path>?DOIACALL+<method>+<input xml to method>
    //	The syntax of DOIACALL is:
    //		http://<hostname>/@@<token>/@<imageid>?DOIACALL+<methodname>+<inputparameters>.
    //	Note the input parameters are not formatted with SOAP headers.
    //
    // passed parameters:
    //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
    //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
    //        requestName            required, dataserver request name
    //        strXML                required, xml string specifying specifics of the request
    //        opt_cbParms            optional parms to send to call back function

    this.doANALSVRREQ = function (cbSuccessFn, cbFailureFn, requestName, strXML, opt_cbParms) {
        var urlXML = encodeURIComponent(strXML); // analysis server inputparameters must be uri encoded
        var parms = {
            type: 'POST', timeout: 6000, cache: false, async: true, dataType: 'html', // 'html' datatype prevents IE complaints about XML
            data: 'DOIACALL' + '+' + requestName + '+' + urlXML,

            success: function success(data, textStatus, jqXHR) {
                if (isImageStillValid() == false) return;

                if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
                else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName);
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                if (isImageStillValid() == false) return;

                if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
                else defaultFailureFn(' Error: DOIACALL ' + requestName + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
            }
        };
        // add authentication to the request parameters and issue the ajax request
        if (ajaxAddAuth('doANALSVRREQ: ' + requestName, parms, imageId)) $.ajax(parms);
    };

    //................................................................. doIMGSVRPOST
    // doIMGSVRPOST - This function posts to image server requests that are not image related
    // passed parameters:
    //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
    //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
    //        requestName            required, dataserver request name
    //        requestData            required, request specific data
    //        opt_cbParms            optional parms to send to call back function

    this.doIMGSVRPOST = function (cbSuccessFn, cbFailureFn, requestName, requestData, opt_cbParms) {

        var parms = {
            type: 'POST', timeout: 6000, async: true, dataType: 'html', // 'html' datatype prevents IE complaints about XML

            success: function success(data, textStatus, jqXHR) {
                if (isImageStillValid() == false) return;

                if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
                else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName + requestData);
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                if (isImageStillValid() == false) return;

                if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
                else defaultFailureFn(' Error: doIMGSVRPOST ' + requestName + requestData + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
            }
        };

        // add authentication to the request parameters and issue the ajax request
        if (ajaxAddAuth2('ajaxPOST', parms)) $.ajax(parms);

        //..................................................
        // closure functions
        //............................................ ajaxAddAuth2
        function ajaxAddAuth2(callerName, parms) {
            var server = viewport.getServer();
            var token = viewport.getToken();
            if (token == undefined || token.length == 0) {
                if (uScope.getPassword() != undefined) {
                    parms.username = uScope.getLoginName();
                    parms.password = uScope.getPassword();
                    parms.url = server + requestName + requestData;
                }
            } else {
                parms.url = server + token + '/' + requestName + requestData;
            }
            return true;
        }

        //..................................................
    };

    // buildFullUrl - This function uses the currently selected image to create a full url for the passed imageId
    self.buildFullUrl = function () {
        var reqImageId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : imageId;
        // note tha imageId must have leading @ sign
        var url = '';
        var fullURL = uScope.getFullURL(); // assumes a selected image
        if (fullURL) {
            var idx = fullURL.lastIndexOf('@');
            if (idx > 0) {
                url = fullURL.substr(0, idx) + reqImageId;
            }
        }
        return url;
    };

    //................................................................. ajaxAddAuth
    //    ajaxAddAuth - This function adds authentication to the passed associative array
    var ajaxAddAuth = function ajaxAddAuth(callerName, parms, reqImageId) {
        parms.url = self.buildFullUrl(reqImageId); // build url with the requested image's Id
        if (parms.url == undefined || parms.url.length == 0) {
            if (uScope.getPassword() != undefined) {
                parms.username = uScope.getLoginName();
                parms.password = uScope.getPassword();
                if (reqImageId) parms.url = uScope.getServer() + reqImageId;
            } else {
                return false;
            }
        }
        return true;
    };

    //................................................................. getErrorStr
    this.getErrorStr = function (jqXHR, textStatus, errorThrown, imageId) {
        var str = ' (' + imageId + ')';
        if (jqXHR && jqXHR.responseText) {
            var idx = jqXHR.responseText.indexOf(';');
            var rtext = idx != -1 ? jqXHR.responseText.slice(0, idx) : jqXHR.responseText;
            str += ' status: ' + jqXHR.status + ', responseText: ' + rtext;

            // ('I\'VE BEEN SEEING CLIPPING .... jqXHR.responseText: ' + jqXHR.responseText); // eslint-disable-line no-undef
        } else str += ' errorThrown: ' + errorThrown;
        return str;
    };
    //................................................................. isImageStillValid
    var isImageStillValid = function isImageStillValid() {
        if (uScope.isThisImageIdValid(imageId) == false) {
            // protect against rapid slide close/open sequence s.t. vpObj no longer is loaded
            // ('Error: ajax request: image is no longer valid: ' + imageId); // eslint-disable-line no-undef
            return false;
        }
        return true;
    };
    //................................................................. defaultSuccessFn
    var defaultSuccessFn = function defaultSuccessFn(data, textStatus, jqXHR, cbParms, requestName) {
        // ('defaultSuccessFn: ' + requestName + '\n' + jqXHR.responseText); // eslint-disable-line no-undef
    };
    //................................................................. defaultFailureFn
    var defaultFailureFn = function defaultFailureFn(str) {
        // (str); // eslint-disable-line no-undef
    };
}

// TODO: (cc) This code looks very MS specific but I'm not seeing any feature/browser branching. Dead code???
$.ajaxTransport(function (options, originalOptions, jqXHR) {
    var xdr;
    return {
        send: function send(unused, completeCallback) {
            xdr = new XDomainRequest();
            xdr.onload = function () {
                var responses = {
                    text: xdr.responseText
                };
                if (xdr.contentType.match(/\/xml/)) {
                    // there is no responseXML in XDomainRequest, so we have to create it manually
                    var dom = new window.ActiveXObject('Microsoft.XMLDOM');
                    dom.async = false;
                    dom.loadXML(xdr.responseText);
                    responses.xml = dom;

                    if ($(dom).children('error').length != 0) {
                        var $error = $(dom).find('error');
                        completeCallback(parseInt($error.attr('response_code')), $error.attr('message_key'), responses);
                    } else {
                        completeCallback(200, 'success', responses);
                    }
                } else {
                    // set status code to 200
                    // XDomainRequest rejects all other successful status codes
                    completeCallback(200, 'success', responses);
                }
            }; // send
            xdr.onerror = xdr.ontimeout = function () {
                var responses = {
                    text: xdr.responseText
                };
                completeCallback(400, 'failed', responses);
            };
            xdr.onprogress = function () {};
            xdr.ontimeout = function () {};
            xdr.open(options.type, options.url);
            if ('POST' == options.type) {
                xdr.send(options.data);
            }
        },
        abort: function abort() {
            if (xdr) {
                xdr.abort();
            }
        }
    };
});
module.exports = exports['default'];

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NotificationService = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _createNotificationBar = __webpack_require__(362);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VALID_STATES = ['information', 'success', 'done', 'warning'];

/**
 * This class allows users to popup dismissible notifications on the uScope UI
 */

var NotificationService = exports.NotificationService = function () {
    function NotificationService(container) {
        var _this = this;

        (0, _classCallCheck3.default)(this, NotificationService);

        this.container = container;

        VALID_STATES.forEach(function (state) {
            _this[state] = function (message, duration) {
                return _this.show(state, message, duration);
            };
        });
    }

    (0, _createClass3.default)(NotificationService, [{
        key: 'show',
        value: function show(type, message) {
            var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;

            this.hide();
            this.ui = (0, _createNotificationBar.createNotificationBar)(type, message);
            this.container.appendChild(this.ui.container);
            this.ui.show();

            setTimeout(this.hide.bind(this), duration);
        }
    }, {
        key: 'hide',
        value: function hide() {
            if (this.ui) {
                this.ui.hide();
                delete this.ui;
            }
        }
    }]);
    return NotificationService;
}();

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PluginService = PluginService;
// Question:    Is this a plugin or a module system? What's the difference?
// Question:    Does it make sense to provide different types of extensions, e.g. "component", "service", "extension"?
//              If so what types make sense? Consider
//              Extension - "thing" that exposes new capability directly to core uScope components. Maybe "Thumbnail"
//              Module - Stand alone "thing" that relies on but doesn't modify the core but can still be injected into
//                          other "things". Maybe "Zoom Buttons" or "Settings"
//              Service - Stand alone "thing" that does not have a public interface and therefore cannot be injected
//                          into other "things". Maybe "performance indicator"
//              Component / Directive - Some "thing" with a user interface
// TODO: Standardize plugin lifecycle events (init, destroy, ?)

var generateId = function generateId() {
    return Math.random().toString(36).substr(2, 10);
};

var createContextDictionary = function createContextDictionary() {
    var dictionary = {};
    return {
        createDictionary: function createDictionary(context) {
            // TODO: don't cause side-effects (e.g. don't mutate the context object).
            context.__CTXID__ = generateId(); // CTXID = context id
            dictionary[context.__CTXID__] = {};
            context.events.on('$destroy', function () {
                return delete dictionary[context.__CTXID__];
            });
        },
        get: function get(name) {
            for (var _len = arguments.length, contexts = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                contexts[_key - 1] = arguments[_key];
            }

            var context = contexts.find(function (context) {
                return context && dictionary[context.__CTXID__] ? dictionary[context.__CTXID__][name] : false;
            });
            return context ? dictionary[context.__CTXID__][name] : undefined;
        },
        set: function set(name, context, value) {
            dictionary[context.__CTXID__][name] = value;
        }
    };
};

function PluginService(events) {
    var self = this;

    var pluginLookup = {};

    // Plugins will be instantiated in sequence based on dependencies and order of inclusion
    var startupQueues = {
        uScope: [],
        viewport: []
    };
    // Dictionary to lookup running services.
    var runningServices = createContextDictionary();

    var getDependencies = function getDependencies(plugin) {
        return plugin.dependencies || (plugin.dependency ? [plugin.dependency] : []);
    };

    var getStartupIndex = function getStartupIndex(queue, plugin) {
        var pluginIndex = -1;
        var dependencies = getDependencies(plugin);

        dependencies.forEach(function (dependency) {
            var depIndex = queue.indexOf(pluginLookup[dependency]);
            if (depIndex > pluginIndex) {
                pluginIndex = depIndex;
            }
        });

        pluginIndex++;
        return pluginIndex;
    };

    var onUScopeCreated = function onUScopeCreated(uScope) {

        runningServices.createDictionary(uScope);

        var handleStartupQueue = function handleStartupQueue(queue, uScope, viewport) {
            var args = [uScope];
            if (viewport) {
                args.push(viewport);
            }
            var getDepInstances = function getDepInstances(plugin) {
                var dependencyList = getDependencies(plugin);
                var dependencies = [];
                var badDeps = [];

                dependencyList.forEach(function (dependencyName) {
                    var dependency = runningServices.get(dependencyName, uScope, viewport);
                    if (!dependency) {
                        badDeps.push(dependencyName);
                    } else {
                        dependencies.push(dependency);
                    }
                });

                if (badDeps.length) {
                    throw new Error('Could not locate dependencies: \'' + badDeps.join(', ') + '\' for plugin \'' + plugin.name + '\'.');
                }

                return dependencies.length ? args.concat(dependencies) : args;
            };

            queue.forEach(function (plugin) {
                if (plugin.hasOwnProperty('canStart') && !plugin.canStart(uScope)) {
                    // ('Not starting ' + plugin.name + ' because it reported it was not allowed to start.'); // eslint-disable-line no-undef
                    return;
                }
                try {
                    var dependencies = getDepInstances(plugin);
                    var instance = Object.create(plugin.constructor.prototype);
                    plugin.constructor.apply(instance, dependencies);
                    instance.configure && instance.configure(uScope.vilSettings.extensions[plugin.name]);
                    runningServices.set(plugin.name, viewport || uScope, instance);
                    // ES6 supports -> Reflect.construct(plugin.constructor, args.concat(dependencies)); We're not there yet...
                } catch (e) {
                    // ('Exception starting ' + plugin.name + '.', e); // eslint-disable-line no-undef
                }
            });
        };

        handleStartupQueue(startupQueues.uScope, uScope);

        uScope.events.on('uscope:image:init', function (viewport) {
            runningServices.createDictionary(viewport);

            viewport.events.on('viewport:initialize-layout', function () {
                handleStartupQueue(startupQueues.viewport, uScope, viewport);
            });
        });
    };

    events.on('lbs.uscope:start', onUScopeCreated);

    self.register = function (plugin) {
        if (!plugin.name || !plugin.constructor) {
            throw new Error('Plugins must contain `name` and `constructor` properties.');
        }

        var queue = startupQueues[plugin.extends];

        if (!queue) {
            throw new Error('Plugins must contain an `extends` property. Valid values are `uScope` or `viewport`');
        }

        var startupIndex = getStartupIndex(queue, plugin);

        queue.splice(startupIndex, 0, plugin);

        pluginLookup[plugin.name] = plugin;
    };

    self.getInstance = function (context, pluginName) {
        return runningServices.get(pluginName, context);
    };
}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DragMomentum = DragMomentum;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DragMomentum(viewport) {
    var self = this;
    var timerInterval = 20; // timer interval in milliseconds
    var damper = 0.8; // linear reduction on relative move
    var maxIterations = 15; // maximum number of momentum cycles

    var count = 0; // drag momentum cycle number
    var sweepX = 0;
    var sweepY = 0; // drag momentum distances

    self.go = function () {
        if (viewport.navModeGet() != _defines2.default.eNavModes.nmNone) // don't keep going if another nav mode has started
            return;
        if (count == 0) {
            // if just starting momentum drag,
            var ptDelta = viewport.getMouseCurDiff(); // initialize the distance to move with the diffs between the last 2 cursor positions
            // insure that at least one iteration of drag momentum occurs (presumably will insure tile positions)
            sweepX = ptDelta.x > 0 ? Math.max(ptDelta.x, 1) : Math.min(ptDelta.x, -1);
            sweepY = ptDelta.y > 0 ? Math.max(ptDelta.y, 1) : Math.min(ptDelta.y, -1);
        } else {
            sweepX = parseInt(sweepX * damper); // otherwise dampen the distance to move
            sweepY = parseInt(sweepY * damper);
        }

        // if enough cycles have been performed or there isn't much of a move taking place, finsh
        // otherwise, move the image some more
        if (++count > maxIterations || Math.abs(sweepX) < 2 && Math.abs(sweepY) < 2) {
            count = sweepX = sweepY = 0; // reset momentum vars
        } else {
            viewport.moveRelative(sweepX, sweepY);
            setTimeout(self.go, timerInterval);
        }
    };
}
//________________________________________________________________________________________________

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaintTimer = PaintTimer;
/**
 * Observes an object for changes and sends change notifications during the browser's paint cycle.
 * @returns {{}}
 * @constructor
 */
function PaintTimer(state) {
    // Timer Status
    var isRunning = false;
    var callback = void 0;

    /**
     * Starts monitoring the watched object for changes and calls the callback along animationFrame edges
     * @param changeDelegate
     */
    this.start = function (changeDelegate) {
        callback = changeDelegate;
        isRunning = true;
        mainLoop();
    };

    /**
     * Stops notifying the change delegate of changes.
     */
    this.stop = function () {
        isRunning = false;
    };

    // Checks for changes and calls the callback if any exist, then recursively calls itself.
    function mainLoop() {
        if (state.hasChanges) {
            callback(state, state.changes);
            state.clearChanges();
        }
        if (!isRunning) {
            return;
        }
        requestAnimationFrame(mainLoop);
    }
}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Renderer = Renderer;
/**
 * Render controller object. Used to synchronize paint events.
 * Not sure how comfortable I am calling this a renderer, but it controls the render cycle, so let's roll with it.
 * @param viewport
 * @constructor
 */
function Renderer(viewport) {
    // Store off a ref to the viewport div
    var $viewportDiv = viewport.vpDivGet();
    // This "sizer div" is used to size the viewport. This allows child layers to size themselves to 100% which precludes
    // us from having to make sure they're all in sync as layers are added and removed. We also only have to manually
    // size the one div, instead of n divs. Ideally the viewport div would be sized directly without the need for the
    // sizer div but lots of legacy code depends on it being where it is at the size it is.
    var sizerDiv = document.createElement('div');
    sizerDiv.className = 'us-viewport-sizer';
    $viewportDiv.append(sizerDiv);
    // "Layers" are actually callback items; not sure if "layer" is the right name here.
    var layers = [];

    // Pre-allocate vars to reduce effect of garbage collection.
    var zoom = void 0;
    var width = void 0;
    var height = void 0;
    var left = void 0;
    var top = void 0;
    var ix = void 0;
    var layer = void 0;

    // Public methods
    Object.assign(this, {
        /**
         * Adds a "layer" to the layers collection.
         * @param layer (object)
         * layer.container: An HTML element that represents a some aspect of the viewport's image. Note that this class
         *                  will resize / reposition these containers, so don't attempt to do so outside this class.
         *                  Used for: Background image, tiles, and annotation layer
         * layer.updatePosition: Called whenever viewport's state changes. Passes in the new dimensions of the container
         *                       Used for: Updating annotation layer state (TODO: Deprecate if possible).
         * layer.paint: Called whenever viewport's state changes. Passes in the current state and an array of the
         *              names of properties that have changed.
         *              Used for: Painting background image, tiles, and annotations.
         * layer.zoomChange: Called whenever viewport's zoom changes. Passes the current state to the callback.
         *                   Used for: Zoom sliders, annotation repaints, thumbnail updates.
         * layer.rotateChange: Called whenever viewport's rotation changes. Passes the current state to the callback.
         *                     Used for:  Rotation dial, thumbnail, annotation updates
         */
        addLayer: function addLayer(layer) {
            layers.push(layer);

            if (layer.container) {
                layer.container.classList.add('us-viewport-layer');
                sizerDiv.appendChild(layer.container);
            }
        },

        /**
         * Triggers a paint event on all registered layers.
         * @param state
         * @param changes
         */
        paint: function paint(state, changes) {
            try {
                paintChildren(state, changes);
            } catch (e) {
                // (e); // eslint-disable-line no-undef
            }
        }
    });

    function paintChildren(state, changes) {
        // Calculate changes to the viewport's size and position
        zoom = state.zoom;
        width = viewport.getImageWidth() / zoom;
        height = viewport.getImageHeight() / zoom;
        left = -Math.floor(state.left / zoom);
        top = -Math.floor(state.top / zoom);

        // Reposition / resize the sizer div
        sizerDiv.style.left = left + 'px';
        sizerDiv.style.top = top + 'px';
        sizerDiv.style.width = width + 'px';
        sizerDiv.style.height = height + 'px';

        // Loop through and update each layer. Note: Use loop rather than .forEach for performance
        for (ix = 0; ix < layers.length; ix++) {
            layer = layers[ix];

            // Have the layers update their position data if needed.
            layer.updatePosition && layer.updatePosition({ left: left, top: top, width: width, height: height, zoom: zoom });

            // Call paint for those that need it.
            layer.paint && layer.paint(state, changes);

            // Some items only care about specific changes; notify them.
            if (changes.includes('zoom')) {
                layer.zoomChange && layer.zoomChange(state);
            }
            if (changes.includes('angleDeg')) {
                layer.rotateChange && layer.rotateChange(state);
            }
        }
    }
}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ViewportBackgroundLayer = ViewportBackgroundLayer;
var MAX_BG_SIZE = 2000;

/**
 * This places a large background image behind the tiled image to improve the apparent performance as the user pans or
 * zooms over areas that haven't yet been fetched.
 * @param viewport
 * @constructor
 */
function ViewportBackgroundLayer(viewport) {
    var container = document.createElement('div');

    var backgroundZoom = void 0,
        scale = void 0;
    var width = void 0,
        height = void 0,
        img = void 0;

    // Expose the container so the renderer can reposition it
    this.container = container;

    // Auto initialize this class.
    (function init() {
        var imageDimensions = viewport.getImageDims();
        container.className = 'us-vp-bg-container';
        backgroundZoom = parseInt(Math.ceil(Math.max(imageDimensions.w, imageDimensions.h) / MAX_BG_SIZE));
        width = parseInt(imageDimensions.w / backgroundZoom);
        height = parseInt(imageDimensions.h / backgroundZoom);

        img = new Image();
        img.style.height = img.style.width = '100%';
        img.src = viewport.urlBuilder.region(0, 0, width, height, backgroundZoom);
        container.appendChild(img);
    })();
}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ViewportRotator = ViewportRotator;

var _helpers = __webpack_require__(4);

/**
 * This helper class rotates the image and all layers inside it when the viewport is rotated.
 * @param viewport
 * @constructor
 */
function ViewportRotator(viewport) {
    var $viewportDiv = viewport.vpDivGet()[0];
    // Pre-allocate to reduce the effects of garbage collection.
    var vpDivDims = void 0;
    var vpW = void 0;
    var vpH = void 0;

    // Expose the rotate change event
    this.rotateChange = function (_ref) {
        var angleRad = _ref.angleRad;

        vpDivDims = viewport.vpDivDimsGet();
        vpW = vpDivDims.w;
        vpH = vpDivDims.h;
        (0, _helpers.divRotate)($viewportDiv, 0, 0, vpW, vpH, angleRad);
    };
}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ViewportState = ViewportState;

var _index = __webpack_require__(16);

/**
 * Observes an object for changes and publishes change notifications as they occur.
 * @param changeDelegate - called any time a change is made to any state object.
 * @returns {{}}
 * @constructor
 */

function ViewportState(changeDelegate) {
    var _this = this;

    // Copy the default state to this instance.
    var state = Object.assign({}, INITIAL_STATE);
    // Allocate a change tracker.
    var changes = [];

    // Attach state properties to this instance. We use ES5 getters/setters to track and publish changes. We want
    // these properties to be enumerable when Object.keys() is called.
    Object.keys(state).forEach(function (key) {
        Object.defineProperty(_this, key, {
            enumerable: true,
            get: function get() {
                return state[key];
            },
            set: function set(val) {
                if (state[key] !== val) {
                    changes.push(key);
                    state[key] = val;
                    changeDelegate(key, val);
                }
            }
        });
    });

    // Expose public items that aren't enumerable (hidden from Object.keys etc).
    Object.defineProperties(this, {
        /**
         * If any properties have changed since the last clear event return true.
         */
        hasChanges: {
            get: function get() {
                return changes.length > 0;
            }
        },
        // Returns a list of all changed properties. This simplifies checks such as "has zoom changed" by centralizing
        // tracking in this class.
        changes: {
            get: function get() {
                return changes;
            }
        },
        // Resets all changes.
        clearChanges: {
            get: function get() {
                // ok this is weird. We return a reference to a function. The reason for this is to hide the function
                // from ownProperty calls such as "Object.keys()"
                return clearChanges;
            }
        }
    });

    function clearChanges() {
        changes.length = 0;
    }
}

// Default Viewport state properties.
var INITIAL_STATE = {
    left: 0,
    top: 0, // the left,top corner of the viewport corresponds to this zoom image coords
    width: 0,
    height: 0, // the width and height of the view in base image coords (pixels) with zoom compensation (view w,h at zoom=2 is 2x view w,h at zoom=1)

    zoom: 1.0, // the zoom factor in the system that ImageServer's GETImage likes: 0.5 = 200%, 1 = 100%, 2 = 50%, 4 = 25% (counter intuitive)
    isFitZoom: false, // flag that zoom factor is derived from "Fit" selection
    prevZoom: 1.0, // previous zoom factor

    tileL: 0,
    tileT: 0, // the tile numbers of the left, top, right, and bottom tiles of the visible viewport (not accurate, BTW)
    tileR: 0,
    tileB: 0,
    csTiles: new _index.Size(0, 0), // the number of tiles in each dimension of the total in a fully refreshed viewport
    csTilesVisible: new _index.Size(0, 0), // the number of tiles in each dimension  of the visible viewport

    angleDeg: 0,
    angleRad: 0, // image rotation angle
    cpRotOffset: new _index.Point(0, 0), // image rotation div offset

    focus: 0, // the z position which will not change until 3D is implemented

    isReadOnly: false // Allows plugins to determine whether they're allowed to manipulate viewport state
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(102);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.ViewportTileLayer = ViewportTileLayer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MINIMUM_TILE_SIZE = 256;

/**
 * Handles rendering the viewport's tiles.
 * @param viewport
 * @constructor
 */
function ViewportTileLayer(viewport) {
    // The concept behind this class is fairly straightforward, assuming you already understand the pyramid (if you don't
    // ask someone on the viewer team). An outer div serves as a container that represents the entire rendering surface
    // of the base image. This div can be (and usually is) extremely large (80k x 80k px, or even larger). The tiles are
    // simply scaled and placed in their rightful position on this div. Obviously for performance reasons we only render
    // tiles that are actually visible in the viewport, and pop them off when they're not.

    // The giant container. The Renderer class handles sizing this element.
    var container = document.createElement('div');
    // Reference to the viewport div so we can compute the visible area of the viewport.
    var $viewportDiv = viewport.vpDivGet();

    // The intro description at the top of this class glossed over the fact that there's multiple layers of tiles.
    // Depending on the current zoom level we'll be picking a different tile sizes to reduce the number of http
    // requests. The simplest way to picture this is, at a base resolution of 80k with tiles at 400px you've got a total
    // of 40,000 tiles. If you scale out to "fit" zoom you don't want to request all those tiles. "Layers" allow us to
    // pick smaller images with fewer tiles.
    var layers = function () {
        var layers = {};
        viewport.getPyramid().forEach(function (layer) {
            // Note the use of a map here makes it convenient for readability but may be slowing down the render pipe.
            // TODO: Evaluate and change if > 5%.
            var tileBuffer = new Map();
            layers[layer.zoom] = {
                tileBuffer: tileBuffer,
                zoom: layer.zoom
            };
        });
        return layers;
    }();
    // This function allows us to pick the "layer" that we want to pull tiles from.
    var getClosestLayer = getClosestLayerFn(layers);

    // Store off references to objects to reduce lookup time.
    var xinfo = viewport.getXinfoObj();
    var vpState = viewport.getVPView();
    var urlBuilder = viewport.urlBuilder;
    var xTileWidth = alignToTileBoundary(xinfo.tileWidth);
    var xTileHeight = alignToTileBoundary(xinfo.tileHeight);

    // Allocate space for primitives outside the paint() function so we don't incur the hit of allocation and garbage
    // collection during the render cycle.
    var layer = void 0,
        lastLayer = void 0;
    var vpWidth = void 0,
        vpHeight = void 0;
    var viewportZoom = void 0,
        pyramidZoom = void 0,
        scale = void 0;
    var tileLeft = void 0,
        tileTop = void 0,
        tileWidth = void 0,
        tileHeight = void 0,
        tilePosition = void 0;
    var tileWidthPx = void 0,
        tileHeightPx = void 0; // String concatenation is (relatively) expensive so reduce how often we do it.
    var tileL = void 0,
        tileR = void 0,
        tileT = void 0,
        tileB = void 0;
    var img = void 0;
    var zoomChanged = void 0;
    var x = void 0,
        y = void 0;

    container.className = 'us-vp-tile-container';

    // Expose the container to the renderer.
    this.container = container;

    // The meat of this class. As much as possible logic is inlined so we don't incur performance hits by making function
    // calls.
    this.paint = function () {
        // First check if zoom has changed; if so we have to do a little more work.
        if (viewportZoom !== vpState.zoom) {
            zoomChanged = true;
            viewportZoom = vpState.zoom;
            layer = getClosestLayer(vpState.zoom);

            // If we've switched pyramid layers clear the old one
            if (lastLayer && lastLayer !== layer) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = lastLayer.tileBuffer[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                            tile = _step$value[1];

                        tile.remove(); // Note IE requires a shim for this call. It's in /lib/utility/browser-compatibility.js
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            // Recalculate the size of tiles that will be rendered. Note that they're "cached" too so we don't have
            // to recalculate if zoom doesn't change.
            pyramidZoom = layer.zoom;
            scale = viewportZoom / pyramidZoom;
            tileWidth = xTileWidth / scale;
            tileHeight = xTileHeight / scale;

            // Note that we increase the width/height of the tile by 1. This is to hide hairline lines that appear
            // between tiles when the viewport is rotated. There's a slight distortion in the image but because it's
            // spanned across the width of the tile (400px) we're talking about 0.025%, which is not perceptible;
            // the same cannot be said for the lines they mask.
            tileWidthPx = tileWidth + 1 + 'px';
            tileHeightPx = tileHeight + 1 + 'px';
        }

        // Capture the width of the viewport.
        // TODO: It might be possible to only capture this on resize events.
        vpWidth = parseInt($viewportDiv[0].style.width, 10);
        vpHeight = parseInt($viewportDiv[0].style.height, 10);

        // add / subtract 1 tile to ensure coverage around the full viewing area, even when rotated.
        tileL = Math.floor(vpState.left / viewportZoom / tileWidth) - 1;
        tileR = Math.ceil(tileL + vpWidth / tileWidth) + 1;
        tileT = Math.floor(vpState.top / viewportZoom / tileHeight) - 1;
        tileB = Math.ceil(tileT + vpHeight / tileHeight) + 1;

        // Hide tiles that have moved offscreen. Note we do this before adding new ones to reduce the loop size.
        // TODO: Evaluate the effect of destructuring on performance.
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = layer.tileBuffer[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
                    pos = _step2$value[0],
                    tile = _step2$value[1];

                // storing tile position in a string results in a large number of string operations and accounts for nearly
                // 30% of all processing in this function; consider storing / retrieving more efficiently.
                var _pos$split = pos.split(','),
                    _pos$split2 = (0, _slicedToArray3.default)(_pos$split, 2),
                    _x = _pos$split2[0],
                    _y = _pos$split2[1];

                if (_x < tileL || _x > tileR || _y < tileT || _y > tileB) {
                    tile.remove();
                }
            }

            // Add tiles to the container if they're in view.
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        for (x = tileL; x <= tileR; x++) {
            for (y = tileT; y <= tileB; y++) {
                tilePosition = x + ',' + y;
                img = layer.tileBuffer.get(tilePosition);
                if (!img) {
                    img = new Image();
                    img.src = urlBuilder.region(x * xTileWidth, y * xTileHeight, xTileWidth, xTileHeight, pyramidZoom);
                    layer.tileBuffer.set(tilePosition, img);
                }
                // If this tile is already on the viewport and we're not scaling it there's nothing left to do.
                if (img.parentElement && !zoomChanged) {
                    continue;
                }

                tileLeft = x * tileWidth;
                tileTop = y * tileHeight;

                // In theory, positioning using css transforms is faster since it can leverage the GPU; in practice
                // this results in the tiles being "fuzzy" and hairline gaps appearing between them. Maybe one day, or
                // maybe we'll just switch to open layers and let someone else deal with the problem. For now use
                // classic absolute positioning.
                img.style.width = tileWidthPx;
                img.style.height = tileHeightPx;
                img.style.left = tileLeft + 'px';
                img.style.top = tileTop + 'px';

                // Useful for debugging:
                // img.setAttribute('x', x)
                // img.setAttribute('y', y)
                // img.setAttribute('z', pyramidZoom);

                container.appendChild(img);
            }
        }

        // Store off the last layer so we can tell when we switch.
        lastLayer = layer;
    };
}

var getClosestLayerFn = function getClosestLayerFn(layers) {
    var list = Object.keys(layers);
    var closestCache = {};

    return function (value) {
        if (!closestCache[value]) {
            var num = Number.MAX_VALUE;
            var distance = Number.MAX_VALUE;
            for (var i = 0; i < list.length; i++) {
                var currentNum = list[i];
                var currentDistance = Math.abs(value - currentNum);
                if (currentDistance < distance) {
                    num = currentNum;
                    distance = currentDistance;
                }
            }
            closestCache[value] = layers[num];
        }
        return closestCache[value];
    };
};

function alignToTileBoundary(size) {
    if (size >= MINIMUM_TILE_SIZE) {
        return size;
    }
    return Math.ceil(MINIMUM_TILE_SIZE / size) * size;
}

/***/ }),
/* 485 */,
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(108);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(159);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _defaults;

exports.default = UserPreferences;

var _lbsPiDash = __webpack_require__(5);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _events = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// original values were not set. False should be equiv. TODO: Replace when ready.
var NOT_SET = false;

var defaults = (_defaults = {}, (0, _defineProperty3.default)(_defaults, _defines2.default.clsDIVZOOMSLIDER, { value: NOT_SET, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.clsDIVZOOMSLIDER, { value: true, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.clsDIVZOOMCTL, { value: true, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.CVSHEATMAP, { value: NOT_SET, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.clsDIVTHUMBNAIL, { value: true, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.clsDIVTHUMBHOVER, { value: true, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.clsDIVGUAGES, { value: NOT_SET, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.CVSHEATMAP, { value: NOT_SET, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.clsDIVSCALEBAR, { value: true, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.clsROTATIONDIV, { value: true, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.clsDIVMAG, { value: false, dbId: null }), (0, _defineProperty3.default)(_defaults, _defines2.default.clsDIVLABEL, { value: NOT_SET, dbId: null }), (0, _defineProperty3.default)(_defaults, 'reportRegionWidth', { value: _defines2.default.eReportSpec.defWidthPx, dbId: null }), (0, _defineProperty3.default)(_defaults, 'reportRegionHeight', { value: _defines2.default.eReportSpec.defHeightPx, dbId: null }), (0, _defineProperty3.default)(_defaults, 'reportRegionType', { value: _defines2.default.eReportSpec.defReportType, dbId: null }), (0, _defineProperty3.default)(_defaults, 'labelRotation', { value: 0, dbId: null }), (0, _defineProperty3.default)(_defaults, 'imageQuality', { value: 80 /* NOT_SET */, dbId: null }), _defaults);

function UserPreferences(uScope) {
    var self = this;

    self.events = uScope.events.$new();

    var userPrefTable = void 0;

    /**
     * This function gets ALL uScope user preferences from the database
     * @param viewport
     */
    this.fetch = function (viewport) {
        if (_defines2.default.DISABLEUSERPREFS2DB == true) return; // if disabled, don't read from database

        var userId = uScope.getUserId(); // only make request if prefs are not know and userId is valid
        if (userId <= 0) {
            // ('ERROR: cUserPrefs: getAll: userId: ' + userId + '  is invalid.  User preferences cannot be read.'); // eslint-disable-line no-undef
            return;
        }

        var xml = '<TableName>UserConfig</TableName>' + '<FilterBy Column="Component" FilterOperator="="FilterValue="uScope" Table="UserConfig"></FilterBy>' + '<FilterBy Column="UserId" FilterOperator="=" FilterValue="' + userId + '" Table="UserConfig"></FilterBy>';

        // note - an image is required by imageserver dodbcall even if request isn't image related
        viewport.ajax.doDATASVRREQ(cbSuccessFn, cbFailureFn, 'GetFilteredRecordList', xml);

        //..................................................
        // closure functions
        //............................................ cbSuccessFn()
        // This function receives the response message from getUserPrefs
        //    and parses the returned user prefs into the user pref table.
        function cbSuccessFn(data, textStatus, jqXHR) {
            var idx = -1;
            var responseText = jqXHR.responseText;
            if ((idx = responseText.lastIndexOf('>')) !== -1) responseText = responseText.slice(0, idx + 1); // remove the garbage char on the end of the response

            var xmlDoc = $.parseXML(responseText);
            var $xml = $(xmlDoc);
            var jResponse = $xml.find('GetFilteredRecordListResponse');
            var jResult = jResponse.find('ASResult');

            if (jResult.text() != '0') {
                var jMessage = jResult.find('ASMessage'); //s/b [ asmessage ]
                // ('Error: cb_getUserPrefs: msg:' + jMessage.text() + '  code: ' + jResult.text()); // eslint-disable-line no-undef
                return;
            }

            // parse and update entry in prefs table for value and id
            var jDataRows = jResponse.find('DataRow'); //ex: [ DataRow] [ DataRow ] [ DataRow ]
            for (var l = 0, len = jDataRows.length; l < len; l++) {
                var jRow = jDataRows.eq(l);
                var dbId = jRow.find('Id').text();
                var name = jRow.find('Name').text();
                var value = jRow.find('Value').text();
                if (name && dbId && value) {
                    initPref(name, value, dbId);
                }
            }

            (0, _events.triggerUScopeEvent)(_defines2.default.evUSERPREFSREADY, { status: true });
            self.events.trigger('load');
        }
        //............................................ cbFailureFn()
        function cbFailureFn(jqXHR, textStatus, errorThrown) {
            // ('cUserPrefs: getAll: doDATASVRREQ: GetFilteredRecordList: ' + viewport.ajax.getErrorStr(jqXHR, textStatus, errorThrown, viewport.getImageId())); // eslint-disable-line no-undef
        }
        //..................................................
    };

    /**
     * This function returns the user preference value for the given name. If the name is not in the pref table and is not a special access pref, undefined is returned.
     * @param name
     * @param defaultVal
     * @returns {*}
     */
    this.get = function (name) {
        var rtnVal;
        if (userPrefTable[name]) {
            rtnVal = userPrefTable[name].value;
        } else {
            // ('user-preferences::get() - requested unknown value \'' + name + '\''); // eslint-disable-line no-undef
        }

        return rtnVal;
    };

    this.getGroup = function () {
        for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
            items[_key] = arguments[_key];
        }

        var out = {};
        items.forEach(function (item) {
            return out[item] = self.get(item);
        });
        return out;
    };

    /**
     * This function updates a user preference and stores it in the database. If the preference does not exist in the table it is added.
     * @param name
     * @param value
     */
    this.set = function (name, value) {
        // if the name is not in the table add it
        if (!userPrefTable[name]) {
            // ('Setting unknown user pref'); // eslint-disable-line no-undef
            initPref(name, value);
        } else if (userPrefTable[name].value == value) {
            return;
        }

        // update table
        userPrefTable[name].value = value;

        (0, _events.triggerUScopeEvent)(_defines2.default.evUSERPREFSET, { className: name, value: value });
        self.events.trigger('change:' + name, value);

        if (_defines2.default.DISABLEUSERPREFS2DB) {
            return;
        }

        // only make request if prefs are not know and userId is valid
        var userId = uScope.getUserId();
        if (userId < 0) {
            return;
        }

        var dbId = userPrefTable[name].dbId ? userPrefTable[name].dbId : 0;

        var xml = '<TableName>UserConfig</TableName>' + '<Tag>' + name + '</Tag>';

        if (dbId > 0) {
            xml += '<Id>' + userPrefTable[name].dbId + '</Id>';
        }
        xml += '<DataRow>' + '<Name>' + name + '</Name>' + '<Value>' + value + '</Value>';

        if (dbId <= 0) {
            xml += '<Component>uScope</Component>' + '<UserId>' + userId + '</UserId>';
        }
        xml += '</DataRow>';

        // note - imageId required by imageserver dodbcall even if the request isn't image related!
        if (uScope.isThisImageValid() == true) {
            var viewport = uScope.getThisImage();
            viewport.ajax.doDATASVRREQ(cbSuccessFn, cbFailureFn, 'PutRecordData', xml);
        }

        function cbSuccessFn(data, textStatus, jqXHR) {
            var idx = -1;
            var responseText = jqXHR.responseText;
            if ((idx = responseText.lastIndexOf('>')) !== -1) responseText = responseText.slice(0, idx + 1); // remove the garbage char on the end of the response

            var xmlDoc = $.parseXML(responseText);
            var $xml = $(xmlDoc);
            var jResponse = $xml.find('PutRecordDataResponse');

            var name = jResponse.find('Tag').text(); // get the returned tag
            if (name) {
                var dbId = jResponse.find('Id').text(); // get the returned preferences id
                if (dbId) {
                    userPrefTable[name].dbId = dbId;
                }
            }
        }

        function cbFailureFn(jqXHR, textStatus, errorThrown) {
            // ('cUserPrefs: set: doDATASVRREQ: PutRecordData: ' + viewport.ajax.getErrorStr(jqXHR, textStatus, errorThrown, viewport.getImageId())); // eslint-disable-line no-undef
        }
    };

    /**
     * This function resets the object and (re)initializes the user preference table
     */
    this.reset = function () {
        userPrefTable = (0, _lbsPiDash.clone)(defaults);
    };

    /**
     * This function adds a set of preferences and default values to the user settings instance. Note that the same
     * preference cannot be registered twice, so it's recommended that each setting be namespaced, e.g. "report-width",
     * "snapshot-width", etc.
     * @param prefs object Simple dictionary containing keys and default values.
     */
    this.registerPreferences = function (prefs) {
        (0, _lbsPiDash.forEach)(prefs, function (value, key) {
            var v = { value: value, dbId: null };
            defaults[key] = v;
            if (!userPrefTable.hasOwnProperty(key)) {
                userPrefTable[key] = v;
            }
        });
    };

    var initPref = function initPref(name, value, dbId) {
        // TODO: In short, it coerces `value` to the type of the original. This logic is kinda brittle, so yea, clean it up a bit.
        var o = userPrefTable[name];
        if (!o) {
            return;
        }
        var type = (0, _typeof3.default)(o.value);
        var typedValue = void 0;
        type = type.charAt(0).toUpperCase() + type.slice(1);
        if (type === 'Boolean') {
            if (value === 'true') typedValue = true;else if (value === 'false') typedValue = false;
        } else {
            typedValue = eval(type + '(\'' + value + '\')');
        }
        userPrefTable[name] = { dbId: dbId, value: typedValue };
    };

    self.reset();
}
module.exports = exports['default'];

/***/ }),
/* 487 */,
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cOverLayout;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _objects = __webpack_require__(16);

var _helpers = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// overLayout.js
//    This file contains cOverLayout, an object that places overlay objects on a viewport.
//
//    history
//    1106    cperz        created
//
//    _______________________________________end_AIHv1/PR __________________________________________
//    141118    cperz        moved from layout.js
//________________________________________________________________________________________________
//    Object Name: cOverLayout
//    Overview: This object performs layout management for all overlayed visuals in the viewports.
//    Its purpose is to facilitate the placement of or moving of these visuals when new
//    visuals are added or when the viewport is repainted.
//  Upon any change the state vector object for the viewport is informed. //cp-reword me!!!
//
//    Associated Panel: o todo
//
//    Dependencies and Supporting objects: o todo
//
//    Assumptions: o todo
//
//    Limitations: o todo
//
//    Terms Used: o todo
//
//    Functionality: o todo
//
//    Data Structures: o todo
//
//    HTML: o todo
//
//    References: o todo
//
//    Notes:
//        An element's layout array contains = {
//                divClass: "us.clsDIVLABEL",    - the class of the object; used to find it in the viewport div
//                                                there must be only one item with this class per viewport
//                precinct: "BR"                 - general location: "BR" (bottom right), "TL" (top left), "C" (center)
//                                                "BL", "TR", ...
//                order: 0                    - when more than one item vies for position, what horizontal order to place them;
//                                                see the note below regarding Flow Order Scheme.
//                bottomOffset: NUM            - a y offset to apply to the position
//                rightOffset: NUM            - an x offset to apply to the position
//                canBePlaced: true            - if false, reposition only if the element is not fully contained in the viewport (e.g. resize event)
//                }
//
//        Flow Order Scheme: the order designations indicate a flow order from the corner of
//                            the precinct (e.g. TL) towards the viewport center
//
//        "TL"                                      "TR"
//        ==============================================
//        =  0 1 2                              2 1 0  =
//        =                                            =
//        =                                            =
//        =               Viewport                     =
//        =                                            =
//        =  0 1 2                              2 1 0  =
//        ==============================================
//        "BL"                                      "BR"
//
//
//todo: in the future provide for vertical flow control
//todo: instead of using kOVERLAY_ELEMENT_SPACE, set overlay element space in css
//todo: rename bottomOffset and rightOffset to x and y, the sign is a little odd too
function cOverLayout(viewport) {
    var self = this;
    var jVpDiv = viewport.vpDivGet('outer');

    // Note that the queue holds refs to the original item so changes can be made to the original item
    var queue = []; // the list of overlay visuals

    var precincts_ = ['TL', 'TR', 'BL', 'BR', 'C']; // precincts implemented

    //............................................ reset() public
    self.reset = function () {
        queue.length = 0;
    };

    //............................................ add() public
    //    add - This function adds a new visual object. Upon call the item must be in the DOM,
    //            perhaps off screen (at us.kDEF_TILE_POS). It returns true for success, false otherwise.
    self.add = function (divLayout) {
        if ((0, _helpers.isUnDefined)(divLayout) || (0, _helpers.isUnDefined)(divLayout.divClass) || (0, _helpers.isUnDefined)(divLayout.precinct)) //cp-check for others?
            return false;

        if (getIndex_(divLayout.divClass) < 0) // if the divLayout is not already in the queue, add it
            queue.push(divLayout); // Note that the queue holds refs to the original item
        // so changes can be made to the original item

        var ok = self.refresh(divLayout.precinct); // and update the position of the item
        return true;
    };

    //............................................ refresh() public
    // refresh - This functions updates the positions of all visual objects in the queue
    self.refresh = function () {
        for (var p = 0, plen = precincts_.length; p < plen; p++) {
            var aPrecinct = precincts_[p]; // refresh this precinct
            self.refreshPrecinct(aPrecinct);
        }
    };

    //............................................ refreshPrecinct() public
    // refreshPrecinct - This functions updates the positions of all visual objects in the passed precinct.
    self.refreshPrecinct = function (aPrecinct) {
        var vpDivDims = viewport.vpDivDimsGet();
        var vpWidth = vpDivDims.w,
            vpHeight = vpDivDims.h;

        var list = getSamePrecinct_(aPrecinct); // collect a flow-order list of indices into the queue of elements in this precinct

        if (list.length > 0) {
            // if there are elements to arrange
            var prevDivWidth = 0,
                prevDivHeight = 0;
            for (var i = 0, llen = list.length; i < llen; i++) {
                // for this element in this precinct
                var idx = list[i].origIdx;
                var jthisDiv = jVpDiv.find('.' + queue[idx].divClass);

                if (jthisDiv.is(':visible') == false) continue;

                // if this element does not want to move, if it is in the view then do not reposition it
                if (queue[idx].canBePlaced != undefined && queue[idx].canBePlaced == false) {
                    var offset = jthisDiv.offset(); // is this element is fully contained in the viewport?
                    if (offset.left + jthisDiv.width() > vpWidth && offset.top + jthisDiv.height() > vpHeight) queue[idx].canBePlaced = true; // no, then re-enable positioning of the element
                    else continue; // yes, then don't reposition
                }

                var divWidth = jthisDiv.outerWidth(true); // this element's outer dimensions
                var divHeight = jthisDiv.outerHeight(true);

                var bottomOffset = queue[idx].bottomOffset || 0;
                var rightOffset = queue[idx].rightOffset || 0;

                var cpPos = new _objects.Point(0, 0); // the relative position in the viewport to place the element

                // determine the desired position for the object;  note that viewport left,top not used, all placement is relative
                if (queue[idx].precinct == 'TL') cpPos.set(_defines2.default.kOVERLAY_ELEMENT_SPACE * (i + 1) + prevDivWidth + rightOffset, _defines2.default.kOVERLAY_ELEMENT_SPACE + bottomOffset);else if (queue[idx].precinct == 'TR') cpPos.set(vpWidth - divWidth - prevDivWidth - (i + 1) * _defines2.default.kOVERLAY_ELEMENT_SPACE - rightOffset, _defines2.default.kOVERLAY_ELEMENT_SPACE + bottomOffset);else if (queue[idx].precinct == 'BR') cpPos.set(vpWidth - divWidth - prevDivWidth - (i + 1) * _defines2.default.kOVERLAY_ELEMENT_SPACE - rightOffset, vpHeight - divHeight - +_defines2.default.kOVERLAY_ELEMENT_SPACE - bottomOffset);else if (queue[idx].precinct == 'BL') cpPos.set(_defines2.default.kOVERLAY_ELEMENT_SPACE * (i + 1) + prevDivWidth + rightOffset, vpHeight - divHeight - +_defines2.default.kOVERLAY_ELEMENT_SPACE - bottomOffset);else if (queue[idx].precinct == 'C') {
                    cpPos.set(Math.round((vpWidth - divWidth) / 2), Math.round((vpHeight - divHeight) / 2));
                }
                cpPos.toInt(); // set the left,top position for this element
                jthisDiv.css({ 'left': cpPos.x + 'px', 'top': cpPos.y + 'px' });

                prevDivWidth += divWidth; // accumulate the previous elements' dimensions
                prevDivHeight += divHeight;
            }
        }
    };

    //............................................ getIndex_() local
    //  getIndex_ - This function returns the index to the item whose name matches the value,
    var getIndex_ = function getIndex_(theObjClass) {
        // return -1 if no match is found
        for (var i = 0, qlen = queue.length; i < qlen; i++) {
            if (queue[i].divClass == theObjClass) return i;
        }
        return -1;
    };
    //............................................ getSamePrecinct_() local
    // getSamePrecinct_ - This function returns an array of indices with precincts of the passed divLayout
    var getSamePrecinct_ = function getSamePrecinct_(precinct) {
        var rtnList = [];
        for (var i = 0, qlen = queue.length; i < qlen; i++) {
            if (queue[i].precinct === precinct) {
                // save the order so they can be sorted, the original index for the caller;
                var temp = { 'order': queue[i].order, 'origIdx': i };
                rtnList.push(temp);
            }
        }
        // sort the rtn list in flow order
        rtnList.sort(function (a, b) {
            return a.order - b.order;
        });
        return rtnList;
    };

    viewport.events.on('viewport:resize', self.refresh);
}
module.exports = exports['default'];

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cStateVector;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _objects = __webpack_require__(16);

var _events = __webpack_require__(31);

var _helpers = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// statevector.js
//todo: update description
//
// cStateVector object - This is a generic container useful for ...
//    Every item added to the queue is time stamped for time series analyis, playback, etc.
//  There are optional functions onAdd[1,2,..]() that the user can define that will be //cp-not right!!!!!
//        called each time imageUpdate() is called.
//
//    Note that the debug statements are commented outin some functions to reduce vpRefresh time.
//cp-mention that this saves mouse & moves only > a fixed amount...
//
//    history
//    1106    cperz    created
//    _______________________________________end_AIHv1/PR __________________________________________
//
//________________________________________________________________________________________________
// todo
//    - could make queue trim on time instead of size (with size max still...)
//  - add methods for getlast direction, mouse position, etc....
//            much more straightforward, no need to understand internal storage of this object!
//________________________________________________________________________________________________
// state types:
//    image: set by viewUpdate()
//    mouse: set by mouseUpdate()
//
_defines2.default.eStateTypes = { image: 0, mouse: 1 }; // TODO: there's only one state type!

function cStateVector(viewport) {
    var self = this;
    var imageId_ = viewport.getImageId();
    var uScopeIdx_ = viewport.getImageIdx();

    var imageSizeMax;
    var mouseSizeMax;

    var d = new Date();
    var dTime = 1. / 10.; // get the start time and scale it from millisecs to 1/100th sec
    var startTime = d.getTime() * dTime;

    var imageQueue = []; // the image state vector queue
    var mouseQueue = []; // the mouse state vector queue
    var cb_imageState = []; // array of image state function callbacks
    var cb_mouseState = []; // array of mouse state function callbacks

    var stateTypeView = _defines2.default.eStateTypes.view;

    var minMoveMagnitude_ = 12; // the minimum magnitude in pixels of movement to record
    var slopeLimit = 4;
    var slopeLimtInv = 0.25; // 1. / slopeLimit

    var kSVQUEUE_VIEW_SIZE = 500; // number of view states to retain in state vector queue
    // this throttles the responsivity of the state vector!

    //............................................ _sinceStartTime local
    //    This function is used for all time stamps in this object.
    //    It converts absolute time from "new Date().getTime()" to a differntial in seconds
    //    (to the 3rd decimal place - milliseconds) since the start time of this object.
    var _sinceStartTime = function _sinceStartTime(time) {
        return (time * dTime - startTime).toFixed(3);
    };
    //............................................ _setSize local
    // This function sets the image and mouse queue maximum sizes.
    var _setSize = function _setSize(newSize) {
        var newMax = newSize ? newSize : 200; // maximum size for queue
        if (newMax < 1 || newMax > 2000) // sanity check on the queue size
            return;
        imageSizeMax = newMax;
        mouseSizeMax = 100; //  parseInt(newMax / 2);     // limit the mouse queue to half the size


        while (imageQueue.length > imageSizeMax) {
            imageQueue.shift();
        }while (mouseQueue.length > mouseSizeMax) {
            mouseQueue.shift();
        }
    };
    //............................................ viewUpdate
    // This function adds an image state vector to its queue.
    // If the state description is a move, the city block distance between this position and the previous state on the queue
    // must be greater than a threshold.  Otherwise the state is not added to the queue.
    //
    // An Image State Vector is a definition of the view state plus:
    //        time stamp
    //        + desc  {"all", "move", "zoom", "focus", "dims", }
    //        + viewport's vpView contents {left, top, width, height, zoom, focus, angleDeg}
    //        + dir {"none", "wholeview", "north", "east", "west", "south", northwest, ...} //cp-fill in and define
    //        + magpx { magnitude of move in pixels }
    //
    //    parameters
    //        state:        {left, top, width, height, zoom, focus, angleDeg}
    //        changeDesc: "all" or "move" or "zoom" or "focus" or "dims" or "rotate"
    //
    //    todo:
    //        - I'd like to know if there are listeners, perhaps I don't do all this if not

    var lastViewState_ = new _objects.Point(0, 0);
    this.viewUpdate = function (state, changeDesc) {
        var zoom = state.zoom;

        if (imageQueue.length == imageSizeMax) // maintain queue size
            imageQueue.shift(); // remove the top element of the array to make room at the bottom

        var magpx = 0;
        if (changeDesc == 'move') {
            // throttle the responsivity to motion
            var magpx = Math.abs(state.left - lastViewState_.x) + Math.abs(state.top - lastViewState_.y); // city-street magnitude of move in pixels
            if (magpx < minMoveMagnitude_) {
                return;
            }
        }

        var sv = []; // add info to new state vector
        sv.time = _sinceStartTime(new Date().getTime()); // add time stamp
        sv.desc = changeDesc; // add input change description
        sv.state = jQuery.extend(true, {}, state); // add input view state, must clone state first
        if (changeDesc == 'move') //
            sv.magpx = magpx; // add magnitude of move (units are pixels)
        _computeDir(sv); // add computed direction 'dir'
        imageQueue.push(sv); // add state vector to the queue
        lastViewState_.set(state.left, state.top); // save last queue view position

        for (var c = 0, len = cb_imageState.length; c < len; c++) {
            // execute the callbacks to signal a SV update event
            cb_imageState[c]();
        } // report coords in normal graphics system space
        var cpCenter = viewport.getViewCenter(_defines2.default.coordSystemNORM); //report out in normal coordSystem
        (0, _events.triggerUScopeEvent)(_defines2.default.evVIEWCHANGE, { // fire event that the view has changed
            imageId: imageId_, uScopeIdx: uScopeIdx_, desc: sv.desc,
            x: cpCenter.x, y: cpCenter.y, zoom: zoom, angleDeg: state.angleDeg
        });

        //............................................ _computeDir
        // This function evaluates the most recent state change and concludes the view motion direction.
        //        It then adds that direction to the passed array.
        function _computeDir(ioSV) {

            ioSV.dir = 'none';
            if (imageQueue.length == 0 || ioSV.desc == 'all' || ioSV.desc != 'move') return;

            var lastState = self.getLast(stateTypeView).state;
            var dx = ioSV.state.left - lastState.left;
            var dy = ioSV.state.top - lastState.top;

            if (Math.abs(dx) > lastState.width * 2 || Math.abs(dy) > lastState.height * 2 // if moved N views  //cp-revisit factor of 2
            || ioSV.desc == 'dim') {
                // or resized view dimensions
                ioSV.dir = 'wholeview'; // then indicate whole view change
                return;
            }
            var dr = slopeLimit + 1; // slope of motion
            if (dy != 0) dr = dx / dy;

            var dir = 'none'; // default direction of move
            if (Math.abs(dr) > slopeLimit) {
                // if horizontal motion
                if (dx < 0) // if moving left
                    dir = 'east';else dir = 'west';
            } else if (Math.abs(dr) < slopeLimtInv) {
                // if vertical motion
                if (dy < 0) // if moving up
                    dir = 'south';else dir = 'north';
            } else if (dx < 0) {
                // diagnal motion, moving left
                if (dy < 0) // if moving up, too
                    dir = 'southeast';else dir = 'northeast';
            } else {
                // diagnal motion, moving right
                if (dy < 0) // if moving up, too
                    dir = 'southwest';else dir = 'northwest';
            }

            ioSV.dir = dir; // add direction to return ioSV
        }
    };

    //............................................ mouseUpdate
    // This function adds an mouse state vector to its queue.
    // If the state description is a mousemove, the city block distance between this position and the previous state on the queue
    // must be greater than a threshold.  Otherwise the state is not added to the queue.
    //
    //    A Mouse State Vector is a definition of the mouse state:
    //        time stamp
    //        + desc {"mousemove", "mousedown", ...}
    //        + state   Point {x,y} of mouse position in base image coordinates, us.coordSystemNORM
    //
    //    parameters
    //        state:            Point {x,y} of mouse position in base image coordinates
    //        eventDesc:        {"mousemove", "mousedown",}
    //        bForce:            boolean, if true the function does not exit when there are no listeners
    //                                    so us.evMOUSECHANGE event is fired if mouse move is sufficient

    var lastMouseState_ = new _objects.Point(0, 0);
    this.mouseUpdate = function (state, eventDesc, bForce) {
        if (bForce == false && cb_mouseState.length == 0) // do not save state if no one is subscribed
            return;

        if (mouseQueue.length == mouseSizeMax) // maintain queue size
            mouseQueue.shift(); // remove the top element of the array to make room at the bottom

        var magpx = 0;
        if (eventDesc == 'mousemove') {
            if (lastMouseState_) {
                // throttle the responsivity to motion
                magpx = lastMouseState_.cityBlockDistance(state);
                if (magpx < minMoveMagnitude_) {
                    return;
                }
            }
        }

        var sv = []; // add info to new state vector
        sv.time = _sinceStartTime(new Date().getTime()); // add time stamp

        sv.desc = eventDesc; // add input change description
        sv.state = jQuery.extend(true, {}, state); // add input view state, must clone state first
        mouseQueue.push(sv); // add state vector to the queue
        lastMouseState_.setPoint(sv.state); // save last queue mouse position

        for (var c = 0, len = cb_mouseState.length; c < len; c++) {
            // execute the callbacks to signal a SV update event
            cb_mouseState[c]();
        }(0, _events.triggerUScopeEvent)(_defines2.default.evMOUSECHANGE, {
            imageId: imageId_,
            uScopeIdx: viewport.getImageIdx(),
            x: state.x,
            y: state.y
        });
    };

    //............................................ getLast
    // This function returns the last state vector for the specified state type.
    this.getLast = function (stateType) {
        //cp-todo rename to get LastState
        if ((0, _helpers.isUnDefined)(stateType)) stateType = _defines2.default.eStateTypes.view;
        if (stateType === _defines2.default.eStateTypes.view) return imageQueue.length > 0 ? imageQueue[imageQueue.length - 1] : undefined;else return mouseQueue.length > 0 ? mouseQueue[mouseQueue.length - 1] : undefined;
    };
    //............................................ report
    // This function converts the passed state into a csv string.
    this.report = function (stateVector, stateType) {
        var str = '';
        if ((0, _helpers.isUnDefined)(stateVector)) return str;
        if ((0, _helpers.isUnDefined)(stateType)) stateType = _defines2.default.eStateTypes.view;

        if (stateType === _defines2.default.eStateTypes.view) {

            var zoom = stateVector.state.zoom;
            var isFit = viewport.isFitZoom(zoom);
            var mag = isFit ? 'Fit' : viewport.convertToMag(zoom);
            zoom = isFit ? 'Fit' : zoom;

            // note that this format is copied into the performance test sequence in cPerformanceTest
            str = parseInt(stateVector.time) + ', "' + stateVector.desc + '", ' + stateVector.state.left + ', ' + stateVector.state.top + ', ' + zoom + ', ' + mag;

            //note: stateVector.dir & stateVector.magpx not reported (yet?)
        } else {
            var sv = mouseQueue[mouseQueue.length - 1];
            str = stateVector.desc;
            str += stateVector.state.toString();
            if (stateVector.magpx) str += '  magnitude_px:' + stateVector.magpx;
        }
        return str;
    };
    this.reportTitle = function (stateType) {
        var str = '';
        if ((0, _helpers.isUnDefined)(stateType)) stateType = _defines2.default.eStateTypes.view;

        str = 'Filename: ' + viewport.getFileName() + ' Width: ' + viewport.getImageWidth() + ' Height:' + viewport.getImageHeight() + '\n';

        if (stateType === _defines2.default.eStateTypes.view) {
            str += 'time, desc, centerX, centerY, zoom, mag\n';
            //note: stateVector.dir & stateVector.magpx not reported (yet?)
        } else {
                // not implemented
            }
        return str;
    };
    //............................................ reportAll
    this.reportAll = function (stateType, normalize) {
        var str = this.reportTitle(stateType);
        if ((0, _helpers.isUnDefined)(stateType)) stateType = _defines2.default.eStateTypes.view;
        if ((0, _helpers.isUnDefined)(normalize)) normalize = false;

        var queue = stateType === _defines2.default.eStateTypes.view ? imageQueue : mouseQueue;
        if (queue.length > 0) {
            for (var s = 0, len = queue.length; s < len; s++) {
                var svRef = queue[s]; // get state vector at index s
                var sv = new _helpers.cloneObject(svRef); // clone the state vector so I can modify it

                var x = sv.state.left; // state reports top left corner, convert to center position
                var y = sv.state.top;
                x = parseInt(x + viewport.getViewWidth() / 2);
                y = parseInt(y + viewport.getViewHeight() / 2);

                if (normalize == true) {
                    // if normalize, x and y are proportion of the image dims
                    x = (x / viewport.getImageWidth()).toFixed(5);
                    y = (y / viewport.getImageHeight()).toFixed(5);
                }
                sv.state.left = x;
                sv.state.top = y;

                str += this.report(sv, stateType) + '\n';
            }
        }
        return str;
    };

    //............................................................................................
    // construction
    _setSize(kSVQUEUE_VIEW_SIZE); // save the max queue size allowed
}
module.exports = exports['default'];

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cViewLayout;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// viewLayout.js
//    This file contains cViewLayout,    an object that provides arrangements of viewport panes for multi-image viewing.
//
//    history
//    1106    cperz        created
//
//    _______________________________________end_AIHv1/PR __________________________________________
//    141118    cperz        moved from layout.js
//
//________________________________________________________________________________________________
//    Object Name: cViewLayout
//    Overview: todo
//
//    Associated Panel: o todo
//
//    Dependencies and Supporting objects:
//        o jquery plugin 'layout'
//            - reference:     http://layout.jquery-dev.net/index.cfm
//            - https://groups.google.com/forum/#!topic/jquery-ui-layout/71vyVOrngfc //  options example
//            If changes need to be made to the fundamental structure of the layout,
//            you could use methods like removePane() and addPane() to change a single pane,
//            or you could destroy() the entire layout and then recreate it with completely new options.
//            This normally happens so quickly that you would not even see it, except for any changes you have specified.
//
//    Assumptions: o todo
//
//    Limitations: o todo
//
//    Terms Used: o todo
//
//    Functionality: o todo
//
//    Data Structures: o todo
//
//    HTML: o todo
//
//    References: o http://layout.jquery-dev.net/index.cfm
//
//
//    construction parameters:
//        jParentDiv
//        crContainer
//        nImages: number of images/views
//        cb_onResizeRef
//        opt_paneDesc: one of the choices for the arrangement in us.viewLayoutMode[imgCount][]
//
//    Notes:
//        after construction, check this.status
function cViewLayout(jParentDiv, crContainer, nImages, cb_onResizeRef, opt_paneDesc) {
    var self = this;
    this.status = true;

    var jContainer; // div created on construction that contains this layout
    var myLayout_; //
    var state = []; // array of size imageCount, each slot contains the following assoc array:
    //    {
    //        divId:            id of the pane's div
    //        jPane:            jquery object ref to the pane
    //        samplePref:        pane's preference for sample type - not currently used by mapImagesToPanes()
    //        imageIdx:        related index into jsonList used to assign images
    //
    //        sampleType:        image's sample type
    //        jImgDiv:        attached jquery object of the image's viewport; if == undefined, the image is not present
    //        imageId:        image's id (prefixed with '@')
    //    }

    // view layout settings

    var viewLayoutMode = []; // viewLayoutMode[imageCount][paneDesc_]
    viewLayoutMode[1] = ['1']; // note that the paneDesc_ text match suffixes of the corresponding toolbar icon
    viewLayoutMode[2] = ['v', 'h']; //        so don't change these assignments without considering that impact
    viewLayoutMode[3] = ['t', 'v', 'h'];
    viewLayoutMode[4] = ['4'];

    var imageCount = 0; // # of images = # of panes; constrained by max allowed
    var paneDesc_; // description of the pane layout
    var minSize = 100; // minimum pane width/height on resizer drag in pixels

    //............................................ construct_() local
    // This function constructs the layout html and attaches it to the DOM, initializes the layout options
    //    and sizes the layout container to fill the passed jParentDiv.
    var construct_ = function construct_() {
        imageCount = Math.min(nImages, _defines2.default.multiSpecs.maxImages); // # of images = # of panes; constrained by max allowed
        if (imageCount < 1) {
            self.status = false;
            // ('Error: cViewLayout: construction: illegal image count: ' + imageCount); // eslint-disable-line no-undef
            return;
        }
        paneDesc_ = opt_paneDesc ? opt_paneDesc // if an arrangement is specified then use it,
        : viewLayoutMode[imageCount][0]; // otherwise select the first as the default layout for this arrangement

        var layoutName = self.getLayoutName(); // create a container and attach to parent element
        jContainer = $('<div/>', { 'id': layoutName }); // will have class .ui-layout-container added to it
        jParentDiv.append(jContainer);

        var html = buildContainerHTML_(imageCount); // define panes for this number of images
        jContainer.append($(html)); // inject panes into jContainer
        var options = buildOptions_(cb_onResizeRef, crContainer); // define the layout options: proportional size of the panes, minsize, resize callbacks, ...
        myLayout_ = jContainer.layout(options); // perform the layout and sizes the panes in pixels
    };

    //............................................ accessor fns public
    this.getImageCount = function () {
        return imageCount;
    };
    this.getPaneDesc = function () {
        return paneDesc_;
    }; // return the pane descriptions (e.g. "v", "h", "t")
    this.getImageState = function (paneIdx) {
        return state[paneIdx];
    }; // return the image state assoc array for the given pane

    this.detatchFromDom = function () {
        // detach conataining element from the DOM
        if (jContainer) jContainer.detach();
    };

    //............................................ getLayoutName() public
    //    This function provides a unique and descriptive name for each layout.
    //
    //    todo: should generalize this to use the viewLayoutMode array contents.
    this.getLayoutName = function () {
        if (imageCount == 1 || imageCount == 4) return 'viewLayout_' + imageCount;else if (imageCount == 2 || imageCount == 3) return 'viewLayout_' + imageCount + '_' + paneDesc_;else return undefined;
    };
    //............................................ getNextPaneDesc() public
    // This function returns the NEXT layout arrangement in the viewLayoutMode sequence.
    //
    //    todo: should generalize this to use the viewLayoutMode array contents.
    this.getNextPaneDesc = function () {
        var rtnDesc = '';
        if (imageCount == 2) // us.viewLayoutMode[2] = ["v", "h"];
            rtnDesc = paneDesc_ == 'v' ? 'h' : 'v';else if (imageCount == 3) // us.viewLayoutMode[3] = ["t", "v", "h"];
            rtnDesc = paneDesc_ == 't' ? 'v' : paneDesc_ == 'v' ? 'h' : 't';
        return rtnDesc;
    };

    //-------------------------------------------------------------------------------------------------
    //    LAYOUT CONFIGURATION FUNCTIONS
    //-------------------------------------------------------------------------------------------------

    //............................................ mapImagesToPanes() local
    //    This function maps the index of an image in jsonList to the state[pane] it is to be rendered in.
    //    The pane preference for positive and negative controls samples are implemented for each layout.
    //
    //    note:    If the jsonList has more than 1 positive control (or more than 1 negative control)
    //            those additional controls are treated as patient samples with no pane preference.
    //
    //    note:  The state[]'s samplePref are not yet filled in, if they were this fn could obey the
    //            prefered pane location for controls.  Right now the preference panes for controls is
    //            just coded in.

    var mapImagesToPanes = function mapImagesToPanes(jsonList) {

        //..................................................
        //    This function identifies the first image in the jsonList of the given sample type
        //    and returns that index into the jsonList or -1 if not found.
        var findSampleTypeIdx = function findSampleTypeIdx(jsonList, sampleType) {
            for (var i = 0; i < imageCount; i++) {
                if (sampleType == jsonList[i].sampleType) return i;
            }
            return -1;
        };
        //..................................................
        //    This function ...
        var assignPatientSamples = function assignPatientSamples() {
            for (var i = 0; i < imageCount; i++) {
                // then assign patient sample types
                if (jsonList[i].assigned == false) {
                    // find unassigned image
                    for (var p = 0; p < imageCount; p++) {

                        if (state[p].imageIdx == undefined) {
                            //assign it to the first empty pane
                            state[p].imageIdx = i;
                            jsonList[i].assigned = true;
                            break;
                        }
                    }
                }
            }
        };
        //..................................................
        for (var i = 0; i < imageCount; i++) {
            // set all images unassigned to a pane
            jsonList[i].assigned = false;
        }var posIdx = findSampleTypeIdx(jsonList, 'positive'); // identify the 1st positive and 1st negative control imgaes
        var negIdx = findSampleTypeIdx(jsonList, 'negative');
        if (posIdx != -1) jsonList[posIdx].assigned = true;
        if (negIdx != -1) jsonList[negIdx].assigned = true;

        if (imageCount == 1) {
            // for each layout configuration, place the controls then the patient samples
            state[0].imageIdx = 0;
        } else if (imageCount == 2) {
            if (posIdx != -1 && negIdx != -1) {
                state[0].imageIdx = posIdx;
                state[1].imageIdx = negIdx;
            } else if (posIdx != -1) {
                state[0].imageIdx = posIdx == 0 ? 1 : 0;
                state[1].imageIdx = posIdx;
            } else if (negIdx != -1) {
                state[0].imageIdx = negIdx == 0 ? 1 : 0;
                state[1].imageIdx = negIdx;
            } else {
                state[0].imageIdx = 0;
                state[1].imageIdx = 1;
            }
        } else if (imageCount == 3) {
            if (paneDesc_ == 't' // assign pos and neg controls first
            || posIdx != -1 && negIdx != -1) {
                if (posIdx != -1) {
                    state[1].imageIdx = posIdx;
                }
                if (negIdx != -1) {
                    state[2].imageIdx = negIdx;
                }
            } else {
                if (posIdx != -1) {
                    state[2].imageIdx = posIdx;
                }
                if (negIdx != -1) {
                    state[2].imageIdx = negIdx;
                }
            }
            assignPatientSamples(); // then the other images in the list
        } else if (imageCount == 4) {
            if (posIdx != -1 && negIdx != -1) {
                // assign pos and neg controls first
                if (posIdx != -1) {
                    state[2].imageIdx = posIdx;
                }
                if (negIdx != -1) {
                    state[3].imageIdx = negIdx;
                }
            } else {
                if (posIdx != -1) {
                    state[3].imageIdx = posIdx;
                }
                if (negIdx != -1) {
                    state[3].imageIdx = negIdx;
                }
            }
            assignPatientSamples(); // then the other images in the list
        }
    };

    //............................................ append() public
    // This function appends, assigns the passed image divs in the newly constructed layout panes.
    this.append = function (jsonList) {
        if (self.status == false) return false;

        if (jsonList.length != imageCount) {
            // ('Error: cViewLayout: append: incorrect input list length'); // eslint-disable-line no-undef
            return false;
        }

        mapImagesToPanes(jsonList);

        for (var p = 0; p < imageCount; p++) {
            var imageIdx = state[p].imageIdx;
            var imageInfo = jsonList[imageIdx];

            var jPane = $(_defines2.default.idHashROOT).find('#' + state[p].divId);
            jPane.append(imageInfo.jImgDiv);
            paneStateUpdate(p, jPane, imageInfo.imageId, imageInfo.sampleType, imageInfo.jImgDiv); //todo? pass imageInfo and let pane update choose what it wants??
        }

        return true;
    };
    //............................................ stateChange() public
    // This function xxxx pane in this layout.
    this.stateChange = function (imageId, typeName, typeValue) {
        var idxPane = paneIdxFind('imageId', imageId);
        if (idxPane == -1) {
            // ('Error: cViewLayout: stateChange: image not found: imageId: ' + imageId); // eslint-disable-line no-undef
            return false;
        }

        if (typeName == 'sampleType') state[idxPane].sampleType = typeValue;

        return idxPane;
    };
    //............................................ remove() public
    // This function removes an image from its pane in this layout.
    this.remove = function (imageId) {
        var idxPane = paneIdxFind('imageId', imageId);
        if (idxPane == -1) {
            // ('Error: cViewLayout: remove: image not found: imageId: ' + imageId); // eslint-disable-line no-undef
            return false;
        }

        var jImgDiv = state[idxPane].jImgDiv;
        jImgDiv.detach();

        state[idxPane].jImgDiv = undefined; // indicates that the image is no longer appended

        return idxPane;
    };
    //............................................ replace() public
    // This function replaces an image in its pane with another.
    this.replace = function (imageId, jsonItem) {
        if (self.status == false) return false;

        var idxPane = this.remove(imageId);
        if (idxPane == -1) return false;

        var jPane = state[idxPane].jPane;
        jPane.append(jsonItem.jImgDiv);
        paneStateUpdate(idxPane, jPane, jsonItem.imageId, jsonItem.sampleType, jsonItem.jImgDiv);

        return true;
    };

    //............................................ compress() public
    // This function moves the images in the passed layout into this layout.
    //    It is typically called on
    //    - when the panes are reconfigured due to the removal of an image
    //    - or when the panes are reconfigured due to the user initiated layout change (3 't' to 3 'v' for instance)

    this.compress = function (curLayout) {
        if (self.status == false) return false;

        curLayout.detatchFromDom(); // current layout is being replaced with new
        var jsonList = curLayoutToJsonList(curLayout);
        return this.append(jsonList);
    };
    //............................................ expand() public
    // This function moves the images in the passed layout into this layout and adds new images.
    this.expand = function (curLayout, jsonList) {
        if (self.status == false) return false;

        curLayout.detatchFromDom(); // current layout is being extended
        var jsonList2 = curLayoutToJsonList(curLayout); //
        jsonList = jsonList2.concat(jsonList); //
        return this.append(jsonList); //
    };

    //............................................ curLayoutToJsonList() local
    var curLayoutToJsonList = function curLayoutToJsonList(curLayout) {
        var jsonList = [];

        var priorImageCount = curLayout.getImageCount(); // # images moving to this layout
        for (var i = 0; i < priorImageCount; i++) {
            var aState = curLayout.getImageState(i);
            if (aState.jImgDiv != undefined) jsonList.push({ imageId: aState.imageId, sampleType: aState.sampleType, jImgDiv: aState.jImgDiv });
        }
        return jsonList;
    };

    //............................................ onResize() public
    // This function recomputes the maximum pane size such that adjacent views' minimum size is respected.
    //    It is called when the browser resizes.
    //
    //    params:
    //        crContainer: the size in a Rectangle of the layout container div

    this.onResize = function (crContainer) {
        if (self.status == false) return false;
        var containWidth = crContainer.w,
            containHeight = crContainer.h;

        myLayout_.resizeAll(); // insures that when DST collapses/expands the layout constainer's dims is updated

        if (imageCount == 1) {} else if (imageCount == 2) {
            if (paneDesc_ == 'v') {
                myLayout_.options.east.maxSize = containWidth - minSize;
            } else {
                myLayout_.options.east.maxSize = containHeight - minSize;
            }
        } else if (imageCount == 3) {
            if (paneDesc_ == 't') {
                myLayout_.options.east.maxSize = containWidth - minSize;
                myLayout_.options.south.maxSize = containHeight - minSize;
            } else if (paneDesc_ == 'v') {
                //todo: not quite right for center pane - can get too small
                myLayout_.options.east.maxSize = containWidth - 2 * minSize;
                myLayout_.options.west.maxSize = containWidth - 2 * minSize;
            } else {
                //todo: not quite right for center pane - can get too small
                myLayout_.options.north.maxSize = containHeight - 2 * minSize;
                myLayout_.options.south.maxSize = containHeight - 2 * minSize;
            }
        } else if (imageCount == 4) {
            //todo: not quite right after resize for move horiz up when increse window or decrease window
            myLayout_.options.center.maxSize = containWidth - minSize;
            myLayout_.options.east.maxSize = containWidth - minSize;
            myLayout_.options.south.maxSize = containHeight - minSize;
        }
    };

    //-------------------------------------------------------------------------------------------------
    //    HTML AND OPTIONS FUNCTIONS
    //-------------------------------------------------------------------------------------------------
    //............................................ buildOptions_() local
    // This function builds the option string that defines the pane features for the layout such as
    //    its minimum size, callbacks when the resizer is dragged, ...
    //
    //    params:
    //        cb_onResize:
    //        crContainer: Rectangle of containter
    //
    //    notes:
    //    - onresize_end fires when a pane is resized, not the browser window
    //    - size is the initial size proportion (e.g. 0.5 is 50%)
    //    - center panes minSize can't be set so the other panes' maxSize provides for the center pane's minSize
    //    - closable true/false enables/disables visibility and operation of pane togglers
    //
    var buildOptions_ = function buildOptions_(cb_onResize, crContainer) {
        var options = {};
        var containWidth = crContainer.w,
            containHeight = crContainer.h;
        var layoutName = self.getLayoutName();

        var closable = true;
        var spacing_closed = 10;

        if (imageCount == 1) {
            options = {
                name: layoutName, onresize_end: cb_onResize, onclose: cb_onResize, minSize: minSize, closable: false
                ////, enableCursorHotkey: false //////test
            };
        } else if (imageCount == 2) {
            if (paneDesc_ == 'v') {
                options = {
                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                    minSize: minSize,
                    closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes

                    , east: {
                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                        minSize: minSize, maxSize: containWidth - minSize, size: .5
                    }
                };
            } else {
                options = {
                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                    minSize: minSize,
                    closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes

                    , south: {
                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                        minSize: minSize, maxSize: containHeight - minSize, size: .5
                    }
                };
            }
        } else if (imageCount == 3) {
            if (paneDesc_ == 't') {

                options = {
                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                    minSize: minSize, east__size: .33, maxSize: containWidth - minSize,
                    closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes

                    , east__children: {
                        name: layoutName,
                        onresize_end: cb_onResize, //insures pulling north/south divider down resizes north
                        south: {
                            name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                            minSize: minSize, maxSize: containHeight - minSize, size: .5
                        }
                    }
                };
            } else if (paneDesc_ == 'v') {
                options = {
                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                    minSize: minSize, maxSize: containWidth - 2 * minSize,
                    closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes
                    , east: {
                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                        minSize: minSize, size: .33,
                        closable: closable, spacing_closed: spacing_closed
                    },
                    west: {
                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                        minSize: minSize, maxSize: containWidth - 2 * minSize, size: .33,
                        closable: closable, spacing_closed: spacing_closed
                    }
                };
            } else {
                options = {
                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                    minSize: minSize, maxSize: containHeight - 2 * minSize,
                    closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes

                    , north: {
                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                        minSize: minSize, size: .33
                    },
                    south: {
                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                        minSize: minSize, maxSize: containHeight - 2 * minSize, size: .33
                    }
                };
            }
        } else if (imageCount == 4) {
            options = {
                name: layoutName,
                onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                minSize: minSize, maxSize: containWidth - minSize, east__size: .5,
                closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes

                , center__children: {
                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                    minSize: minSize, maxSize: containHeight - minSize, south__size: .5
                },
                east__children: {
                    name: layoutName,
                    onresize_end: cb_onResize, //insures pulling north/south divider down resizes north
                    south: {
                        onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
                        minSize: minSize, maxSize: containHeight - minSize, size: .5
                    }
                }
            };
        }
        ////////////////////////////////////////// not working for all views!
        options.togglerTip_open = 'Hide View';
        options.togglerTip_closed = 'Show View';
        options.resizerTip = 'Drag to Resize Views';
        options.sliderTip = 'Drag to Show View';
        //////////////////////////////////////////

        return options;
    };

    //............................................ buildContainerHTML_() local
    // This function builds the html string that defines the layout panes as a function of imageCount.
    //    It initializes the state array with the pane id.

    var buildContainerHTML_ = function buildContainerHTML_() {
        var html = '';
        if (imageCount == 1) {
            state[0] = paneStateInit('us_centerpane', 'none');
            html = '<div class="ui-layout-center"     id="us_centerpane">patient sample1</div>';
        } else if (imageCount == 2) {
            if (paneDesc_ == 'v') {
                state[0] = paneStateInit('us_leftpane', 'none');
                state[1] = paneStateInit('us_rightpane', 'none');

                html = '<div class="ui-layout-center" id="us_leftpane">patient sample1</div>' + '<div class="ui-layout-east"   id="us_rightpane">patient sample2</div>';
            } else {
                //"h"
                state[0] = paneStateInit('us_toppane', 'none');
                state[1] = paneStateInit('us_bottompane', 'none');

                html = '<div class="ui-layout-center" id="us_toppane">patient sample1</div>' + '<div class="ui-layout-south"  id="us_bottompane">patient sample2</div>';
            }
        } else if (imageCount == 3) {
            if (paneDesc_ == 't') {
                state[0] = paneStateInit('us_leftpane', 'none');
                state[1] = paneStateInit('us_toprightpane', 'none');
                state[2] = paneStateInit('us_bottomrightpane', 'none');

                html = '<div class="ui-layout-center"  id="us_leftpane">patient sample</div>' + '<div class="ui-layout-east"><b><u>Outer East</u></b>' // right side pane (east of center)
                + '<div class="ui-layout-center"  id="us_toprightpane">posControl</div>' + '<div class="ui-layout-south"   id="us_bottomrightpane">negControl</div>';
            } else if (paneDesc_ == 'v') {
                state[0] = paneStateInit('us_leftpane', 'none');
                state[1] = paneStateInit('us_centerpane', 'none');
                state[2] = paneStateInit('us_rightpane', 'none');

                html = '<div class="ui-layout-west"    id="us_leftpane">patient sample1</div>' + '<div class="ui-layout-center"  id="us_centerpane">patient sample2</div>' + '<div class="ui-layout-east"    id="us_rightpane">patient sample3</div>';
            } else {
                //"h"
                state[0] = paneStateInit('us_toppane', 'none');
                state[1] = paneStateInit('us_centerpane', 'none');
                state[2] = paneStateInit('us_bottompane', 'none');

                html = '<div class="ui-layout-north"  id="us_toppane">patient sample1</div>' + '<div class="ui-layout-center" id="us_centerpane">patient sample2</div>' + '<div class="ui-layout-south"  id="us_bottompane">patient sample3</div>';
            }
        } else if (imageCount == 4) {
            state[0] = paneStateInit('us_topleftpane', 'none');
            state[1] = paneStateInit('us_bottomleftpane', 'none');
            state[2] = paneStateInit('us_toprightpane', 'none');
            state[3] = paneStateInit('us_bottomrightpane', 'none');

            html = '<div class="ui-layout-center">patient sample' + '<div class="ui-layout-center"  id="us_topleftpane">top left</div>' + '<div class="ui-layout-south"   id="us_bottomleftpane">bottom left</div>' + '</div>' + '<div class="ui-layout-east"><b><u>Outer East</u></b>' // right side pane (east of center)
            + '<div class="ui-layout-center"  id="us_toprightpane">northeast</div>' + '<div class="ui-layout-south"   id="us_bottomrightpane">southeast</div>' + '</div>';
        }
        return html;
    };
    //-------------------------------------------------------------------------------------------------
    //    STATE ARRAY HELPERS
    //-------------------------------------------------------------------------------------------------
    //............................................ buipaneStateInitldHTML() local
    // This function returns an initialized pane object for the state array.
    var paneStateInit = function paneStateInit(divId, pref) {
        return {
            divId: divId, samplePref: pref,
            imageIdx: undefined, jPane: undefined,
            sampleType: undefined, imageId: undefined, jImgDiv: undefined
        };
    };
    //............................................ paneStateUpdate() local
    // This function updates a specific pane object in the state array.
    var paneStateUpdate = function paneStateUpdate(idx, jPane, imageId, sampleType, jImgDiv) {
        state[idx].jPane = jPane; // save a ref to the pane's div

        state[idx].imageId = imageId; // save the image's id
        state[idx].sampleType = sampleType; // save the image's sample type
        state[idx].jImgDiv = jImgDiv; // save a ref to the appended image's div
    };
    //............................................ paneIdxFind() local
    // This function finds the index in the state array with the key value specified
    //    or -1 if the key value pair doesn't exist in the state array.
    var paneIdxFind = function paneIdxFind(key, value) {
        for (var s = 0; s < imageCount; s++) {
            if (state[s][key] == value) return s;
        }
        return -1;
    };

    //............................................ construction
    construct_();
}
//________________________________________________________________________________________________

module.exports = exports['default'];

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ViewportAP;

var _lbsPiDash = __webpack_require__(5);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _browserCompatibility = __webpack_require__(26);

var _objects = __webpack_require__(16);

var _viewportBase = __webpack_require__(492);

var _viewportBase2 = _interopRequireDefault(_viewportBase);

var _navigation = __webpack_require__(314);

var _events = __webpack_require__(31);

var _helpers = __webpack_require__(4);

var _DragMomentum = __webpack_require__(478);

var _ViewportRotator = __webpack_require__(482);

var _ViewportBackgroundLayer = __webpack_require__(481);

var _ViewportTileLayer = __webpack_require__(484);

var _Renderer = __webpack_require__(480);

var _PaintTimer = __webpack_require__(479);

var _ViewportState = __webpack_require__(483);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// viewportAP.js
//    This file contains the ViewportAP (aperio renderer) object that manages the image view.
//    ViewportAP is derived from ViewportBase.
//
//    history
//    _______________________________________end AIHv1 _____________________________________________
//    1410    cperz        created from cViewport, in conjunction with ViewportBase
//    141029    cperz        viewRefresh: fix one contributor to missing tile mystery by removinging tiles by class
//    141118    cperz        removed prefetch and cache - have been disabled for past release;
//                        break out from cViewport to use ViewportBase;
//    141222    cperz        add analysis support: specifically markup functionality; add viewRefreshForce();
//    150318    cperz        build out for analysis: display markups,
//                        convert to capitalized user vars = this for js parser clarity;
//                        added isPtInView();
//    _______________________________________12.3 __________________________________________________
//    150612    cperz        openImage: call viewRotate if initialize view angle
//                        viewRotate protect against uninitialized annot object
//    150717    cboarman    Enable rotation during conference
//________________________________________________________________________________________________
//    Object Name: cViewport
//    Overview: A cViewport obect is associated with a viewport div.  It performs the opening/closing,
//            view presentation, navigation,and event handling for a single image and its associated markup images.
//            It owns (creates and destroys) all overlay visuals,    an annotation object associated with
//            its image, as well as several helper objects.
//
//    Associated Panel: none
//
//    Dependencies and Supporting objects:
//        o ViewportBase
//        o cRequestQueue
//        o cOverLayout
//        o cStateVector
//        o all the overlay visual objects
//
//    Assumptions: o todo
//
//    Limitations:
//        o
//
//    Terms Used:
//        o Overlay Visuals: the set of imagery, controls, and viewer-defined graphics that are displayed
//                    on top of the tiled image; e.g. the thumbnail, magnifier, scale bar and zoom control.
//
//    Functionality:
//        o View tiling:
//        o
//
//    Data Structures: todo
//
//    HTML:
//        The viewport div associated with this object is created by the uScope object.
//
//    References: -
//
//    Coordinate systems used:
//        o image base: the scanned image's pyramid base coordinate system;
//                    left,top is 0,0; positive x to the right; positive y down;
//        o viewport relative: the view coordinate system; a window into the scanned image;
//                    left,top is 0,0; positive x to the right; positive y down;

//________________________________________________________________________________________________
//    ViewportAP - This function manages an image viewport.
//
//    Input parameters:
//        initState:
//            imageID:    req'd, image id number starting with the @ sign or filename starting with imageserver/
//            centerX:    optional, initial center of view X position
//            centerY:    optional, initial center of view X position
//            focus:        optional, initial focus (z position)
//            zoom:        optional, initial zoom where 0.5 = 200%, 1 = 100%, 2 = 50%, 4 = 25%, "Fit" and "Scan" are ok
//
function ViewportAP(initState, uScope) {
    var self = this;

    // Extend base class
    _viewportBase2.default.call(self, initState, uScope);

    // ..... to group fns in js parser, for ease of search (e.g. search for all 'VPAP_VIEW')
    var VPAP_GET = this; //
    var VPAP_IMAGE = this;
    var VPAP_MOUSE = this;
    var VPAP_MOVE = this;
    var VPAP_PYRAMID = this;
    var VPAP_ROTATION = this;
    var VPAP_VIEW = this;
    var VPAP_ZOOM = this;

    VPAP_VIEW.coordSystem = _defines2.default.coordSystemNORM; // this viewport's coordinate system

    // annotations object ..................................
    VPAP_GET.getAnnotObj = function () {
        return self.annots;
    }; // accessor to annotation object for this viewport

    var baseImageOpen = self.imageOpen; // at this point nothing in base is overridden
    var baseImageClose = self.imageClose; // so get refs to base fns to be called on

    //______________________________________________________
    // NAVIGATION RELATED
    //______________________________________________________
    // pinch and drag momentum related .....................
    self.initDist = 0; // pinch zoom initial distance between fingers
    self.initMag = 0; // pinch zoom initial magnfication
    var viewDragMomentum = void 0; // drag momentum object

    self.dragConstrainCnt = 0; // used to throttle calls during drag navigation
    self.partialRefreshCnt = 1; // used to monitor tile accumulation in viewport div

    //______________________________________________________
    // VIEWPORT DIV RELATED
    //______________________________________________________
    var jVpDiv = void 0;
    var viewOverFlowTiles_ = 0; //was us.kOVERTILES            // number of tiles to overflow viewport boundaries //todo: remove - no longer used

    // State object.
    var vpView = void 0;
    var paintTimer = void 0;

    VPAP_VIEW.getVPView = function () {
        return vpView;
    };
    VPAP_VIEW.getVPViewRect2 = function () {
        return new _objects.BoundingBox(vpView.left, vpView.top, vpView.left + vpView.width - 1, vpView.top + vpView.height - 1);
    };
    VPAP_VIEW.isPtInView = function (cpBase) {
        return !!(cpBase.x > vpView.left && cpBase.x < vpView.left + vpView.width && cpBase.y > vpView.top && cpBase.y < vpView.top + vpView.height - 1);
    };
    VPAP_VIEW.setReadOnlyMode = function (isReadOnly) {
        isReadOnly = Boolean(isReadOnly);

        if (vpView.isReadOnly !== isReadOnly) {
            vpView.isReadOnly = isReadOnly;
            self.events.trigger('state-readonly:change', isReadOnly);
        }
    };
    VPAP_VIEW.viewPosInfoUpdate = function (left, top) {
        vpView.left = left; // set viewport left,top corner position
        vpView.top = top;
        self.moveConstrain(); // limit left,top so viewport always includes the image content

        vpView.tileL = Math.floor(vpView.left / tileWidthXZoom);
        vpView.tileT = Math.floor(vpView.top / tileHeightXZoom);

        // the number of tiles contributing to a view varies as the view LT corner changes
        vpView.csTilesVisible.set(Math.ceil((vpView.left - vpView.tileL * tileWidthXZoom + vpView.width) / tileWidthXZoom), Math.ceil((vpView.top - vpView.tileT * tileHeightXZoom + vpView.height) / tileHeightXZoom));

        vpView.csTiles.set(vpView.csTilesVisible.w, vpView.csTilesVisible.h);

        if (viewOverFlowTiles_ > 0) {
            // the total number of tiles in the viewport accounts for over tiling about the border
            vpView.tileL -= viewOverFlowTiles_;
            vpView.tileT -= viewOverFlowTiles_;
            vpView.csTiles.add(2 * viewOverFlowTiles_, 2 * viewOverFlowTiles_);
        }

        vpView.tileR = vpView.tileL + vpView.csTiles.w - 1;
        vpView.tileB = vpView.tileT + vpView.csTiles.h - 1;

        self.events.trigger('viewport:position-update');
    };

    //............................................ viewDimsUpdate
    // note: update position must be set to compute the new view dims in tiles
    VPAP_VIEW.viewDimsUpdate = function (bUpdatePosition) {
        var zoom = vpView.zoom;
        var vpDivDims = self.vpDivDimsGet();
        vpView.width = Math.floor(vpDivDims.w * zoom);
        vpView.height = Math.floor(vpDivDims.h * zoom);

        if (self.isFitZoom()) {
            // on resize, fit zoom changes but viewPosInfoUpdate() called below needs tileWidthXZoom up to date
            var fitZoom = self.fitZoomCompute();
            tileWidthXZoom = self.getTileWidth() * zoom; // update for quick access  //todo: I'm not certain this is that useful anymore
            tileHeightXZoom = self.getTileHeight() * zoom;
        }
        if (bUpdatePosition == true) {
            self.viewPosInfoUpdate(vpView.left, vpView.top);
        }
    };

    VPAP_VIEW.viewPosInfoPyramid = function (zoom) {
        var zoomOfView = self.getViewZoom();
        var xCenter = void 0,
            yCenter = void 0,
            width = void 0,
            height = void 0,
            top = void 0,
            left = void 0;
        if (zoom != self.getViewZoom()) {
            if (self.isFitZoom(zoom)) {
                var imgDims = self.getImageDims(); // in fit zoom, the center of the view is the center of the image
                xCenter = Math.floor(imgDims.w / 2);
                yCenter = Math.floor(imgDims.h / 2);
            } else {
                xCenter = self.getViewCenterX(); // from zoom absolute
                yCenter = self.getViewCenterY();
            }
            var vpDivDims = self.vpDivDimsGet();
            width = Math.floor(vpDivDims.w * zoomOfView); // from viewDimsUpdate
            height = Math.floor(vpDivDims.h * zoomOfView);

            left = Math.floor(xCenter - width / 2.); // from zoom absolute
            top = Math.floor(yCenter - height / 2.);
        } else {
            left = vpView.left;
            top = vpView.top;
            width = vpView.width;
            height = vpView.height;
        }

        var tileWXZoom = self.getTileWidth() * zoom;
        var tileHXZoom = self.getTileHeight() * zoom;

        var tileL = Math.floor(left / tileWXZoom); // from viewPosInfoUpdate
        var tileT = Math.floor(top / tileHXZoom);

        var csTilesVisible = new _objects.Size(Math.ceil((left - tileL * tileWXZoom + width) / tileWXZoom), Math.ceil((top - tileT * tileHXZoom + height) / tileHXZoom));

        var csTiles = new _objects.Size(csTilesVisible.w, csTilesVisible.h);
        var tileR = tileL + csTilesVisible.w - 1;
        var tileB = tileT + csTilesVisible.h - 1;

        if (viewOverFlowTiles_ > 0) {
            //todo possibly: could increase viewOverFlowTiles_ as tileScale
            tileL -= viewOverFlowTiles_;
            tileT -= viewOverFlowTiles_;
            csTiles.add(2 * viewOverFlowTiles_, 2 * viewOverFlowTiles_);
            tileR = tileL + csTiles.w - 1;
            tileB = tileT + csTiles.h - 1;
        }

        return { left: left, top: top, zoom: zoom, tileL: tileL, tileT: tileT, tileR: tileR, tileB: tileB, csTiles: csTiles, csTilesVisible: csTilesVisible };
    };

    //______________________________________________________
    // NAVIGATION RELATED
    //______________________________________________________
    var tileWidthXZoom = void 0;
    var tileHeightXZoom = void 0;

    var ptMouseDown = new _objects.Point(0, 0); // viewport relative cursor position of last mouse down event
    VPAP_MOUSE.setMouseDown = function (x, y) {
        ptMouseDown.set(x, y);
    };
    VPAP_MOUSE.getMouseDown = function () {
        return ptMouseDown;
    };

    var ptPrevMouseCur = new _objects.Point(0, 0); // viewport relative previous cursor position
    var ptMouseCur = new _objects.Point(0, 0); // viewport relative current cursor position
    VPAP_MOUSE.setMouseCur = function (x, y, option) {
        if (option == 'initPrev') ptPrevMouseCur.set(x, y); // if initializing previous too, then previous position = new position
        else ptPrevMouseCur.setPoint(ptMouseCur); // else the previous position = current position
        ptMouseCur.set(x, y); // current position = new position
    };
    VPAP_MOUSE.getMouseCur = function () {
        return ptMouseCur;
    };

    VPAP_MOUSE.setMouseCurRtnDiff = function (x, y) {
        ptPrevMouseCur.setPoint(ptMouseCur); // previous position = current position
        ptMouseCur.set(x, y); // current position = new position
        return new _objects.Point(ptPrevMouseCur.x - ptMouseCur.x, ptPrevMouseCur.y - ptMouseCur.y);
    };
    VPAP_MOUSE.getMouseCurDiff = function () {
        // difference between previous and current mouse positions
        var ptRtn = new _objects.Point(ptPrevMouseCur.x - ptMouseCur.x, ptPrevMouseCur.y - ptMouseCur.y);
        return ptRtn;
    };

    // ..................................................... position, dimension related
    VPAP_VIEW.getViewLeft = function () {
        return vpView.left;
    };
    VPAP_VIEW.getViewTop = function () {
        return vpView.top;
    };
    VPAP_VIEW.getViewLeftTop = function () {
        return new _objects.Point(vpView.left, vpView.top);
    };

    ///perf impr: do not recompute except for on resize event
    /**
     * Returns view center in base coords
     * @returns {Point}
     */
    VPAP_VIEW.getViewCenter = function () {
        return new _objects.Point(self.getViewCenterX(), self.getViewCenterY());
    };
    VPAP_VIEW.getViewCenterX = function () {
        return Math.round(vpView.left + vpView.width / 2);
    };
    VPAP_VIEW.getViewCenterY = function () {
        return Math.round(vpView.top + vpView.height / 2);
    };

    VPAP_VIEW.getViewWidth = function () {
        return vpView.width;
    };
    VPAP_VIEW.getViewHeight = function () {
        return vpView.height;
    };

    //note: getVisibleTileCount is only actually true when ENABLEPYRAMIDREFRESH = false (not using the pyramid)
    VPAP_VIEW.getVisibleTileCount = function () {
        return vpView.csTilesVisible.getArea();
    };
    VPAP_VIEW.getViewFocus = function () {
        return vpView.focus;
    };

    //______________________________________________________
    // ROTATION RELATED
    //______________________________________________________
    // ..................................................... rotation related
    VPAP_ROTATION.getViewAngle = function (inDegrees) {
        return inDegrees == true ? vpView.angleDeg : vpView.angleRad;
    };
    VPAP_ROTATION.saveRotationAngle = function (angleDeg) {
        vpView.angleDeg = angleDeg;
        vpView.angleRad = angleDeg * _defines2.default.Deg2Rad;
    };
    VPAP_ROTATION.getRotationOffset = function () {
        return vpView.cpRotOffset;
    };
    VPAP_ROTATION.setRotationOffset = function () {
        var vpDivDims = self.vpDivDimsGet();
        vpView.cpRotOffset = (0, _helpers.computeRotationOffset)(vpDivDims.w, vpDivDims.h, vpView.angleRad);
        return vpView.cpRotOffset;
    };

    //______________________________________________________
    // ZOOM RELATED
    //______________________________________________________
    // ..................................................... fit zoom related
    var fixedZooms_ = void 0; ////todo: ??? copy of base var????
    var fitZoomChanged = true;
    VPAP_ZOOM.getFitZoom = function () {
        return fixedZooms_[0].zoom;
    };
    VPAP_ZOOM.setFitZoom = function (opt_zoom) {
        if (!opt_zoom) opt_zoom = self.fitZoomCompute();else (0, _helpers.roundToDecimals)(opt_zoom);

        if (vpView.prevZoom === fixedZooms_[0].zoom) vpView.prevZoom = opt_zoom;else if (vpView.zoom === fixedZooms_[0].zoom) vpView.zoom = opt_zoom;
        fixedZooms_[0].zoom = opt_zoom;
    };
    VPAP_ZOOM.isFitZoom = function (opt_zoom) {
        if (opt_zoom) return opt_zoom === fixedZooms_[0].zoom ? true : false;else return vpView.isFitZoom;
    };
    VPAP_ZOOM.fitZoomChangedGet = function () {
        return fitZoomChanged;
    };
    VPAP_ZOOM.fitZoomChangedSet = function () {
        fitZoomChanged = true;
    };
    VPAP_ZOOM.fitZoomChangedReset = function () {
        fitZoomChanged = false;
    };

    VPAP_ZOOM.fitZoomCompute = function () {
        //override base
        var csImgDims = self.getImageDims();
        var imageWHRatio = csImgDims.w / csImgDims.h; // compute the image w/h ratio

        var viewDimsPx = self.vpDivDimsGet();
        var viewWHRatio = viewDimsPx.w / viewDimsPx.h;

        if (viewDimsPx.w < 1 || viewDimsPx.h < 1) {
            // ('Error: fitZoomCompute: view dimensions are zero!  Defaulting Fit Zoom but this may cause other issues'); // eslint-disable-line no-undef
            return 2;
        }

        // select dimension to scale by
        var zoom = imageWHRatio > viewWHRatio ? parseInt(csImgDims.w / viewDimsPx.w) : parseInt(csImgDims.h / viewDimsPx.h);
        zoom = (0, _helpers.limitValue)(zoom, 1, _defines2.default.zoomSpecs.fitZoomMax); // constrain fit zoom factor between 1 and max of fitZoomMax
        zoom = (0, _helpers.roundToDecimals)(zoom); // keep zoom in proper resolution

        return zoom;
    };
    // ..................................................... view zoom related
    //todo: reconcile prev zoom with base class?
    VPAP_ZOOM.getViewPrevZoom = function () {
        return vpView.prevZoom;
    }; // get previous zoom
    VPAP_ZOOM.getViewZoom = function () {
        return vpView.zoom;
    };
    VPAP_ZOOM.setViewZoom = function (zoom) {
        if (self.isFitZoom() && zoom === 'Fit') {
            // if already at fit zoom and only updating fit zoom value
            vpView.zoom = self.fitZoomCompute();
        } else {
            vpView.prevZoom = vpView.zoom; // set vpView's prevZoom, zoom, and isFitZoom
            if (zoom === 'Fit') zoom = self.fitZoomCompute(); // if string passed, convert to value
            vpView.zoom = zoom;
            vpView.isFitZoom = self.isFitZoom(zoom);
        }
        tileWidthXZoom = self.getTileWidth() * zoom; // update for quick access  //toconsider: I'm not certain this is that useful anymore
        tileHeightXZoom = self.getTileHeight() * zoom;
    };
    VPAP_ZOOM.getViewMag = function () {
        return self.convertToMag(vpView.zoom);
    };

    //______________________________________________________
    // PYRAMID RELATED
    //______________________________________________________
    var pyrSequence_ = {}; // assoc array of pyramid zooms to use in tile requests for a given zoom
    var pyramid_ = []; // note that the thumbnail is not on the pyramid
    VPAP_PYRAMID.getPyramid = function () {
        return pyramid_;
    };
    VPAP_PYRAMID.pyramidZoomsToUse = function (zoomOfRequest) {
        if (!pyrSequence_[zoomOfRequest]) {
            // if pyramid at this zoom isn't already available, compute it
            pyrSequence_[zoomOfRequest] = self.pyramidSequenceGet(zoomOfRequest);
        }
        return pyrSequence_[zoomOfRequest];
    };

    //............................................ viewDragMomemtumGo()
    VPAP_VIEW.viewDragMomemtumGo = function () {
        if (viewDragMomentum != undefined) viewDragMomentum.go();
    };

    //............................................ viewRotate() public
    // viewRotate - This function rotates the view and the thumbnail about their centers.
    VPAP_VIEW.viewRotate = function (newAngleDeg) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { animate: false },
            animate = _ref.animate;

        newAngleDeg = newAngleDeg % 360; // bound input angle
        var curAngleDeg = self.getViewAngle(true); // get current angle
        if (curAngleDeg == newAngleDeg) // and get out if there is nothing to do
            return;

        if (animate && !isAnimating.transform) {
            isAnimating.transform = true;
            jVpDiv.addClass('animate');
            jVpDiv.on('transitionend', disableAnimation);
        }

        self.saveRotationAngle(newAngleDeg); // save the new rotation angle
        self.stateVector.viewUpdate(vpView, 'rotate'); // add rotation angle to view state vector

        // note - the reported offset is always +/- 1 pixel from my result in computeRotationOffset

        // note- this offset is applied to the inner vpDiv automatically when rotated to keep centered
        self.setRotationOffset(); // compute and save the rotation offset
    };

    //............................................ bindEvents_() local
    // bindEvents_ - This function adds viewport event handlers.
    //
    //    Note that all event handlers bound to this image use the same namespace as this viewport.
    //    So when this viewport removes its events by namespace, they are also removed.
    var bindEvents_ = function bindEvents_() {
        var namespace = self.eventNameSpaceGet();
        jVpDiv = self.vpDivGet();
        var mouseHandler = _navigation.VP_MOUSEHANDLER.bind(null, self);

        jVpDiv.on('mousedown' + namespace + ' mouseup' + namespace + ' mouseleave' + namespace + ' dblclick' + namespace, mouseHandler);

        jVpDiv.on('mousemove' + namespace, mouseHandler);

        if (!_browserCompatibility.env.isIOS) {
            // no mousewheel on iOS!
            jVpDiv.on('mousewheel' + namespace, function (e, delta, deltaX, deltaY) {
                // don't try to zoom > scan
                if (self.getViewZoom() === 1 && deltaY < 0) {
                    return false;
                }

                (0, _navigation.VP_MOUSEWHEEL)(self, e, delta, deltaX, deltaY); // perform mouse wheel zoom

                e.preventDefault();
                return false;
            });
        }

        // TODO: Make bg image load before tiles
        self.renderer.addLayer(new _ViewportRotator.ViewportRotator(self));
        self.renderer.addLayer(new _ViewportBackgroundLayer.ViewportBackgroundLayer(self));
        self.renderer.addLayer(new _ViewportTileLayer.ViewportTileLayer(self));
        paintTimer.start(self.renderer.paint);

        // This event doesn't really make sense to trigger; maintaining for consistency with legacy lifecycle. TODO: Rework
        self.events.trigger('viewport:bind-events', namespace);
    };

    VPAP_IMAGE.imageClose = function () {
        baseImageClose();

        paintTimer.stop();
        self.events.trigger('viewport:image-close', self);
        self.events.$destroy();
    };

    VPAP_IMAGE.imageOpen = function (inImageId) {
        var status = baseImageOpen(inImageId);
        if (status) {
            self.pyramidInit(); // build array containing the refresh pyramid
            fixedZooms_ = self.getFixedZoomArray(); // copy of base var

            self.stateVector.viewUpdate(vpView, 'all'); // inform state vector of initial image state

            vpView.prevZoom = fixedZooms_[0].zoom; // initialize with vpView zoom of 1 and prevZoom of fit, and let initState overrule those settings

            if (self.initState.zoom != undefined) {
                // the initialState zoom has priority over the initialState magnification
                self.initState.zoom = self.zoomConstrain(self.initState.zoom); // conferencing can initialize with an unrealizable fit zoom
                self.initState.mag = self.convertToMag(self.initState.zoom);
            } else if (self.initState.mag != undefined) {
                // if an initState magnification is defined, redefine zoom and view dimensions
                self.initState.zoom = 1.0; // initialize the current view zoom
                if (self.initState.mag === 'Fit') self.initState.zoom = self.getFitZoom();else if (self.initState.mag !== 'Scan') self.initState.zoom = self.convertToZoom(self.initState.mag);
            }
            self.setViewZoom(self.initState.zoom);
            if (self.isFitZoom(self.initState.zoom) == true) {
                // initialize the previous view zoom
                // opening at fit then the desired previous zoom is 4x mag when current zoom is Fit
                // if that prev zoom can be achieved use it,  otherwise set the prev zoom to the scan zoom
                var prevZoom = self.convertToZoom(4);
                vpView.prevZoom = prevZoom < vpView.zoom ? prevZoom : fixedZooms_[fixedZooms_.length - 1].zoom;
            } else {
                // not opening at fit, then set the previous zoom to fit
                vpView.prevZoom = fixedZooms_[0].zoom; // constrain zoom factor to fixed zoom min and max
                vpView.zoom = self.zoomConstrain(self.initState.zoom); // don't use setViewZoom here - it will change prevZoom
            }
            self.viewDimsUpdate(false); // update width, height of vpView (base image coord system)


            // initialize left, top corner of vpView (base image coord system)
            vpView.left = self.initState.centerX ? // if the initial state value is valid
            Math.floor(self.initState.centerX - vpView.width / 2.) // use it
            : Math.floor((self.xinfo.get_imageWidth() - vpView.width) / 2.); // else center the image in X

            vpView.top = self.initState.centerY ? // if the initial state value is valid
            Math.floor(self.initState.centerY - vpView.height / 2.) // use it
            : Math.floor((self.xinfo.get_imageHeight() - vpView.height) / 2.); // else center the image in Y

            self.viewPosInfoUpdate(vpView.left, vpView.top); // initialize the view and frame positions

            self.viewOverlayInit_(); // base class fn: load the overlay visuals

            viewDragMomentum = new _DragMomentum.DragMomentum(self); // create the drag momentum object

            if (self.initState.angle) // .............................. now paint the first view
                self.viewRotate(self.initState.angle); // if initial rotation is set, view rotation refresh

            bindEvents_(); // add event handlers

            self.setInitialized(); // indicate that initialization is successful
            // Pass "true" to inform uScope that this image is in focus. Note that uScope already knows this image is
            // selected; the reason this is really done is because uScope triggers a "viewport selected" event which
            // everything and its mother listens to. This is poor control flow; uScope probably shouldn't consider
            // the image selected till it's open, and it should be the thing choosing whether the viewport is selected
            // or not. TODO: rework...
            self.setImageSelected(true);

            self.events.trigger('viewport:image-opened', self);
        }

        (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGEREADY, { // fire event: the image is loaded
            imageId: self.getImageId(), uScopeIdx: self.getImageIdx(), status: self.getStatus()
        });

        return status;
    };

    //______________________________________________________
    // VIEW NAVIGATION RELATED
    //______________________________________________________

    //............................................ moveRelative
    // moveRelative - This function moves the selected image the specified amount in x and y.
    //
    //    Note: This function is core to panning and so speed is very important. The vpView items are directly
    //         addressed rather than use the access functions (e.g. getViewZoom, getViewLeft, getViewTop).
    //        This is permitted as the function is a part of the cViewport object.
    VPAP_MOVE.moveRelative = function (dx, dy, options) {
        var zoom = vpView.zoom;
        var left = parseInt(vpView.left + dx * zoom);
        var top = parseInt(vpView.top + dy * zoom);

        return self.moveAbsolute(left, top, options);
    };

    //............................................ moveAbsolute
    // moveAbsolute - This function moves the selected image to the specified position
    //                    and informs the state vector object of the position change.
    //
    //  RULE: Always adjust the viewport position first, then the image position wrt viewport.
    //
    //    parameters:
    //        left, top:        required, integer, the view's left,top position in base image coordinates
    //    return:                the maximum number of tileRequests - note that all, some or none may be requested (none?)
    //
    VPAP_MOVE.moveAbsolute = function (left, top) {
        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { animate: false },
            animate = _ref2.animate;

        if (animate) {
            enableAnimation(left, top);
        } else {
            disableAnimation();
        }

        self.viewPosInfoUpdate(left, top);
        self.stateVector.viewUpdate(vpView, 'move');
    };

    var isAnimating = {
        left: false,
        top: false,
        transform: false
    };
    var enableAnimation = function enableAnimation(left, top) {
        if (!isAnimating.left && left !== vpView.left) {
            isAnimating.left = true;
            jVpDiv.addClass('animate');
            jVpDiv.on('transitionend', disableAnimation);
        }
        if (!isAnimating.top && top !== vpView.top) {
            isAnimating.top = true;
            jVpDiv.addClass('animate');
            jVpDiv.on('transitionend', disableAnimation);
        }
    };
    var disableAnimation = function disableAnimation(e) {
        if (e) {
            isAnimating[e.originalEvent.propertyName] = false;
        } else {
            isAnimating.left = isAnimating.top = isAnimating.transform = false;
        }
        if (!isAnimating.left && !isAnimating.top && !isAnimating.transform) {
            jVpDiv.removeClass('animate');
            jVpDiv.off('transitionend');
        }
    };

    //............................................ moveAbsoluteCenter
    // moveAbsoluteCenter - This function moves the image to the specified center coords.
    //
    VPAP_MOVE.moveAbsoluteCenter = function (centerX, centerY, animate) {
        self.moveAbsolute(parseInt(centerX - self.getViewWidth() / 2), parseInt(centerY - self.getViewHeight() / 2), animate);
    };

    //............................................ vpConstrainView
    // vpConstrainView - This function constrains the image position to remain inside the viewport.
    //
    //    Note that for speed's sake items accessed more than once are assiged to vars.
    VPAP_MOVE.moveConstrain = function () {
        var bHalfViewOK = true; // allowing view to stay centered while zooming
        if (bHalfViewOK == true) {
            var vpWidth2 = vpView.width / 2;
            var vpHeight2 = vpView.height / 2;

            if (vpView.left < -vpWidth2) {
                // moved past left edge?
                vpView.left = -vpWidth2;
            } else {
                var imgWidth = self.getImageWidth();
                if (vpView.left + vpWidth2 > imgWidth) {
                    // moved past right edge?
                    vpView.left = Math.floor(imgWidth - vpWidth2);
                }
            }

            if (vpView.top < -vpHeight2) {
                // moved past left top?
                vpView.top = -vpHeight2;
            } else {
                var imgHeight = self.getImageHeight();
                if (vpView.top + vpHeight2 > imgHeight) {
                    // moved past bottom?
                    vpView.top = Math.floor(imgHeight - vpHeight2);
                }
            }
        } else {
            var vpWidth = vpView.width; //perf impr
            var vpHeight = vpView.height;
            if (vpView.left < 0) {
                // moved past left edge?
                vpView.left = 0;
            } else {
                var _imgWidth = self.getImageWidth(); // moved past right edge?
                if (vpView.left + vpWidth > _imgWidth) {
                    vpView.left = Math.floor(_imgWidth - vpWidth);
                }
            }

            if (vpView.top < 0) {
                // moved past left top?
                vpView.top = 0;
            } else {
                var _imgHeight = self.getImageHeight(); // moved past bottom?
                if (vpView.top + vpHeight > _imgHeight) {
                    vpView.top = Math.floor(_imgHeight - vpHeight);
                }
            }
        }
    };

    //______________________________________________________
    // ZOOM RELATED
    //______________________________________________________

    //............................................ zoomRelative
    // zoomRelative, zoomAbsolute
    //    These functions implement image scaling on the specified image by the speicified zoom factor.
    //    The image center remains intact after scaling.  Scaling is constrained to min/max values
    //    and a input value of "Fit" causes a computation of the zoom factor that will fill the view
    //    with the image.  Finally the method informs the state vector object of the zoom change.
    //
    VPAP_ZOOM.zoomRelative = function (zoomFactor) {
        if (!zoomFactor) {
            return;
        }
        var zoom = self.getViewZoom() * zoomFactor;
        return self.zoomAbsolute(zoom);
    };

    //............................................ zoomAbsolute
    //  zoomAbsolute - This function refreshes the view at the commanded zoom and current view center.
    //
    //    Note that even if the new zoom is the same as the original zoom the update should still happen.
    //    This is because this occurs in the iOS case and the zoom state needs to be cleaned up via viewRefresh.
    //
    //    Passed Parameters:
    //        zoom:            required, number, the zoom value
    //                        - Note that smaller zoom result in higher resolution: .5 = 200%, 2 = 50%, 4 = 25%.
    //                        - Note that incoming zoom can be "Fit" or value of zoom at Fit
    //                            or regular value of zoom (zoom is saved as a value)
    VPAP_ZOOM.zoomAbsolute = function (zoom) {
        if (zoom === vpView.zoom) {
            return;
        }
        if (zoom !== 'Fit') {
            zoom = (0, _helpers.roundToDecimals)(zoom);
        }

        var xCenter = self.getViewCenterX(); // get viewport current center in base image pixel coords
        var yCenter = self.getViewCenterY();

        if (zoom === 'Fit' || self.isFitZoom(zoom)) {
            zoom = self.fitZoomCompute(); // fit zoom changes on resize events, so always redo it
            self.setFitZoom(zoom);
            self.setViewZoom('Fit');
            var imgDims = self.getImageDims(); // in fit zoom, always center the image
            xCenter = Math.floor(imgDims.w / 2);
            yCenter = Math.floor(imgDims.h / 2);
        } else {
            zoom = self.zoomConstrain(zoom); // constrain zoom factor to fixed zoom min and max; resolve Fit zoom
            self.setViewZoom(zoom); //cp-maybe constraint should be enforced in setViewZoom?
        }
        self.viewDimsUpdate(false); // update vpView width and height and account for zoom

        // keep the to-be zoomed image center at the current zoom center
        vpView.left = Math.floor(xCenter - self.getViewWidth() / 2);
        vpView.top = Math.floor(yCenter - self.getViewHeight() / 2);

        self.moveConstrain(_defines2.default.WITHFORCE); // limit left,top so viewport always includes the image content
        self.viewPosInfoUpdate(vpView.left, vpView.top); //

        // update all the things that need to be updated when the zoom changes!
        self.stateVector.viewUpdate(vpView, 'zoom');
    };

    //............................................ step() public
    //    This function steps the zoom up/down within the range and quantization of the slider.
    VPAP_ZOOM.zoomStep = function (step) {
        var mag = self.getViewMag();
        step = 1 + step;
        mag = constrainMag(mag * step);
        var zoom = self.convertToZoom(mag);

        self.zoomAbsolute(zoom);
    };

    //............................................ constrainMag
    // constrainMag - This function constrains the image magnfication to the fit to allowable mag range.
    var constrainMag = function constrainMag(mag) {
        if (mag > self.getMaximumMag()) mag = self.getMaximumMag();else if (mag < self.getFitMag()) mag = self.getFitMag();
        return mag;
    };

    //............................................ zoomConstrain
    // zoomConstrain - This function constrains the image zoom to reasonable values and returns the zoom value.
    //
    //        Notes: Remember zoom: .5 = 200%, 2 = 50%, 4 = 25% and that for this call, "Fit" is a legal zoom.
    VPAP_ZOOM.zoomConstrain = function (zoom) {
        var rv = zoom;
        if (!self.isFitZoom(zoom)) {
            // only fit is allowed outside the zoom control fixed mag range
            var fixedZooms = self.getFixedZoomArray(); // constrain zoom factor to fixed zoom min and max
            rv = (0, _helpers.limitValue)(zoom, fixedZooms[fixedZooms.length - 1].zoom, fixedZooms[0].zoom);
        }
        return rv;
    };

    //............................................ zoomDblClick
    // zoomDblClick - This function moves the image center to the position of the event and
    //                    zooms the image to the previous zoom state.
    //
    VPAP_ZOOM.zoomDblClick = function (e) {
        var crsrPosBase = _defines2.default.coordBaseImage(e, this); // get the position of the cursor in base image coords

        self.moveAbsoluteCenter(crsrPosBase.x, crsrPosBase.y); // move image center to the cursor position
        self.zoomAbsolute(self.getViewPrevZoom()); // and execute the zoom
    };

    //______________________________________________________
    // PYRAMID RELATED
    //______________________________________________________

    //............................................ pyramidInit() public
    //    pyramidInit - This function creates and returns the pyramid used to select the request zooms.
    //
    //        Note that this pyramid structure is not identical to that of the image file.
    //        Specifically
    //            1) its dimensions in tiles is the tile size used by this viewport
    //            2) depending upon the state of us.ADDINTERMEDIATELEVEL
    //                it may have inserted addition levels that the viewport wants to also request at.
    //                These levels are indicated by the const 'fileLevel' set to false
    //
    // a typical pyramid for a 20x scan looks like this
    //    pyramid[0]: zoom: 1,    mag: 20,    csTiles: (111x92),    fileLevel: true
    //    pyramid[1]: zoom: 2,    mag: 10,    csTiles: (56x46),    fileLevel: false  <--- inserted level
    //    pyramid[2]: zoom: 4,    mag: 5,        csTiles: (28x23),    fileLevel: true
    //    pyramid[3]: zoom: 16,    mag: 1.25,    csTiles: (7x6),        fileLevel: true
    // toconsider : insert levels when base is 83x???
    VPAP_PYRAMID.pyramidInit = function () {
        var xinfo = self.xinfo;
        var pyrLevels = self.xinfo.get_imageLevels();
        var p = 0;
        for (var l = 0; l < pyrLevels; l++, p++) {
            // for each level in the pyramid
            var levelZoom = xinfo.get_imageZoom(l);
            var csTilesComputed = self.getImageDimsInTiles(levelZoom); // rtns a ref - don't change it
            var mag = self.convertToMag(levelZoom);

            pyramid_[p] = {
                zoom: levelZoom,
                mag: mag,
                csTiles: new _objects.Size(csTilesComputed.w, csTilesComputed.h),
                fileLevel: true
            };

            if (_defines2.default.ADDINTERMEDIATELEVEL && l < pyrLevels - 1) {
                // insert a pyramid level at an intermediate level?
                var nextLevelZoom = xinfo.get_imageZoom(l + 1);
                var nextMag = self.convertToMag(nextLevelZoom);
                var ratio = mag / nextMag;
                if (ratio > 3 && nextLevelZoom < 5) {
                    // add intermediate levels only for high power mags
                    mag = pyramid_[l].mag / 2;
                    p++;
                    levelZoom = self.convertToZoom(mag);
                    csTilesComputed = self.getImageDimsInTiles(levelZoom); // rtns a ref- don't change it

                    pyramid_[p] = {
                        zoom: +levelZoom, // insure zoom is in int format
                        mag: mag,
                        csTiles: new _objects.Size(csTilesComputed.w, csTilesComputed.h),
                        fileLevel: false
                    };
                }
            }
        }
    };

    //............................................ pyramidAbout() public
    //    This function returns a string indicating the pyramid settings.
    VPAP_PYRAMID.pyramidAbout = function () {
        var str = '';
        if (_defines2.default.ENABLEPYRAMIDREFRESH == true) {
            str += 'Refresh Uses Image Pyramid';
            str += _defines2.default.USEMULTIPYRAMIDLEVELS == false ? ' (single level)' : ' (multiple levels)';
        } else str += 'Refresh relies on ImageServer to Zoom';
        return str;
    };

    //............................................ pyramidSequenceGet() public
    //    This function returns the pyramid level zoom sequence to perform tile requests at.
    //    ------ Do not call this fn directly, instead call pyramidZoomsToUse().  ------
    //    This fn is a support fn to pyramidZoomsToUse() which builds a cache of
    //    this fn's results per zoom for efficiency.
    //
    // For a given image pyramid
    //        pyramid[0]: zoom: 1, mag: 20
    //        pyramid[1]: zoom: 2, mag: 10
    //        pyramid[2]: zoom: 4, mag: 5
    //        pyramid[3]: zoom: 16, mag: 1.25
    //
    // the following zoom sequence would be performed
    //        zoomOfRequest: 1    1st zoom: 2 (mag: 10)    2nd zoom: 1 (mag: 20)
    //        zoomOfRequest: 1.5    1st zoom: 2 (mag: 10)    2nd zoom: 1 (mag: 20)
    //        zoomOfRequest: 2    1st zoom: 4 (mag: 5)    2nd zoom: 2 (mag: 10)
    //        zoomOfRequest: 3    1st zoom: 4 (mag: 5)    2nd zoom: 2 (mag: 10)
    //        zoomOfRequest: 4    1st zoom: 4 (mag: 5)
    //        zoomOfRequest: 5    1st zoom: 4 (mag: 5)
    //        zoomOfRequest: 6    1st zoom: 4 (mag: 5)
    //        zoomOfRequest: 7    1st zoom: 4 (mag: 5)
    //        zoomOfRequest: 8    1st zoom: 4 (mag: 5)
    //        zoomOfRequest: 10    1st zoom: 4 (mag: 5)
    //        zoomOfRequest: 12    1st zoom: 16 (mag: 1.25)
    //        zoomOfRequest: 14    1st zoom: 16 (mag: 1.25)
    //        zoomOfRequest: 16    1st zoom: 16 (mag: 1.25)
    //        zoomOfRequest: 17    1st zoom: 16 (mag: 1.25)
    //todo: how to handle NON-pyramid images????
    //toconsider: could improve speed by making a lut dyamically... I do that for image dim in tiles at zoom
    VPAP_PYRAMID.pyramidSequenceGet = function (zoomOfRequest) {
        var rtnZoomSequence = []; //
        var idx = -1;
        var idx2 = -1;
        var nPyrLevels = pyramid_.length;

        if (zoomOfRequest == self.getFitZoom()) {
            // if zoomOfRequest is fit zoom
            rtnZoomSequence.push(self.getFitZoom()); // then just get at fit zoom
        } else if (zoomOfRequest < 1) {
            // if zoomOfRequest value > highest resolution level (zoom of 0.5 is 200%)
            idx = 0; // then use highest resolution level
            rtnZoomSequence.push(pyramid_[0].zoom);
        } else if (zoomOfRequest >= pyramid_[nPyrLevels - 1].zoom) {
            // if zoomOfRequest value > lowest resolution level
            idx = nPyrLevels - 1; // then use lowset resolution level
            rtnZoomSequence.push(pyramid_[idx].zoom);
        } else {
            // otherwise use the resolution levels bounding the zoomOfRequest
            for (var l = 1; l < nPyrLevels; l++) {
                if (zoomOfRequest >= 4) {
                    // at 20x bas mag then mag < 5 ... one level to request
                    if (l == nPyrLevels - 1) {
                        // if at last choice of the top of the pyramid, use it
                        idx = l;
                        rtnZoomSequence.push(pyramid_[idx].zoom);
                        break;
                    } else {
                        //
                        if (zoomOfRequest >= pyramid_[l].zoom && zoomOfRequest < pyramid_[l + 1].zoom) {

                            var midZoom = pyramid_[l].zoom + (pyramid_[l + 1].zoom - pyramid_[l].zoom) / 2;
                            idx = zoomOfRequest <= midZoom ? idx = l : idx = l + 1;

                            rtnZoomSequence.push(pyramid_[idx].zoom);
                            break;
                        }
                    }
                } else {
                    // two levels to request when zoom < 4 (mag > 5 when 20x base mag)
                    if (pyramid_[l].zoom > zoomOfRequest) {
                        idx = l;
                        rtnZoomSequence.push(pyramid_[idx].zoom);
                        idx2 = l - 1;
                        rtnZoomSequence.push(pyramid_[idx2].zoom);
                        break;
                    }
                }
            }
        }

        return rtnZoomSequence;
    };

    (function init() {
        vpView = new _ViewportState.ViewportState(function (key, value) {
            self.events.trigger('viewport:state-changed', key, value);
        });
        paintTimer = new _PaintTimer.PaintTimer(vpView);
        self.renderer = new _Renderer.Renderer(self);
    })();
}
module.exports = exports['default'];

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ViewportBase;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _UrlBuilder = __webpack_require__(312);

var _objects = __webpack_require__(16);

var _statevector = __webpack_require__(489);

var _statevector2 = _interopRequireDefault(_statevector);

var _xinfo = __webpack_require__(307);

var _xinfo2 = _interopRequireDefault(_xinfo);

var _overLayout = __webpack_require__(488);

var _overLayout2 = _interopRequireDefault(_overLayout);

var _events = __webpack_require__(31);

var _legacyAjaxWrapper = __webpack_require__(475);

var _legacyAjaxWrapper2 = _interopRequireDefault(_legacyAjaxWrapper);

var _helpers = __webpack_require__(4);

var _lbsPiDash = __webpack_require__(5);

var _keyCodes = __webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// viewportBase.js
//    This file contains the ViewportBase object that uScope image renderer's will derive from.
//
//    key functionality of viewportBase includes:
//        o issuing of the XINFO request for the specified image, receives & parses response in imageOpen()
//        o creates a set of overlay tools, toolbars
//        o creates the following objects for use by derived classes: xinfo, urlBuilder, stateVector, rasterScan
//
//        o public logging facility: log(msg)
//
//    All derived objects must overridden the functions specified by 'OVERRIDE_ME_viewportBase'
//
//    history
//    _______________________________________end_AIHv1/PR __________________________________________
//    141118    cperz        created from cViewport
//    141120    cperz        add support for negative pen
//    141222    cperz        change call from ajaxXXXCall to doDATASVRREQ and doIMGSRVREQ with callbacks;
//                        add analysis support;
//    150318    cperz        update for doIMGSRVREQ signature change;
//                        convert to capitalized user vars = this for js parser clarity;
//                        urlBuilder: add setQuality() for markups; add coordBaseToView()
//    150902    rellis        don't set focus to outer viewport when in conferencing. It messes up the DST for conference participants
//
//________________________________________________________________________________________________

function ViewportBase(initState, uScope) {
    var self = this;

    // ..... to group fns in js parser, for ease of search (e.g. search for all 'VPBASE_VIEW')
    var OVERRIDE_ME_viewportBase = self; // EVERYTHING identified with OVERRIDE_ME_viewportBase must be overridden by derived object

    var VPBASE_GET = self;
    var VPBASE_IMAGE = self;
    var VPBASE_NAV = self;
    var VPBASE_MOUSE = self;
    var VPBASE_OVERLAY = self;
    var VPBASE_PINNED = self;
    var VPBASE_RASTERSCAN = self;
    var VPBASE_SAMPLE = self;
    var VPBASE_STATEVECTOR = self;
    var VPBASE_STATUS = self;
    var VPBASE_URLBUILDER = self;
    var VPBASE_VIEW = self;
    var VPBASE_INFO = self;
    var VPBASE_ZOOM = self;

    self.events = uScope.events.$new();

    // status related ......................................
    var status = true; // false if a show stopping error was detected
    VPBASE_STATUS.getStatus = function () {
        return status;
    };
    VPBASE_STATUS.setStatus = function (bstate) {
        status = bstate === true;
        return status;
    };
    VPBASE_STATUS.isConnectedViaApache = function () {
        return self.initState.indexOf('imageserver') != -1;
    };

    var vpInitialized_ = false; // init() completed successfully
    VPBASE_STATUS.setInitialized = function () {
        vpInitialized_ = true;
    };
    VPBASE_STATUS.isInitialized = function () {
        return vpInitialized_;
    };

    // initialization state info ...........................
    self.initState = (0, _lbsPiDash.clone)(initState); // passed in initial state, save for closure     //todo: consider if initState must be pulic

    var imageId = initState.imageId; // quick acccess to "@idnumber"
    var uScopeIdx = initState.uScopeIdx; // quick acccess
    var namespace_ = '.' + imageId;
    VPBASE_IMAGE.getImageId = function () {
        return imageId;
    }; // includes '@' sign
    VPBASE_IMAGE.getImageIdx = function () {
        return uScopeIdx;
    };
    VPBASE_GET.eventNameSpaceGet = function () {
        return namespace_;
    };

    // initialization ajax requestor ..........................
    self.ajax = new _legacyAjaxWrapper2.default(uScope, self, imageId);

    self.open = function () {
        if (_defines2.default.kTILEMULTIPLIER < 1) _defines2.default.kTILEMULTIPLIER = 1; // insure min tile multiplier
        if (jVpDivOuter.length < 1 || jVpDiv.length < 1) {
            // insure divs exist
            // ('cViewport: viewport div does not exist for imageId: ' + imageId); // eslint-disable-line no-undef
            self.setStatus(false);
            return;
        }
        // create objects
        self.xinfo = new _xinfo2.default(imageId); // this viewport's xinfo object
        self.stateVector = new _statevector2.default(self);

        // initialize the url builder
        var urlRoot = self.initState.fullURL ? self.initState.fullURL : self.initState.server + imageId;
        self.urlBuilder = new _UrlBuilder.UrlBuilder(urlRoot, imageId);

        // send the xinfo request
        self.ajax.doIMGSRVREQ(cbSuccessFn, cbFailureFn, 'XINFO', { 'request': 'XINFO', 'imageId': imageId }, 'xml');

        //..................................................
        // closure functions
        //............................................ cbSuccessFn()
        function cbSuccessFn(data, textStatus, jqXHR) {
            self.xinfo.init(data, imageId); // initialize the xinfo class
            self.imageOpen(imageId); // and initialze the viewport
        }

        //............................................ cbFailureFn()
        function cbFailureFn(jqXHR, textStatus, errorThrown) {
            // ('XINFO: ' + self.ajax.getErrorStr(jqXHR, textStatus, errorThrown, imageId)); // eslint-disable-line no-undef
            self.setStatus(false);
            self.xinfo.setStatus(false); // indicate that xinfo failed

            var imageSet = { 'images': [{ 'imagePath': imageId }] };
            uScope.imageUpdate('remove', imageSet.images); // remove the vp object and related divs

            (0, _events.triggerUScopeEvent)(_defines2.default.evAJAXERROR, { imageId: imageId, request: 'XINFO', jqXHR: jqXHR });
            (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGEREADY, { imageId: imageId, status: false });
        }

        //..................................................
    };
    //............................................ bindEvents_() local
    // bindEvents_ - This function adds the viewport base event handlers.
    var bindEvents_ = function bindEvents_() {
        var namespace = self.eventNameSpaceGet();
        jVpDiv.on('mousedown' + namespace, function (e) {
            self.setImageSelected();
            // necessary for IE panning to halt properly when pan cursor moves off viewport
            e.preventDefault();
            return true;
        });
        jVpDiv.on('mousedown' + namespace, function (e) {
            var navMode = self.navModeGet();
            // mouse down when autopanning means stop
            if (navMode == _defines2.default.eNavModes.nmAutoPan || navMode == _defines2.default.eNavModes.nmRasterScan) {
                self.navModeHalt();
            }
        });

        $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
            // image select event
            // set the selected/unselected (green/gray) border color of the outer viewport
            jVpDivOuter.css({ 'border-color': parms.uScopeIdx == uScopeIdx ? '#008000' : '#A6B7C7' });

            // the main toolbar moves onto the selected image below the image toolbar
            if (parms.uScopeIdx == uScopeIdx) {
                // if this is the selected image
                self.focus(); // force focus here for hot keys
                uScope.topToolbar.position(self.toolbar.getOffsetRect()); // position the main toolbar
            }
        });

        $(_defines2.default.idHashROOT).on(_defines2.default.evNAVMODEHALT + namespace, function (e, parms) {
            //
            // if this image is specified or ALL images are specified (parms.uScopeIdx == -1) then halt
            if (parms.imageId == '@0' || parms.uScopeIdx == -1 || parms.imageId == imageId || parms.uScopeIdx == uScopeIdx) {
                self.navModeHalt();
            }
        });

        // In IE, jQuery will fire keydown(), not keypress() for the arrow keys, because they are considered 'special' keys.
        // Note that focus must be on the viewport.  Sometimes Tab must be hit if you think these keys aren't working.
        jVpDivOuter.on('keydown' + namespace_ + ' keyup' + namespace_, handleKeyboardEvent);
    };

    // overlay objects and assoc data ............................................................
    //    - most of these objects are created in viewOverlayInit_
    VPBASE_OVERLAY.toolbar = undefined; // the viewport's primary toolbar
    /////////////////////////////////////////////////////////////////////////////
    //______________________________________________________
    // operational objects and assoc data
    //    - these objects are created in construct_
    //______________________________________________________

    // xinfo object ........................................
    VPBASE_INFO.xinfo = undefined; // this viewport's xinfo
    VPBASE_INFO.getXinfoObj = function () {
        return self.xinfo;
    };

    // rasterScan object ...................................
    self.rasterScan = undefined; // the rasterScan navigation object
    VPBASE_RASTERSCAN.getRasterScan = function () {
        return self.rasterScan;
    };

    // vpView state vector manager object ..................
    // RULE: add vpView to state vector manager whenever anything in vpView is changed
    VPBASE_STATEVECTOR.stateVector = undefined; // the state vector object
    VPBASE_STATEVECTOR.getStateVector = function () {
        return self.stateVector;
    };

    // url build object ....................................
    VPBASE_URLBUILDER.urlBuilder = undefined; // the url build object
    VPBASE_URLBUILDER.getUrlBuilder = function () {
        return self.urlBuilder;
    };

    //______________________________________________________
    // MOUSE RELATED
    //______________________________________________________
    // handy cursor set function ..............................
    VPBASE_MOUSE.setCursor = function (type) {
        jVpDiv.css('cursor', type);
    };

    //______________________________________________________
    // NAVIGATION RELATED
    //______________________________________________________

    OVERRIDE_ME_viewportBase.moveAbsolute = function (left, top) {};
    OVERRIDE_ME_viewportBase.moveAbsoluteCenter = function (centerX, centerY) {};
    OVERRIDE_ME_viewportBase.zoomAbsolute = function (zoom) {};
    OVERRIDE_ME_viewportBase.zoomStep = function (amount) {};
    OVERRIDE_ME_viewportBase.viewRotate = function (newAngleDeg) {};

    //______________________________________________________
    // VIEWPORT DIV RELATED
    //______________________________________________________

    // viewport div accessors ..............................
    VPBASE_VIEW.clsIMAGEID = _defines2.default.classFromImageId(imageId); // save class name, e.g. "IMG_42"
    VPBASE_VIEW.clsDotIMAGEID = '.' + self.clsIMAGEID; // save . class name, e.g. ".IMG_42"

    var jVpDivOuter = $(_defines2.default.clsDotOUTERVIEWPORT + '.' + self.clsIMAGEID); // outer div
    var jVpDiv = $(_defines2.default.clsDotVIEWPORT + '.' + self.clsIMAGEID); // inner div

    self.$container = jVpDivOuter;

    VPBASE_VIEW.vpDivGet = function (outer) {
        // handy access to this image's viewport div - use it!
        return outer == 'outer' ? jVpDivOuter : jVpDiv;
    };
    VPBASE_VIEW.focus = function () {
        if (uScope.isModeConference() == false) {
            jVpDivOuter.focus();
        }
    }; // outer vp has tabindex, used specifically to enable hot keys

    var vpDivDims = new _objects.Size(0, 0); // outer div dimensions, maintained by viewResize()
    VPBASE_VIEW.vpDivDimsGet = function () {
        return vpDivDims;
    };

    //______________________________________________________
    // VIEW RELATED
    //______________________________________________________
    VPBASE_VIEW.setImageSelected = function () {
        var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (uScope.getSelImageIdx() !== uScopeIdx || force) {
            self.events.trigger('viewport:selected', uScopeIdx, force);
            self.focus();
        }
    };

    // ..................................................... position, dimension related
    OVERRIDE_ME_viewportBase.getViewLeft = function () {
        return 0;
    };
    OVERRIDE_ME_viewportBase.getViewTop = function () {
        return 0;
    };
    OVERRIDE_ME_viewportBase.getViewLeftTop = function () {
        return undefined;
    };

    self.getMinZoom = function () {
        var fixedZooms = self.getFixedZoomArray();
        var minZoom = fixedZooms[fixedZooms.length - 1].zoom;
        self.getMinZoom = function () {
            return minZoom;
        };
        return minZoom;
    };
    self.getMaxZoom = function () {
        var maxZoom = self.getFixedZoomArray()[0].zoom;
        self.getMaxZoom = function () {
            return maxZoom;
        };
        return maxZoom;
    };

    ///perf impr: do not recompute except for on resize event
    OVERRIDE_ME_viewportBase.getViewCenter = function () {
        return 0;
    }; // in base coords
    OVERRIDE_ME_viewportBase.getViewCenterX = function () {
        return 0;
    }; // in base coords
    OVERRIDE_ME_viewportBase.getViewCenterY = function () {
        return 0;
    }; // in base coords

    OVERRIDE_ME_viewportBase.getViewWidth = function () {
        return 0;
    };
    OVERRIDE_ME_viewportBase.getViewHeight = function () {
        return 0;
    };

    OVERRIDE_ME_viewportBase.getViewFocus = function () {
        return 0;
    };
    OVERRIDE_ME_viewportBase.getViewAngle = function (inDegrees) {
        return 0;
    };
    //............................................ viewOverlayInit_()
    //    viewOverlayInit_ - This function performs one-time initialization for the overlay visuals.
    //                        Note that the tile meter overlay is initialized in imageOpen prior to tile requests.
    VPBASE_VIEW.viewOverlayInit_ = function () {
        if (self.isInitialized() == false) {
            self.overLayout = new _overLayout2.default(self); // arranges overlay visuals (thumbnail, zoom control, etc.)

            self.events.trigger('viewport:initialize-layout');

            // TODO: Does this belong here?
            self.getImageData(); // with all the priority calls issued, now request image data
        }
    };
    //.......................................................... viewResize() public
    // viewResize - This function performs all necessary operations to perform/respond to the viewport resize
    //
    //    parameters:
    //        autoThumbResize:    a boolean defining whether the thumbnail must be resized // TODO: Find out why this is necessary
    VPBASE_VIEW.viewResize = function (resizeThumbnail) {
        var jOuterVpParent = jVpDivOuter.parent(); // do not cache: layout change causes parent changes
        var borderWidthX2 = 2 * parseInt(jVpDivOuter.css('border-left-width'));
        var rectDiv = new _objects.Rectangle(0, 0, jOuterVpParent.width() - borderWidthX2, jOuterVpParent.height() - borderWidthX2);

        if (vpDivDims.w == rectDiv.w && vpDivDims.h == rectDiv.h) {
            // don't resize if not necessary
            return;
        }

        // note that the positions and dimensions of both the outer and inner vp divs must be set
        jVpDivOuter.css({
            'left': rectDiv.x + 'px',
            'top': rectDiv.y + 'px',
            'width': rectDiv.w + 'px',
            'height': rectDiv.h + 'px'
        });

        // inner vp position is relative so its left,top is always 0,0
        jVpDiv.css({ 'left': '0px', 'top': '0px', 'width': rectDiv.w + 'px', 'height': rectDiv.h + 'px' });
        vpDivDims.set(parseInt(jVpDivOuter.width()), parseInt(jVpDivOuter.height()));

        if (vpDivDims.w < 1 || vpDivDims.h < 1) {
            // collapsing a view forces a dimension change
            return; // so don't update the hidden view
        }

        if (self.isInitialized()) {

            if (self.isFitZoom()) {
                self.zoomAbsolute('Fit'); // peforms image refresh at Fit zoom after updating Fit zoom
            }

            if (uScope.getSelImageIdx() == uScopeIdx) {
                // if this is the selected image
                uScope.topToolbar.position(self.toolbar.getOffsetRect()); // position the main toolbar
            }

            self.events.trigger('viewport:resize', resizeThumbnail);
            (0, _events.triggerUScopeEvent)(_defines2.default.evVIEWRESIZE, {}); // TODO: replace with local event channel above
        }
    };

    //______________________________________________________
    // IMAGE STATE RELATED
    //______________________________________________________

    //    - use these accessors or add new ones here, if they require data from xinfo then initialize them in init()
    var fileName; // name of image file; see getImageData
    VPBASE_IMAGE.getFullURL = function () {
        return self.initState.fullURL;
    };
    VPBASE_IMAGE.getServer = function () {
        return self.initState.server;
    };
    VPBASE_IMAGE.getToken = function () {
        return self.initState.token;
    };

    VPBASE_IMAGE.getTitle = function () {
        // VIL defined title with replacement keywords (filename, imageid); can be undefined
        var initTitle = self.initState.title;
        if (initTitle == 'filename') return self.getFileName();else if (initTitle == 'imageid') return self.getImageId();else return initTitle;
    };

    // tissue sample type, e.g. "patient", "positive"(control), "negative" (control); can be undefined
    VPBASE_SAMPLE.sampleTypeSet = function (type) {
        self.initState.sampleType = type;
        // note: a race condition can occur if the image is still initializing when its state is changed
        //        so the exisitence of the toolbar and overlay layout objects are verified
        if (self.toolbar) self.toolbar.sampleTypeSet(type);
        if (self.overLayout) self.overLayout.refresh();
    };

    VPBASE_SAMPLE.sampleTypeGet = function () {
        return self.initState.sampleType;
    };
    VPBASE_SAMPLE.sampleTypeIsControl = function () {
        return self.sampleTypeGet() != 'patient';
    };
    VPBASE_SAMPLE.sampleTypeIsPatient = function () {
        return self.sampleTypeGet() == 'patient';
    };

    VPBASE_PINNED.isPinned = function () {
        return self.initState.isPinned;
    };
    VPBASE_PINNED.isPinnedSet = function (bval) {
        self.initState.isPinned = bval;
        self.toolbar.isPinnedSet(bval);
    };
    //______________________________________________________
    // IMAGE RELATED
    //______________________________________________________
    //............................................ imageOpen()
    // derived should call this first, upon return call:
    //             self.viewOverlayInit_(); //todo:remove the _ (OR MOVE THIS TO HERE!!!!) all overlays controlled by derived class?????                                // load the overlay visuals
    //vpInitialized_ = true;                                     // indicate that initialization is successful
    //self.setImageSelected(true);                                 // inform uScope that this image is in focus
    // and fire evIMAGEREADY
    //todo: would it be better to call a second base function?

    VPBASE_IMAGE.imageOpen = function (inImageId) {
        if (inImageId !== self.getImageId()) {
            // ('viewportBase: imageOpen: passed imageId ' + inImageId + ' is not associated with this viewport whose imageId is ' + self.getImageId()); // eslint-disable-line no-undef
            return self.setStatus(false);
        }
        self.events.trigger('viewport:before-image-open', self);

        self.viewResize(true); // place and size this viewport's div (size into parent div)

        scanner = self.xinfo.scanner;
        baseMag = self.xinfo.get_baseMag();
        baseMPP = self.xinfo.get_MPP(); // define vars for quick access (cc - using get_MPP() doesn't actually get the base value; it gets one that's
        // normalized for zoom. This seems risky; why not just use xinfo.MPP?)
        captureType = +self.xinfo.capturetype;
        hasALabel = self.xinfo.label.isValid;
        hasAThumbnail = self.xinfo.thumb.isValid;
        csThumbDims = new _objects.Size(self.xinfo.thumb.width, self.xinfo.thumb.height);
        thumbZoom = self.xinfo.thumb.zoom;

        if (self.xinfo.tileWidth > 600 || self.xinfo.tileHeight > 600) _defines2.default.kTILEMULTIPLIER = 1; // (cc - Changing a constant... why?
        // Won't this have potential downstream impacts? (say after a new image is opened))
        tileWidth = self.xinfo.tileWidth * _defines2.default.kTILEMULTIPLIER;
        tileHeight = self.xinfo.tileHeight * _defines2.default.kTILEMULTIPLIER;

        imageWidth = self.xinfo.get_imageWidth();
        imageHeight = self.xinfo.get_imageHeight();

        backgroundColor = captureType == _defines2.default.eAICCaptureType.aic_i_FL ? '#000' : '#fff';
        jVpDiv.css('background-color', backgroundColor); // set viewport background color in accordance with capture type

        fixedZooms_ = zoomInitFixed_(self); // build array containing the zoom control options (zoom, mag, level)

        bindEvents_(); // add event handlers
        return self.setStatus(true); // set status successful image open, return status
    };
    //............................................ imageClose()
    VPBASE_IMAGE.imageClose = function () {

        bindEventsOff_(); // remove event handlers for viewport

        uScope.setImageNextSelected(uScopeIdx); // inform uScope to select the next image (deselect me)

        self.events.$destroy();

        //................................closure fns
        //    bindEventsOff_ - This function removes event handlers for viewport by namespace:  "." + imageId
        function bindEventsOff_() {
            var namespace = self.eventNameSpaceGet();
            $(_defines2.default.idHashROOT).off(namespace);
        }
    };

    //................................................................. getImageData
    //  This function issues an ajax call to get the image data.
    // TODO: The sole purpose of this function is to retrieve the file name, which is used in the settings dialog (elsewhere?)
    // TODO: Extract to separate service; make available to wherever it's used
    VPBASE_IMAGE.getImageData = function () {
        var attempts_ = 0;
        var imageId = self.getImageId();
        if (uScope.isThisImageIdValid(imageId) == true) {
            ///// note this check should not be nec.... doing it to see if strange alert that pops up is caused by it ever
            attempts_++;
            var xml = '<ImageId>' + (0, _helpers.stripLeadingAtSign)(imageId) + '</ImageId>';
            var parms = { 'imageId': imageId };
            self.ajax.doDATASVRREQ(cbSuccessFn, cbFailureFn, 'GetImageData', xml, parms);
        } else {
            // ('viewportBase: getImageData: not a valid imageId: ' + imageId); // eslint-disable-line no-undef
        }

        //................................closure fns
        //............................................ cbFailureFn()
        // Because it is necessary for analysis to have the compressedFilename of the image, retry on failure
        function cbFailureFn(jqXHR, textStatus, errorThrown) {
            if (attempts_ < 3) {
                // ('getImageData: attempt #' + attempts_ + ' ' + self.ajax.getErrorStr(jqXHR, textStatus, errorThrown, self.getImageId())); // eslint-disable-line no-undef
                attempts_++;
                var xml = '<ImageId>' + (0, _helpers.stripLeadingAtSign)(imageId) + '</ImageId>';
                var parms = { 'imageId': imageId };
                self.ajax.doDATASVRREQ(cbSuccessFn, cbFailureFn, 'GetImageData', xml, parms);
            } else {
                // ('getImageData: surrendering after ' + attempts_ + ' attempts, ' + self.ajax.getErrorStr(jqXHR, self.getImageId())); // eslint-disable-line no-undef
            }
        }
        //............................................ cbSuccessFn()
        //  This function parses the response for the compressed file location.
        function cbSuccessFn(data, textStatus, jqXHR) {
            var idx = -1;
            var responseXML = jqXHR.responseText;
            if ((idx = responseXML.lastIndexOf('>')) !== -1) responseXML = responseXML.slice(0, idx + 1); // remove the garbage char on the end of the response

            var x2js = new X2JS();
            var jsonObj_ = x2js.xml_str2json(responseXML); // convert input xml to json object
            var code = +jsonObj_.GetImageDataResponse.GetImageDataResult.ASResult;
            if (code != 0) {
                var message = jsonObj_.GetImageDataResponse.GetImageDataResult.ASMessage;
                // ('viewportBase: getImageDataRtn:   msg:' + message + '  code: ' + code); // eslint-disable-line no-undef
                return;
            }
            var jsImage = jsonObj_.GetImageDataResponse.ImageData.Image;
            var msgImageId = '@' + jsImage.ImageId;
            if (msgImageId == self.getImageId()) {
                // insure the ajax return is for this image
                fileName = jsImage.CompressedFileLocation; // e.g. \\aperio-00824\images\21287_Her2.svs
            }
        }
    };

    VPBASE_IMAGE.getFileName = function () {
        return (0, _helpers.isDefined)(fileName) ? fileName : self.xinfo.filename;
    };
    VPBASE_IMAGE.getFileTypeDesc = function () {
        return self.xinfo.comptypedesc;
    };
    VPBASE_IMAGE.getCompQuality = function () {
        return self.xinfo.compquality;
    };
    VPBASE_IMAGE.getImageICCProfile = function () {
        return self.xinfo.iccProfile;
    };
    VPBASE_IMAGE.getScanScopeId = function () {
        return self.xinfo.scanScopeId;
    };
    VPBASE_IMAGE.getImageDate = function () {
        return self.xinfo.date;
    };
    VPBASE_IMAGE.getImageDescription = function () {
        return self.xinfo.description;
    };

    var scanner, baseMag, baseMPP, captureType, hasALabel, hasAThumbnail, csThumbDims, thumbZoom, imageWidth, imageHeight, tileWidth, tileHeight;
    VPBASE_IMAGE.getScanner = function () {
        return scanner;
    };
    VPBASE_IMAGE.getMaximumMag = function () {
        return baseMag;
    };
    VPBASE_IMAGE.getBaseMag = function () {
        return baseMag * self.getNormalizationFactor();
    };
    VPBASE_IMAGE.getNormalizationFactor = function () {
        if (!magNeedsNormalization()) {
            return 1;
        }
        var sf = getScaleFactor();
        return MAG_CONSTS.BASELINE_SCALE_FACTOR / sf;
    };
    VPBASE_IMAGE.getBaseMPP = function () {
        return baseMPP;
    };
    VPBASE_IMAGE.getCaptureType = function () {
        return captureType;
    };
    VPBASE_IMAGE.hasALabel = function () {
        return hasALabel;
    };
    VPBASE_IMAGE.hasAThumbnail = function () {
        return hasAThumbnail;
    };
    VPBASE_IMAGE.getThumbFileDims = function () {
        return csThumbDims;
    }; // not live thumbnail dims but the defn from xinfo
    VPBASE_IMAGE.getThumbZoom = function () {
        return thumbZoom;
    }; // not live thumbnail zoom but the defn from xinfo
    VPBASE_IMAGE.getTileWidth = function () {
        return tileWidth;
    }; // requested tile width
    VPBASE_IMAGE.getTileHeight = function () {
        return tileHeight;
    }; // requested tile

    var backgroundColor = '#000000';
    VPBASE_GET.getBackgroundColor = function () {
        return backgroundColor;
    };

    // image dimensions related ............................
    VPBASE_IMAGE.getImageWidth = function () {
        return imageWidth;
    };
    VPBASE_IMAGE.getImageHeight = function () {
        return imageHeight;
    };
    VPBASE_IMAGE.getImageDims = function () {
        return new _objects.Size(imageWidth, imageHeight);
    };

    //todo: it would be good to also allow zoom or mag in and return image dims @ that zoom or mag
    var imageDimInTiles_ = {}; // assoc array of zoom, image dimensions in tiles at that zoom
    VPBASE_IMAGE.getImageDimsInTiles = function (zoom) {
        // This function returns a reference to a Size of the image dimensions in tiles at the given zoom.
        if (zoom == undefined) zoom = 1;

        if (imageDimInTiles_[zoom] == undefined) {
            // if dims at this zoom isn't already available, compute it
            var csImageDims = self.getImageDims(); // returns a reference
            var csDims = new _objects.Size(csImageDims.w, csImageDims.h);
            csDims.toTileNums(tileWidth, tileHeight, zoom);

            imageDimInTiles_[zoom] = new _objects.Size(csDims.w, csDims.h);
        }
        return imageDimInTiles_[zoom];
    };
    var imageDimAtZoom_ = {}; // assoc array of zoom, image dimensions at that zoom
    VPBASE_IMAGE.getImageDimsAtZoom = function (zoom) {
        // This function returns a reference to a Size of the image dimensions at the given zoom.
        if (zoom == undefined) zoom = 1;

        if (imageDimAtZoom_[zoom] == undefined) {
            // if dims at this zoom isn't already available, compute it
            var csImageDims = self.getImageDims(); // returns a reference
            var csDims = new _objects.Size(csImageDims.w, csImageDims.h);
            csDims.div(zoom, zoom);
            csDims.toInt();
            imageDimAtZoom_[zoom] = new _objects.Size(csDims.w, csDims.h);
        }
        return imageDimAtZoom_[zoom];
    };
    // ..................................................... MPP related
    VPBASE_IMAGE.getMPP = function (opt_zoom) {
        // return micron/pixel for a given zoom
        return (0, _helpers.isUnDefined)(opt_zoom) ? self.getBaseMPP() : self.getBaseMPP() * opt_zoom;
    };

    //______________________________________________________
    // NAVIGATION MODE RELATED
    //______________________________________________________
    VPBASE_NAV.navMode = _defines2.default.eNavModes.nmNone; // navigation mode
    VPBASE_NAV.pyrModeSave = _defines2.default.ENABLEPYRAMIDREFRESH; // backup of nav mode   //todo: this really does not belong in base
    VPBASE_NAV.navModeGet = function () {
        return self.navMode;
    };

    var navModeKeys = Object.keys(_defines2.default.eNavModes);
    VPBASE_NAV.navModeGetStr = function (opt_idx) {
        return opt_idx ? navModeKeys[opt_idx] : navModeKeys[self.navMode];
    };

    // This flag prevents infinite recursion in navModeHalt (which is an indication of event hell...)
    var isChangingNavMode = false;
    //    navModeHalt - This function returns the state of navigation (autopan, drawing, ...) to none.
    VPBASE_NAV.navModeHalt = function () {
        var navMode = self.navModeGet();

        // mouseleave events enter here to cancel drag, etc.
        if (isChangingNavMode || navMode === _defines2.default.eNavModes.nmNone) {
            return;
        }

        // Despite IDE warnings to the contrary, this function is unfortunately recursive, so this value will be evaluated
        // on the previous line should some extension (annotations...) call viewport.navModeHalt()
        isChangingNavMode = true;

        var fireModeChange = false;
        switch (navMode) {
            case _defines2.default.eNavModes.nmDragImage:
            case _defines2.default.eNavModes.nmThumbDragImage:
            case _defines2.default.eNavModes.nmDClickZoom:
            case _defines2.default.eNavModes.nmZoom:
                self.setCursor('auto'); // return to auto cursor
                fireModeChange = true;
                break;

            case _defines2.default.eNavModes.nmSmoothZoom:
            case _defines2.default.eNavModes.nmPinchZoom:
                _defines2.default.ENABLEPYRAMIDREFRESH = self.pyrModeSave; // smooth zoom switched to use the pyramid, restore original setting
                self.setCursor('auto'); // return to auto cursor
                fireModeChange = true;
                break;
            case _defines2.default.eNavModes.nmRotatingOverlay:
                fireModeChange = true;
                break;
            default:
        }

        if (!fireModeChange) {
            var results = self.events.triggerWithReturn('viewport:stop-navigation', navMode);
            fireModeChange = (0, _lbsPiDash.compact)(results).length > 0;
        }

        if (fireModeChange) {
            self.navMode = _defines2.default.eNavModes.nmNone;
            (0, _events.triggerUScopeEvent)(_defines2.default.evMODECHANGE, {
                imageId: self.getImageId(),
                uScopeIdx: self.getImageIdx(),
                navMode: self.navMode,
                navModePrev: navMode
            });
        }

        isChangingNavMode = false;
    };

    //............................................ navModeSwitch
    //    navModeSwitch - This function changes the navigation mode.
    VPBASE_NAV.navModeSwitch = function () {
        var navMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defines2.default.eNavModes.nmNone;

        navMode = Number(navMode);
        if (navMode === self.navMode) {
            return;
        }
        // halt current nav move, if any
        if (self.navMode !== _defines2.default.eNavModes.nmNone) {
            self.navModeHalt();
        } else if (navMode === self.navMode) {
            // cc - added because it seems like pointless to change nav mode if it hasn't changed.
            return;
        }

        var requestHandled = false;

        switch (navMode) {
            /////////////////////////////////////////////////////new for tuning window
            case _defines2.default.eNavModes.nmDragImage:
            case _defines2.default.eNavModes.nmThumbDragImage:
                requestHandled = true;
                break;
            /////////////////////////////////////////////////////
            case _defines2.default.eNavModes.nmSmoothZoom:
            case _defines2.default.eNavModes.nmPinchZoom:
                // smooth zoom MUST use the pyramid to operate fast enough
                // so, I save the current refresh mode and switch to pyramid
                self.pyrModeSave = _defines2.default.ENABLEPYRAMIDREFRESH;
                _defines2.default.ENABLEPYRAMIDREFRESH = true;
                break;

            case _defines2.default.eNavModes.nmAutoPan:
                requestHandled = true;
                break;

            case _defines2.default.eNavModes.nmRasterScan:
                // rasterscan mode
                requestHandled = true;
                break;

            case _defines2.default.eNavModes.nmRotatingOverlay:
                //not required triggerUScopeEvent(us.evMODECHANGE, ... );
                break;
            default:
        }

        if (!requestHandled) {
            var results = self.events.triggerWithReturn('viewport:change-navigation', navMode);
            requestHandled = (0, _lbsPiDash.compact)(results).length > 0;
        }

        if (requestHandled) {
            (0, _events.triggerUScopeEvent)(_defines2.default.evMODECHANGE, {
                imageId: self.getImageId(),
                uScopeIdx: self.getImageIdx(),
                navMode: navMode,
                navModePrev: self.navMode
            });
        }

        self.navMode = navMode;

        isChangingNavMode = false;
    };

    //______________________________________________________
    // ZOOM RELATED
    //______________________________________________________

    // ..................................................... fit zoom related
    VPBASE_ZOOM.getFitZoom = function () {
        return fixedZooms_[0].zoom;
    };
    VPBASE_ZOOM.isFitZoom = function (opt_zoom) {
        if (opt_zoom == undefined) opt_zoom = self.getViewZoom();
        return opt_zoom === fixedZooms_[0].zoom;
    };
    // fitZoomCompute -This function computes the zoom of fit magnification for the passed image.
    VPBASE_ZOOM.fitZoomCompute = function () {
        var csImgDims = self.getImageDims();
        var imageWHRatio = csImgDims.w / csImgDims.h; // compute the image w/h ratio

        var vpDivDims = self.vpDivDimsGet();
        var viewWHRatio = vpDivDims.w / vpDivDims.h; // compute the view w/h ratio
        var zoom = imageWHRatio > viewWHRatio ? parseInt(csImgDims.w / vpDivDims.w) : parseInt(csImgDims.h / vpDivDims.h);

        return nextHighestPowOf2(zoom);

        function nextHighestPowOf2(v) {
            // ref http://graphics.stanford.edu/~seander/bithacks.html
            v--;
            v |= v >> 1;
            v |= v >> 2;
            v |= v >> 4;
            v |= v >> 8;
            v |= v >> 16;
            v++;
            return v;
        }
    };
    // ..................................................... view zoom related
    //todo: reconcile prev zoom with derived
    var prevZoom_ = 4.0;
    var curZoom_ = 1.0;
    VPBASE_ZOOM.getViewPrevZoom = function () {
        return prevZoom_;
    }; // get previous zoom
    VPBASE_ZOOM.setViewPrevZoom = function (currentZoom) {
        prevZoom_ = curZoom_;
        curZoom_ = currentZoom;
    }; // pass in the current zoom

    OVERRIDE_ME_viewportBase.getViewZoom = function () {
        return self.view.getResolution();
    };

    ////CINDY --- move convertToMag  to us namespace and pass in thisImg
    //note: always use roundToDecimals and convertToZoom so zoom precision is managed consistently;
    // TODO: extract consistent means for calculating zoom so we don't need to remember to round and convert...
    VPBASE_ZOOM.convertToZoom = function (mag) {
        // convert magnification to zoom
        return (0, _helpers.roundToDecimals)(self.getBaseMag() / mag);
    };

    // ..................................................... mag related
    VPBASE_ZOOM.getFitMag = function () {
        return self.convertToMag(fixedZooms_[0].zoom);
    };
    OVERRIDE_ME_viewportBase.getViewMag = function () {
        return 0;
    };

    VPBASE_ZOOM.convertToMag = function (zoom) {
        // convert zoom to magnification
        var mag = self.getBaseMag() / zoom;

        if (mag >= 2) mag = roundToHalf(mag); // if mag > 2 then round it to integer or 1/2 way between
        else mag = (0, _helpers.roundToNearset)(mag, 10); // otherwise round to tenths
        return mag;
    };

    // ..................................................... fixed zooms related
    var fixedZooms_; // array of fixed zooms on zoom control
    VPBASE_ZOOM.getFixedZoomArray = function () {
        return fixedZooms_;
    };
    VPBASE_ZOOM.getFixedZoomIdx = function (zoom) {
        // if this zoom value is one of the fixed zooms, return its index; otherwise return -1;
        for (var z = 0, len = fixedZooms_.length; z < len; z++) {
            if (zoom == fixedZooms_[z].zoom) return z;
        }
        return -1;
    };

    //............................................ zoomInitFixed
    //    zoomInitFixed - This function computes the zoom control magnification levels.
    //        It sets the mag levels in one of two manners:
    //            1) forced magnifications: The mags are forced to that of the scan resolution and
    //                    a predefined setof magnfications followed by a "Fit" mag.
    //            2) not forced magnifications: The mags are set to each pyramid level as well as
    //                    fabricated pyramid levels to fill in magnifier gaps > 1.5, followed by a "Fit" mag.
    //
    //    The returned fixedZooms array contains:
    //        zoom:    the image pyramid level zoom value (e.g. 1, 4, 16, FitValue)
    //        mag:    the image pyramid level magnification value (e.g. 20, 5, 1.25, Fit) - note that the "Fit" mag really is the literal string "Fit"
    //        level:    the image pyramid level of this zoom (>= 0 means is a pyramid level; < 0 means is a fabricated level)
    //
    var zoomInitFixed_ = function zoomInitFixed_(thisImg) {
        var xinfo = thisImg.xinfo;
        var fixedZooms = []; // array of zoom, mag, level for each mag in the zoom control

        var baseMag = VPBASE_IMAGE.getMaximumMag(); // get the magnification factor at the base pyramid level

        var useForcedMagnifications = true; // manner to compute
        var l, len, zoom, item, mag;
        if (useForcedMagnifications) {
            item = { zoom: 'Fit', level: -1, mag: 'Fit' }; // add the fit level to the fixedZooms array
            item.zoom = thisImg.fitZoomCompute(thisImg); // replace the fit zoom value
            fixedZooms.push(item);

            for (l = 0, len = FORCED_MAGNICATION_LEVELS.length; l < len; l++) {
                // step thru the forcedMags array
                mag = FORCED_MAGNICATION_LEVELS[l];
                if (mag < baseMag) {
                    // find the index in forcedMags just below scan mag
                    zoom = thisImg.convertToZoom(mag);
                    item = { zoom: zoom, level: -1, mag: mag };
                    fixedZooms.push(item);
                }
            }

            // add the lowest available scan level to the fixedZooms array (NOTE that this may not be the base scan level if the image is being normalized)
            item = {
                zoom: thisImg.convertToZoom(baseMag),
                level: 0,
                mag: baseMag
            };
            fixedZooms.push(item);
        } else {
            var fakeZooms = []; // temp holding for fabricated level info
            var newLevel;

            var minMagNotIncl = 5.0;
            var levels = xinfo.get_imageLevels(); // get number of image pyramid levels
            var zoomRatio;
            for (l = 0; l < levels; l++) {
                // for each level in the pyramid
                //todo: IMPORTANT viewport should have the call to get image zoom at a level so this fn does not access xinfo
                zoom = (0, _helpers.roundToDecimals)(xinfo.get_imageZoom(l)); // add this pyramid level to the fixedZooms array
                if (baseMag / zoom <= minMagNotIncl) break;
                fixedZooms[l] = { zoom: zoom, level: l, mag: thisImg.convertToMag(zoom) };

                // if there's more than a 1.5 : 1 gap to the next level, fabricate a pyramid level
                if (l < levels - 1 && (zoomRatio = xinfo.get_imageZoom(l + 1) / zoom / 2) > 1.5) {
                    zoomRatio = (0, _helpers.roundToNearset)(zoomRatio, 10);
                    var newZoom = (0, _helpers.roundToDecimals)(zoom * zoomRatio);
                    newLevel = { zoom: newZoom, level: -1, mag: thisImg.convertToMag(newZoom) };
                    if (newLevel.mag >= minMagNotIncl) fakeZooms.push(newLevel); // add this new level to the fakeZooms array
                }
            }
            if (levels == 1) {
                // create fakeZooms for the case where there is only one level
                mag = fixedZooms[0].mag;
                while (mag / 2 > minMagNotIncl) {
                    mag = mag / 2;
                    zoom = thisImg.convertToZoom(mag);
                    newLevel = { zoom: zoom, level: -1, mag: mag };
                    fakeZooms.push(newLevel); // add this new level to the fakeZooms array
                }
            }

            newLevel = { zoom: thisImg.convertToZoom(4), level: -1, mag: 4 }; // add 4X to the fakeZooms array
            fixedZooms.unshift(newLevel); // Note: .unshift() method does not return a length property in Internet Explorer.
            newLevel = { zoom: thisImg.convertToZoom(2), level: -1, mag: 2 }; // add 2X to the fakeZooms array
            fixedZooms.unshift(newLevel);
            newLevel = { zoom: thisImg.convertToZoom(1), level: -1, mag: 1 }; // add the fit level to the fakeZooms array
            fixedZooms.unshift(newLevel);

            fixedZooms = fixedZooms.concat(fakeZooms); // concatentate the fixedZooms and fakeZooms arrays into the fixedZooms array

            fixedZooms.sort(function (a, b) {
                return a.mag - b.mag;
            }); // sort the fixedZooms array in ascending magnification order

            newLevel = { zoom: 'Fit', level: -1, mag: 'Fit' }; // add the fit level to the fakeZooms array
            newLevel.zoom = thisImg.fitZoomCompute(thisImg); // replace the fit zoom value
            fixedZooms.unshift(newLevel);
        }

        return fixedZooms;
    };

    function handleKeyboardEvent(e) {
        // don't bother handling if no image is selected
        // processing keyup and keydown would cause double actions; only handle keydown
        if (e.type !== 'keydown') {
            return;
        }

        // Track if we've handled the event so we can intelligently prevent event propagation.
        var eventIsHandled = true;

        // Note that key events on special keys like control are not reported as e.ctrlKey
        // so I use 'which' to normalizes keycodes between browsers.
        // Note: jQuery normalizes the property name to 'which', but not the value of the property, which can vary between browsers for some keys
        // http://stackoverflow.com/questions/18177818/why-jquerys-event-which-gives-different-results-in-firefox-and-chrome
        var keyCode = e.which;

        var overlapHigh = 0.25; // proportion of view width or height to move
        var overlapLow = 0.75; // proportion of view width or height to move
        var dx = void 0;
        var dy = void 0;
        var rotXY = void 0;

        switch (keyCode) {
            // spacebar is used for rasterScan
            case _keyCodes.keyCodes.spacebar:
                (0, _events.triggerUScopeEvent)(_defines2.default.evSPACEBAR, {});
                break;

            //............................................ panning
            //.......... xy position moves
            case _keyCodes.keyCodes.arrowUp:
            case _keyCodes.keyCodes.arrowDown:
                dx = 0;
                dy = e.shiftKey ? self.getViewHeight() * overlapLow : self.getViewHeight() * overlapHigh;
                dy = dy / self.getViewZoom();

                // only when dev hot key is enabled b/c slide tray uses control + arrow
                // if control key is pressed, add -x direction; else if alt key is pressed, add +x direction
                if (_defines2.default.ENABLEDEVHOTKEYS == true) {
                    if (e.ctrlKey) dx = dy; // north or south west move
                    else if (e.altKey) dx = -dy; // north or south east move
                }
                if (e.keyCode == _keyCodes.keyCodes.arrowUp) dy = -dy;

                rotXY = _defines2.default.coordUnRotToRot(dx, dy, self);
                self.moveRelative(rotXY.x, rotXY.y, { animate: true });
                break;
            case _keyCodes.keyCodes.arrowLeft:
            case _keyCodes.keyCodes.arrowRight:
                dy = 0;
                dx = e.shiftKey ? self.getViewWidth() * overlapLow : self.getViewWidth() * overlapHigh;
                dx = dx / self.getViewZoom();
                if (e.keyCode == _keyCodes.keyCodes.arrowLeft) {
                    dx = -dx;
                }

                rotXY = _defines2.default.coordUnRotToRot(dx, dy, self);
                self.moveRelative(rotXY.x, rotXY.y, { animate: true }); //xf - just for consistency,
                break;
            //............................................ zooming
            case _keyCodes.keyCodes.minus: //zoom out
            case _keyCodes.keyCodes.numMinus:
            case _keyCodes.keyCodes.FF_minus:
                if (e.ctrlKey) {
                    self.zoomStep(-_defines2.default.zoomSpecs.stepFactor);
                }
                break;
            case _keyCodes.keyCodes.plus: // zoom in shows more detail so a 10x could become 20x
            case _keyCodes.keyCodes.numPlus:
            case _keyCodes.keyCodes.FF_plus:
                if (e.ctrlKey) {
                    self.zoomStep(_defines2.default.zoomSpecs.stepFactor);
                }
                break;
            //............................................ rotation
            case _keyCodes.keyCodes.num0: // set rotation to 0
            case _keyCodes.keyCodes.zero:
                if (_defines2.default.ENABLEROTATION == true) {
                    self.viewRotate(0, { animate: true });
                }
                break;
            case _keyCodes.keyCodes.r:
                // no shift key => step 1 degrees, shift key => step 15 degree; control key => rotate ccw
                if (_defines2.default.ENABLEROTATION == true) {
                    var angleDeg = self.getViewAngle(true);
                    if (e.shiftKey && e.ctrlKey) angleDeg -= 1;else if (e.shiftKey) angleDeg += 1;else if (e.ctrlKey) angleDeg -= 15;else angleDeg += 15;

                    self.viewRotate(angleDeg, { animate: true });
                }
                break;
            //............................................ next/prev slide
            case _keyCodes.keyCodes.e:
                //
                (0, _events.triggerUScopeEvent)(_defines2.default.evOPENNEXTSLIDE, {});
                break;
            case _keyCodes.keyCodes.q:
                //
                (0, _events.triggerUScopeEvent)(_defines2.default.evOPENPREVSLIDE, {});
                break;
            //............................................
            case _keyCodes.keyCodes.t:
                break;
            default:
                eventIsHandled = _defines2.default.ENABLEDEVHOTKEYS;
        }

        // this disables scrolling while moving around on the self
        if (eventIsHandled) {
            e.preventDefault();
        } else {
            self.events.trigger('viewport:keyup', keyCode, e);
        }
    }

    var FORCED_MAGNICATION_LEVELS = !_defines2.default.DBGZMBTNPYRAMID ? [1, 2, 4, 10, 20, 40, 60, 83, 100] : [1, 1.25, 2, 4, 5, 8, 9, 10, 11, 12, 15, 16, 20, 40, 60, 83, 100];
    var MAG_CONSTS = {
        BASELINE_MPP: 0.5,
        MIN_MPP: 0.45,
        MAX_MPP: 0.55,
        BASELINE_APP_MAG: 20,
        BASELINE_SCALE_FACTOR: 10, // appMag * mpp
        MIN_SCALE_FACTOR: 9,
        MAX_SCALE_FACTOR: 11
    };
    var getScaleFactor = function getScaleFactor() {
        return self.xinfo.MPP * self.xinfo.apparentMag;
    };
    var magNeedsNormalization = function magNeedsNormalization() {
        var sf = getScaleFactor();
        return !(sf >= MAG_CONSTS.MIN_SCALE_FACTOR && sf <= MAG_CONSTS.MAX_SCALE_FACTOR);
    };
}
//________________________________________________________________________________________________

// Below are viewport functions shared by cViewport and ViewportBase/OL.
// Ideally they would all be in ViewportBase and cViewport would derive from base
//    but since that hasn't happened yet, they just reside in the us. namespace.

//-------------------------------------------------------------------------------------------------
// viewport nav mode handlers
//-------------------------------------------------------------------------------------------------
//............................................ setAnnotNavModes()
// This function fills the passed array with boolean true for each drawing nav mode slot.
// TODO: A better approach to this is probably to have Annotations call something like "viewport.hideOverlays()". This
// TODO: would allow us to decouple annotations more thoroughly
_defines2.default.setAnnotNavModes = function (navModesArray) {
    navModesArray[_defines2.default.eNavModes.nmAnnotPin] = true;
    navModesArray[_defines2.default.eNavModes.nmAnnotArrow] = true;
    navModesArray[_defines2.default.eNavModes.nmAnnotRect] = true;
    navModesArray[_defines2.default.eNavModes.nmAnnotEllipse] = true;
    navModesArray[_defines2.default.eNavModes.nmAnnotPen] = true;
    navModesArray[_defines2.default.eNavModes.nmAnnotNegPen] = true;
    navModesArray[_defines2.default.eNavModes.nmAnnotCaliper] = true;
    navModesArray[_defines2.default.eNavModes.nmAnnotText] = true;
    navModesArray[_defines2.default.eNavModes.nmAnnotReport] = true;
    navModesArray[_defines2.default.eNavModes.nmRedrawStarting] = true;
    navModesArray[_defines2.default.eNavModes.nmRedraw] = true;
    navModesArray[_defines2.default.eNavModes.nmAnnotPolygon] = true;
};

//-------------------------------------------------------------------------------------------------
//    COORDINATE TRANSFORMS
//-------------------------------------------------------------------------------------------------
//............................................ coordBaseImage
//    coordBaseImage - This function computes the image base coord position of the cursor position from
//                    the passed vp div position and the event object. Viewport relative means viewport window
//                    coordinates.
_defines2.default.coordBaseImage = function (event, thisImg) {
    var cpVpRelPos = _defines2.default.coordPageToView(event, thisImg); // the unrotated viewport relative cursor position
    return _defines2.default.coordBaseImage2(cpVpRelPos, thisImg);
};

//............................................ coordBaseImage2
//    coordBaseImage2 - This function computes the image base coord position of the cursor position
//                    from the viewport relative coordinates.
_defines2.default.coordBaseImage2 = function (relPos, thisImg) {
    var basePos = new _objects.Point(relPos.x, relPos.y);
    var zoom = thisImg.getViewZoom();
    basePos.multiply(zoom, zoom);
    basePos.add(thisImg.getViewLeft(), thisImg.getViewTop());
    basePos.toInt();
    return basePos;
};

//............................................ coordBaseToView
//    coordBaseToView - This function converts base coordinates to view coordinates
//        Improvement: take rotation into account and does this work for multi-image views?
_defines2.default.coordBaseToView = function (cpBase, thisImg) {
    var cpLT = thisImg.getViewLeftTop(_defines2.default.coordSystemNORM);
    var zoom = thisImg.getViewZoom();
    return new _objects.Point(Math.floor((cpBase.x - cpLT.x) / zoom), Math.floor((cpBase.y - cpLT.y) / zoom));
};

//............................................ coordPageToView
//    coordPageToView - This function converts page coordinates to viewport relative coordinates.
//        Passed Parameters:    event object
//        Returns a Point of the cursor position within the unrotated image
_defines2.default.coordPageToView = function (e, thisImg) {
    var cpRtn = new _objects.Point(0, 0); // return position object
    var jVpDiv = thisImg.vpDivGet();
    var offset = jVpDiv.offset(); // the current position of the target relative to the document

    var vpX = e.pageX - offset.left; // translate viewport left top position
    var vpY = e.pageY - offset.top;
    cpRtn = _defines2.default.coordUnRotate(vpX, vpY, thisImg); // un-rotate the viewport coordinate

    return cpRtn;
};

//............................................ coordUnRotate
// coordUnRotate - This function converts a rotated vp cursor position to unrotated vp cursor position (not image, vp div position)
_defines2.default.coordUnRotate = function (x, y, thisImg) {
    var cpRtn = new _objects.Point(x, y); // return position object
    var imgRotAngleRad = thisImg.getViewAngle();
    if (imgRotAngleRad != 0) {
        var vpDivDims = thisImg.vpDivDimsGet();
        var vpW = vpDivDims.w,
            vpH = vpDivDims.h;

        var vpOffset = thisImg.getRotationOffset();
        var ptx = x + vpOffset.x,
            pty = y + vpOffset.y;
        var xc = vpW / 2,
            yc = vpH / 2; // Thumbnail center position

        var dx = ptx - xc,
            dy = yc - pty; // Transform Point Coordinates to view center (xc,yc)
        var hyp = Math.sqrt(dx * dx + dy * dy); //    Hypotenuse
        var thetaRad = Math.atan2(dy, dx); // Transformed Point Angle

        var phiRad = thetaRad + imgRotAngleRad; // Add Rotation to Point Angle
        cpRtn.x = hyp * Math.cos(phiRad); // Compute Shift
        cpRtn.y = hyp * Math.sin(phiRad);

        var xi = cpRtn.x + xc,
            yi = yc - cpRtn.y; // compute x-shift and convert to image coordiantes
        cpRtn.x = Math.round(xi);
        cpRtn.y = Math.round(yi);
    }
    return cpRtn;
};

//............................................ coordUnRotToRot
//    coordUnRotToRot - This function converts a distance in unrotated coords to rotated coords.
_defines2.default.coordUnRotToRot = function (dx, dy, thisImg) {
    var rtnXY = new _objects.Point(dx, dy);
    var imgAngleRad = thisImg.getViewAngle();
    if (imgAngleRad != 0) {

        var movAngleRad = Math.atan2(dy, dx); // direction of move
        var movMag = Math.sqrt(dx * dx + dy * dy); // magnitude of move

        var rotMoveAngleRad = movAngleRad - imgAngleRad; // angle between move direction and view rotation

        var rotDx = Math.round(movMag * Math.cos(rotMoveAngleRad)); //todo-cosolodate
        var rotDy = Math.round(movMag * Math.sin(rotMoveAngleRad));
        rtnXY.set(rotDx, rotDy);
    }
    return rtnXY;
};

//-------------------------------------------------------------------------------------------------
//    VIEWPORT ID & CLASS HELPERS
//-------------------------------------------------------------------------------------------------
//............................................ us.classFromImageId()
//    This function converts the input imageId to a class id for the viewport    divs.
//    In doing so it verifies that the imageId is valid.  If the image id is not valid, undefined is returned.
//
//        return example: "us_img_2" returned for imageId = 2 if us.clsPREPEND_ID = "us_img_"
_defines2.default.classFromImageId = function (imageId) {
    var rtnClass;
    if (imageId.indexOf('@') === 0) // this is an imageId format (starts with '@')
        return _defines2.default.clsPREPEND_ID + imageId.substr(1); // return example: "us_img_2"

    if (imageId.toUpperCase().indexOf('IMAGESERVER') === 0) {
        // this is format of imageserver/filename
        rtnClass = _defines2.default.clsPREPEND_ID + imageId.slice('IMAGESERVER'.length + 1); // remove the imageserver/
        rtnClass = rtnClass.slice(0, rtnClass.lastIndexOf('.')); // remove the .ext
        return rtnClass;
    }
    return rtnClass;
};

//............................................ us.extractImageIdFromClass()
// This function receives a string presumably in the format of us.clsPREPEND_ID + imageId (without the @ sign).
//    If us.clsPREPEND_ID exists in the passed string it extracts the imageIdand returns it.
//    If it doesn't exist, undefined is returned.
_defines2.default.extractImageIdFromClass = function (cls) {
    var rtnId;
    var index = cls.indexOf(_defines2.default.clsPREPEND_ID);
    if (index !== -1) rtnId = cls.slice(_defines2.default.clsPREPEND_ID.length - cls.length);
    return rtnId;
};

//-------------------------------------------------------------------------------------------------
// roundToHalf - This function rounds a float value to the nearest integer or 1/2.
function roundToHalf(value) {
    var ival = parseInt(value);
    var fraction = value - ival;
    if (fraction < 0.25) return ival;else if (fraction >= 0.75) return ival + 1;
    return ival + 0.5;
}
module.exports = exports['default'];

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(499), __esModule: true };

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(500), __esModule: true };

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(501), __esModule: true };

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(503), __esModule: true };

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(504), __esModule: true };

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(505), __esModule: true };

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(77);
__webpack_require__(76);
module.exports = __webpack_require__(522);

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(77);
__webpack_require__(76);
module.exports = __webpack_require__(523);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(525);
var $Object = __webpack_require__(12).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(526);
var $Object = __webpack_require__(12).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(527);
module.exports = __webpack_require__(12).Object.setPrototypeOf;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(528);
__webpack_require__(106);
__webpack_require__(529);
__webpack_require__(530);
module.exports = __webpack_require__(12).Symbol;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(76);
__webpack_require__(77);
module.exports = __webpack_require__(170).f('iterator');

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(85)
  , toLength  = __webpack_require__(104)
  , toIndex   = __webpack_require__(520);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(141)
  , gOPS    = __webpack_require__(320)
  , pIE     = __webpack_require__(164);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(28);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(28);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(163)
  , descriptor     = __webpack_require__(142)
  , setToStringTag = __webpack_require__(75)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(35)(IteratorPrototype, __webpack_require__(3)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(141)
  , toIObject = __webpack_require__(85);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(143)('meta')
  , isObject = __webpack_require__(46)
  , has      = __webpack_require__(84)
  , setDesc  = __webpack_require__(33).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(140)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(33)
  , anObject = __webpack_require__(13)
  , getKeys  = __webpack_require__(141);

module.exports = __webpack_require__(32) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(85)
  , gOPN      = __webpack_require__(319).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(84)
  , toObject    = __webpack_require__(521)
  , IE_PROTO    = __webpack_require__(165)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(46)
  , anObject = __webpack_require__(13);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(19)(Function.call, __webpack_require__(318).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(167)
  , defined   = __webpack_require__(161);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(167)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(161);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13)
  , get      = __webpack_require__(105);
module.exports = __webpack_require__(12).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(82)
  , ITERATOR  = __webpack_require__(3)('iterator')
  , Iterators = __webpack_require__(47);
module.exports = __webpack_require__(12).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(506)
  , step             = __webpack_require__(512)
  , Iterators        = __webpack_require__(47)
  , toIObject        = __webpack_require__(85);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(317)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(45)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(163)});

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(45);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(32), 'Object', {defineProperty: __webpack_require__(33).f});

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(45);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(518).set});

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(7)
  , has            = __webpack_require__(84)
  , DESCRIPTORS    = __webpack_require__(32)
  , $export        = __webpack_require__(45)
  , redefine       = __webpack_require__(322)
  , META           = __webpack_require__(514).KEY
  , $fails         = __webpack_require__(140)
  , shared         = __webpack_require__(166)
  , setToStringTag = __webpack_require__(75)
  , uid            = __webpack_require__(143)
  , wks            = __webpack_require__(3)
  , wksExt         = __webpack_require__(170)
  , wksDefine      = __webpack_require__(169)
  , keyOf          = __webpack_require__(513)
  , enumKeys       = __webpack_require__(508)
  , isArray        = __webpack_require__(510)
  , anObject       = __webpack_require__(13)
  , toIObject      = __webpack_require__(85)
  , toPrimitive    = __webpack_require__(168)
  , createDesc     = __webpack_require__(142)
  , _create        = __webpack_require__(163)
  , gOPNExt        = __webpack_require__(516)
  , $GOPD          = __webpack_require__(318)
  , $DP            = __webpack_require__(33)
  , $keys          = __webpack_require__(141)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(319).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(164).f  = $propertyIsEnumerable;
  __webpack_require__(320).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(74)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(35)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(169)('asyncIterator');

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(169)('observable');

/***/ }),
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144);
__webpack_require__(145);
__webpack_require__(349);
__webpack_require__(348);
module.exports = __webpack_require__(6);


/***/ })
/******/ ]);